(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiredea3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiredea3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("lJx7k", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdb52fb6797430f0$export$2e2bcd8739ae039);
/*! DataTables Bootstrap 4 integration
 * © SpryMedia Ltd - datatables.net/license
 */ 
var $iUSsr = parcelRequire("iUSsr");

var $63jfO = parcelRequire("63jfO");
// Allow reassignment of the $ variable
let $bdb52fb6797430f0$var$$ = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)));
/**
 * DataTables integration for Bootstrap 4.
 *
 * This file sets the defaults and adds options to DataTables to style its
 * controls using Bootstrap. See https://datatables.net/manual/styling/bootstrap
 * for further information.
 */ /* Set the defaults for DataTables initialisation */ $bdb52fb6797430f0$var$$.extend(true, (0, $63jfO.default).defaults, {
    renderer: 'bootstrap'
});
/* Default class modification */ $bdb52fb6797430f0$var$$.extend(true, (0, $63jfO.default).ext.classes, {
    container: "dt-container dt-bootstrap4",
    search: {
        input: "form-control form-control-sm"
    },
    length: {
        select: "custom-select custom-select-sm form-control form-control-sm"
    },
    processing: {
        container: "dt-processing card"
    },
    layout: {
        row: 'row justify-content-between',
        cell: 'd-md-flex justify-content-between align-items-center',
        tableCell: 'col-12',
        start: 'dt-layout-start col-md-auto mr-auto',
        end: 'dt-layout-end col-md-auto ml-auto',
        full: 'dt-layout-full col-md'
    }
});
/* Bootstrap paging button renderer */ (0, $63jfO.default).ext.renderer.pagingButton.bootstrap = function(settings, buttonType, content, active, disabled) {
    var btnClasses = [
        'dt-paging-button',
        'page-item'
    ];
    if (active) btnClasses.push('active');
    if (disabled) btnClasses.push('disabled');
    var li = $bdb52fb6797430f0$var$$('<li>').addClass(btnClasses.join(' '));
    var a = $bdb52fb6797430f0$var$$('<a>', {
        'href': disabled ? null : '#',
        'class': 'page-link'
    }).html(content).appendTo(li);
    return {
        display: li,
        clicker: a
    };
};
(0, $63jfO.default).ext.renderer.pagingContainer.bootstrap = function(settings, buttonEls) {
    return $bdb52fb6797430f0$var$$('<ul/>').addClass('pagination').append(buttonEls);
};
var $bdb52fb6797430f0$export$2e2bcd8739ae039 = (0, $63jfO.default);

});
parcelRegister("iUSsr", function(module, exports) {
/*!
 * jQuery JavaScript Library v4.0.0
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.com/license/
 *
 * Date: 2026-01-18T00:20Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    module.exports = factory(global, true);
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    "use strict";
    if (!window1.document) throw new Error("jQuery requires a window with a document");
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    // Support: IE 11+
    // IE doesn't have Array#flat; provide a fallback.
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    // [[Class]] -> type pairs
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    // All support tests are defined in their respective modules.
    var support = {};
    function toType(obj) {
        if (obj == null) return obj + "";
        return typeof obj === "object" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    function isWindow(obj) {
        return obj != null && obj === obj.window;
    }
    function isArrayLike(obj) {
        var length = !!obj && obj.length, type = toType(obj);
        if (typeof obj === "function" || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    var document$1 = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document$1;
        var i, script = doc.createElement("script");
        script.text = code;
        for(i in preservedScriptAttributes)if (node && node[i]) script[i] = node[i];
        if (doc.head.appendChild(script).parentNode) script.parentNode.removeChild(script);
    }
    var version = "4.0.0", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        }
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && typeof target !== "function") target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Note: an element does not contain itself
        contains: function(a, b) {
            var bup = b && b.parentNode;
            return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
            // IE doesn't have `contains` on SVG.
            (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
        },
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    // https://www.w3.org/TR/css3-selectors/#whitespace
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var isIE = document$1.documentMode;
    var rbuggyQSA = isIE && new RegExp(// Support: IE 9 - 11+
    // IE's :disabled selector does not pick up the children of disabled fieldsets
    ":enabled|:disabled|\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
    var identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+";
    var rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*");
    var rdescend = new RegExp(whitespace + "|>");
    var rsibling = /[+~]/;
    var documentElement$1 = document$1.documentElement;
    // Support: IE 9 - 11+
    // IE requires a prefix.
    var matches = documentElement$1.matches || documentElement$1.msMatchesSelector;
    /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
        var keys = [];
        function cache(key, value) {
            // Use (key + " ") to avoid collision with native prototype properties
            // (see https://github.com/jquery/sizzle/issues/157)
            if (keys.push(key + " ") > jQuery.expr.cacheLength) // Only keep the most recent entries
            delete cache[keys.shift()];
            return cache[key + " "] = value;
        }
        return cache;
    }
    /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
        return context && typeof context.getElementsByTagName !== "undefined" && context;
    }
    // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
    var attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
    "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
    "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]";
    var pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
    // 1. quoted (capture 3; capture 4 or capture 5)
    "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
    "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
    ".*" + ")\\)|)";
    var filterMatchExpr = {
        ID: new RegExp("^#(" + identifier + ")"),
        CLASS: new RegExp("^\\.(" + identifier + ")"),
        TAG: new RegExp("^(" + identifier + "|[*])"),
        ATTR: new RegExp("^" + attributes),
        PSEUDO: new RegExp("^" + pseudos),
        CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i")
    };
    var rpseudo = new RegExp(pseudos);
    // CSS escapes
    // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
    var runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
        var high = "0x" + escape.slice(1) - 0x10000;
        if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
        return nonHex;
        // Replace a hexadecimal escape sequence with the encoded Unicode code point
        // Support: IE <=11+
        // For values outside the Basic Multilingual Plane (BMP), manually construct a
        // surrogate pair
        return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
    };
    function unescapeSelector(sel) {
        return sel.replace(runescape, funescape);
    }
    function selectorError(msg) {
        jQuery.error("Syntax error, unrecognized expression: " + msg);
    }
    var rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*");
    var tokenCache = createCache();
    function tokenize(selector, parseOnly) {
        var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
        if (cached) return parseOnly ? 0 : cached.slice(0);
        soFar = selector;
        groups = [];
        preFilters = jQuery.expr.preFilter;
        while(soFar){
            // Comma and first run
            if (!matched || (match = rcomma.exec(soFar))) {
                if (match) // Don't consume trailing commas as valid
                soFar = soFar.slice(match[0].length) || soFar;
                groups.push(tokens = []);
            }
            matched = false;
            // Combinators
            if (match = rleadingCombinator.exec(soFar)) {
                matched = match.shift();
                tokens.push({
                    value: matched,
                    // Cast descendant combinators to space
                    type: match[0].replace(rtrimCSS, " ")
                });
                soFar = soFar.slice(matched.length);
            }
            // Filters
            for(type in filterMatchExpr)if ((match = jQuery.expr.match[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                matched = match.shift();
                tokens.push({
                    value: matched,
                    type: type,
                    matches: match
                });
                soFar = soFar.slice(matched.length);
            }
            if (!matched) break;
        }
        // Return the length of the invalid excess
        // if we're just parsing
        // Otherwise, throw an error or return tokens
        if (parseOnly) return soFar.length;
        return soFar ? selectorError(selector) : // Cache the tokens
        tokenCache(selector, groups).slice(0);
    }
    var preFilter = {
        ATTR: function(match) {
            match[1] = unescapeSelector(match[1]);
            // Move the given value to match[3] whether quoted or unquoted
            match[3] = unescapeSelector(match[3] || match[4] || match[5] || "");
            if (match[2] === "~=") match[3] = " " + match[3] + " ";
            return match.slice(0, 4);
        },
        CHILD: function(match) {
            /* matches from filterMatchExpr["CHILD"]
			1 type (only|nth|...)
			2 what (child|of-type)
			3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
			4 xn-component of xn+y argument ([+-]?\d*n|)
			5 sign of xn-component
			6 x of xn-component
			7 sign of y-component
			8 y of y-component
		*/ match[1] = match[1].toLowerCase();
            if (match[1].slice(0, 3) === "nth") {
                // nth-* requires argument
                if (!match[3]) selectorError(match[0]);
                // numeric x and y parameters for jQuery.expr.filter.CHILD
                // remember that false/true cast respectively to 0/1
                match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                match[5] = +(match[7] + match[8] || match[3] === "odd");
            // other types prohibit arguments
            } else if (match[3]) selectorError(match[0]);
            return match;
        },
        PSEUDO: function(match) {
            var excess, unquoted = !match[6] && match[2];
            if (filterMatchExpr.CHILD.test(match[0])) return null;
            // Accept quoted arguments as-is
            if (match[3]) match[2] = match[4] || match[5] || "";
            else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
            (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
            (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                // excess is a negative index
                match[0] = match[0].slice(0, excess);
                match[2] = unquoted.slice(0, excess);
            }
            // Return only captures needed by the pseudo filter method (type and argument)
            return match.slice(0, 3);
        }
    };
    function toSelector(tokens) {
        var i = 0, len = tokens.length, selector = "";
        for(; i < len; i++)selector += tokens[i].value;
        return selector;
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    function access(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (typeof value !== "function") raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    }
    // Only count HTML whitespace
    // Other whitespace should count in values
    // https://infra.spec.whatwg.org/#ascii-whitespace
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()];
            if (value !== undefined) {
                if (value === null || // For compat with previous handling of boolean attributes,
                // remove when `false` passed. For ARIA attributes -
                // many of which recognize a `"false"` value - continue to
                // set the `"false"` value as jQuery <4 did.
                value === false && name.toLowerCase().indexOf("aria-") !== 0) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value);
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = elem.getAttribute(name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {},
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Support: IE <=11+
    // An input loses its value after becoming a radio
    if (isIE) jQuery.attrHooks.type = {
        set: function(elem, value) {
            if (value === "radio" && nodeName(elem, "input")) {
                var val = elem.value;
                elem.setAttribute("type", value);
                if (val) elem.value = val;
                return value;
            }
        }
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var sort = arr.sort;
    var splice = arr.splice;
    var hasDuplicate;
    // Document order sorting
    function sortOrder(a, b) {
        // Flag for duplicate removal
        if (a === b) {
            hasDuplicate = true;
            return 0;
        }
        // Sort on method existence if only one input has compareDocumentPosition
        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
        if (compare) return compare;
        // Calculate position if both inputs belong to the same document
        // Support: IE 11+
        // IE sometimes throws a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
        1;
        // Disconnected nodes
        if (compare & 1) {
            // Choose the first element that is related to the document
            // Support: IE 11+
            // IE sometimes throws a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (a == document$1 || a.ownerDocument == document$1 && jQuery.contains(document$1, a)) return -1;
            // Support: IE 11+
            // IE sometimes throws a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (b == document$1 || b.ownerDocument == document$1 && jQuery.contains(document$1, b)) return 1;
            // Maintain original order
            return 0;
        }
        return compare & 4 ? -1 : 1;
    }
    /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
        var elem, duplicates = [], j = 0, i = 0;
        hasDuplicate = false;
        sort.call(results, sortOrder);
        if (hasDuplicate) {
            while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
            while(j--)splice.call(results, duplicates[j], 1);
        }
        return results;
    };
    jQuery.fn.uniqueSort = function() {
        return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
    };
    var i, outermostContext, // Local document vars
    document, documentElement, documentIsHTML, // Instance-specific data
    dirruns = 0, done = 0, classCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), // Regular expressions
    // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
    rwhitespace = new RegExp(whitespace + "+", "g"), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = jQuery.extend({
        // For use in libraries implementing .is()
        // We use this for POS matching in `select`
        needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
    }, filterMatchExpr), rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
    rquickExpr$1 = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, // Used for iframes; see `setDocument`.
    // Support: IE 9 - 11+
    // Removing the function wrapper causes a "Permission Denied"
    // error in IE.
    unloadHandler = function() {
        setDocument();
    }, inDisabledFieldset = addCombinator(function(elem) {
        return elem.disabled === true && nodeName(elem, "fieldset");
    }, {
        dir: "parentNode",
        next: "legend"
    });
    function find(selector, context, results, seed) {
        var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
        nodeType = context ? context.nodeType : 9;
        results = results || [];
        // Return early from calls with invalid selector or context
        if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
        // Try to shortcut find operations (as opposed to filters) in HTML documents
        if (!seed) {
            setDocument(context);
            context = context || document;
            if (documentIsHTML) {
                // If the selector is sufficiently simple, try using a "get*By*" DOM method
                // (excepting DocumentFragment context, where the methods don't exist)
                if (nodeType !== 11 && (match = rquickExpr$1.exec(selector))) {
                    // ID selector
                    if (m = match[1]) {
                        // Document context
                        if (nodeType === 9) {
                            if (elem = context.getElementById(m)) push.call(results, elem);
                            return results;
                        // Element context
                        } else if (newContext && (elem = newContext.getElementById(m)) && jQuery.contains(context, elem)) {
                            push.call(results, elem);
                            return results;
                        }
                    // Type selector
                    } else if (match[2]) {
                        push.apply(results, context.getElementsByTagName(selector));
                        return results;
                    // Class selector
                    } else if ((m = match[3]) && context.getElementsByClassName) {
                        push.apply(results, context.getElementsByClassName(m));
                        return results;
                    }
                }
                // Take advantage of querySelectorAll
                if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                    newSelector = selector;
                    newContext = context;
                    // qSA considers elements outside a scoping root when evaluating child or
                    // descendant combinators, which is not what we want.
                    // In such cases, we work around the behavior by prefixing every selector in the
                    // list with an ID selector referencing the scope context.
                    // The technique has to be used as well when a leading combinator is used
                    // as such selectors are not recognized by querySelectorAll.
                    // Thanks to Andrew Dupont for this technique.
                    if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                        // Expand context for sibling selectors
                        newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                        // Outside of IE, if we're not changing the context we can
                        // use :scope instead of an ID.
                        // Support: IE 11+
                        // IE sometimes throws a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (newContext != context || isIE) {
                            // Capture the context ID, setting it first if necessary
                            if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                            else context.setAttribute("id", nid = jQuery.expando);
                        }
                        // Prefix every selector in the list
                        groups = tokenize(selector);
                        i = groups.length;
                        while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                        newSelector = groups.join(",");
                    }
                    try {
                        push.apply(results, newContext.querySelectorAll(newSelector));
                        return results;
                    } catch (qsaError) {
                        nonnativeSelectorCache(selector, true);
                    } finally{
                        if (nid === jQuery.expando) context.removeAttribute("id");
                    }
                }
            }
        }
        // All others
        return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
    }
    /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
        fn[jQuery.expando] = true;
        return fn;
    }
    /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
        return function(elem) {
            return nodeName(elem, "input") && elem.type === type;
        };
    }
    /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
        return function(elem) {
            return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
        };
    }
    /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
        // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
        return function(elem) {
            // Only certain elements can match :enabled or :disabled
            // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
            // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
            if ("form" in elem) {
                // Check for inherited disabledness on relevant non-disabled elements:
                // * listed form-associated elements in a disabled fieldset
                //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                // * option elements in a disabled optgroup
                //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                // All such elements have a "form" property.
                if (elem.parentNode && elem.disabled === false) {
                    // Option elements defer to a parent optgroup if present
                    if ("label" in elem) {
                        if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                        else return elem.disabled === disabled;
                    }
                    // Support: IE 6 - 11+
                    // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                    return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                    elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                }
                return elem.disabled === disabled;
            // Try to winnow out elements that can't be disabled before trusting the disabled property.
            // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
            // even exist on them, let alone have a boolean value.
            } else if ("label" in elem) return elem.disabled === disabled;
            // Remaining elements are neither :enabled nor :disabled
            return false;
        };
    }
    /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
        return markFunction(function(argument) {
            argument = +argument;
            return markFunction(function(seed, matches) {
                var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                // Match elements found at the specified indexes
                while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
            });
        });
    }
    /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 */ function setDocument(node) {
        var subWindow, doc = node ? node.ownerDocument || node : document$1;
        // Return early if doc is invalid or already selected
        // Support: IE 11+
        // IE sometimes throws a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        if (doc == document || doc.nodeType !== 9) return;
        // Update global variables
        document = doc;
        documentElement = document.documentElement;
        documentIsHTML = !jQuery.isXMLDoc(document);
        // Support: IE 9 - 11+
        // Accessing iframe documents after unload throws "permission denied" errors (see trac-13936)
        // Support: IE 11+
        // IE sometimes throws a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        if (isIE && document$1 != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) subWindow.addEventListener("unload", unloadHandler);
    }
    find.matches = function(expr, elements) {
        return find(expr, null, null, elements);
    };
    find.matchesSelector = function(elem, expr) {
        setDocument(elem);
        if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
            return matches.call(elem, expr);
        } catch (e) {
            nonnativeSelectorCache(expr, true);
        }
        return find(expr, document, null, [
            elem
        ]).length > 0;
    };
    jQuery.expr = {
        // Can be adjusted by the user
        cacheLength: 50,
        createPseudo: markFunction,
        match: matchExpr,
        find: {
            ID: function(id, context) {
                if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                    var elem = context.getElementById(id);
                    return elem ? [
                        elem
                    ] : [];
                }
            },
            TAG: function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            },
            CLASS: function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            }
        },
        relative: {
            ">": {
                dir: "parentNode",
                first: true
            },
            " ": {
                dir: "parentNode"
            },
            "+": {
                dir: "previousSibling",
                first: true
            },
            "~": {
                dir: "previousSibling"
            }
        },
        preFilter: preFilter,
        filter: {
            ID: function(id) {
                var attrId = unescapeSelector(id);
                return function(elem) {
                    return elem.getAttribute("id") === attrId;
                };
            },
            TAG: function(nodeNameSelector) {
                var expectedNodeName = unescapeSelector(nodeNameSelector).toLowerCase();
                return nodeNameSelector === "*" ? function() {
                    return true;
                } : function(elem) {
                    return nodeName(elem, expectedNodeName);
                };
            },
            CLASS: function(className) {
                var pattern = classCache[className + " "];
                return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                    return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                }));
            },
            ATTR: function(name, operator, check) {
                return function(elem) {
                    var result = jQuery.attr(elem, name);
                    if (result == null) return operator === "!=";
                    if (!operator) return true;
                    result += "";
                    if (operator === "=") return result === check;
                    if (operator === "!=") return result !== check;
                    if (operator === "^=") return check && result.indexOf(check) === 0;
                    if (operator === "*=") return check && result.indexOf(check) > -1;
                    if (operator === "$=") return check && result.slice(-check.length) === check;
                    if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                    if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                    return false;
                };
            },
            CHILD: function(type, what, _argument, first, last) {
                var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                function(elem) {
                    return !!elem.parentNode;
                } : function(elem, _context, xml) {
                    var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                    if (parent) {
                        // :(first|last|only)-(child|of-type)
                        if (simple) {
                            while(dir){
                                node = elem;
                                while(node = node[dir]){
                                    if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                }
                                // Reverse direction for :only-* (if we haven't yet done so)
                                start = dir = type === "only" && !start && "nextSibling";
                            }
                            return true;
                        }
                        start = [
                            forward ? parent.firstChild : parent.lastChild
                        ];
                        // non-xml :nth-child(...) stores cache data on `parent`
                        if (forward && useCache) {
                            // Seek `elem` from a previously-cached index
                            outerCache = parent[jQuery.expando] || (parent[jQuery.expando] = {});
                            cache = outerCache[type] || [];
                            nodeIndex = cache[0] === dirruns && cache[1];
                            diff = nodeIndex && cache[2];
                            node = nodeIndex && parent.childNodes[nodeIndex];
                            while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                            (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                            if (node.nodeType === 1 && ++diff && node === elem) {
                                outerCache[type] = [
                                    dirruns,
                                    nodeIndex,
                                    diff
                                ];
                                break;
                            }
                        } else {
                            // Use previously-cached element index if available
                            if (useCache) {
                                outerCache = elem[jQuery.expando] || (elem[jQuery.expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex;
                            }
                            // xml :nth-child(...)
                            // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                            if (diff === false) {
                                // Use the same loop as above to seek `elem` from the start
                                while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                    // Cache the index of each encountered element
                                    if (useCache) {
                                        outerCache = node[jQuery.expando] || (node[jQuery.expando] = {});
                                        outerCache[type] = [
                                            dirruns,
                                            diff
                                        ];
                                    }
                                    if (node === elem) break;
                                }
                            }
                        }
                        // Incorporate the offset, then check against cycle size
                        diff -= last;
                        return diff === first || diff % first === 0 && diff / first >= 0;
                    }
                };
            },
            PSEUDO: function(pseudo, argument) {
                // pseudo-class names are case-insensitive
                // https://www.w3.org/TR/selectors/#pseudo-classes
                // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                // Remember that setFilters inherits from pseudos
                var fn = jQuery.expr.pseudos[pseudo] || jQuery.expr.setFilters[pseudo.toLowerCase()] || selectorError("unsupported pseudo: " + pseudo);
                // The user may use createPseudo to indicate that
                // arguments are needed to create the filter function
                // just as jQuery does
                if (fn[jQuery.expando]) return fn(argument);
                return fn;
            }
        },
        pseudos: {
            // Potentially complex pseudos
            not: markFunction(function(selector) {
                // Trim the selector passed to compile
                // to avoid treating leading and trailing
                // spaces as combinators
                var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                return matcher[jQuery.expando] ? markFunction(function(seed, matches, _context, xml) {
                    var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                    // Match elements unmatched by `matcher`
                    while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                }) : function(elem, _context, xml) {
                    input[0] = elem;
                    matcher(input, null, xml, results);
                    // Don't keep the element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    input[0] = null;
                    return !results.pop();
                };
            }),
            has: markFunction(function(selector) {
                return function(elem) {
                    return find(selector, elem).length > 0;
                };
            }),
            contains: markFunction(function(text) {
                text = unescapeSelector(text);
                return function(elem) {
                    return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                };
            }),
            // "Whether an element is represented by a :lang() selector
            // is based solely on the element's language value
            // being equal to the identifier C,
            // or beginning with the identifier C immediately followed by "-".
            // The matching of C against the element's language value is performed case-insensitively.
            // The identifier C does not have to be a valid language name."
            // https://www.w3.org/TR/selectors/#lang-pseudo
            lang: markFunction(function(lang) {
                // lang value must be a valid identifier
                if (!ridentifier.test(lang || "")) selectorError("unsupported lang: " + lang);
                lang = unescapeSelector(lang).toLowerCase();
                return function(elem) {
                    var elemLang;
                    do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                        elemLang = elemLang.toLowerCase();
                        return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                    }
                    while ((elem = elem.parentNode) && elem.nodeType === 1);
                    return false;
                };
            }),
            // Miscellaneous
            target: function(elem) {
                var hash = window1.location && window1.location.hash;
                return hash && hash.slice(1) === elem.id;
            },
            root: function(elem) {
                return elem === documentElement;
            },
            focus: function(elem) {
                return elem === document.activeElement && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
            },
            // Boolean properties
            enabled: createDisabledPseudo(false),
            disabled: createDisabledPseudo(true),
            checked: function(elem) {
                // In CSS3, :checked should return both checked and selected elements
                // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
            },
            selected: function(elem) {
                // Support: IE <=11+
                // Accessing the selectedIndex property
                // forces the browser to treat the default option as
                // selected when in an optgroup.
                if (isIE && elem.parentNode) // eslint-disable-next-line no-unused-expressions
                elem.parentNode.selectedIndex;
                return elem.selected === true;
            },
            // Contents
            empty: function(elem) {
                // https://www.w3.org/TR/selectors/#empty-pseudo
                // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                //   but not by others (comment: 8; processing instruction: 7; etc.)
                // nodeType < 6 works because attributes (2) do not appear as children
                for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                    if (elem.nodeType < 6) return false;
                }
                return true;
            },
            parent: function(elem) {
                return !jQuery.expr.pseudos.empty(elem);
            },
            // Element/input types
            header: function(elem) {
                return rheader.test(elem.nodeName);
            },
            input: function(elem) {
                return rinputs.test(elem.nodeName);
            },
            button: function(elem) {
                return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
            },
            text: function(elem) {
                return nodeName(elem, "input") && elem.type === "text";
            },
            // Position-in-collection
            first: createPositionalPseudo(function() {
                return [
                    0
                ];
            }),
            last: createPositionalPseudo(function(_matchIndexes, length) {
                return [
                    length - 1
                ];
            }),
            eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                return [
                    argument < 0 ? argument + length : argument
                ];
            }),
            even: createPositionalPseudo(function(matchIndexes, length) {
                var i = 0;
                for(; i < length; i += 2)matchIndexes.push(i);
                return matchIndexes;
            }),
            odd: createPositionalPseudo(function(matchIndexes, length) {
                var i = 1;
                for(; i < length; i += 2)matchIndexes.push(i);
                return matchIndexes;
            }),
            lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                var i;
                if (argument < 0) i = argument + length;
                else if (argument > length) i = length;
                else i = argument;
                for(; --i >= 0;)matchIndexes.push(i);
                return matchIndexes;
            }),
            gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                var i = argument < 0 ? argument + length : argument;
                for(; ++i < length;)matchIndexes.push(i);
                return matchIndexes;
            })
        }
    };
    jQuery.expr.pseudos.nth = jQuery.expr.pseudos.eq;
    // Add button/input type pseudos
    for(i in {
        radio: true,
        checkbox: true,
        file: true,
        password: true,
        image: true
    })jQuery.expr.pseudos[i] = createInputPseudo(i);
    for(i in {
        submit: true,
        reset: true
    })jQuery.expr.pseudos[i] = createButtonPseudo(i);
    // Easy API for creating new setFilters
    function setFilters() {}
    setFilters.prototype = jQuery.expr.pseudos;
    jQuery.expr.setFilters = new setFilters();
    function addCombinator(matcher, combinator, base) {
        var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
        return combinator.first ? // Check against closest ancestor/preceding element
        function(elem, context, xml) {
            while(elem = elem[dir]){
                if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
            }
            return false;
        } : // Check against all ancestor/preceding elements
        function(elem, context, xml) {
            var oldCache, outerCache, newCache = [
                dirruns,
                doneName
            ];
            // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
            if (xml) {
                while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                    if (matcher(elem, context, xml)) return true;
                }
            } else {
                while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                    outerCache = elem[jQuery.expando] || (elem[jQuery.expando] = {});
                    if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                    else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                    return newCache[2] = oldCache[2];
                    else {
                        // Reuse newcache so results back-propagate to previous elements
                        outerCache[key] = newCache;
                        // A match means we're done; a fail means we have to keep checking
                        if (newCache[2] = matcher(elem, context, xml)) return true;
                    }
                }
            }
            return false;
        };
    }
    function elementMatcher(matchers) {
        return matchers.length > 1 ? function(elem, context, xml) {
            var i = matchers.length;
            while(i--){
                if (!matchers[i](elem, context, xml)) return false;
            }
            return true;
        } : matchers[0];
    }
    function multipleContexts(selector, contexts, results) {
        var i = 0, len = contexts.length;
        for(; i < len; i++)find(selector, contexts[i], results);
        return results;
    }
    function condense(unmatched, map, filter, context, xml) {
        var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
        for(; i < len; i++){
            if (elem = unmatched[i]) {
                if (!filter || filter(elem, context, xml)) {
                    newUnmatched.push(elem);
                    if (mapped) map.push(i);
                }
            }
        }
        return newUnmatched;
    }
    function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
        if (postFilter && !postFilter[jQuery.expando]) postFilter = setMatcher(postFilter);
        if (postFinder && !postFinder[jQuery.expando]) postFinder = setMatcher(postFinder, postSelector);
        return markFunction(function(seed, results, context, xml) {
            var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
            elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                context
            ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
            matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
            if (matcher) {
                // If we have a postFinder, or filtered seed, or non-seed postFilter
                // or preexisting results,
                matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                [] : // ...otherwise use results directly
                results;
                // Find primary matches
                matcher(matcherIn, matcherOut, context, xml);
            } else matcherOut = matcherIn;
            // Apply postFilter
            if (postFilter) {
                temp = condense(matcherOut, postMap);
                postFilter(temp, [], context, xml);
                // Un-match failing elements by moving them back to matcherIn
                i = temp.length;
                while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
            }
            if (seed) {
                if (postFinder || preFilter) {
                    if (postFinder) {
                        // Get the final matcherOut by condensing this intermediate into postFinder contexts
                        temp = [];
                        i = matcherOut.length;
                        while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                        temp.push(matcherIn[i] = elem);
                        postFinder(null, matcherOut = [], temp, xml);
                    }
                    // Move matched elements from seed to results to keep them synchronized
                    i = matcherOut.length;
                    while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                }
            } else {
                matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                if (postFinder) postFinder(null, results, matcherOut, xml);
                else push.apply(results, matcherOut);
            }
        });
    }
    function matcherFromTokens(tokens) {
        var checkContext, matcher, j, len = tokens.length, leadingRelative = jQuery.expr.relative[tokens[0].type], implicitRelative = leadingRelative || jQuery.expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
        matchContext = addCombinator(function(elem) {
            return elem === checkContext;
        }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
            return indexOf.call(checkContext, elem) > -1;
        }, implicitRelative, true), matchers = [
            function(elem, context, xml) {
                // Support: IE 11+
                // IE sometimes throws a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                // Avoid hanging onto element
                // (see https://github.com/jquery/sizzle/issues/299)
                checkContext = null;
                return ret;
            }
        ];
        for(; i < len; i++)if (matcher = jQuery.expr.relative[tokens[i].type]) matchers = [
            addCombinator(elementMatcher(matchers), matcher)
        ];
        else {
            matcher = jQuery.expr.filter[tokens[i].type].apply(null, tokens[i].matches);
            // Return special upon seeing a positional matcher
            if (matcher[jQuery.expando]) {
                // Find the next relative operator (if any) for proper handling
                j = ++i;
                for(; j < len; j++){
                    if (jQuery.expr.relative[tokens[j].type]) break;
                }
                return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                tokens.slice(0, i - 1).concat({
                    value: tokens[i - 2].type === " " ? "*" : ""
                })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
            }
            matchers.push(matcher);
        }
        return elementMatcher(matchers);
    }
    function matcherFromGroupMatchers(elementMatchers, setMatchers) {
        var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
            var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
            elems = seed || byElement && jQuery.expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
            dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1;
            if (outermost) // Support: IE 11+
            // IE sometimes throws a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            outermostContext = context == document || context || outermost;
            // Add elements passing elementMatchers directly to results
            for(; (elem = elems[i]) != null; i++){
                if (byElement && elem) {
                    j = 0;
                    // Support: IE 11+
                    // IE sometimes throws a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (!context && elem.ownerDocument != document) {
                        setDocument(elem);
                        xml = !documentIsHTML;
                    }
                    while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                        push.call(results, elem);
                        break;
                    }
                    if (outermost) dirruns = dirrunsUnique;
                }
                // Track unmatched elements for set filters
                if (bySet) {
                    // They will have gone through all possible matchers
                    if (elem = !matcher && elem) matchedCount--;
                    // Lengthen the array for every element, matched or not
                    if (seed) unmatched.push(elem);
                }
            }
            // `i` is now the count of elements visited above, and adding it to `matchedCount`
            // makes the latter nonnegative.
            matchedCount += i;
            // Apply set filters to unmatched elements
            // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
            // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
            // no element matchers and no seed.
            // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
            // case, which will result in a "00" `matchedCount` that differs from `i` but is also
            // numerically zero.
            if (bySet && i !== matchedCount) {
                j = 0;
                while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                if (seed) {
                    // Reintegrate element matches to eliminate the need for sorting
                    if (matchedCount > 0) {
                        while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                    }
                    // Discard index placeholder values to get only actual matches
                    setMatched = condense(setMatched);
                }
                // Add matches to results
                push.apply(results, setMatched);
                // Seedless set matches succeeding multiple successful matchers stipulate sorting
                if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
            }
            // Override manipulation of globals by nested matchers
            if (outermost) {
                dirruns = dirrunsUnique;
                outermostContext = contextBackup;
            }
            return unmatched;
        };
        return bySet ? markFunction(superMatcher) : superMatcher;
    }
    function compile(selector, match /* Internal Use Only */ ) {
        var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
        if (!cached) {
            // Generate a function of recursive functions that can be used to check each element
            if (!match) match = tokenize(selector);
            i = match.length;
            while(i--){
                cached = matcherFromTokens(match[i]);
                if (cached[jQuery.expando]) setMatchers.push(cached);
                else elementMatchers.push(cached);
            }
            // Cache the compiled function
            cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
            // Save selector and tokenization
            cached.selector = selector;
        }
        return cached;
    }
    /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
        var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
        results = results || [];
        // Try to minimize operations if there is only one selector in the list and no seed
        // (the latter of which guarantees us context)
        if (match.length === 1) {
            // Reduce context if the leading compound selector is an ID
            tokens = match[0] = match[0].slice(0);
            if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && jQuery.expr.relative[tokens[1].type]) {
                context = (jQuery.expr.find.ID(unescapeSelector(token.matches[0]), context) || [])[0];
                if (!context) return results;
                else if (compiled) context = context.parentNode;
                selector = selector.slice(tokens.shift().value.length);
            }
            // Fetch a seed set for right-to-left matching
            i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
            while(i--){
                token = tokens[i];
                // Abort if we hit a combinator
                if (jQuery.expr.relative[type = token.type]) break;
                if (find = jQuery.expr.find[type]) // Search, expanding context for leading sibling combinators
                {
                    if (seed = find(unescapeSelector(token.matches[0]), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                        // If seed is empty or no tokens remain, we can return early
                        tokens.splice(i, 1);
                        selector = seed.length && toSelector(tokens);
                        if (!selector) {
                            push.apply(results, seed);
                            return results;
                        }
                        break;
                    }
                }
            }
        }
        // Compile and execute a filtering function if one is not provided
        // Provide `match` to avoid retokenization if we modified the selector above
        (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
        return results;
    }
    // Initialize against the default document
    setDocument();
    jQuery.find = find;
    // These have always been private, but they used to be documented as part of
    // Sizzle so let's maintain them for now for backwards compatibility purposes.
    find.compile = compile;
    find.select = select;
    find.setDocument = setDocument;
    find.tokenize = tokenize;
    function dir(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    }
    function siblings(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    }
    var rneedsContext = jQuery.expr.match.needsContext;
    // rsingleTag matches a string consisting of a single HTML element with no attributes
    // and captures the element's name
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    function isObviousHtml(input) {
        return input[0] === "<" && input[input.length - 1] === ">" && input.length >= 3;
    }
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (typeof qualifier === "function") return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // HANDLE: $(DOMElement)
        if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (typeof selector === "function") return rootjQuery.ready !== undefined ? rootjQuery.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        else {
            // Handle obvious HTML strings
            match = selector + "";
            if (isObviousHtml(match)) // Assume that strings that start and end with <> are HTML and skip
            // the regex check. This also handles browser-supported HTML wrappers
            // like TrustedHTML.
            match = [
                null,
                selector,
                null
            ];
            else if (typeof selector === "string") match = rquickExpr.exec(selector);
            else return jQuery.makeArray(selector, this);
            // Match html or make sure no context is specified for #id
            // Note: match[1] may be a string or a TrustedHTML wrapper
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document$1, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (typeof this[match] === "function") this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document$1.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || rootjQuery).find(selector);
            else return this.constructor(context).find(selector);
        }
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document$1);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11+
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (typeof arg === "function") {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && typeof (method = value.promise) === "function") method.call(value).done(resolve).fail(reject);
            else if (value && typeof (method = value.then) === "function") method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            reject(value);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                catch: function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = typeof fns[tuple[4]] === "function" && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && typeof returned.promise === "function") returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (typeof then === "function") {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, typeof onProgress === "function" ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, typeof onFulfilled === "function" ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, typeof onRejected === "function" ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || typeof (resolveValues[i] && resolveValues[i].then) === "function") return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        if (error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception", error, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document$1, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document$1.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    if (document$1.readyState !== "loading") // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document$1.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Matches dashed string for camelizing
    var rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase
    function camelCase(string) {
        return string.replace(rdashAlpha, fcamelCase);
    }
    /**
 * Determines whether an object can have data
 */ function acceptData(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    }
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = Object.create(null);
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return value;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45+
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11+
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.set(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.set(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    // isHiddenWithinTree reports if an element has a non-"none" display style (inline and/or
    // through the CSS cascade), which is useful in deciding whether or not to make it visible.
    // It differs from the :hidden selector (jQuery.expr.pseudos.hidden) in two important ways:
    // * A hidden ancestor does not force an element to be classified as hidden.
    // * Being disconnected from the document does not force an element to be classified as hidden.
    // These differences improve the behavior of .toggle() et al. when applied to elements that are
    // detached or contained within hidden ancestors (gh-2404, gh-2863).
    function isHiddenWithinTree(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && jQuery.css(elem, "display") === "none";
    }
    var ralphaStart = /^[a-z]/, // The regex visualized:
    //
    //                         /----------\
    //                        |            |    /-------\
    //                        |  / Top  \  |   |         |
    //         /--- Border ---+-| Right  |-+---+- Width -+---\
    //        |                 | Bottom |                    |
    //        |                  \ Left /                     |
    //        |                                               |
    //        |                              /----------\     |
    //        |          /-------------\    |            |    |- END
    //        |         |               |   |  / Top  \  |    |
    //        |         |  / Margin  \  |   | | Right  | |    |
    //        |---------+-|           |-+---+-| Bottom |-+----|
    //        |            \ Padding /         \ Left /       |
    // BEGIN -|                                               |
    //        |                /---------\                    |
    //        |               |           |                   |
    //        |               |  / Min \  |    / Width  \     |
    //         \--------------+-|       |-+---|          |---/
    //                           \ Max /       \ Height /
    rautoPx = /^(?:Border(?:Top|Right|Bottom|Left)?(?:Width|)|(?:Margin|Padding)?(?:Top|Right|Bottom|Left)?|(?:Min|Max)?(?:Width|Height))$/;
    function isAutoPx(prop) {
        // The first test is used to ensure that:
        // 1. The prop starts with a lowercase letter (as we uppercase it for the second regex).
        // 2. The prop is not empty.
        return ralphaStart.test(prop) && rautoPx.test(prop[0].toUpperCase() + prop.slice(1));
    }
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (isAutoPx(prop) ? "px" : ""), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (!isAutoPx(prop) || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54 - 66+
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/;
    // Convert dashed to camelCase, handle vendor prefixes.
    // Used by the css & effects modules.
    // Support: IE <=9 - 11+
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function cssCamelCase(string) {
        return camelCase(string.replace(rmsPrefix, "ms-"));
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+
    // Check attachment across shadow DOM boundaries when possible (gh-3504).
    // Provide a fallback for browsers without Shadow DOM v1 support.
    if (!documentElement$1.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    };
    // rtagName captures the name from the first start tag in a string of HTML
    // https://html.spec.whatwg.org/multipage/syntax.html#tag-open-state
    // https://html.spec.whatwg.org/multipage/syntax.html#tag-name-state
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var wrapMap = {
        // Table parts need to be wrapped with `<table>` or they're
        // stripped to their contents when put in a div.
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do, so we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            "table"
        ],
        col: [
            "colgroup",
            "table"
        ],
        tr: [
            "tbody",
            "table"
        ],
        td: [
            "tr",
            "tbody",
            "table"
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    function getAll(context, tag) {
        // Support: IE <=9 - 11+
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") // Use slice to snapshot the live collection from gEBTN
        ret = arr.slice.call(context.getElementsByTagName(tag || "*"));
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object" && (elem.nodeType || isArrayLike(elem))) jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || arr;
                    // Create wrappers & descend into them.
                    j = wrap.length;
                    while(--j > -1)tmp = tmp.appendChild(context.createElement(wrap[j]));
                    tmp.innerHTML = jQuery.htmlPrefilter(elem);
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = typeof value === "function";
        if (valueIsFunction) return collection.each(function(index) {
            var self = collection.eq(index);
            args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.get(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce,
                                    crossOrigin: node.crossOrigin
                                }, doc);
                            } else DOMEval(node.textContent, node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement$1, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: Firefox <=42 - 66+
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11+
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: typeof hook === "function" ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: jQuery.extend(Object.create(null), {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    if (event.result !== undefined) // Setting `event.originalEvent.returnValue` in modern
                    // browsers does the same as just calling `preventDefault()`,
                    // the browsers ignore the value anyway.
                    // Incidentally, IE 11 is the only browser from our supported
                    // ones which respects the value returned from a `beforeunload`
                    // handler attached by `addEventListener`; other browsers do
                    // so only for inline handlers, so not setting the value
                    // directly shouldn't reduce any functionality.
                    event.preventDefault();
                }
            }
        })
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                // This controller function is invoked under multiple circumstances,
                // differentiated by the stored value in `saved`:
                // 1. For an outer synthetic `.trigger()`ed event (detected by
                //    `event.isTrigger & 1` and non-array `saved`), it records arguments
                //    as an array and fires an [inner] native event to prompt state
                //    changes that should be observed by registered listeners (such as
                //    checkbox toggling and focus updating), then clears the stored value.
                // 2. For an [inner] native event (detected by `saved` being
                //    an array), it triggers an inner synthetic event, records the
                //    result, and preempts propagation to further jQuery listeners.
                // 3. For an inner synthetic event (detected by `event.isTrigger & 1` and
                //    array `saved`), it prevents double-propagation of surrogate events
                //    but otherwise allows everything to proceed (particularly including
                //    further listeners).
                // Possible `saved` data shapes: `[...], `{ value }`, `false`.
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved.length) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object),
                        // so this array will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            // Support: Chrome 86+
                            // In Chrome, if an element having a focusout handler is
                            // blurred by clicking outside of it, it invokes the handler
                            // synchronously. If that handler calls `.remove()` on
                            // the element, the data is cleared, leaving `result`
                            // undefined. We need to guard against this.
                            return result && result.value;
                        }
                    // If this is an inner synthetic event for an event with a bubbling
                    // surrogate (focus or blur), assume that the surrogate already
                    // propagated from triggering the native event and prevent that
                    // from happening again here.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order.
                // Fire an inner synthetic event with the original arguments.
                } else if (saved.length) {
                    // ...and capture the result
                    dataPriv.set(this, type, {
                        value: jQuery.event.trigger(saved[0], saved.slice(1), this)
                    });
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented ? returnTrue : returnFalse;
            // Create target properties
            this.target = src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        // Support: IE 11+
        // Attach a single focusin/focusout handler on the document while someone wants focus/blur.
        // This is because the former are synchronous in IE while the latter are async. In other
        // browsers, all those handlers are invoked synchronously.
        function focusMappedHandler(nativeEvent) {
            // `eventHandle` would already wrap the event, but we need to change the `type` here.
            var event = jQuery.event.fix(nativeEvent);
            event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
            event.isSimulated = true;
            // focus/blur don't bubble while focusin/focusout do; simulate the former by only
            // invoking the handler at the lower level.
            if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
            // `jQuery.event.add`, so event handle will already have been set
            // by this point.
            dataPriv.get(this, "handle")(event);
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (isIE) this.addEventListener(delegateType, focusMappedHandler);
                else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                if (isIE) this.removeEventListener(delegateType, focusMappedHandler);
                else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11+
    // In IE using regex groups here causes severe slowdowns.
    rnoInnerhtml = /<script|<style|<link/i;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var type, i, l, events = dataPriv.get(src, "events");
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (events) {
            dataPriv.remove(dest, "handle events");
            for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) dataUser.set(dest, jQuery.extend({}, dataUser.get(src)));
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (isIE && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)// Support: IE <=11+
                // IE fails to set the defaultValue to the correct value when
                // cloning textareas.
                if (nodeName(destElements[i], "textarea")) destElements[i].defaultValue = srcElements[i].defaultValue;
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                push.apply(ret, elems);
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    function getStyles(elem) {
        // Support: IE <=11+ (trac-14150)
        // In IE popup's `window` is the opener window which makes `window.getComputedStyle( elem )`
        // break. Using `elem.ownerDocument.defaultView` avoids the issue.
        var view = elem.ownerDocument.defaultView;
        // `document.implementation.createHTMLDocument( "" )` has a `null` `defaultView`
        // property; check `defaultView` truthiness to fallback to window in such a case.
        if (!view) view = window1;
        return view.getComputedStyle(elem);
    }
    // A method for quickly swapping in/out CSS properties to get correct calculations.
    function swap(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    }
    function curCSS(elem, name, computed) {
        var ret, isCustomProp = rcustomProp.test(name);
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for `.css('--customProperty')` (gh-3144)
        if (computed) {
            // A fallback to direct property access is needed as `computed`, being
            // the output of `getComputedStyle`, contains camelCased keys and
            // `getPropertyValue` requires kebab-case ones.
            //
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105 - 135+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
        }
        return ret !== undefined ? // Support: IE <=9 - 11+
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document$1.createElement("div").style;
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped vendor prefixed property
    function finalPropName(name) {
        if (name in emptyStyle) return name;
        return vendorPropName(name) || name;
    }
    var reliableTrDimensionsVal, reliableColDimensionsVal, table = document$1.createElement("table");
    // Executing table tests requires only one layout, so they're executed
    // at the same time to save the second computation.
    function computeTableStyleTests() {
        if (// This is a singleton, we need to execute it only once
        !table || // Finish early in limited (non-browser) environments
        !table.style) return;
        var trStyle, col = document$1.createElement("col"), tr = document$1.createElement("tr"), td = document$1.createElement("td");
        table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate;border-spacing:0";
        tr.style.cssText = "box-sizing:content-box;border:1px solid;height:1px";
        td.style.cssText = "height:9px;width:9px;padding:0";
        col.span = 2;
        documentElement$1.appendChild(table).appendChild(col).parentNode.appendChild(tr).appendChild(td).parentNode.appendChild(td.cloneNode(true));
        // Don't run until window is visible
        if (table.offsetWidth === 0) {
            documentElement$1.removeChild(table);
            return;
        }
        trStyle = window1.getComputedStyle(tr);
        // Support: Firefox 135+
        // Firefox always reports computed width as if `span` was 1.
        // Support: Safari 18.3+
        // In Safari, computed width for columns is always 0.
        // In both these browsers, using `offsetWidth` solves the issue.
        // Support: IE 11+
        // In IE, `<col>` computed width is `"auto"` unless `width` is set
        // explicitly via CSS so measurements there remain incorrect. Because of
        // the lack of a proper workaround, we accept this limitation, treating
        // IE as passing the test.
        reliableColDimensionsVal = isIE || Math.round(parseFloat(window1.getComputedStyle(col).width)) === 18;
        // Support: IE 10 - 11+
        // IE misreports `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Support: Firefox 70 - 135+
        // Only Firefox includes border widths
        // in computed dimensions for table rows. (gh-4529)
        reliableTrDimensionsVal = Math.round(parseFloat(trStyle.height) + parseFloat(trStyle.borderTopWidth) + parseFloat(trStyle.borderBottomWidth)) === tr.offsetHeight;
        documentElement$1.removeChild(table);
        // Nullify the table so it wouldn't be stored in the memory;
        // it will also be a sign that checks were already performed.
        table = null;
    }
    jQuery.extend(support, {
        reliableTrDimensions: function() {
            computeTableStyleTests();
            return reliableTrDimensionsVal;
        },
        reliableColDimensions: function() {
            computeTableStyleTests();
            return reliableColDimensionsVal;
        }
    });
    var cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = isIE || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        if (// Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        (val === "auto" || // Support: IE 9 - 11+
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        isIE && isBorderBox || !support.reliableColDimensions() && nodeName(elem, "col") || !support.reliableTrDimensions() && nodeName(elem, "tr")) && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = cssCamelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If the value is a number, add `px` for certain CSS properties
                if (type === "number") value += ret && ret[3] || (isAutoPx(origName) ? "px" : "");
                // Support: IE <=9 - 11+
                // background-* props of a cloned element affect the source element (trac-8908)
                if (isIE && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = cssCamelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Elements with `display: none` can have dimension info if
                // we invisibly show them.
                return jQuery.css(elem, "display") === "none" ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                isBorderBox = extra && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (isAutoPx(prop) ? "px" : "");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document$1.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, 13);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11+
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.set(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                // eslint-disable-next-line no-loop-func
                anim.done(function() {
                    // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = cssCamelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), percent = 1 - (remaining / animation.duration || 0), index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (typeof result.stop === "function") jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (typeof animation.opts.start === "function") animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (typeof props === "function") {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || easing || typeof speed === "function" && speed,
            duration: speed,
            easing: fn && easing || easing && typeof easing !== "function" && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (typeof opt.old === "function") opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11+
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = elem.getAttribute("tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || // href-less anchor's `tabIndex` property value is `0` and
                    // the `tabindex` attribute value: `null`. We want `-1`.
                    rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11+
    // Accessing the selectedIndex property forces the browser to respect
    // setting selected on the option. The getter ensures a default option
    // is selected when in an optgroup. ESLint rule "no-unused-expressions"
    // is disabled for this code since it considers such accessions noop.
    if (isIE) jQuery.propHooks.selected = {
        get: function(elem) {
            var parent = elem.parentNode;
            if (parent && parent.parentNode) // eslint-disable-next-line no-unused-expressions
            parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            var parent = elem.parentNode;
            if (parent) {
                // eslint-disable-next-line no-unused-expressions
                parent.selectedIndex;
                if (parent.parentNode) // eslint-disable-next-line no-unused-expressions
                parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (typeof value === "function") return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (typeof value === "function") return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self;
            if (typeof value === "function") return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean") return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                // Toggle individual class names
                self = jQuery(this);
                for(i = 0; i < classNames.length; i++){
                    className = classNames[i];
                    // Check each className given, space separated list
                    if (self.hasClass(className)) self.removeClass(className);
                    else self.addClass(className);
                }
            });
            return this;
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = typeof value === "function";
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        if (option.selected && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        if (option.selected = jQuery.inArray(jQuery(option).val(), values) > -1) optionSet = true;
                    }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    if (isIE) jQuery.valHooks.option = {
        get: function(elem) {
            var val = elem.getAttribute("value");
            return val != null ? val : // Support: IE <=10 - 11+
            // option.text throws exceptions (trac-14686, trac-14858)
            // Strip and collapse whitespace
            // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
            stripAndCollapse(jQuery.text(elem));
        }
    };
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
    });
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document$1
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document$1;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document$1)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && typeof elem[type] === "function" && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11+
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = typeof valueOrFunction === "function" ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document$1.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (typeof func === "function") {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))// Support: IE 11+
                            // `getResponseHeader( key )` in IE doesn't combine all header
                            // values for the provided key into a single result with values
                            // joined by commas as other browsers do. Instead, it returns
                            // them on separate lines.
                            responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document$1.createElement("a");
                // Support: IE <=8 - 11+
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11+
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an ESM-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted.
            // Handle the null callback placeholder.
            if (typeof data === "function" || data === null) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            scriptAttrs: options.crossOrigin ? {
                "crossOrigin": options.crossOrigin
            } : undefined,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (typeof html === "function") html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (typeof html === "function") return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = typeof html === "function";
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        return new window1.XMLHttpRequest();
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200
    };
    jQuery.ajaxTransport(function(options) {
        var callback;
        return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                            xhr.status, xhr.statusText);
                            else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") === "text" ? {
                                text: xhr.responseText
                            } : {
                                binary: xhr.response
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                xhr.onabort = xhr.onerror = xhr.ontimeout = callback("error");
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    function canUseScriptTag(s) {
        // A script tag can only be used for async, cross domain or forced-by-attrs requests.
        // Requests with headers cannot use a script tag. However, when both `scriptAttrs` &
        // `headers` options are specified, both are impossible to satisfy together; we
        // prefer `scriptAttrs` then.
        // Sync requests remain handled differently to preserve strict script ordering.
        return s.scriptAttrs || !s.headers && (s.crossDomain || // When dealing with JSONP (`s.dataTypes` include "json" then)
        // don't use a script tag so that error responses still may have
        // `responseJSON` set. Continue using a script tag for JSONP requests that:
        //   * are cross-domain as AJAX requests won't work without a CORS setup
        //   * have `scriptAttrs` set as that's a script-only functionality
        // Note that this means JSONP requests violate strict CSP script-src settings.
        // A proper solution is to migrate from using JSONP to a CORS setup.
        s.async && jQuery.inArray("json", s.dataTypes) < 0);
    }
    // Install script dataType. Don't specify `contents.script` so that an explicit
    // `dataType: "script"` is required (see gh-2432, gh-4822)
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        // These types of requests are handled via a script tag
        // so force their methods to GET.
        if (canUseScriptTag(s)) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        if (canUseScriptTag(s)) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document$1.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Get callback name, remembering preexisting value associated with it
        callbackName = s.jsonpCallback = typeof s.jsonpCallback === "function" ? s.jsonpCallback() : s.jsonpCallback;
        // Insert callback into url or form data
        if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
        else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
        // Use data converter to retrieve json after script execution
        s.converters["script json"] = function() {
            if (!responseContainer) jQuery.error(callbackName + " was not called");
            return responseContainer[0];
        };
        // Force json dataType
        s.dataTypes[0] = "json";
        // Install callback
        overwritten = window1[callbackName];
        window1[callbackName] = function() {
            responseContainer = arguments;
        };
        // Clean-up function (fires after converters)
        jqXHR.always(function() {
            // If previous value didn't exist - remove it
            if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
            else window1[callbackName] = overwritten;
            // Save back as free
            if (s[callbackName]) {
                // Make sure that re-using the options doesn't screw things around
                s.jsonpCallback = originalSettings.jsonpCallback;
                // Save the callback name for future use
                oldCallbacks.push(callbackName);
            }
            // Call if it was a function and we have a response
            if (responseContainer && typeof overwritten === "function") overwritten(responseContainer[0]);
            responseContainer = overwritten = undefined;
        });
        // Delegate to script
        return "script";
    });
    jQuery.ajaxPrefilter(function(s, origOptions) {
        // Binary data needs to be passed to XHR as-is without stringification.
        if (typeof s.data !== "string" && !jQuery.isPlainObject(s.data) && !Array.isArray(s.data) && // Don't disable data processing if explicitly set by the user.
        !("processData" in origOptions)) s.processData = false;
        // `Content-Type` for requests with `FormData` bodies needs to be set
        // by the browser as it needs to append the `boundary` it generated.
        if (s.data instanceof window1.FormData) s.contentType = false;
    });
    // Argument "data" should be string of html or a TrustedHTML wrapper of obvious HTML
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string" && !isObviousHtml(data + "")) return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var parsed, scripts;
        if (!context) // Stop scripts or inline event handlers from being executed immediately
        // by using DOMParser
        context = new window1.DOMParser().parseFromString("", "text/html");
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (typeof params === "function") {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (typeof options === "function") // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11+
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && offsetParent !== doc.documentElement && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent || doc.documentElement;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 && jQuery.css(offsetParent, "position") !== "static") {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement$1;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (typeof fn !== "function") return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.expr[":"] = jQuery.expr.filters = jQuery.expr.pseudos;
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, gh-557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRegister("63jfO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $44bb6d473543b89d$export$2e2bcd8739ae039);
/*! DataTables 2.3.8
 * © SpryMedia Ltd - datatables.net/license
 */ 
var $iUSsr = parcelRequire("iUSsr");
// DataTables code uses $ internally, but we want to be able to
// reassign $ with the `use` method, so it is a regular var.
var $44bb6d473543b89d$var$$ = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)));
var $44bb6d473543b89d$var$DataTable = function(selector, options) {
    // Check if called with a window or jQuery object for DOM less applications
    // This is for backwards compatibility
    if ($44bb6d473543b89d$var$DataTable.factory(selector, options)) return $44bb6d473543b89d$var$DataTable;
    // When creating with `new`, create a new DataTable, returning the API instance
    if (this instanceof $44bb6d473543b89d$var$DataTable) return $44bb6d473543b89d$var$$(selector).DataTable(options);
    else // Argument switching
    options = selector;
    var _that = this;
    var emptyInit = options === undefined;
    var len = this.length;
    if (emptyInit) options = {};
    // Method to get DT API instance from jQuery object
    this.api = function() {
        return new $44bb6d473543b89d$var$_Api(this);
    };
    this.each(function() {
        // For each initialisation we want to give it a clean initialisation
        // object that can be bashed around
        var o = {};
        var oInit = len > 1 ? $44bb6d473543b89d$var$_fnExtend(o, options, true) : options;
        var i = 0, iLen;
        var sId = this.getAttribute('id');
        var defaults = $44bb6d473543b89d$var$DataTable.defaults;
        var $this = $44bb6d473543b89d$var$$(this);
        // Sanity check
        if (this.nodeName.toLowerCase() != 'table') {
            $44bb6d473543b89d$var$_fnLog(null, 0, 'Non-table node initialisation (' + this.nodeName + ')', 2);
            return;
        }
        // Special case for options
        if (oInit.on && oInit.on.options) $44bb6d473543b89d$var$_fnListener($this, 'options', oInit.on.options);
        $this.trigger('options.dt', oInit);
        /* Backwards compatibility for the defaults */ $44bb6d473543b89d$var$_fnCompatOpts(defaults);
        $44bb6d473543b89d$var$_fnCompatCols(defaults.column);
        /* Convert the camel-case defaults to Hungarian */ $44bb6d473543b89d$var$_fnCamelToHungarian(defaults, defaults, true);
        $44bb6d473543b89d$var$_fnCamelToHungarian(defaults.column, defaults.column, true);
        /* Setting up the initialisation object */ $44bb6d473543b89d$var$_fnCamelToHungarian(defaults, $44bb6d473543b89d$var$$.extend(oInit, $44bb6d473543b89d$var$_fnEscapeObject($this.data())), true);
        /* Check to see if we are re-initialising a table */ var allSettings = $44bb6d473543b89d$var$DataTable.settings;
        for(i = 0, iLen = allSettings.length; i < iLen; i++){
            var s = allSettings[i];
            /* Base check on table node */ if (s.nTable == this || s.nTHead && s.nTHead.parentNode == this || s.nTFoot && s.nTFoot.parentNode == this) {
                var bRetrieve = oInit.bRetrieve !== undefined ? oInit.bRetrieve : defaults.bRetrieve;
                var bDestroy = oInit.bDestroy !== undefined ? oInit.bDestroy : defaults.bDestroy;
                if (emptyInit || bRetrieve) return s.oInstance;
                else if (bDestroy) {
                    new $44bb6d473543b89d$var$DataTable.Api(s).destroy();
                    break;
                } else {
                    $44bb6d473543b89d$var$_fnLog(s, 0, 'Cannot reinitialise DataTable', 3);
                    return;
                }
            }
            /* If the element we are initialising has the same ID as a table which was previously
			 * initialised, but the table nodes don't match (from before) then we destroy the old
			 * instance by simply deleting it. This is under the assumption that the table has been
			 * destroyed by other methods. Anyone using non-id selectors will need to do this manually
			 */ if (s.sTableId == this.id) {
                allSettings.splice(i, 1);
                break;
            }
        }
        /* Ensure the table has an ID - required for accessibility */ if (sId === null || sId === "") {
            sId = "DataTables_Table_" + $44bb6d473543b89d$var$DataTable.ext._unique++;
            this.id = sId;
        }
        // Replacing an existing colgroup with our own. Not ideal, but a merge could take a lot of code
        $this.children('colgroup').remove();
        /* Create the settings object for this table and set some of the default parameters */ var oSettings = $44bb6d473543b89d$var$$.extend(true, {}, $44bb6d473543b89d$var$DataTable.models.oSettings, {
            "sDestroyWidth": $this[0].style.width,
            "sInstance": sId,
            "sTableId": sId,
            colgroup: $44bb6d473543b89d$var$$('<colgroup>'),
            fastData: function(row, column, type) {
                return $44bb6d473543b89d$var$_fnGetCellData(oSettings, row, column, type);
            }
        });
        oSettings.nTable = this;
        oSettings.oInit = oInit;
        allSettings.push(oSettings);
        // Make a single API instance available for internal handling
        oSettings.api = new $44bb6d473543b89d$var$_Api(oSettings);
        // Need to add the instance after the instance after the settings object has been added
        // to the settings array, so we can self reference the table instance if more than one
        oSettings.oInstance = _that.length === 1 ? _that : $this.dataTable();
        // Backwards compatibility, before we apply all the defaults
        $44bb6d473543b89d$var$_fnCompatOpts(oInit);
        // If the length menu is given, but the init display length is not, use the length menu
        if (oInit.aLengthMenu && !oInit.iDisplayLength) oInit.iDisplayLength = Array.isArray(oInit.aLengthMenu[0]) ? oInit.aLengthMenu[0][0] : $44bb6d473543b89d$var$$.isPlainObject(oInit.aLengthMenu[0]) ? oInit.aLengthMenu[0].value : oInit.aLengthMenu[0];
        // Apply the defaults and init options to make a single init object will all
        // options defined from defaults and instance options.
        oInit = $44bb6d473543b89d$var$_fnExtend($44bb6d473543b89d$var$$.extend(true, {}, defaults), oInit);
        // Map the initialisation options onto the settings object
        $44bb6d473543b89d$var$_fnMap(oSettings.oFeatures, oInit, [
            "bPaginate",
            "bLengthChange",
            "bFilter",
            "bSort",
            "bSortMulti",
            "bInfo",
            "bProcessing",
            "bAutoWidth",
            "bSortClasses",
            "bServerSide",
            "bDeferRender"
        ]);
        $44bb6d473543b89d$var$_fnMap(oSettings, oInit, [
            "ajax",
            "fnFormatNumber",
            "sServerMethod",
            "aaSorting",
            "aaSortingFixed",
            "aLengthMenu",
            "sPaginationType",
            "iStateDuration",
            "bSortCellsTop",
            "iTabIndex",
            "sDom",
            "fnStateLoadCallback",
            "fnStateSaveCallback",
            "renderer",
            "searchDelay",
            "rowId",
            "caption",
            "layout",
            "orderDescReverse",
            "orderIndicators",
            "orderHandler",
            "titleRow",
            "typeDetect",
            "columnTitleTag",
            [
                "iCookieDuration",
                "iStateDuration"
            ],
            [
                "oSearch",
                "oPreviousSearch"
            ],
            [
                "aoSearchCols",
                "aoPreSearchCols"
            ],
            [
                "iDisplayLength",
                "_iDisplayLength"
            ]
        ]);
        $44bb6d473543b89d$var$_fnMap(oSettings.oScroll, oInit, [
            [
                "sScrollX",
                "sX"
            ],
            [
                "sScrollXInner",
                "sXInner"
            ],
            [
                "sScrollY",
                "sY"
            ],
            [
                "bScrollCollapse",
                "bCollapse"
            ]
        ]);
        $44bb6d473543b89d$var$_fnMap(oSettings.oLanguage, oInit, "fnInfoCallback");
        /* Callback functions which are array driven */ $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoDrawCallback', oInit.fnDrawCallback);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoStateSaveParams', oInit.fnStateSaveParams);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoStateLoadParams', oInit.fnStateLoadParams);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoStateLoaded', oInit.fnStateLoaded);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoRowCallback', oInit.fnRowCallback);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoRowCreatedCallback', oInit.fnCreatedRow);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoHeaderCallback', oInit.fnHeaderCallback);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoFooterCallback', oInit.fnFooterCallback);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoInitComplete', oInit.fnInitComplete);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoPreDrawCallback', oInit.fnPreDrawCallback);
        oSettings.rowIdFn = $44bb6d473543b89d$var$_fnGetObjectDataFn(oInit.rowId);
        // Add event listeners
        if (oInit.on) Object.keys(oInit.on).forEach(function(key) {
            $44bb6d473543b89d$var$_fnListener($this, key, oInit.on[key]);
        });
        /* Browser support detection */ $44bb6d473543b89d$var$_fnBrowserDetect(oSettings);
        var oClasses = oSettings.oClasses;
        $44bb6d473543b89d$var$$.extend(oClasses, $44bb6d473543b89d$var$DataTable.ext.classes, oInit.oClasses);
        $this.addClass(oClasses.table);
        if (!oSettings.oFeatures.bPaginate) oInit.iDisplayStart = 0;
        if (oSettings.iInitDisplayStart === undefined) {
            /* Display start point, taking into account the save saving */ oSettings.iInitDisplayStart = oInit.iDisplayStart;
            oSettings._iDisplayStart = oInit.iDisplayStart;
        }
        var defer = oInit.iDeferLoading;
        if (defer !== null) {
            oSettings.deferLoading = true;
            var tmp = Array.isArray(defer);
            oSettings._iRecordsDisplay = tmp ? defer[0] : defer;
            oSettings._iRecordsTotal = tmp ? defer[1] : defer;
        }
        /*
		 * Columns
		 * See if we should load columns automatically or use defined ones
		 */ var columnsInit = [];
        var thead = this.getElementsByTagName('thead');
        var initHeaderLayout = $44bb6d473543b89d$var$_fnDetectHeader(oSettings, thead[0]);
        // If we don't have a columns array, then generate one with nulls
        if (oInit.aoColumns) columnsInit = oInit.aoColumns;
        else if (initHeaderLayout.length) for(i = 0, iLen = initHeaderLayout[0].length; i < iLen; i++)columnsInit.push(null);
        // Add the columns
        for(i = 0, iLen = columnsInit.length; i < iLen; i++)$44bb6d473543b89d$var$_fnAddColumn(oSettings);
        // Apply the column definitions
        $44bb6d473543b89d$var$_fnApplyColumnDefs(oSettings, oInit.aoColumnDefs, columnsInit, initHeaderLayout, function(iCol, oDef) {
            $44bb6d473543b89d$var$_fnColumnOptions(oSettings, iCol, oDef);
        });
        /* HTML5 attribute detection - build an mData object automatically if the
		 * attributes are found
		 */ var rowOne = $this.children('tbody').find('tr:first-child').eq(0);
        if (rowOne.length) {
            var a = function(cell, name) {
                return cell.getAttribute('data-' + name) !== null ? name : null;
            };
            $44bb6d473543b89d$var$$(rowOne[0]).children('th, td').each(function(i, cell) {
                var col = oSettings.aoColumns[i];
                if (!col) $44bb6d473543b89d$var$_fnLog(oSettings, 0, 'Incorrect column count', 18);
                if (col.mData === i) {
                    var sort = a(cell, 'sort') || a(cell, 'order');
                    var filter = a(cell, 'filter') || a(cell, 'search');
                    if (sort !== null || filter !== null) {
                        col.mData = {
                            _: i + '.display',
                            sort: sort !== null ? i + '.@data-' + sort : undefined,
                            type: sort !== null ? i + '.@data-' + sort : undefined,
                            filter: filter !== null ? i + '.@data-' + filter : undefined
                        };
                        col._isArrayHost = true;
                        $44bb6d473543b89d$var$_fnColumnOptions(oSettings, i);
                    }
                }
            });
        }
        // Must be done after everything which can be overridden by the state saving!
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoDrawCallback', $44bb6d473543b89d$var$_fnSaveState);
        var features = oSettings.oFeatures;
        if (oInit.bStateSave) features.bStateSave = true;
        // If aaSorting is not defined, then we use the first indicator in asSorting
        // in case that has been altered, so the default sort reflects that option
        if (oInit.aaSorting === undefined) {
            var sorting = oSettings.aaSorting;
            for(i = 0, iLen = sorting.length; i < iLen; i++)sorting[i][1] = oSettings.aoColumns[i].asSorting[0];
        }
        // Do a first pass on the sorting classes (allows any size changes to be taken into
        // account, and also will apply sorting disabled classes if disabled
        $44bb6d473543b89d$var$_fnSortingClasses(oSettings);
        $44bb6d473543b89d$var$_fnCallbackReg(oSettings, 'aoDrawCallback', function() {
            if (oSettings.bSorted || $44bb6d473543b89d$var$_fnDataSource(oSettings) === 'ssp' || features.bDeferRender) $44bb6d473543b89d$var$_fnSortingClasses(oSettings);
        });
        /*
		 * Table HTML init
		 * Cache the header, body and footer as required, creating them if needed
		 */ var caption = $this.children('caption');
        if (oSettings.caption) {
            if (caption.length === 0) caption = $44bb6d473543b89d$var$$('<caption/>').prependTo($this);
            caption.html(oSettings.caption);
        }
        // Store the caption side, so we can remove the element from the document
        // when creating the element
        if (caption.length) {
            caption[0]._captionSide = caption.css('caption-side');
            oSettings.captionNode = caption[0];
        }
        // Place the colgroup element in the correct location for the HTML structure
        if (caption.length) oSettings.colgroup.insertAfter(caption);
        else oSettings.colgroup.prependTo(oSettings.nTable);
        if (thead.length === 0) thead = $44bb6d473543b89d$var$$('<thead/>').appendTo($this);
        oSettings.nTHead = thead[0];
        var tbody = $this.children('tbody');
        if (tbody.length === 0) tbody = $44bb6d473543b89d$var$$('<tbody/>').insertAfter(thead);
        oSettings.nTBody = tbody[0];
        var tfoot = $this.children('tfoot');
        if (tfoot.length === 0) // If we are a scrolling table, and no footer has been given, then we need to create
        // a tfoot element for the caption element to be appended to
        tfoot = $44bb6d473543b89d$var$$('<tfoot/>').appendTo($this);
        oSettings.nTFoot = tfoot[0];
        // Copy the data index array
        oSettings.aiDisplay = oSettings.aiDisplayMaster.slice();
        // Initialisation complete - table can be drawn
        oSettings.bInitialised = true;
        // Language definitions
        var oLanguage = oSettings.oLanguage;
        $44bb6d473543b89d$var$$.extend(true, oLanguage, oInit.oLanguage);
        if (oLanguage.sUrl) // Get the language definitions from a file
        $44bb6d473543b89d$var$$.ajax({
            dataType: 'json',
            url: oLanguage.sUrl,
            success: function(json) {
                $44bb6d473543b89d$var$_fnCamelToHungarian(defaults.oLanguage, json);
                $44bb6d473543b89d$var$$.extend(true, oLanguage, json, oSettings.oInit.oLanguage);
                $44bb6d473543b89d$var$_fnCallbackFire(oSettings, null, 'i18n', [
                    oSettings
                ], true);
                $44bb6d473543b89d$var$_fnInitialise(oSettings);
            },
            error: function() {
                // Error occurred loading language file
                $44bb6d473543b89d$var$_fnLog(oSettings, 0, 'i18n file loading error', 21);
                // Continue on as best we can
                $44bb6d473543b89d$var$_fnInitialise(oSettings);
            }
        });
        else {
            $44bb6d473543b89d$var$_fnCallbackFire(oSettings, null, 'i18n', [
                oSettings
            ], true);
            $44bb6d473543b89d$var$_fnInitialise(oSettings);
        }
    });
    _that = null;
    return this;
};
/**
 * DataTables extensions
 * 
 * This namespace acts as a collection area for plug-ins that can be used to
 * extend DataTables capabilities. Indeed many of the build in methods
 * use this method to provide their own capabilities (sorting methods for
 * example).
 *
 * Note that this namespace is aliased to `jQuery.fn.dataTableExt` for legacy
 * reasons
 *
 *  @namespace
 */ $44bb6d473543b89d$var$DataTable.ext = $44bb6d473543b89d$var$_ext = {
    /**
	 * DataTables build type (expanded by the download builder)
	 *
	 *  @type string
	 */ builder: "-source-",
    /**
	 * Buttons. For use with the Buttons extension for DataTables. This is
	 * defined here so other extensions can define buttons regardless of load
	 * order. It is _not_ used by DataTables core.
	 *
	 *  @type object
	 *  @default {}
	 */ buttons: {},
    /**
	 * ColumnControl buttons and content
	 *
	 *  @type object
	 */ ccContent: {},
    /**
	 * Element class names
	 *
	 *  @type object
	 *  @default {}
	 */ classes: {},
    /**
	 * Error reporting.
	 * 
	 * How should DataTables report an error. Can take the value 'alert',
	 * 'throw', 'none' or a function.
	 *
	 *  @type string|function
	 *  @default alert
	 */ errMode: "alert",
    /** HTML entity escaping */ escape: {
        /** When reading data-* attributes for initialisation options */ attributes: false
    },
    /**
	 * Legacy so v1 plug-ins don't throw js errors on load
	 */ feature: [],
    /**
	 * Feature plug-ins.
	 * 
	 * This is an object of callbacks which provide the features for DataTables
	 * to be initialised via the `layout` option.
	 */ features: {},
    /**
	 * Row searching.
	 * 
	 * This method of searching is complimentary to the default type based
	 * searching, and a lot more comprehensive as it allows you complete control
	 * over the searching logic. Each element in this array is a function
	 * (parameters described below) that is called for every row in the table,
	 * and your logic decides if it should be included in the searching data set
	 * or not.
	 *
	 * Searching functions have the following input parameters:
	 *
	 * 1. `{object}` DataTables settings object: see
	 *    {@link DataTable.models.oSettings}
	 * 2. `{array|object}` Data for the row to be processed (same as the
	 *    original format that was passed in as the data source, or an array
	 *    from a DOM data source
	 * 3. `{int}` Row index ({@link DataTable.models.oSettings.aoData}), which
	 *    can be useful to retrieve the `TR` element if you need DOM interaction.
	 *
	 * And the following return is expected:
	 *
	 * * {boolean} Include the row in the searched result set (true) or not
	 *   (false)
	 *
	 * Note that as with the main search ability in DataTables, technically this
	 * is "filtering", since it is subtractive. However, for consistency in
	 * naming we call it searching here.
	 *
	 *  @type array
	 *  @default []
	 *
	 *  @example
	 *    // The following example shows custom search being applied to the
	 *    // fourth column (i.e. the data[3] index) based on two input values
	 *    // from the end-user, matching the data in a certain range.
	 *    $.fn.dataTable.ext.search.push(
	 *      function( settings, data, dataIndex ) {
	 *        var min = document.getElementById('min').value * 1;
	 *        var max = document.getElementById('max').value * 1;
	 *        var version = data[3] == "-" ? 0 : data[3]*1;
	 *
	 *        if ( min == "" && max == "" ) {
	 *          return true;
	 *        }
	 *        else if ( min == "" && version < max ) {
	 *          return true;
	 *        }
	 *        else if ( min < version && "" == max ) {
	 *          return true;
	 *        }
	 *        else if ( min < version && version < max ) {
	 *          return true;
	 *        }
	 *        return false;
	 *      }
	 *    );
	 */ search: [],
    /**
	 * Selector extensions
	 *
	 * The `selector` option can be used to extend the options available for the
	 * selector modifier options (`selector-modifier` object data type) that
	 * each of the three built in selector types offer (row, column and cell +
	 * their plural counterparts). For example the Select extension uses this
	 * mechanism to provide an option to select only rows, columns and cells
	 * that have been marked as selected by the end user (`{selected: true}`),
	 * which can be used in conjunction with the existing built in selector
	 * options.
	 *
	 * Each property is an array to which functions can be pushed. The functions
	 * take three attributes:
	 *
	 * * Settings object for the host table
	 * * Options object (`selector-modifier` object type)
	 * * Array of selected item indexes
	 *
	 * The return is an array of the resulting item indexes after the custom
	 * selector has been applied.
	 *
	 *  @type object
	 */ selector: {
        cell: [],
        column: [],
        row: []
    },
    /**
	 * Legacy configuration options. Enable and disable legacy options that
	 * are available in DataTables.
	 *
	 *  @type object
	 */ legacy: {
        /**
		 * Enable / disable DataTables 1.9 compatible server-side processing
		 * requests
		 *
		 *  @type boolean
		 *  @default null
		 */ ajax: null
    },
    /**
	 * Pagination plug-in methods.
	 * 
	 * Each entry in this object is a function and defines which buttons should
	 * be shown by the pagination rendering method that is used for the table:
	 * {@link DataTable.ext.renderer.pageButton}. The renderer addresses how the
	 * buttons are displayed in the document, while the functions here tell it
	 * what buttons to display. This is done by returning an array of button
	 * descriptions (what each button will do).
	 *
	 * Pagination types (the four built in options and any additional plug-in
	 * options defined here) can be used through the `paginationType`
	 * initialisation parameter.
	 *
	 * The functions defined take two parameters:
	 *
	 * 1. `{int} page` The current page index
	 * 2. `{int} pages` The number of pages in the table
	 *
	 * Each function is expected to return an array where each element of the
	 * array can be one of:
	 *
	 * * `first` - Jump to first page when activated
	 * * `last` - Jump to last page when activated
	 * * `previous` - Show previous page when activated
	 * * `next` - Show next page when activated
	 * * `{int}` - Show page of the index given
	 * * `{array}` - A nested array containing the above elements to add a
	 *   containing 'DIV' element (might be useful for styling).
	 *
	 * Note that DataTables v1.9- used this object slightly differently whereby
	 * an object with two functions would be defined for each plug-in. That
	 * ability is still supported by DataTables 1.10+ to provide backwards
	 * compatibility, but this option of use is now decremented and no longer
	 * documented in DataTables 1.10+.
	 *
	 *  @type object
	 *  @default {}
	 *
	 *  @example
	 *    // Show previous, next and current page buttons only
	 *    $.fn.dataTableExt.oPagination.current = function ( page, pages ) {
	 *      return [ 'previous', page, 'next' ];
	 *    };
	 */ pager: {},
    renderer: {
        pageButton: {},
        header: {}
    },
    /**
	 * Ordering plug-ins - custom data source
	 * 
	 * The extension options for ordering of data available here is complimentary
	 * to the default type based ordering that DataTables typically uses. It
	 * allows much greater control over the data that is being used to
	 * order a column, but is necessarily therefore more complex.
	 * 
	 * This type of ordering is useful if you want to do ordering based on data
	 * live from the DOM (for example the contents of an 'input' element) rather
	 * than just the static string that DataTables knows of.
	 * 
	 * The way these plug-ins work is that you create an array of the values you
	 * wish to be ordering for the column in question and then return that
	 * array. The data in the array much be in the index order of the rows in
	 * the table (not the currently ordering order!). Which order data gathering
	 * function is run here depends on the `dt-init columns.orderDataType`
	 * parameter that is used for the column (if any).
	 *
	 * The functions defined take two parameters:
	 *
	 * 1. `{object}` DataTables settings object: see
	 *    {@link DataTable.models.oSettings}
	 * 2. `{int}` Target column index
	 *
	 * Each function is expected to return an array:
	 *
	 * * `{array}` Data for the column to be ordering upon
	 *
	 *  @type array
	 *
	 *  @example
	 *    // Ordering using `input` node values
	 *    $.fn.dataTable.ext.order['dom-text'] = function  ( settings, col )
	 *    {
	 *      return this.api().column( col, {order:'index'} ).nodes().map( function ( td, i ) {
	 *        return $('input', td).val();
	 *      } );
	 *    }
	 */ order: {},
    /**
	 * Type based plug-ins.
	 *
	 * Each column in DataTables has a type assigned to it, either by automatic
	 * detection or by direct assignment using the `type` option for the column.
	 * The type of a column will effect how it is ordering and search (plug-ins
	 * can also make use of the column type if required).
	 *
	 * @namespace
	 */ type: {
        /**
		 * Automatic column class assignment
		 */ className: {},
        /**
		 * Type detection functions.
		 *
		 * The functions defined in this object are used to automatically detect
		 * a column's type, making initialisation of DataTables super easy, even
		 * when complex data is in the table.
		 *
		 * The functions defined take two parameters:
		 *
	     *  1. `{*}` Data from the column cell to be analysed
	     *  2. `{settings}` DataTables settings object. This can be used to
	     *     perform context specific type detection - for example detection
	     *     based on language settings such as using a comma for a decimal
	     *     place. Generally speaking the options from the settings will not
	     *     be required
		 *
		 * Each function is expected to return:
		 *
		 * * `{string|null}` Data type detected, or null if unknown (and thus
		 *   pass it on to the other type detection functions.
		 *
		 *  @type array
		 *
		 *  @example
		 *    // Currency type detection plug-in:
		 *    $.fn.dataTable.ext.type.detect.push(
		 *      function ( data, settings ) {
		 *        // Check the numeric part
		 *        if ( ! data.substring(1).match(/[0-9]/) ) {
		 *          return null;
		 *        }
		 *
		 *        // Check prefixed by currency
		 *        if ( data.charAt(0) == '$' || data.charAt(0) == '&pound;' ) {
		 *          return 'currency';
		 *        }
		 *        return null;
		 *      }
		 *    );
		 */ detect: [],
        /**
		 * Automatic renderer assignment
		 */ render: {},
        /**
		 * Type based search formatting.
		 *
		 * The type based searching functions can be used to pre-format the
		 * data to be search on. For example, it can be used to strip HTML
		 * tags or to de-format telephone numbers for numeric only searching.
		 *
		 * Note that is a search is not defined for a column of a given type,
		 * no search formatting will be performed.
		 * 
		 * Pre-processing of searching data plug-ins - When you assign the sType
		 * for a column (or have it automatically detected for you by DataTables
		 * or a type detection plug-in), you will typically be using this for
		 * custom sorting, but it can also be used to provide custom searching
		 * by allowing you to pre-processing the data and returning the data in
		 * the format that should be searched upon. This is done by adding
		 * functions this object with a parameter name which matches the sType
		 * for that target column. This is the corollary of <i>afnSortData</i>
		 * for searching data.
		 *
		 * The functions defined take a single parameter:
		 *
	     *  1. `{*}` Data from the column cell to be prepared for searching
		 *
		 * Each function is expected to return:
		 *
		 * * `{string|null}` Formatted string that will be used for the searching.
		 *
		 *  @type object
		 *  @default {}
		 *
		 *  @example
		 *    $.fn.dataTable.ext.type.search['title-numeric'] = function ( d ) {
		 *      return d.replace(/\n/g," ").replace( /<.*?>/g, "" );
		 *    }
		 */ search: {},
        /**
		 * Type based ordering.
		 *
		 * The column type tells DataTables what ordering to apply to the table
		 * when a column is sorted upon. The order for each type that is defined,
		 * is defined by the functions available in this object.
		 *
		 * Each ordering option can be described by three properties added to
		 * this object:
		 *
		 * * `{type}-pre` - Pre-formatting function
		 * * `{type}-asc` - Ascending order function
		 * * `{type}-desc` - Descending order function
		 *
		 * All three can be used together, only `{type}-pre` or only
		 * `{type}-asc` and `{type}-desc` together. It is generally recommended
		 * that only `{type}-pre` is used, as this provides the optimal
		 * implementation in terms of speed, although the others are provided
		 * for compatibility with existing JavaScript sort functions.
		 *
		 * `{type}-pre`: Functions defined take a single parameter:
		 *
	     *  1. `{*}` Data from the column cell to be prepared for ordering
		 *
		 * And return:
		 *
		 * * `{*}` Data to be sorted upon
		 *
		 * `{type}-asc` and `{type}-desc`: Functions are typical JavaScript sort
		 * functions, taking two parameters:
		 *
	     *  1. `{*}` Data to compare to the second parameter
	     *  2. `{*}` Data to compare to the first parameter
		 *
		 * And returning:
		 *
		 * * `{*}` Ordering match: <0 if first parameter should be sorted lower
		 *   than the second parameter, ===0 if the two parameters are equal and
		 *   >0 if the first parameter should be sorted height than the second
		 *   parameter.
		 * 
		 *  @type object
		 *  @default {}
		 *
		 *  @example
		 *    // Numeric ordering of formatted numbers with a pre-formatter
		 *    $.extend( $.fn.dataTable.ext.type.order, {
		 *      "string-pre": function(x) {
		 *        a = (a === "-" || a === "") ? 0 : a.replace( /[^\d\-\.]/g, "" );
		 *        return parseFloat( a );
		 *      }
		 *    } );
		 *
		 *  @example
		 *    // Case-sensitive string ordering, with no pre-formatting method
		 *    $.extend( $.fn.dataTable.ext.order, {
		 *      "string-case-asc": function(x,y) {
		 *        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
		 *      },
		 *      "string-case-desc": function(x,y) {
		 *        return ((x < y) ? 1 : ((x > y) ? -1 : 0));
		 *      }
		 *    } );
		 */ order: {}
    },
    /**
	 * Unique DataTables instance counter
	 *
	 * @type int
	 * @private
	 */ _unique: 0,
    //
    // Depreciated
    // The following properties are retained for backwards compatibility only.
    // The should not be used in new projects and will be removed in a future
    // version
    //
    /**
	 * Version check function.
	 *  @type function
	 *  @depreciated Since 1.10
	 */ fnVersionCheck: $44bb6d473543b89d$var$DataTable.fnVersionCheck,
    /**
	 * Index for what 'this' index API functions should use
	 *  @type int
	 *  @deprecated Since v1.10
	 */ iApiIndex: 0,
    /**
	 * Software version
	 *  @type string
	 *  @deprecated Since v1.10
	 */ sVersion: $44bb6d473543b89d$var$DataTable.version
};
//
// Backwards compatibility. Alias to pre 1.10 Hungarian notation counter parts
//
$44bb6d473543b89d$var$$.extend($44bb6d473543b89d$var$_ext, {
    afnFiltering: $44bb6d473543b89d$var$_ext.search,
    aTypes: $44bb6d473543b89d$var$_ext.type.detect,
    ofnSearch: $44bb6d473543b89d$var$_ext.type.search,
    oSort: $44bb6d473543b89d$var$_ext.type.order,
    afnSortData: $44bb6d473543b89d$var$_ext.order,
    aoFeatures: $44bb6d473543b89d$var$_ext.feature,
    oStdClasses: $44bb6d473543b89d$var$_ext.classes,
    oPagination: $44bb6d473543b89d$var$_ext.pager
});
$44bb6d473543b89d$var$$.extend($44bb6d473543b89d$var$DataTable.ext.classes, {
    container: 'dt-container',
    empty: {
        row: 'dt-empty'
    },
    info: {
        container: 'dt-info'
    },
    layout: {
        row: 'dt-layout-row',
        cell: 'dt-layout-cell',
        tableRow: 'dt-layout-table',
        tableCell: '',
        start: 'dt-layout-start',
        end: 'dt-layout-end',
        full: 'dt-layout-full'
    },
    length: {
        container: 'dt-length',
        select: 'dt-input'
    },
    order: {
        canAsc: 'dt-orderable-asc',
        canDesc: 'dt-orderable-desc',
        isAsc: 'dt-ordering-asc',
        isDesc: 'dt-ordering-desc',
        none: 'dt-orderable-none',
        position: 'sorting_'
    },
    processing: {
        container: 'dt-processing'
    },
    scrolling: {
        body: 'dt-scroll-body',
        container: 'dt-scroll',
        footer: {
            self: 'dt-scroll-foot',
            inner: 'dt-scroll-footInner'
        },
        header: {
            self: 'dt-scroll-head',
            inner: 'dt-scroll-headInner'
        }
    },
    search: {
        container: 'dt-search',
        input: 'dt-input'
    },
    table: 'dataTable',
    tbody: {
        cell: '',
        row: ''
    },
    thead: {
        cell: '',
        row: ''
    },
    tfoot: {
        cell: '',
        row: ''
    },
    paging: {
        active: 'current',
        button: 'dt-paging-button',
        container: 'dt-paging',
        disabled: 'disabled',
        nav: ''
    }
});
/*
 * It is useful to have variables which are scoped locally so only the
 * DataTables functions can access them and they don't leak into global space.
 * At the same time these functions are often useful over multiple files in the
 * core and API, so we list, or at least document, all variables which are used
 * by DataTables as private variables here. This also ensures that there is no
 * clashing of variable names and that they can easily referenced for reuse.
 */ // Defined else where
//  _selector_run
//  _selector_opts
//  _selector_row_indexes
var $44bb6d473543b89d$var$_ext; // DataTable.ext
var $44bb6d473543b89d$var$_Api; // DataTable.Api
var $44bb6d473543b89d$var$_api_register; // DataTable.Api.register
var $44bb6d473543b89d$var$_api_registerPlural; // DataTable.Api.registerPlural
var $44bb6d473543b89d$var$_re_dic = {};
var $44bb6d473543b89d$var$_re_new_lines = /[\r\n\u2028]/g;
var $44bb6d473543b89d$var$_re_html = /<([^>]*>)/g;
var $44bb6d473543b89d$var$_max_str_len = Math.pow(2, 28);
// This is not strict ISO8601 - Date.parse() is quite lax, although
// implementations differ between browsers.
var $44bb6d473543b89d$var$_re_date = /^\d{2,4}[./-]\d{1,2}[./-]\d{1,2}([T ]{1}\d{1,2}[:.]\d{2}([.:]\d{2})?)?$/;
// Escape regular expression special characters
var $44bb6d473543b89d$var$_re_escape_regex = new RegExp('(\\' + [
    '/',
    '.',
    '*',
    '+',
    '?',
    '|',
    '(',
    ')',
    '[',
    ']',
    '{',
    '}',
    '\\',
    '$',
    '^',
    '-'
].join('|\\') + ')', 'g');
// https://en.wikipedia.org/wiki/Foreign_exchange_market
// - \u20BD - Russian ruble.
// - \u20a9 - South Korean Won
// - \u20BA - Turkish Lira
// - \u20B9 - Indian Rupee
// - R - Brazil (R$) and South Africa
// - fr - Swiss Franc
// - kr - Swedish krona, Norwegian krone and Danish krone
// - \u2009 is thin space and \u202F is narrow no-break space, both used in many
// - Ƀ - Bitcoin
// - Ξ - Ethereum
//   standards as thousands separators.
var $44bb6d473543b89d$var$_re_formatted_numeric = /['\u00A0,$£€¥%\u2009\u202F\u20BD\u20a9\u20BArfkɃΞ]/gi;
var $44bb6d473543b89d$var$_empty = function(d) {
    return !d || d === true || d === '-' ? true : false;
};
var $44bb6d473543b89d$var$_intVal = function(s) {
    var integer = parseInt(s, 10);
    return !isNaN(integer) && isFinite(s) ? integer : null;
};
// Convert from a formatted number with characters other than `.` as the
// decimal place, to a JavaScript number
var $44bb6d473543b89d$var$_numToDecimal = function(num, decimalPoint) {
    // Cache created regular expressions for speed as this function is called often
    if (!$44bb6d473543b89d$var$_re_dic[decimalPoint]) $44bb6d473543b89d$var$_re_dic[decimalPoint] = new RegExp($44bb6d473543b89d$var$_fnEscapeRegex(decimalPoint), 'g');
    return typeof num === 'string' && decimalPoint !== '.' ? num.replace(/\./g, '').replace($44bb6d473543b89d$var$_re_dic[decimalPoint], '.') : num;
};
var $44bb6d473543b89d$var$_isNumber = function(d, decimalPoint, formatted, allowEmpty) {
    var type = typeof d;
    var strType = type === 'string';
    if (type === 'number' || type === 'bigint') return true;
    // If empty return immediately so there must be a number if it is a
    // formatted string (this stops the string "k", or "kr", etc being detected
    // as a formatted number for currency
    if (allowEmpty && $44bb6d473543b89d$var$_empty(d)) return true;
    if (decimalPoint && strType) d = $44bb6d473543b89d$var$_numToDecimal(d, decimalPoint);
    if (formatted && strType) d = d.replace($44bb6d473543b89d$var$_re_formatted_numeric, '');
    return !isNaN(parseFloat(d)) && isFinite(d);
};
// A string without HTML in it can be considered to be HTML still
var $44bb6d473543b89d$var$_isHtml = function(d) {
    return $44bb6d473543b89d$var$_empty(d) || typeof d === 'string';
};
// Is a string a number surrounded by HTML?
var $44bb6d473543b89d$var$_htmlNumeric = function(d, decimalPoint, formatted, allowEmpty) {
    if (allowEmpty && $44bb6d473543b89d$var$_empty(d)) return true;
    // input and select strings mean that this isn't just a number
    if (typeof d === 'string' && d.match(/<(input|select)/i)) return null;
    var html = $44bb6d473543b89d$var$_isHtml(d);
    return !html ? null : $44bb6d473543b89d$var$_isNumber($44bb6d473543b89d$var$_stripHtml(d), decimalPoint, formatted, allowEmpty) ? true : null;
};
var $44bb6d473543b89d$var$_pluck = function(a, prop, prop2) {
    var out = [];
    var i = 0, iLen = a.length;
    // Could have the test in the loop for slightly smaller code, but speed
    // is essential here
    if (prop2 !== undefined) {
        for(; i < iLen; i++)if (a[i] && a[i][prop]) out.push(a[i][prop][prop2]);
    } else {
        for(; i < iLen; i++)if (a[i]) out.push(a[i][prop]);
    }
    return out;
};
// Basically the same as _pluck, but rather than looping over `a` we use `order`
// as the indexes to pick from `a`
var $44bb6d473543b89d$var$_pluck_order = function(a, order, prop, prop2) {
    var out = [];
    var i = 0, iLen = order.length;
    // Could have the test in the loop for slightly smaller code, but speed
    // is essential here
    if (prop2 !== undefined) {
        for(; i < iLen; i++)if (a[order[i]] && a[order[i]][prop]) out.push(a[order[i]][prop][prop2]);
    } else {
        for(; i < iLen; i++)if (a[order[i]]) out.push(a[order[i]][prop]);
    }
    return out;
};
var $44bb6d473543b89d$var$_range = function(len, start) {
    var out = [];
    var end;
    if (start === undefined) {
        start = 0;
        end = len;
    } else {
        end = start;
        start = len;
    }
    for(var i = start; i < end; i++)out.push(i);
    return out;
};
var $44bb6d473543b89d$var$_removeEmpty = function(a) {
    var out = [];
    for(var i = 0, iLen = a.length; i < iLen; i++)if (a[i]) out.push(a[i]);
    return out;
};
// Replaceable function in api.util
var $44bb6d473543b89d$var$_stripHtml = function(input, replacement) {
    if (!input || typeof input !== 'string') return input;
    // Irrelevant check to workaround CodeQL's false positive on the regex
    if (input.length > $44bb6d473543b89d$var$_max_str_len) throw new Error('Exceeded max str len');
    var previous;
    input = input.replace($44bb6d473543b89d$var$_re_html, replacement || ''); // Complete tags
    // Safety for incomplete script tag - use do / while to ensure that
    // we get all instances
    do {
        previous = input;
        input = input.replace(/<script/i, '');
    }while (input !== previous);
    return previous;
};
// Replaceable function in api.util
var $44bb6d473543b89d$var$_escapeHtml = function(d) {
    if (Array.isArray(d)) d = d.join(',');
    return typeof d === 'string' ? d.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;') : d;
};
// Remove diacritics from a string by decomposing it and then removing
// non-ascii characters
var $44bb6d473543b89d$var$_normalize = function(str, both) {
    if (typeof str !== 'string') return str;
    // It is faster to just run `normalize` than it is to check if
    // we need to with a regex! (Check as it isn't available in old
    // Safari)
    var res = str.normalize ? str.normalize("NFD") : str;
    // Equally, here we check if a regex is needed or not
    return res.length !== str.length ? (both === true ? str + ' ' : '') + res.replace(/[\u0300-\u036f]/g, "") : res;
};
/**
 * Determine if all values in the array are unique. This means we can short
 * cut the _unique method at the cost of a single loop. A sorted array is used
 * to easily check the values.
 *
 * @param  {array} src Source array
 * @return {boolean} true if all unique, false otherwise
 * @ignore
 */ var $44bb6d473543b89d$var$_areAllUnique = function(src) {
    if (src.length < 2) return true;
    var sorted = src.slice().sort();
    var last = sorted[0];
    for(var i = 1, iLen = sorted.length; i < iLen; i++){
        if (sorted[i] === last) return false;
        last = sorted[i];
    }
    return true;
};
/**
 * Find the unique elements in a source array.
 *
 * @param  {array} src Source array
 * @return {array} Array of unique items
 * @ignore
 */ var $44bb6d473543b89d$var$_unique = function(src) {
    if (Array.from && Set) return Array.from(new Set(src));
    if ($44bb6d473543b89d$var$_areAllUnique(src)) return src.slice();
    // A faster unique method is to use object keys to identify used values,
    // but this doesn't work with arrays or objects, which we must also
    // consider. See jsperf.app/compare-array-unique-versions/4 for more
    // information.
    var out = [], val, i, iLen = src.length, j, k = 0;
    again: for(i = 0; i < iLen; i++){
        val = src[i];
        for(j = 0; j < k; j++){
            if (out[j] === val) continue again;
        }
        out.push(val);
        k++;
    }
    return out;
};
// Surprisingly this is faster than [].concat.apply
// https://jsperf.com/flatten-an-array-loop-vs-reduce/2
var $44bb6d473543b89d$var$_flatten = function(out, val) {
    if (Array.isArray(val)) for(var i = 0; i < val.length; i++)$44bb6d473543b89d$var$_flatten(out, val[i]);
    else out.push(val);
    return out;
};
// Similar to jQuery's addClass, but use classList.add
function $44bb6d473543b89d$var$_addClass(el, name) {
    if (name) name.split(' ').forEach(function(n) {
        if (n) // `add` does deduplication, so no need to check `contains`
        el.classList.add(n);
    });
}
/**
 * DataTables utility methods
 * 
 * This namespace provides helper methods that DataTables uses internally to
 * create a DataTable, but which are not exclusively used only for DataTables.
 * These methods can be used by extension authors to save the duplication of
 * code.
 *
 *  @namespace
 */ $44bb6d473543b89d$var$DataTable.util = {
    /**
	 * Return a string with diacritic characters decomposed
	 * @param {*} mixed Function or string to normalize
	 * @param {*} both Return original string and the normalized string
	 * @returns String or undefined
	 */ diacritics: function(mixed, both) {
        var type = typeof mixed;
        if (type !== 'function') return $44bb6d473543b89d$var$_normalize(mixed, both);
        $44bb6d473543b89d$var$_normalize = mixed;
    },
    /**
	 * Debounce a function
	 *
	 * @param {function} fn Function to be called
	 * @param {integer} freq Call frequency in mS
	 * @return {function} Wrapped function
	 */ debounce: function(fn, timeout) {
        var timer;
        return function() {
            var that = this;
            var args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function() {
                fn.apply(that, args);
            }, timeout || 250);
        };
    },
    /**
	 * Throttle the calls to a function. Arguments and context are maintained
	 * for the throttled function.
	 *
	 * @param {function} fn Function to be called
	 * @param {integer} freq Call frequency in mS
	 * @return {function} Wrapped function
	 */ throttle: function(fn, freq) {
        var frequency = freq !== undefined ? freq : 200, last, timer;
        return function() {
            var that = this, now = +new Date(), args = arguments;
            if (last && now < last + frequency) {
                clearTimeout(timer);
                timer = setTimeout(function() {
                    last = undefined;
                    fn.apply(that, args);
                }, frequency);
            } else {
                last = now;
                fn.apply(that, args);
            }
        };
    },
    /**
	 * Escape a string such that it can be used in a regular expression
	 *
	 *  @param {string} val string to escape
	 *  @returns {string} escaped string
	 */ escapeRegex: function(val) {
        return val.replace($44bb6d473543b89d$var$_re_escape_regex, '\\$1');
    },
    /**
	 * Create a function that will write to a nested object or array
	 * @param {*} source JSON notation string
	 * @returns Write function
	 */ set: function(source) {
        if ($44bb6d473543b89d$var$$.isPlainObject(source)) /* Unlike get, only the underscore (global) option is used for for
			 * setting data since we don't know the type here. This is why an object
			 * option is not documented for `mData` (which is read/write), but it is
			 * for `mRender` which is read only.
			 */ return $44bb6d473543b89d$var$DataTable.util.set(source._);
        else if (source === null) // Nothing to do when the data source is null
        return function() {};
        else if (typeof source === 'function') return function(data, val, meta) {
            source(data, 'set', val, meta);
        };
        else if (typeof source === 'string' && (source.indexOf('.') !== -1 || source.indexOf('[') !== -1 || source.indexOf('(') !== -1)) {
            // Like the get, we need to get data from a nested object
            var setData = function(data, val, src) {
                var a = $44bb6d473543b89d$var$_fnSplitObjNotation(src), b;
                var aLast = a[a.length - 1];
                var arrayNotation, funcNotation, o, innerSrc;
                for(var i = 0, iLen = a.length - 1; i < iLen; i++){
                    // Protect against prototype pollution
                    if (a[i] === '__proto__' || a[i] === 'constructor') throw new Error('Cannot set prototype values');
                    // Check if we are dealing with an array notation request
                    arrayNotation = a[i].match($44bb6d473543b89d$var$__reArray);
                    funcNotation = a[i].match($44bb6d473543b89d$var$__reFn);
                    if (arrayNotation) {
                        a[i] = a[i].replace($44bb6d473543b89d$var$__reArray, '');
                        data[a[i]] = [];
                        // Get the remainder of the nested object to set so we can recurse
                        b = a.slice();
                        b.splice(0, i + 1);
                        innerSrc = b.join('.');
                        // Traverse each entry in the array setting the properties requested
                        if (Array.isArray(val)) for(var j = 0, jLen = val.length; j < jLen; j++){
                            o = {};
                            setData(o, val[j], innerSrc);
                            data[a[i]].push(o);
                        }
                        else // We've been asked to save data to an array, but it
                        // isn't array data to be saved. Best that can be done
                        // is to just save the value.
                        data[a[i]] = val;
                        // The inner call to setData has already traversed through the remainder
                        // of the source and has set the data, thus we can exit here
                        return;
                    } else if (funcNotation) {
                        // Function call
                        a[i] = a[i].replace($44bb6d473543b89d$var$__reFn, '');
                        data = data[a[i]](val);
                    }
                    // If the nested object doesn't currently exist - since we are
                    // trying to set the value - create it
                    if (data[a[i]] === null || data[a[i]] === undefined) data[a[i]] = {};
                    data = data[a[i]];
                }
                // Last item in the input - i.e, the actual set
                if (aLast.match($44bb6d473543b89d$var$__reFn)) // Function call
                data = data[aLast.replace($44bb6d473543b89d$var$__reFn, '')](val);
                else // If array notation is used, we just want to strip it and use the property name
                // and assign the value. If it isn't used, then we get the result we want anyway
                data[aLast.replace($44bb6d473543b89d$var$__reArray, '')] = val;
            };
            return function(data, val) {
                return setData(data, val, source);
            };
        } else // Array or flat object mapping
        return function(data, val) {
            data[source] = val;
        };
    },
    /**
	 * Create a function that will read nested objects from arrays, based on JSON notation
	 * @param {*} source JSON notation string
	 * @returns Value read
	 */ get: function(source) {
        if ($44bb6d473543b89d$var$$.isPlainObject(source)) {
            // Build an object of get functions, and wrap them in a single call
            var o = {};
            $44bb6d473543b89d$var$$.each(source, function(key, val) {
                if (val) o[key] = $44bb6d473543b89d$var$DataTable.util.get(val);
            });
            return function(data, type, row, meta) {
                var t = o[type] || o._;
                return t !== undefined ? t(data, type, row, meta) : data;
            };
        } else if (source === null) // Give an empty string for rendering / sorting etc
        return function(data) {
            return data;
        };
        else if (typeof source === 'function') return function(data, type, row, meta) {
            return source(data, type, row, meta);
        };
        else if (typeof source === 'string' && (source.indexOf('.') !== -1 || source.indexOf('[') !== -1 || source.indexOf('(') !== -1)) {
            /* If there is a . in the source string then the data source is in a
			 * nested object so we loop over the data for each level to get the next
			 * level down. On each loop we test for undefined, and if found immediately
			 * return. This allows entire objects to be missing and sDefaultContent to
			 * be used if defined, rather than throwing an error
			 */ var fetchData = function(data, type, src) {
                var arrayNotation, funcNotation, out, innerSrc;
                if (src !== "") {
                    var a = $44bb6d473543b89d$var$_fnSplitObjNotation(src);
                    for(var i = 0, iLen = a.length; i < iLen; i++){
                        // Check if we are dealing with special notation
                        arrayNotation = a[i].match($44bb6d473543b89d$var$__reArray);
                        funcNotation = a[i].match($44bb6d473543b89d$var$__reFn);
                        if (arrayNotation) {
                            // Array notation
                            a[i] = a[i].replace($44bb6d473543b89d$var$__reArray, '');
                            // Condition allows simply [] to be passed in
                            if (a[i] !== "") data = data[a[i]];
                            out = [];
                            // Get the remainder of the nested object to get
                            a.splice(0, i + 1);
                            innerSrc = a.join('.');
                            // Traverse each entry in the array getting the properties requested
                            if (Array.isArray(data)) for(var j = 0, jLen = data.length; j < jLen; j++)out.push(fetchData(data[j], type, innerSrc));
                            // If a string is given in between the array notation indicators, that
                            // is used to join the strings together, otherwise an array is returned
                            var join = arrayNotation[0].substring(1, arrayNotation[0].length - 1);
                            data = join === "" ? out : out.join(join);
                            break;
                        } else if (funcNotation) {
                            // Function call
                            a[i] = a[i].replace($44bb6d473543b89d$var$__reFn, '');
                            data = data[a[i]]();
                            continue;
                        }
                        if (data === null || data[a[i]] === null) return null;
                        else if (data === undefined || data[a[i]] === undefined) return undefined;
                        data = data[a[i]];
                    }
                }
                return data;
            };
            return function(data, type) {
                return fetchData(data, type, source);
            };
        } else // Array or flat object mapping
        return function(data) {
            return data[source];
        };
    },
    stripHtml: function(mixed, replacement) {
        var type = typeof mixed;
        if (type === 'function') {
            $44bb6d473543b89d$var$_stripHtml = mixed;
            return;
        } else if (type === 'string') return $44bb6d473543b89d$var$_stripHtml(mixed, replacement);
        return mixed;
    },
    escapeHtml: function(mixed) {
        var type = typeof mixed;
        if (type === 'function') {
            $44bb6d473543b89d$var$_escapeHtml = mixed;
            return;
        } else if (type === 'string' || Array.isArray(mixed)) return $44bb6d473543b89d$var$_escapeHtml(mixed);
        return mixed;
    },
    unique: $44bb6d473543b89d$var$_unique
};
/**
 * Create a mapping object that allows camel case parameters to be looked up
 * for their Hungarian counterparts. The mapping is stored in a private
 * parameter called `_hungarianMap` which can be accessed on the source object.
 *  @param {object} o
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnHungarianMap(o) {
    var hungarian = 'a aa ai ao as b fn i m o s ', match, newKey, map = {};
    $44bb6d473543b89d$var$$.each(o, function(key) {
        match = key.match(/^([^A-Z]+?)([A-Z])/);
        if (match && hungarian.indexOf(match[1] + ' ') !== -1) {
            newKey = key.replace(match[0], match[2].toLowerCase());
            map[newKey] = key;
            if (match[1] === 'o') $44bb6d473543b89d$var$_fnHungarianMap(o[key]);
        }
    });
    o._hungarianMap = map;
}
/**
 * Convert from camel case parameters to Hungarian, based on a Hungarian map
 * created by _fnHungarianMap.
 *  @param {object} src The model object which holds all parameters that can be
 *    mapped.
 *  @param {object} user The object to convert from camel case to Hungarian.
 *  @param {boolean} force When set to `true`, properties which already have a
 *    Hungarian value in the `user` object will be overwritten. Otherwise they
 *    won't be.
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnCamelToHungarian(src, user, force) {
    if (!src._hungarianMap) $44bb6d473543b89d$var$_fnHungarianMap(src);
    var hungarianKey;
    $44bb6d473543b89d$var$$.each(user, function(key) {
        hungarianKey = src._hungarianMap[key];
        if (hungarianKey !== undefined && (force || user[hungarianKey] === undefined)) {
            // For objects, we need to buzz down into the object to copy parameters
            if (hungarianKey.charAt(0) === 'o') {
                // Copy the camelCase options over to the hungarian
                if (!user[hungarianKey]) user[hungarianKey] = {};
                $44bb6d473543b89d$var$$.extend(true, user[hungarianKey], user[key]);
                $44bb6d473543b89d$var$_fnCamelToHungarian(src[hungarianKey], user[hungarianKey], force);
            } else user[hungarianKey] = user[key];
        }
    });
}
/**
 * Map one parameter onto another
 *  @param {object} o Object to map
 *  @param {*} knew The new parameter name
 *  @param {*} old The old parameter name
 */ var $44bb6d473543b89d$var$_fnCompatMap = function(o, knew, old) {
    if (o[knew] !== undefined) o[old] = o[knew];
};
/**
 * Provide backwards compatibility for the main DT options. Note that the new
 * options are mapped onto the old parameters, so this is an external interface
 * change only.
 *  @param {object} init Object to map
 */ function $44bb6d473543b89d$var$_fnCompatOpts(init) {
    $44bb6d473543b89d$var$_fnCompatMap(init, 'ordering', 'bSort');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'orderMulti', 'bSortMulti');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'orderClasses', 'bSortClasses');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'orderCellsTop', 'bSortCellsTop');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'order', 'aaSorting');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'orderFixed', 'aaSortingFixed');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'paging', 'bPaginate');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'pagingType', 'sPaginationType');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'pageLength', 'iDisplayLength');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'searching', 'bFilter');
    // Boolean initialisation of x-scrolling
    if (typeof init.sScrollX === 'boolean') init.sScrollX = init.sScrollX ? '100%' : '';
    if (typeof init.scrollX === 'boolean') init.scrollX = init.scrollX ? '100%' : '';
    // Objects for ordering
    if (typeof init.bSort === 'object') {
        init.orderIndicators = init.bSort.indicators !== undefined ? init.bSort.indicators : true;
        init.orderHandler = init.bSort.handler !== undefined ? init.bSort.handler : true;
        init.bSort = true;
    } else if (init.bSort === false) {
        init.orderIndicators = false;
        init.orderHandler = false;
    } else if (init.bSort === true) {
        init.orderIndicators = true;
        init.orderHandler = true;
    }
    // Which cells are the title cells?
    if (typeof init.bSortCellsTop === 'boolean') init.titleRow = init.bSortCellsTop;
    // Column search objects are in an array, so it needs to be converted
    // element by element
    var searchCols = init.aoSearchCols;
    if (searchCols) {
        for(var i = 0, iLen = searchCols.length; i < iLen; i++)if (searchCols[i]) $44bb6d473543b89d$var$_fnCamelToHungarian($44bb6d473543b89d$var$DataTable.models.oSearch, searchCols[i]);
    }
    // Enable search delay if server-side processing is enabled
    if (init.serverSide && !init.searchDelay) init.searchDelay = 400;
}
/**
 * Provide backwards compatibility for column options. Note that the new options
 * are mapped onto the old parameters, so this is an external interface change
 * only.
 *  @param {object} init Object to map
 */ function $44bb6d473543b89d$var$_fnCompatCols(init) {
    $44bb6d473543b89d$var$_fnCompatMap(init, 'orderable', 'bSortable');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'orderData', 'aDataSort');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'orderSequence', 'asSorting');
    $44bb6d473543b89d$var$_fnCompatMap(init, 'orderDataType', 'sortDataType');
    // orderData can be given as an integer
    var dataSort = init.aDataSort;
    if (typeof dataSort === 'number' && !Array.isArray(dataSort)) init.aDataSort = [
        dataSort
    ];
}
/**
 * Browser feature detection for capabilities, quirks
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnBrowserDetect(settings) {
    // We don't need to do this every time DataTables is constructed, the values
    // calculated are specific to the browser and OS configuration which we
    // don't expect to change between initialisations
    if (!$44bb6d473543b89d$var$DataTable.__browser) {
        var browser = {};
        $44bb6d473543b89d$var$DataTable.__browser = browser;
        // Scrolling feature / quirks detection
        var n = $44bb6d473543b89d$var$$('<div/>').css({
            position: 'fixed',
            top: 0,
            left: -1 * window.pageXOffset,
            height: 1,
            width: 1,
            overflow: 'hidden'
        }).append($44bb6d473543b89d$var$$('<div/>').css({
            position: 'absolute',
            top: 1,
            left: 1,
            width: 100,
            overflow: 'scroll'
        }).append($44bb6d473543b89d$var$$('<div/>').css({
            width: '100%',
            height: 10
        }))).appendTo('body');
        var outer = n.children();
        var inner = outer.children();
        // Get scrollbar width
        browser.barWidth = outer[0].offsetWidth - outer[0].clientWidth;
        // In rtl text layout, some browsers (most, but not all) will place the
        // scrollbar on the left, rather than the right.
        browser.bScrollbarLeft = Math.round(inner.offset().left) !== 1;
        n.remove();
    }
    $44bb6d473543b89d$var$$.extend(settings.oBrowser, $44bb6d473543b89d$var$DataTable.__browser);
    settings.oScroll.iBarWidth = $44bb6d473543b89d$var$DataTable.__browser.barWidth;
}
/**
 * Add a column to the list used for the table with default values
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnAddColumn(oSettings) {
    // Add column to aoColumns array
    var oDefaults = $44bb6d473543b89d$var$DataTable.defaults.column;
    var iCol = oSettings.aoColumns.length;
    var oCol = $44bb6d473543b89d$var$$.extend({}, $44bb6d473543b89d$var$DataTable.models.oColumn, oDefaults, {
        "aDataSort": oDefaults.aDataSort ? oDefaults.aDataSort : [
            iCol
        ],
        "mData": oDefaults.mData ? oDefaults.mData : iCol,
        idx: iCol,
        searchFixed: {},
        colEl: $44bb6d473543b89d$var$$('<col>').attr('data-dt-column', iCol)
    });
    oSettings.aoColumns.push(oCol);
    // Add search object for column specific search. Note that the `searchCols[ iCol ]`
    // passed into extend can be undefined. This allows the user to give a default
    // with only some of the parameters defined, and also not give a default
    var searchCols = oSettings.aoPreSearchCols;
    searchCols[iCol] = $44bb6d473543b89d$var$$.extend({}, $44bb6d473543b89d$var$DataTable.models.oSearch, searchCols[iCol]);
}
/**
 * Apply options for a column
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iCol column index to consider
 *  @param {object} oOptions object with sType, bVisible and bSearchable etc
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnColumnOptions(oSettings, iCol, oOptions) {
    var oCol = oSettings.aoColumns[iCol];
    /* User specified column options */ if (oOptions !== undefined && oOptions !== null) {
        // Backwards compatibility
        $44bb6d473543b89d$var$_fnCompatCols(oOptions);
        // Map camel case parameters to their Hungarian counterparts
        $44bb6d473543b89d$var$_fnCamelToHungarian($44bb6d473543b89d$var$DataTable.defaults.column, oOptions, true);
        /* Backwards compatibility for mDataProp */ if (oOptions.mDataProp !== undefined && !oOptions.mData) oOptions.mData = oOptions.mDataProp;
        if (oOptions.sType) oCol._sManualType = oOptions.sType;
        // `class` is a reserved word in JavaScript, so we need to provide
        // the ability to use a valid name for the camel case input
        if (oOptions.className && !oOptions.sClass) oOptions.sClass = oOptions.className;
        var origClass = oCol.sClass;
        $44bb6d473543b89d$var$$.extend(oCol, oOptions);
        $44bb6d473543b89d$var$_fnMap(oCol, oOptions, "sWidth", "sWidthOrig");
        // Merge class from previously defined classes with this one, rather than just
        // overwriting it in the extend above
        if (origClass !== oCol.sClass) oCol.sClass = origClass + ' ' + oCol.sClass;
        /* iDataSort to be applied (backwards compatibility), but aDataSort will take
		 * priority if defined
		 */ if (oOptions.iDataSort !== undefined) oCol.aDataSort = [
            oOptions.iDataSort
        ];
        $44bb6d473543b89d$var$_fnMap(oCol, oOptions, "aDataSort");
    }
    /* Cache the data get and set functions for speed */ var mDataSrc = oCol.mData;
    var mData = $44bb6d473543b89d$var$_fnGetObjectDataFn(mDataSrc);
    // The `render` option can be given as an array to access the helper rendering methods.
    // The first element is the rendering method to use, the rest are the parameters to pass
    if (oCol.mRender && Array.isArray(oCol.mRender)) {
        var copy = oCol.mRender.slice();
        var name = copy.shift();
        oCol.mRender = $44bb6d473543b89d$var$DataTable.render[name].apply(window, copy);
    }
    oCol._render = oCol.mRender ? $44bb6d473543b89d$var$_fnGetObjectDataFn(oCol.mRender) : null;
    var attrTest = function(src) {
        return typeof src === 'string' && src.indexOf('@') !== -1;
    };
    oCol._bAttrSrc = $44bb6d473543b89d$var$$.isPlainObject(mDataSrc) && (attrTest(mDataSrc.sort) || attrTest(mDataSrc.type) || attrTest(mDataSrc.filter));
    oCol._setter = null;
    oCol.fnGetData = function(rowData, type, meta) {
        var innerData = mData(rowData, type, undefined, meta);
        return oCol._render && type ? oCol._render(innerData, type, rowData, meta) : innerData;
    };
    oCol.fnSetData = function(rowData, val, meta) {
        return $44bb6d473543b89d$var$_fnSetObjectDataFn(mDataSrc)(rowData, val, meta);
    };
    // Indicate if DataTables should read DOM data as an object or array
    // Used in _fnGetRowElements
    if (typeof mDataSrc !== 'number' && !oCol._isArrayHost) oSettings._rowReadObject = true;
    /* Feature sorting overrides column specific when off */ if (!oSettings.oFeatures.bSort) oCol.bSortable = false;
}
/**
 * Adjust the table column widths for new data. Note: you would probably want to
 * do a redraw after calling this function!
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnAdjustColumnSizing(settings) {
    $44bb6d473543b89d$var$_fnCalculateColumnWidths(settings);
    $44bb6d473543b89d$var$_fnColumnSizes(settings);
    var scroll = settings.oScroll;
    if (scroll.sY !== '' || scroll.sX !== '') $44bb6d473543b89d$var$_fnScrollDraw(settings);
    $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'column-sizing', [
        settings
    ]);
}
/**
 * Apply column sizes
 *
 * @param {*} settings DataTables settings object
 */ function $44bb6d473543b89d$var$_fnColumnSizes(settings) {
    var cols = settings.aoColumns;
    for(var i = 0; i < cols.length; i++){
        var width = $44bb6d473543b89d$var$_fnColumnsSumWidth(settings, [
            i
        ], false, false);
        cols[i].colEl.css('width', width);
        if (settings.oScroll.sX) cols[i].colEl.css('min-width', width);
    }
}
/**
 * Convert the index of a visible column to the index in the data array (take account
 * of hidden columns)
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iMatch Visible column index to lookup
 *  @returns {int} i the data index
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnVisibleToColumnIndex(oSettings, iMatch) {
    var aiVis = $44bb6d473543b89d$var$_fnGetColumns(oSettings, 'bVisible');
    return typeof aiVis[iMatch] === 'number' ? aiVis[iMatch] : null;
}
/**
 * Convert the index of an index in the data array and convert it to the visible
 *   column index (take account of hidden columns)
 *  @param {int} iMatch Column index to lookup
 *  @param {object} oSettings dataTables settings object
 *  @returns {int} i the data index
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnColumnIndexToVisible(oSettings, iMatch) {
    var aiVis = $44bb6d473543b89d$var$_fnGetColumns(oSettings, 'bVisible');
    var iPos = aiVis.indexOf(iMatch);
    return iPos !== -1 ? iPos : null;
}
/**
 * Get the number of visible columns
 *  @param {object} oSettings dataTables settings object
 *  @returns {int} i the number of visible columns
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnVisibleColumns(settings) {
    var layout = settings.aoHeader;
    var columns = settings.aoColumns;
    var vis = 0;
    if (layout.length) {
        for(var i = 0, iLen = layout[0].length; i < iLen; i++)if (columns[i].bVisible && $44bb6d473543b89d$var$$(layout[0][i].cell).css('display') !== 'none') vis++;
    }
    return vis;
}
/**
 * Get an array of column indexes that match a given property
 *  @param {object} oSettings dataTables settings object
 *  @param {string} sParam Parameter in aoColumns to look for - typically
 *    bVisible or bSearchable
 *  @returns {array} Array of indexes with matched properties
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnGetColumns(oSettings, sParam) {
    var a = [];
    oSettings.aoColumns.map(function(val, i) {
        if (val[sParam]) a.push(i);
    });
    return a;
}
/**
 * Allow the result from a type detection function to be `true` while
 * translating that into a string. Old type detection functions will
 * return the type name if it passes. An object store would be better,
 * but not backwards compatible.
 *
 * @param {*} typeDetect Object or function for type detection
 * @param {*} res Result from the type detection function
 * @returns Type name or false
 */ function $44bb6d473543b89d$var$_typeResult(typeDetect, res) {
    return res === true ? typeDetect._name : res;
}
/**
 * Calculate the 'type' of a column
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnColumnTypes(settings) {
    var columns = settings.aoColumns;
    var data = settings.aoData;
    var types = $44bb6d473543b89d$var$DataTable.ext.type.detect;
    var i, iLen, j, jen, k, ken;
    var col, detectedType, cache;
    // For each column, spin over the data type detection functions, seeing if one matches
    for(i = 0, iLen = columns.length; i < iLen; i++){
        col = columns[i];
        cache = [];
        if (!col.sType && col._sManualType) col.sType = col._sManualType;
        else if (!col.sType) {
            // With SSP type detection can be unreliable and error prone, so we provide a way
            // to turn it off.
            if (!settings.typeDetect) return;
            for(j = 0, jen = types.length; j < jen; j++){
                var typeDetect = types[j];
                // There can be either one, or three type detection functions
                var oneOf = typeDetect.oneOf;
                var allOf = typeDetect.allOf || typeDetect;
                var init = typeDetect.init;
                var one = false;
                detectedType = null;
                // Fast detect based on column assignment
                if (init) {
                    detectedType = $44bb6d473543b89d$var$_typeResult(typeDetect, init(settings, col, i));
                    if (detectedType) {
                        col.sType = detectedType;
                        break;
                    }
                }
                for(k = 0, ken = data.length; k < ken; k++){
                    if (!data[k]) continue;
                    // Use a cache array so we only need to get the type data
                    // from the formatter once (when using multiple detectors)
                    if (cache[k] === undefined) cache[k] = $44bb6d473543b89d$var$_fnGetCellData(settings, k, i, 'type');
                    // Only one data point in the column needs to match this function
                    if (oneOf && !one) one = $44bb6d473543b89d$var$_typeResult(typeDetect, oneOf(cache[k], settings));
                    // All data points need to match this function
                    detectedType = $44bb6d473543b89d$var$_typeResult(typeDetect, allOf(cache[k], settings));
                    // If null, then this type can't apply to this column, so
                    // rather than testing all cells, break out. There is an
                    // exception for the last type which is `html`. We need to
                    // scan all rows since it is possible to mix string and HTML
                    // types
                    if (!detectedType && j !== types.length - 3) break;
                    // Only a single match is needed for html type since it is
                    // bottom of the pile and very similar to string - but it
                    // must not be empty
                    if (detectedType === 'html' && !$44bb6d473543b89d$var$_empty(cache[k])) break;
                }
                // Type is valid for all data points in the column - use this
                // type
                if (oneOf && one && detectedType || !oneOf && detectedType) {
                    col.sType = detectedType;
                    break;
                }
            }
            // Fall back - if no type was detected, always use string
            if (!col.sType) col.sType = 'string';
        }
        // Set class names for header / footer for auto type classes
        var autoClass = $44bb6d473543b89d$var$_ext.type.className[col.sType];
        if (autoClass) {
            $44bb6d473543b89d$var$_columnAutoClass(settings.aoHeader, i, autoClass);
            $44bb6d473543b89d$var$_columnAutoClass(settings.aoFooter, i, autoClass);
        }
        var renderer = $44bb6d473543b89d$var$_ext.type.render[col.sType];
        // This can only happen once! There is no way to remove
        // a renderer. After the first time the renderer has
        // already been set so createTr will run the renderer itself.
        if (renderer && !col._render) {
            col._render = $44bb6d473543b89d$var$DataTable.util.get(renderer);
            $44bb6d473543b89d$var$_columnAutoRender(settings, i);
        }
    }
}
/**
 * Apply an auto detected renderer to data which doesn't yet have
 * a renderer
 */ function $44bb6d473543b89d$var$_columnAutoRender(settings, colIdx) {
    var data = settings.aoData;
    for(var i = 0; i < data.length; i++)if (data[i].nTr) {
        // We have to update the display here since there is no
        // invalidation check for the data
        var display = $44bb6d473543b89d$var$_fnGetCellData(settings, i, colIdx, 'display');
        data[i].displayData[colIdx] = display;
        $44bb6d473543b89d$var$_fnWriteCell(data[i].anCells[colIdx], display);
    // No need to update sort / filter data since it has
    // been invalidated and will be re-read with the
    // renderer now applied
    }
}
/**
 * Apply a class name to a column's header cells
 */ function $44bb6d473543b89d$var$_columnAutoClass(container, colIdx, className) {
    container.forEach(function(row) {
        if (row[colIdx] && row[colIdx].unique) $44bb6d473543b89d$var$_addClass(row[colIdx].cell, className);
    });
}
/**
 * Take the column definitions and static columns arrays and calculate how
 * they relate to column indexes. The callback function will then apply the
 * definition found for a column to a suitable configuration object.
 *  @param {object} oSettings dataTables settings object
 *  @param {array} aoColDefs The aoColumnDefs array that is to be applied
 *  @param {array} aoCols The aoColumns array that defines columns individually
 *  @param {array} headerLayout Layout for header as it was loaded
 *  @param {function} fn Callback function - takes two parameters, the calculated
 *    column index and the definition for that column.
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnApplyColumnDefs(oSettings, aoColDefs, aoCols, headerLayout, fn) {
    var i, iLen, j, jLen, k, kLen, def;
    var columns = oSettings.aoColumns;
    if (aoCols) {
        for(i = 0, iLen = aoCols.length; i < iLen; i++)if (aoCols[i] && aoCols[i].name) columns[i].sName = aoCols[i].name;
    }
    // Column definitions with aTargets
    if (aoColDefs) /* Loop over the definitions array - loop in reverse so first instance has priority */ for(i = aoColDefs.length - 1; i >= 0; i--){
        def = aoColDefs[i];
        /* Each definition can target multiple columns, as it is an array */ var aTargets = def.target !== undefined ? def.target : def.targets !== undefined ? def.targets : def.aTargets;
        if (!Array.isArray(aTargets)) aTargets = [
            aTargets
        ];
        for(j = 0, jLen = aTargets.length; j < jLen; j++){
            var target = aTargets[j];
            if (typeof target === 'number' && target >= 0) {
                /* Add columns that we don't yet know about */ while(columns.length <= target)$44bb6d473543b89d$var$_fnAddColumn(oSettings);
                /* Integer, basic index */ fn(target, def);
            } else if (typeof target === 'number' && target < 0) /* Negative integer, right to left column counting */ fn(columns.length + target, def);
            else if (typeof target === 'string') for(k = 0, kLen = columns.length; k < kLen; k++){
                if (target === '_all') // Apply to all columns
                fn(k, def);
                else if (target.indexOf(':name') !== -1) // Column selector
                {
                    if (columns[k].sName === target.replace(':name', '')) fn(k, def);
                } else // Cell selector
                headerLayout.forEach(function(row) {
                    if (row[k]) {
                        var cell = $44bb6d473543b89d$var$$(row[k].cell);
                        // Legacy support. Note that it means that we don't support
                        // an element name selector only, since they are treated as
                        // class names for 1.x compat.
                        if (target.match(/^[a-z][\w-]*$/i)) target = '.' + target;
                        if (cell.is(target)) fn(k, def);
                    }
                });
            }
        }
    }
    // Statically defined columns array
    if (aoCols) for(i = 0, iLen = aoCols.length; i < iLen; i++)fn(i, aoCols[i]);
}
/**
 * Get the width for a given set of columns
 *
 * @param {*} settings DataTables settings object
 * @param {*} targets Columns - comma separated string or array of numbers
 * @param {*} original Use the original width (true) or calculated (false)
 * @param {*} incVisible Include visible columns (true) or not (false)
 * @returns Combined CSS value
 */ function $44bb6d473543b89d$var$_fnColumnsSumWidth(settings, targets, original, incVisible) {
    if (!Array.isArray(targets)) targets = $44bb6d473543b89d$var$_fnColumnsFromHeader(targets);
    var sum = 0;
    var unit;
    var columns = settings.aoColumns;
    for(var i = 0, iLen = targets.length; i < iLen; i++){
        var column = columns[targets[i]];
        var definedWidth = original ? column.sWidthOrig : column.sWidth;
        if (!incVisible && column.bVisible === false) continue;
        if (definedWidth === null || definedWidth === undefined) return null; // can't determine a defined width - browser defined
        else if (typeof definedWidth === 'number') {
            unit = 'px';
            sum += definedWidth;
        } else {
            var matched = definedWidth.match(/([\d\.]+)([^\d]*)/);
            if (matched) {
                sum += matched[1] * 1;
                unit = matched.length === 3 ? matched[2] : 'px';
            }
        }
    }
    return sum + unit;
}
function $44bb6d473543b89d$var$_fnColumnsFromHeader(cell) {
    var attr = $44bb6d473543b89d$var$$(cell).closest('[data-dt-column]').attr('data-dt-column');
    if (!attr) return [];
    return attr.split(',').map(function(val) {
        return val * 1;
    });
}
/**
 * Add a data array to the table, creating DOM node etc. This is the parallel to
 * _fnGatherData, but for adding rows from a JavaScript source, rather than a
 * DOM source.
 *  @param {object} settings dataTables settings object
 *  @param {array} data data array to be added
 *  @param {node} [tr] TR element to add to the table - optional. If not given,
 *    DataTables will create a row automatically
 *  @param {array} [tds] Array of TD|TH elements for the row - must be given
 *    if nTr is.
 *  @returns {int} >=0 if successful (index of new aoData entry), -1 if failed
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnAddData(settings, dataIn, tr, tds) {
    /* Create the object for storing information about this new row */ var rowIdx = settings.aoData.length;
    var rowModel = $44bb6d473543b89d$var$$.extend(true, {}, $44bb6d473543b89d$var$DataTable.models.oRow, {
        src: tr ? 'dom' : 'data',
        idx: rowIdx
    });
    rowModel._aData = dataIn;
    settings.aoData.push(rowModel);
    var columns = settings.aoColumns;
    for(var i = 0, iLen = columns.length; i < iLen; i++)// Invalidate the column types as the new data needs to be revalidated
    columns[i].sType = null;
    /* Add to the display array */ settings.aiDisplayMaster.push(rowIdx);
    var id = settings.rowIdFn(dataIn);
    if (id !== undefined) settings.aIds[id] = rowModel;
    /* Create the DOM information, or register it if already present */ if (tr || !settings.oFeatures.bDeferRender) $44bb6d473543b89d$var$_fnCreateTr(settings, rowIdx, tr, tds);
    return rowIdx;
}
/**
 * Add one or more TR elements to the table. Generally we'd expect to
 * use this for reading data from a DOM sourced table, but it could be
 * used for an TR element. Note that if a TR is given, it is used (i.e.
 * it is not cloned).
 *  @param {object} settings dataTables settings object
 *  @param {array|node|jQuery} trs The TR element(s) to add to the table
 *  @returns {array} Array of indexes for the added rows
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnAddTr(settings, trs) {
    var row;
    // Allow an individual node to be passed in
    if (!(trs instanceof $44bb6d473543b89d$var$$)) trs = $44bb6d473543b89d$var$$(trs);
    return trs.map(function(i, el) {
        row = $44bb6d473543b89d$var$_fnGetRowElements(settings, el);
        return $44bb6d473543b89d$var$_fnAddData(settings, row.data, el, row.cells);
    });
}
/**
 * Get the data for a given cell from the internal cache, taking into account data mapping
 *  @param {object} settings dataTables settings object
 *  @param {int} rowIdx aoData row id
 *  @param {int} colIdx Column index
 *  @param {string} type data get type ('display', 'type' 'filter|search' 'sort|order')
 *  @returns {*} Cell data
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnGetCellData(settings, rowIdx, colIdx, type) {
    if (type === 'search') type = 'filter';
    else if (type === 'order') type = 'sort';
    var row = settings.aoData[rowIdx];
    if (!row) return undefined;
    var draw = settings.iDraw;
    var col = settings.aoColumns[colIdx];
    var rowData = row._aData;
    var defaultContent = col.sDefaultContent;
    var cellData = col.fnGetData(rowData, type, {
        settings: settings,
        row: rowIdx,
        col: colIdx
    });
    // Allow for a node being returned for non-display types
    if (type !== 'display' && cellData && typeof cellData === 'object' && cellData.nodeName) cellData = cellData.innerHTML;
    if (cellData === undefined) {
        if (settings.iDrawError != draw && defaultContent === null) {
            $44bb6d473543b89d$var$_fnLog(settings, 0, "Requested unknown parameter " + (typeof col.mData == 'function' ? '{function}' : "'" + col.mData + "'") + " for row " + rowIdx + ", column " + colIdx, 4);
            settings.iDrawError = draw;
        }
        return defaultContent;
    }
    // When the data source is null and a specific data type is requested (i.e.
    // not the original data), we can use default column data
    if ((cellData === rowData || cellData === null) && defaultContent !== null && type !== undefined) cellData = defaultContent;
    else if (typeof cellData === 'function') // If the data source is a function, then we run it and use the return,
    // executing in the scope of the data object (for instances)
    return cellData.call(rowData);
    if (cellData === null && type === 'display') return '';
    if (type === 'filter') {
        var formatters = $44bb6d473543b89d$var$DataTable.ext.type.search;
        if (formatters[col.sType]) cellData = formatters[col.sType](cellData);
    }
    return cellData;
}
/**
 * Set the value for a specific cell, into the internal data cache
 *  @param {object} settings dataTables settings object
 *  @param {int} rowIdx aoData row id
 *  @param {int} colIdx Column index
 *  @param {*} val Value to set
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnSetCellData(settings, rowIdx, colIdx, val) {
    var col = settings.aoColumns[colIdx];
    var rowData = settings.aoData[rowIdx]._aData;
    col.fnSetData(rowData, val, {
        settings: settings,
        row: rowIdx,
        col: colIdx
    });
}
/**
 * Write a value to a cell
 * @param {*} td Cell
 * @param {*} val Value
 */ function $44bb6d473543b89d$var$_fnWriteCell(td, val) {
    if (val && typeof val === 'object' && val.nodeName) $44bb6d473543b89d$var$$(td).empty().append(val);
    else td.innerHTML = val;
}
// Private variable that is used to match action syntax in the data property object
var $44bb6d473543b89d$var$__reArray = /\[.*?\]$/;
var $44bb6d473543b89d$var$__reFn = /\(\)$/;
/**
 * Split string on periods, taking into account escaped periods
 * @param  {string} str String to split
 * @return {array} Split string
 */ function $44bb6d473543b89d$var$_fnSplitObjNotation(str) {
    var parts = str.match(/(\\.|[^.])+/g) || [
        ''
    ];
    return parts.map(function(s) {
        return s.replace(/\\\./g, '.');
    });
}
/**
 * Return a function that can be used to get data from a source object, taking
 * into account the ability to use nested objects as a source
 *  @param {string|int|function} mSource The data source for the object
 *  @returns {function} Data get function
 *  @memberof DataTable#oApi
 */ var $44bb6d473543b89d$var$_fnGetObjectDataFn = $44bb6d473543b89d$var$DataTable.util.get;
/**
 * Return a function that can be used to set data from a source object, taking
 * into account the ability to use nested objects as a source
 *  @param {string|int|function} mSource The data source for the object
 *  @returns {function} Data set function
 *  @memberof DataTable#oApi
 */ var $44bb6d473543b89d$var$_fnSetObjectDataFn = $44bb6d473543b89d$var$DataTable.util.set;
/**
 * Return an array with the full table data
 *  @param {object} oSettings dataTables settings object
 *  @returns array {array} aData Master data array
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnGetDataMaster(settings) {
    return $44bb6d473543b89d$var$_pluck(settings.aoData, '_aData');
}
/**
 * Nuke the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnClearTable(settings) {
    settings.aoData.length = 0;
    settings.aiDisplayMaster.length = 0;
    settings.aiDisplay.length = 0;
    settings.aIds = {};
}
/**
 * Mark cached data as invalid such that a re-read of the data will occur when
 * the cached data is next requested. Also update from the data source object.
 *
 * @param {object} settings DataTables settings object
 * @param {int}    rowIdx   Row index to invalidate
 * @param {string} [src]    Source to invalidate from: undefined, 'auto', 'dom'
 *     or 'data'
 * @param {int}    [colIdx] Column index to invalidate. If undefined the whole
 *     row will be invalidated
 * @memberof DataTable#oApi
 *
 * @todo For the modularisation of v1.11 this will need to become a callback, so
 *   the sort and filter methods can subscribe to it. That will required
 *   initialisation options for sorting, which is why it is not already baked in
 */ function $44bb6d473543b89d$var$_fnInvalidate(settings, rowIdx, src, colIdx) {
    var row = settings.aoData[rowIdx];
    var i, iLen;
    // Remove the cached data for the row
    row._aSortData = null;
    row._aFilterData = null;
    row.displayData = null;
    // Are we reading last data from DOM or the data object?
    if (src === 'dom' || (!src || src === 'auto') && row.src === 'dom') // Read the data from the DOM
    row._aData = $44bb6d473543b89d$var$_fnGetRowElements(settings, row, colIdx, colIdx === undefined ? undefined : row._aData).data;
    else {
        // Reading from data object, update the DOM
        var cells = row.anCells;
        var display = $44bb6d473543b89d$var$_fnGetRowDisplay(settings, rowIdx);
        if (cells) {
            if (colIdx !== undefined) $44bb6d473543b89d$var$_fnWriteCell(cells[colIdx], display[colIdx]);
            else for(i = 0, iLen = cells.length; i < iLen; i++)$44bb6d473543b89d$var$_fnWriteCell(cells[i], display[i]);
        }
    }
    // Column specific invalidation
    var cols = settings.aoColumns;
    if (colIdx !== undefined) {
        // Type - the data might have changed
        cols[colIdx].sType = null;
        // Max length string. Its a fairly cheep recalculation, so not worth
        // something more complicated
        cols[colIdx].wideStrings = null;
    } else {
        for(i = 0, iLen = cols.length; i < iLen; i++){
            cols[i].sType = null;
            cols[i].wideStrings = null;
        }
        // Update DataTables special `DT_*` attributes for the row
        $44bb6d473543b89d$var$_fnRowAttributes(settings, row);
    }
}
/**
 * Build a data source object from an HTML row, reading the contents of the
 * cells that are in the row.
 *
 * @param {object} settings DataTables settings object
 * @param {node|object} TR element from which to read data or existing row
 *   object from which to re-read the data from the cells
 * @param {int} [colIdx] Optional column index
 * @param {array|object} [d] Data source object. If `colIdx` is given then this
 *   parameter should also be given and will be used to write the data into.
 *   Only the column in question will be written
 * @returns {object} Object with two parameters: `data` the data read, in
 *   document order, and `cells` and array of nodes (they can be useful to the
 *   caller, so rather than needing a second traversal to get them, just return
 *   them from here).
 * @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnGetRowElements(settings, row, colIdx, d) {
    var tds = [], td = row.firstChild, name, col, i = 0, contents, columns = settings.aoColumns, objectRead = settings._rowReadObject;
    // Allow the data object to be passed in, or construct
    d = d !== undefined ? d : objectRead ? {} : [];
    var attr = function(str, td) {
        if (typeof str === 'string') {
            var idx = str.indexOf('@');
            if (idx !== -1) {
                var attr = str.substring(idx + 1);
                var setter = $44bb6d473543b89d$var$_fnSetObjectDataFn(str);
                setter(d, td.getAttribute(attr));
            }
        }
    };
    // Read data from a cell and store into the data object
    var cellProcess = function(cell) {
        if (colIdx === undefined || colIdx === i) {
            col = columns[i];
            contents = cell.innerHTML.trim();
            if (col && col._bAttrSrc) {
                var setter = $44bb6d473543b89d$var$_fnSetObjectDataFn(col.mData._);
                setter(d, contents);
                attr(col.mData.sort, cell);
                attr(col.mData.type, cell);
                attr(col.mData.filter, cell);
            } else // Depending on the `data` option for the columns the data can
            // be read to either an object or an array.
            if (objectRead) {
                if (!col._setter) // Cache the setter function
                col._setter = $44bb6d473543b89d$var$_fnSetObjectDataFn(col.mData);
                col._setter(d, contents);
            } else d[i] = contents;
        }
        i++;
    };
    if (td) // `tr` element was passed in
    while(td){
        name = td.nodeName.toUpperCase();
        if (name == "TD" || name == "TH") {
            cellProcess(td);
            tds.push(td);
        }
        td = td.nextSibling;
    }
    else {
        // Existing row object passed in
        tds = row.anCells;
        for(var j = 0, jen = tds.length; j < jen; j++)cellProcess(tds[j]);
    }
    // Read the ID from the DOM if present
    var rowNode = row.firstChild ? row : row.nTr;
    if (rowNode) {
        var id = rowNode.getAttribute('id');
        if (id) $44bb6d473543b89d$var$_fnSetObjectDataFn(settings.rowId)(d, id);
    }
    return {
        data: d,
        cells: tds
    };
}
/**
 * Render and cache a row's display data for the columns, if required
 * @returns 
 */ function $44bb6d473543b89d$var$_fnGetRowDisplay(settings, rowIdx) {
    var rowModal = settings.aoData[rowIdx];
    var columns = settings.aoColumns;
    if (!rowModal.displayData) {
        // Need to render and cache
        rowModal.displayData = [];
        for(var colIdx = 0, len = columns.length; colIdx < len; colIdx++)rowModal.displayData.push($44bb6d473543b89d$var$_fnGetCellData(settings, rowIdx, colIdx, 'display'));
    }
    return rowModal.displayData;
}
/**
 * Create a new TR element (and it's TD children) for a row
 *  @param {object} oSettings dataTables settings object
 *  @param {int} iRow Row to consider
 *  @param {node} [nTrIn] TR element to add to the table - optional. If not given,
 *    DataTables will create a row automatically
 *  @param {array} [anTds] Array of TD|TH elements for the row - must be given
 *    if nTr is.
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnCreateTr(oSettings, iRow, nTrIn, anTds) {
    var row = oSettings.aoData[iRow], rowData = row._aData, cells = [], nTr, nTd, oCol, i, iLen, create, trClass = oSettings.oClasses.tbody.row;
    if (row.nTr === null) {
        nTr = nTrIn || document.createElement('tr');
        row.nTr = nTr;
        row.anCells = cells;
        $44bb6d473543b89d$var$_addClass(nTr, trClass);
        /* Use a private property on the node to allow reserve mapping from the node
		 * to the aoData array for fast look up
		 */ nTr._DT_RowIndex = iRow;
        /* Special parameters can be given by the data source to be used on the row */ $44bb6d473543b89d$var$_fnRowAttributes(oSettings, row);
        /* Process each column */ for(i = 0, iLen = oSettings.aoColumns.length; i < iLen; i++){
            oCol = oSettings.aoColumns[i];
            create = nTrIn && anTds[i] ? false : true;
            nTd = create ? document.createElement(oCol.sCellType) : anTds[i];
            if (!nTd) $44bb6d473543b89d$var$_fnLog(oSettings, 0, 'Incorrect column count', 18);
            nTd._DT_CellIndex = {
                row: iRow,
                column: i
            };
            cells.push(nTd);
            var display = $44bb6d473543b89d$var$_fnGetRowDisplay(oSettings, iRow);
            // Need to create the HTML if new, or if a rendering function is defined
            if (create || (oCol.mRender || oCol.mData !== i) && (!$44bb6d473543b89d$var$$.isPlainObject(oCol.mData) || oCol.mData._ !== i + '.display')) $44bb6d473543b89d$var$_fnWriteCell(nTd, display[i]);
            // column class
            $44bb6d473543b89d$var$_addClass(nTd, oCol.sClass);
            // Visibility - add or remove as required
            if (oCol.bVisible && create) nTr.appendChild(nTd);
            else if (!oCol.bVisible && !create) nTd.parentNode.removeChild(nTd);
            if (oCol.fnCreatedCell) oCol.fnCreatedCell.call(oSettings.oInstance, nTd, $44bb6d473543b89d$var$_fnGetCellData(oSettings, iRow, i), rowData, iRow, i);
        }
        $44bb6d473543b89d$var$_fnCallbackFire(oSettings, 'aoRowCreatedCallback', 'row-created', [
            nTr,
            rowData,
            iRow,
            cells
        ]);
    } else $44bb6d473543b89d$var$_addClass(row.nTr, trClass);
}
/**
 * Add attributes to a row based on the special `DT_*` parameters in a data
 * source object.
 *  @param {object} settings DataTables settings object
 *  @param {object} DataTables row object for the row to be modified
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnRowAttributes(settings, row) {
    var tr = row.nTr;
    var data = row._aData;
    if (tr) {
        var id = settings.rowIdFn(data);
        if (id) tr.id = id;
        if (data.DT_RowClass) {
            // Remove any classes added by DT_RowClass before
            var a = data.DT_RowClass.split(' ');
            row.__rowc = row.__rowc ? $44bb6d473543b89d$var$_unique(row.__rowc.concat(a)) : a;
            $44bb6d473543b89d$var$$(tr).removeClass(row.__rowc.join(' ')).addClass(data.DT_RowClass);
        }
        if (data.DT_RowAttr) $44bb6d473543b89d$var$$(tr).attr(data.DT_RowAttr);
        if (data.DT_RowData) $44bb6d473543b89d$var$$(tr).data(data.DT_RowData);
    }
}
/**
 * Create the HTML header for the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnBuildHead(settings, side) {
    var classes = settings.oClasses;
    var columns = settings.aoColumns;
    var i, iLen, row;
    var target = side === 'header' ? settings.nTHead : settings.nTFoot;
    var titleProp = side === 'header' ? 'sTitle' : side;
    // Footer might be defined
    if (!target) return;
    // If no cells yet and we have content for them, then create
    if (side === 'header' || $44bb6d473543b89d$var$_pluck(settings.aoColumns, titleProp).join('')) {
        row = $44bb6d473543b89d$var$$('tr', target);
        // Add a row if needed
        if (!row.length) row = $44bb6d473543b89d$var$$('<tr/>').appendTo(target);
        // Add the number of cells needed to make up to the number of columns
        if (row.length === 1) {
            var cellCount = 0;
            $44bb6d473543b89d$var$$('td, th', row).each(function() {
                cellCount += this.colSpan;
            });
            for(i = cellCount, iLen = columns.length; i < iLen; i++)$44bb6d473543b89d$var$$('<th/>').html(columns[i][titleProp] || '').appendTo(row);
        }
    }
    var detected = $44bb6d473543b89d$var$_fnDetectHeader(settings, target, true);
    if (side === 'header') {
        settings.aoHeader = detected;
        $44bb6d473543b89d$var$$('tr', target).addClass(classes.thead.row);
    } else {
        settings.aoFooter = detected;
        $44bb6d473543b89d$var$$('tr', target).addClass(classes.tfoot.row);
    }
    // Every cell needs to be passed through the renderer
    $44bb6d473543b89d$var$$(target).children('tr').children('th, td').each(function() {
        $44bb6d473543b89d$var$_fnRenderer(settings, side)(settings, $44bb6d473543b89d$var$$(this), classes);
    });
}
/**
 * Build a layout structure for a header or footer
 *
 * @param {*} settings DataTables settings
 * @param {*} source Source layout array
 * @param {*} incColumns What columns should be included
 * @returns Layout array in column index order
 */ function $44bb6d473543b89d$var$_fnHeaderLayout(settings, source, incColumns) {
    var row, column, cell;
    var local = [];
    var structure = [];
    var columns = settings.aoColumns;
    var columnCount = columns.length;
    var rowspan, colspan;
    if (!source) return;
    // Default is to work on only visible columns
    if (!incColumns) incColumns = $44bb6d473543b89d$var$_range(columnCount).filter(function(idx) {
        return columns[idx].bVisible;
    });
    // Make a copy of the master layout array, but with only the columns we want
    for(row = 0; row < source.length; row++){
        // Remove any columns we haven't selected
        local[row] = source[row].slice().filter(function(cell, i) {
            return incColumns.includes(i);
        });
        // Prep the structure array - it needs an element for each row
        structure.push([]);
    }
    for(row = 0; row < local.length; row++)for(column = 0; column < local[row].length; column++){
        rowspan = 1;
        colspan = 1;
        // Check to see if there is already a cell (row/colspan) covering our target
        // insert point. If there is, then there is nothing to do.
        if (structure[row][column] === undefined) {
            cell = local[row][column].cell;
            // Expand for rowspan
            while(local[row + rowspan] !== undefined && local[row][column].cell == local[row + rowspan][column].cell){
                structure[row + rowspan][column] = null;
                rowspan++;
            }
            // And for colspan
            while(local[row][column + colspan] !== undefined && local[row][column].cell == local[row][column + colspan].cell){
                // Which also needs to go over rows
                for(var k = 0; k < rowspan; k++)structure[row + k][column + colspan] = null;
                colspan++;
            }
            var titleSpan = $44bb6d473543b89d$var$$('.dt-column-title', cell);
            structure[row][column] = {
                cell: cell,
                colspan: colspan,
                rowspan: rowspan,
                title: titleSpan.length ? titleSpan.html() : $44bb6d473543b89d$var$$(cell).html()
            };
        }
    }
    return structure;
}
/**
 * Draw the header (or footer) element based on the column visibility states.
 *
 *  @param object oSettings dataTables settings object
 *  @param array aoSource Layout array from _fnDetectHeader
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnDrawHead(settings, source) {
    var layout = $44bb6d473543b89d$var$_fnHeaderLayout(settings, source);
    var tr, n;
    for(var row = 0; row < source.length; row++){
        tr = source[row].row;
        // All cells are going to be replaced, so empty out the row
        // Can't use $().empty() as that kills event handlers
        if (tr) while(n = tr.firstChild)tr.removeChild(n);
        for(var column = 0; column < layout[row].length; column++){
            var point = layout[row][column];
            if (point) $44bb6d473543b89d$var$$(point.cell).appendTo(tr).attr('rowspan', point.rowspan).attr('colspan', point.colspan);
        }
    }
}
/**
 * Insert the required TR nodes into the table for display
 *  @param {object} oSettings dataTables settings object
 *  @param ajaxComplete true after ajax call to complete rendering
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnDraw(oSettings, ajaxComplete) {
    // Allow for state saving and a custom start position
    $44bb6d473543b89d$var$_fnStart(oSettings);
    /* Provide a pre-callback function which can be used to cancel the draw is false is returned */ var aPreDraw = $44bb6d473543b89d$var$_fnCallbackFire(oSettings, 'aoPreDrawCallback', 'preDraw', [
        oSettings
    ]);
    if (aPreDraw.indexOf(false) !== -1) {
        $44bb6d473543b89d$var$_fnProcessingDisplay(oSettings, false);
        return;
    }
    var anRows = [];
    var iRowCount = 0;
    var bServerSide = $44bb6d473543b89d$var$_fnDataSource(oSettings) == 'ssp';
    var aiDisplay = oSettings.aiDisplay;
    var iDisplayStart = oSettings._iDisplayStart;
    var iDisplayEnd = oSettings.fnDisplayEnd();
    var columns = oSettings.aoColumns;
    var body = $44bb6d473543b89d$var$$(oSettings.nTBody);
    oSettings.bDrawing = true;
    /* Server-side processing draw intercept */ if (oSettings.deferLoading) {
        oSettings.deferLoading = false;
        oSettings.iDraw++;
        $44bb6d473543b89d$var$_fnProcessingDisplay(oSettings, false);
    } else if (!bServerSide) oSettings.iDraw++;
    else if (!oSettings.bDestroying && !ajaxComplete) {
        // Show loading message for server-side processing
        if (oSettings.iDraw === 0) body.empty().append($44bb6d473543b89d$var$_emptyRow(oSettings));
        $44bb6d473543b89d$var$_fnAjaxUpdate(oSettings);
        return;
    }
    if (aiDisplay.length !== 0) {
        var iStart = bServerSide ? 0 : iDisplayStart;
        var iEnd = bServerSide ? oSettings.aoData.length : iDisplayEnd;
        for(var j = iStart; j < iEnd; j++){
            var iDataIndex = aiDisplay[j];
            var aoData = oSettings.aoData[iDataIndex];
            // Row has been deleted - can't be displayed
            if (aoData === null) continue;
            // Row node hasn't been created yet
            if (aoData.nTr === null) $44bb6d473543b89d$var$_fnCreateTr(oSettings, iDataIndex);
            var nRow = aoData.nTr;
            // Add various classes as needed
            for(var i = 0; i < columns.length; i++){
                var col = columns[i];
                var td = aoData.anCells[i];
                $44bb6d473543b89d$var$_addClass(td, $44bb6d473543b89d$var$_ext.type.className[col.sType]); // auto class
                $44bb6d473543b89d$var$_addClass(td, oSettings.oClasses.tbody.cell); // all cells
            }
            // Row callback functions - might want to manipulate the row
            // iRowCount and j are not currently documented. Are they at all
            // useful?
            $44bb6d473543b89d$var$_fnCallbackFire(oSettings, 'aoRowCallback', null, [
                nRow,
                aoData._aData,
                iRowCount,
                j,
                iDataIndex
            ]);
            anRows.push(nRow);
            iRowCount++;
        }
    } else anRows[0] = $44bb6d473543b89d$var$_emptyRow(oSettings);
    /* Header and footer callbacks */ $44bb6d473543b89d$var$_fnCallbackFire(oSettings, 'aoHeaderCallback', 'header', [
        $44bb6d473543b89d$var$$(oSettings.nTHead).children('tr')[0],
        $44bb6d473543b89d$var$_fnGetDataMaster(oSettings),
        iDisplayStart,
        iDisplayEnd,
        aiDisplay
    ]);
    $44bb6d473543b89d$var$_fnCallbackFire(oSettings, 'aoFooterCallback', 'footer', [
        $44bb6d473543b89d$var$$(oSettings.nTFoot).children('tr')[0],
        $44bb6d473543b89d$var$_fnGetDataMaster(oSettings),
        iDisplayStart,
        iDisplayEnd,
        aiDisplay
    ]);
    // replaceChildren is faster, but only became widespread in 2020,
    // so a fall back in jQuery is provided for older browsers.
    if (body[0].replaceChildren) body[0].replaceChildren.apply(body[0], anRows);
    else {
        body.children().detach();
        body.append($44bb6d473543b89d$var$$(anRows));
    }
    // Empty table needs a specific class
    $44bb6d473543b89d$var$$(oSettings.nTableWrapper).toggleClass('dt-empty-footer', $44bb6d473543b89d$var$$('tr', oSettings.nTFoot).length === 0);
    /* Call all required callback functions for the end of a draw */ $44bb6d473543b89d$var$_fnCallbackFire(oSettings, 'aoDrawCallback', 'draw', [
        oSettings
    ], true);
    /* Draw is complete, sorting and filtering must be as well */ oSettings.bSorted = false;
    oSettings.bFiltered = false;
    oSettings.bDrawing = false;
}
/**
 * Redraw the table - taking account of the various features which are enabled
 *  @param {object} oSettings dataTables settings object
 *  @param {boolean} [holdPosition] Keep the current paging position. By default
 *    the paging is reset to the first page
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnReDraw(settings, holdPosition, recompute) {
    var features = settings.oFeatures, sort = features.bSort, filter = features.bFilter;
    if (recompute === undefined || recompute === true) {
        // Resolve any column types that are unknown due to addition or invalidation
        $44bb6d473543b89d$var$_fnColumnTypes(settings);
        if (sort) $44bb6d473543b89d$var$_fnSort(settings);
        if (filter) $44bb6d473543b89d$var$_fnFilterComplete(settings, settings.oPreviousSearch);
        else // No filtering, so we want to just use the display master
        settings.aiDisplay = settings.aiDisplayMaster.slice();
    }
    if (holdPosition !== true) settings._iDisplayStart = 0;
    else // Keep position, but make sure that there is actually data to display,
    // otherwise we need to rewind a bit (e.g. if rows were deleted)
    $44bb6d473543b89d$var$_fnLengthOverflow(settings);
    // Let any modules know about the draw hold position state (used by
    // scrolling internally)
    settings._drawHold = holdPosition;
    $44bb6d473543b89d$var$_fnDraw(settings);
    settings.api.one('draw', function() {
        settings._drawHold = false;
    });
}
/*
 * Table is empty - create a row with an empty message in it
 */ function $44bb6d473543b89d$var$_emptyRow(settings) {
    var oLang = settings.oLanguage;
    var zero = oLang.sZeroRecords;
    var dataSrc = $44bb6d473543b89d$var$_fnDataSource(settings);
    // Make use of the fact that settings.json is only set once the initial data has
    // been loaded. Show loading when that isn't the case
    if ((dataSrc === 'ssp' || dataSrc === 'ajax') && !settings.json) zero = oLang.sLoadingRecords;
    else if (oLang.sEmptyTable && settings.fnRecordsTotal() === 0) zero = oLang.sEmptyTable;
    return $44bb6d473543b89d$var$$('<tr/>').append($44bb6d473543b89d$var$$('<td />', {
        'colSpan': $44bb6d473543b89d$var$_fnVisibleColumns(settings),
        'class': settings.oClasses.empty.row
    }).html(zero))[0];
}
/**
 * Expand the layout items into an object for the rendering function
 */ function $44bb6d473543b89d$var$_layoutItems(row, align, items) {
    if (Array.isArray(items)) {
        for(var i = 0; i < items.length; i++)$44bb6d473543b89d$var$_layoutItems(row, align, items[i]);
        return;
    }
    var rowCell = row[align];
    // If it is an object, then there can be multiple features contained in it
    if ($44bb6d473543b89d$var$$.isPlainObject(items)) {
        // A feature plugin cannot be named "features" due to this check
        if (items.features) {
            if (items.rowId) row.id = items.rowId;
            if (items.rowClass) row.className = items.rowClass;
            rowCell.id = items.id;
            rowCell.className = items.className;
            $44bb6d473543b89d$var$_layoutItems(row, align, items.features);
        } else Object.keys(items).map(function(key) {
            rowCell.contents.push({
                feature: key,
                opts: items[key]
            });
        });
    } else rowCell.contents.push(items);
}
/**
 * Find, or create a layout row
 */ function $44bb6d473543b89d$var$_layoutGetRow(rows, rowNum, align) {
    var row;
    // Find existing rows
    for(var i = 0; i < rows.length; i++){
        row = rows[i];
        if (row.rowNum === rowNum) // full is on its own, but start and end share a row
        {
            if (align === 'full' && row.full || (align === 'start' || align === 'end') && (row.start || row.end)) {
                if (!row[align]) row[align] = {
                    contents: []
                };
                return row;
            }
        }
    }
    // If we get this far, then there was no match, create a new row
    row = {
        rowNum: rowNum
    };
    row[align] = {
        contents: []
    };
    rows.push(row);
    return row;
}
/**
 * Convert a `layout` object given by a user to the object structure needed
 * for the renderer. This is done twice, once for above and once for below
 * the table. Ordering must also be considered.
 *
 * @param {*} settings DataTables settings object
 * @param {*} layout Layout object to convert
 * @param {string} side `top` or `bottom`
 * @returns Converted array structure - one item for each row.
 */ function $44bb6d473543b89d$var$_layoutArray(settings, layout, side) {
    var rows = [];
    // Split out into an array
    $44bb6d473543b89d$var$$.each(layout, function(pos, items) {
        if (items === null) return;
        var parts = pos.match(/^([a-z]+)([0-9]*)([A-Za-z]*)$/);
        var rowNum = parts[2] ? parts[2] * 1 : 0;
        var align = parts[3] ? parts[3].toLowerCase() : 'full';
        // Filter out the side we aren't interested in
        if (parts[1] !== side) return;
        // Get or create the row we should attach to
        var row = $44bb6d473543b89d$var$_layoutGetRow(rows, rowNum, align);
        $44bb6d473543b89d$var$_layoutItems(row, align, items);
    });
    // Order by item identifier
    rows.sort(function(a, b) {
        var order1 = a.rowNum;
        var order2 = b.rowNum;
        // If both in the same row, then the row with `full` comes first
        if (order1 === order2) {
            var ret = a.full && !b.full ? -1 : 1;
            return side === 'bottom' ? ret * -1 : ret;
        }
        return order2 - order1;
    });
    // Invert for below the table
    if (side === 'bottom') rows.reverse();
    for(var row = 0; row < rows.length; row++){
        delete rows[row].rowNum;
        $44bb6d473543b89d$var$_layoutResolve(settings, rows[row]);
    }
    return rows;
}
/**
 * Convert the contents of a row's layout object to nodes that can be inserted
 * into the document by a renderer. Execute functions, look up plug-ins, etc.
 *
 * @param {*} settings DataTables settings object
 * @param {*} row Layout object for this row
 */ function $44bb6d473543b89d$var$_layoutResolve(settings, row) {
    var getFeature = function(feature, opts) {
        if (!$44bb6d473543b89d$var$_ext.features[feature]) $44bb6d473543b89d$var$_fnLog(settings, 0, 'Unknown feature: ' + feature);
        return $44bb6d473543b89d$var$_ext.features[feature].apply(this, [
            settings,
            opts
        ]);
    };
    var resolve = function(item) {
        if (!row[item]) return;
        var line = row[item].contents;
        for(var i = 0, iLen = line.length; i < iLen; i++){
            if (!line[i]) continue;
            else if (typeof line[i] === 'string') line[i] = getFeature(line[i], null);
            else if ($44bb6d473543b89d$var$$.isPlainObject(line[i])) // If it's an object, it just has feature and opts properties from
            // the transform in _layoutArray
            line[i] = getFeature(line[i].feature, line[i].opts);
            else if (typeof line[i].node === 'function') line[i] = line[i].node(settings);
            else if (typeof line[i] === 'function') {
                var inst = line[i](settings);
                line[i] = typeof inst.node === 'function' ? inst.node() : inst;
            }
        }
    };
    resolve('start');
    resolve('end');
    resolve('full');
}
/**
 * Add the options to the page HTML for the table
 *  @param {object} settings DataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnAddOptionsHtml(settings) {
    var classes = settings.oClasses;
    var table = $44bb6d473543b89d$var$$(settings.nTable);
    // Wrapper div around everything DataTables controls
    var insert = $44bb6d473543b89d$var$$('<div/>').attr({
        id: settings.sTableId + '_wrapper',
        'class': classes.container
    }).insertBefore(table);
    settings.nTableWrapper = insert[0];
    if (settings.sDom) // Legacy
    $44bb6d473543b89d$var$_fnLayoutDom(settings, settings.sDom, insert);
    else {
        var top = $44bb6d473543b89d$var$_layoutArray(settings, settings.layout, 'top');
        var bottom = $44bb6d473543b89d$var$_layoutArray(settings, settings.layout, 'bottom');
        var renderer = $44bb6d473543b89d$var$_fnRenderer(settings, 'layout');
        // Everything above - the renderer will actually insert the contents into the document
        top.forEach(function(item) {
            renderer(settings, insert, item);
        });
        // The table - always the center of attention
        renderer(settings, insert, {
            full: {
                table: true,
                contents: [
                    $44bb6d473543b89d$var$_fnFeatureHtmlTable(settings)
                ]
            }
        });
        // Everything below
        bottom.forEach(function(item) {
            renderer(settings, insert, item);
        });
    }
    // Processing floats on top, so it isn't an inserted feature
    $44bb6d473543b89d$var$_processingHtml(settings);
}
/**
 * Draw the table with the legacy DOM property
 * @param {*} settings DT settings object
 * @param {*} dom DOM string
 * @param {*} insert Insert point
 */ function $44bb6d473543b89d$var$_fnLayoutDom(settings, dom, insert) {
    var parts = dom.match(/(".*?")|('.*?')|./g);
    var featureNode, option, newNode, next, attr;
    for(var i = 0; i < parts.length; i++){
        featureNode = null;
        option = parts[i];
        if (option == '<') {
            // New container div
            newNode = $44bb6d473543b89d$var$$('<div/>');
            // Check to see if we should append an id and/or a class name to the container
            next = parts[i + 1];
            if (next[0] == "'" || next[0] == '"') {
                attr = next.replace(/['"]/g, '');
                var id = '', className;
                /* The attribute can be in the format of "#id.class", "#id" or "class" This logic
				 * breaks the string into parts and applies them as needed
				 */ if (attr.indexOf('.') != -1) {
                    var split = attr.split('.');
                    id = split[0];
                    className = split[1];
                } else if (attr[0] == "#") id = attr;
                else className = attr;
                newNode.attr('id', id.substring(1)).addClass(className);
                i++; // Move along the position array
            }
            insert.append(newNode);
            insert = newNode;
        } else if (option == '>') // End container div
        insert = insert.parent();
        else if (option == 't') // Table
        featureNode = $44bb6d473543b89d$var$_fnFeatureHtmlTable(settings);
        else $44bb6d473543b89d$var$DataTable.ext.feature.forEach(function(feature) {
            if (option == feature.cFeature) featureNode = feature.fnInit(settings);
        });
        // Add to the display
        if (featureNode) insert.append(featureNode);
    }
}
/**
 * Use the DOM source to create up an array of header cells. The idea here is to
 * create a layout grid (array) of rows x columns, which contains a reference
 * to the cell at that point in the grid (regardless of col/rowspan), such that
 * any column / row could be removed and the new grid constructed
 *  @param {node} thead The header/footer element for the table
 *  @returns {array} Calculated layout array
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnDetectHeader(settings, thead, write) {
    var columns = settings.aoColumns;
    var rows = $44bb6d473543b89d$var$$(thead).children('tr');
    var row, cell;
    var i, k, l, iLen, shifted, column, colspan, rowspan;
    var titleRow = settings.titleRow;
    var isHeader = thead && thead.nodeName.toLowerCase() === 'thead';
    var layout = [];
    var unique;
    var shift = function(a, i, j) {
        var k = a[i];
        while(k[j])j++;
        return j;
    };
    // We know how many rows there are in the layout - so prep it
    for(i = 0, iLen = rows.length; i < iLen; i++)layout.push([]);
    for(i = 0, iLen = rows.length; i < iLen; i++){
        row = rows[i];
        column = 0;
        // For every cell in the row..
        cell = row.firstChild;
        while(cell){
            if (cell.nodeName.toUpperCase() == 'TD' || cell.nodeName.toUpperCase() == 'TH') {
                var cols = [];
                var jqCell = $44bb6d473543b89d$var$$(cell);
                // Get the col and rowspan attributes from the DOM and sanitise them
                colspan = cell.getAttribute('colspan') * 1;
                rowspan = cell.getAttribute('rowspan') * 1;
                colspan = !colspan || colspan === 0 || colspan === 1 ? 1 : colspan;
                rowspan = !rowspan || rowspan === 0 || rowspan === 1 ? 1 : rowspan;
                // There might be colspan cells already in this row, so shift our target
                // accordingly
                shifted = shift(layout, i, column);
                // Cache calculation for unique columns
                unique = colspan === 1 ? true : false;
                // Perform header setup
                if (write) {
                    if (unique) {
                        // Allow column options to be set from HTML attributes
                        $44bb6d473543b89d$var$_fnColumnOptions(settings, shifted, $44bb6d473543b89d$var$_fnEscapeObject(jqCell.data()));
                        // Get the width for the column. This can be defined from the
                        // width attribute, style attribute or `columns.width` option
                        var columnDef = columns[shifted];
                        var width = cell.getAttribute('width') || null;
                        var t = cell.style.width.match(/width:\s*(\d+[pxem%]+)/);
                        if (t) width = t[1];
                        columnDef.sWidthOrig = columnDef.sWidth || width;
                        if (isHeader) {
                            // Column title handling - can be user set, or read from the DOM
                            // This happens before the render, so the original is still in place
                            if (columnDef.sTitle !== null && !columnDef.autoTitle) {
                                if (titleRow === true && i === 0 || // top row
                                titleRow === false && i === rows.length - 1 || // bottom row
                                titleRow === i || // specific row
                                titleRow === null) cell.innerHTML = columnDef.sTitle;
                            }
                            if (!columnDef.sTitle && unique) {
                                columnDef.sTitle = $44bb6d473543b89d$var$_stripHtml(cell.innerHTML);
                                columnDef.autoTitle = true;
                            }
                        } else // Footer specific operations
                        if (columnDef.footer) cell.innerHTML = columnDef.footer;
                        // Fall back to the aria-label attribute on the table header if no ariaTitle is
                        // provided.
                        if (!columnDef.ariaTitle) columnDef.ariaTitle = jqCell.attr("aria-label") || columnDef.sTitle;
                        // Column specific class names
                        if (columnDef.className) jqCell.addClass(columnDef.className);
                    }
                    // Wrap the column title so we can write to it in future
                    if ($44bb6d473543b89d$var$$('.dt-column-title', cell).length === 0) $44bb6d473543b89d$var$$(document.createElement(settings.columnTitleTag)).addClass('dt-column-title').append(cell.childNodes).appendTo(cell);
                    if (settings.orderIndicators && isHeader && jqCell.filter(':not([data-dt-order=disable])').length !== 0 && jqCell.parent(':not([data-dt-order=disable])').length !== 0 && $44bb6d473543b89d$var$$('.dt-column-order', cell).length === 0) $44bb6d473543b89d$var$$(document.createElement(settings.columnTitleTag)).addClass('dt-column-order').appendTo(cell);
                    // We need to wrap the elements in the header in another element to use flexbox
                    // layout for those elements
                    var headerFooter = isHeader ? 'header' : 'footer';
                    if ($44bb6d473543b89d$var$$('div.dt-column-' + headerFooter, cell).length === 0) $44bb6d473543b89d$var$$('<div>').addClass('dt-column-' + headerFooter).append(cell.childNodes).appendTo(cell);
                }
                // If there is col / rowspan, copy the information into the layout grid
                for(l = 0; l < colspan; l++){
                    for(k = 0; k < rowspan; k++){
                        layout[i + k][shifted + l] = {
                            cell: cell,
                            unique: unique
                        };
                        layout[i + k].row = row;
                    }
                    cols.push(shifted + l);
                }
                // Assign an attribute so spanning cells can still be identified
                // as belonging to a column
                cell.setAttribute('data-dt-column', $44bb6d473543b89d$var$_unique(cols).join(','));
            }
            cell = cell.nextSibling;
        }
    }
    return layout;
}
/**
 * Set the start position for draw
 *  @param {object} oSettings dataTables settings object
 */ function $44bb6d473543b89d$var$_fnStart(oSettings) {
    var bServerSide = $44bb6d473543b89d$var$_fnDataSource(oSettings) == 'ssp';
    var iInitDisplayStart = oSettings.iInitDisplayStart;
    // Check and see if we have an initial draw position from state saving
    if (iInitDisplayStart !== undefined && iInitDisplayStart !== -1) {
        oSettings._iDisplayStart = bServerSide ? iInitDisplayStart : iInitDisplayStart >= oSettings.fnRecordsDisplay() ? 0 : iInitDisplayStart;
        oSettings.iInitDisplayStart = -1;
    }
}
/**
 * Create an Ajax call based on the table's settings, taking into account that
 * parameters can have multiple forms, and backwards compatibility.
 *
 * @param {object} oSettings dataTables settings object
 * @param {array} data Data to send to the server, required by
 *     DataTables - may be augmented by developer callbacks
 * @param {function} fn Callback function to run when data is obtained
 */ function $44bb6d473543b89d$var$_fnBuildAjax(oSettings, data, fn) {
    var ajaxData;
    var ajax = oSettings.ajax;
    var instance = oSettings.oInstance;
    var callback = function(json) {
        var status = oSettings.jqXHR ? oSettings.jqXHR.status : null;
        if (json === null || typeof status === 'number' && status == 204) {
            json = {};
            $44bb6d473543b89d$var$_fnAjaxDataSrc(oSettings, json, []);
        }
        var error = json.error || json.sError;
        if (error) $44bb6d473543b89d$var$_fnLog(oSettings, 0, error);
        // Microsoft often wrap JSON as a string in another JSON object
        // Let's handle that automatically
        if (json.d && typeof json.d === 'string') try {
            json = JSON.parse(json.d);
        } catch (e) {
        // noop
        }
        oSettings.json = json;
        $44bb6d473543b89d$var$_fnCallbackFire(oSettings, null, 'xhr', [
            oSettings,
            json,
            oSettings.jqXHR
        ], true);
        fn(json);
    };
    if ($44bb6d473543b89d$var$$.isPlainObject(ajax) && ajax.data) {
        ajaxData = ajax.data;
        var newData = typeof ajaxData === 'function' ? ajaxData(data, oSettings) // fn can manipulate data or return
         : ajaxData; // an object or array to merge
        // If the function returned something, use that alone
        data = typeof ajaxData === 'function' && newData ? newData : $44bb6d473543b89d$var$$.extend(true, data, newData);
        // Remove the data property as we've resolved it already and don't want
        // jQuery to do it again (it is restored at the end of the function)
        delete ajax.data;
    }
    var baseAjax = {
        url: typeof ajax === 'string' ? ajax : '',
        data: data,
        success: callback,
        dataType: 'json',
        cache: false,
        type: oSettings.sServerMethod,
        error: function(xhr, error) {
            var ret = $44bb6d473543b89d$var$_fnCallbackFire(oSettings, null, 'xhr', [
                oSettings,
                null,
                oSettings.jqXHR
            ], true);
            if (ret.indexOf(true) === -1) {
                if (error == 'parsererror') $44bb6d473543b89d$var$_fnLog(oSettings, 0, 'Invalid JSON response', 1);
                else if (xhr.readyState === 4) $44bb6d473543b89d$var$_fnLog(oSettings, 0, 'Ajax error', 7);
            }
            $44bb6d473543b89d$var$_fnProcessingDisplay(oSettings, false);
        }
    };
    // If `ajax` option is an object, extend and override our default base
    if ($44bb6d473543b89d$var$$.isPlainObject(ajax)) $44bb6d473543b89d$var$$.extend(baseAjax, ajax);
    // Store the data submitted for the API
    oSettings.oAjaxData = data;
    // Allow plug-ins and external processes to modify the data
    $44bb6d473543b89d$var$_fnCallbackFire(oSettings, null, 'preXhr', [
        oSettings,
        data,
        baseAjax
    ], true);
    // Custom Ajax option to submit the parameters as a JSON string
    if (baseAjax.submitAs === 'json' && typeof data === 'object') {
        baseAjax.data = JSON.stringify(data);
        if (!baseAjax.contentType) baseAjax.contentType = 'application/json; charset=utf-8';
    }
    if (typeof ajax === 'function') // Is a function - let the caller define what needs to be done
    oSettings.jqXHR = ajax.call(instance, data, callback, oSettings);
    else if (ajax.url === '') {
        // No url, so don't load any data. Just apply an empty data array
        // to the object for the callback.
        var empty = {};
        $44bb6d473543b89d$var$_fnAjaxDataSrc(oSettings, empty, []);
        callback(empty);
    } else // Object to extend the base settings
    oSettings.jqXHR = $44bb6d473543b89d$var$$.ajax(baseAjax);
    // Restore for next time around
    if (ajaxData) ajax.data = ajaxData;
}
/**
 * Update the table using an Ajax call
 *  @param {object} settings dataTables settings object
 *  @returns {boolean} Block the table drawing or not
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnAjaxUpdate(settings) {
    settings.iDraw++;
    $44bb6d473543b89d$var$_fnProcessingDisplay(settings, true);
    $44bb6d473543b89d$var$_fnBuildAjax(settings, $44bb6d473543b89d$var$_fnAjaxParameters(settings), function(json) {
        $44bb6d473543b89d$var$_fnAjaxUpdateDraw(settings, json);
    });
}
/**
 * Build up the parameters in an object needed for a server-side processing
 * request.
 *  @param {object} oSettings dataTables settings object
 *  @returns {bool} block the table drawing or not
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnAjaxParameters(settings) {
    var columns = settings.aoColumns, features = settings.oFeatures, preSearch = settings.oPreviousSearch, preColSearch = settings.aoPreSearchCols, colData = function(idx, prop) {
        return typeof columns[idx][prop] === 'function' ? 'function' : columns[idx][prop];
    };
    return {
        draw: settings.iDraw,
        columns: columns.map(function(column, i) {
            return {
                data: colData(i, 'mData'),
                name: column.sName,
                searchable: column.bSearchable,
                orderable: column.bSortable,
                search: {
                    value: preColSearch[i].search,
                    regex: preColSearch[i].regex,
                    fixed: Object.keys(column.searchFixed).map(function(name) {
                        return {
                            name: name,
                            term: typeof column.searchFixed[name] !== 'function' ? column.searchFixed[name].toString() : 'function'
                        };
                    })
                }
            };
        }),
        order: $44bb6d473543b89d$var$_fnSortFlatten(settings).map(function(val) {
            return {
                column: val.col,
                dir: val.dir,
                name: colData(val.col, 'sName')
            };
        }),
        start: settings._iDisplayStart,
        length: features.bPaginate ? settings._iDisplayLength : -1,
        search: {
            value: preSearch.search,
            regex: preSearch.regex,
            fixed: Object.keys(settings.searchFixed).map(function(name) {
                return {
                    name: name,
                    term: typeof settings.searchFixed[name] !== 'function' ? settings.searchFixed[name].toString() : 'function'
                };
            })
        }
    };
}
/**
 * Data the data from the server (nuking the old) and redraw the table
 *  @param {object} oSettings dataTables settings object
 *  @param {object} json json data return from the server.
 *  @param {string} json.sEcho Tracking flag for DataTables to match requests
 *  @param {int} json.iTotalRecords Number of records in the data set, not accounting for filtering
 *  @param {int} json.iTotalDisplayRecords Number of records in the data set, accounting for filtering
 *  @param {array} json.aaData The data to display on this page
 *  @param {string} [json.sColumns] Column ordering (sName, comma separated)
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnAjaxUpdateDraw(settings, json) {
    var data = $44bb6d473543b89d$var$_fnAjaxDataSrc(settings, json);
    var draw = $44bb6d473543b89d$var$_fnAjaxDataSrcParam(settings, 'draw', json);
    var recordsTotal = $44bb6d473543b89d$var$_fnAjaxDataSrcParam(settings, 'recordsTotal', json);
    var recordsFiltered = $44bb6d473543b89d$var$_fnAjaxDataSrcParam(settings, 'recordsFiltered', json);
    if (draw !== undefined) {
        // Protect against out of sequence returns
        if (draw * 1 < settings.iDraw) return;
        settings.iDraw = draw * 1;
    }
    // No data in returned object, so rather than an array, we show an empty table
    if (!data) data = [];
    $44bb6d473543b89d$var$_fnClearTable(settings);
    settings._iRecordsTotal = parseInt(recordsTotal, 10);
    settings._iRecordsDisplay = parseInt(recordsFiltered, 10);
    for(var i = 0, iLen = data.length; i < iLen; i++)$44bb6d473543b89d$var$_fnAddData(settings, data[i]);
    settings.aiDisplay = settings.aiDisplayMaster.slice();
    $44bb6d473543b89d$var$_fnColumnTypes(settings);
    $44bb6d473543b89d$var$_fnDraw(settings, true);
    $44bb6d473543b89d$var$_fnInitComplete(settings);
    $44bb6d473543b89d$var$_fnProcessingDisplay(settings, false);
}
/**
 * Get the data from the JSON data source to use for drawing a table. Using
 * `_fnGetObjectDataFn` allows the data to be sourced from a property of the
 * source object, or from a processing function.
 *  @param {object} settings dataTables settings object
 *  @param  {object} json Data source object / array from the server
 *  @return {array} Array of data to use
 */ function $44bb6d473543b89d$var$_fnAjaxDataSrc(settings, json, write) {
    var dataProp = 'data';
    if ($44bb6d473543b89d$var$$.isPlainObject(settings.ajax) && settings.ajax.dataSrc !== undefined) {
        // Could in inside a `dataSrc` object, or not!
        var dataSrc = settings.ajax.dataSrc;
        // string, function and object are valid types
        if (typeof dataSrc === 'string' || typeof dataSrc === 'function') dataProp = dataSrc;
        else if (dataSrc.data !== undefined) dataProp = dataSrc.data;
    }
    if (!write) {
        if (dataProp === 'data') // If the default, then we still want to support the old style, and safely ignore
        // it if possible
        return json.aaData || json[dataProp];
        return dataProp !== '' ? $44bb6d473543b89d$var$_fnGetObjectDataFn(dataProp)(json) : json;
    }
    // set
    $44bb6d473543b89d$var$_fnSetObjectDataFn(dataProp)(json, write);
}
/**
 * Very similar to _fnAjaxDataSrc, but for the other SSP properties
 * @param {*} settings DataTables settings object
 * @param {*} param Target parameter
 * @param {*} json JSON data
 * @returns Resolved value
 */ function $44bb6d473543b89d$var$_fnAjaxDataSrcParam(settings, param, json) {
    var dataSrc = $44bb6d473543b89d$var$$.isPlainObject(settings.ajax) ? settings.ajax.dataSrc : null;
    if (dataSrc && dataSrc[param]) // Get from custom location
    return $44bb6d473543b89d$var$_fnGetObjectDataFn(dataSrc[param])(json);
    // else - Default behaviour
    var old = '';
    // Legacy support
    if (param === 'draw') old = 'sEcho';
    else if (param === 'recordsTotal') old = 'iTotalRecords';
    else if (param === 'recordsFiltered') old = 'iTotalDisplayRecords';
    return json[old] !== undefined ? json[old] : json[param];
}
/**
 * Filter the table using both the global filter and column based filtering
 *  @param {object} settings dataTables settings object
 *  @param {object} input search information
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnFilterComplete(settings, input) {
    var columnsSearch = settings.aoPreSearchCols;
    // In server-side processing all filtering is done by the server, so no point hanging around here
    if ($44bb6d473543b89d$var$_fnDataSource(settings) != 'ssp') {
        // Check if any of the rows were invalidated
        $44bb6d473543b89d$var$_fnFilterData(settings);
        // Start from the full data set
        settings.aiDisplay = settings.aiDisplayMaster.slice();
        // Global filter first
        $44bb6d473543b89d$var$_fnFilter(settings.aiDisplay, settings, input.search, input);
        $44bb6d473543b89d$var$$.each(settings.searchFixed, function(name, term) {
            $44bb6d473543b89d$var$_fnFilter(settings.aiDisplay, settings, term, {});
        });
        // Then individual column filters
        for(var i = 0; i < columnsSearch.length; i++){
            var col = columnsSearch[i];
            $44bb6d473543b89d$var$_fnFilter(settings.aiDisplay, settings, col.search, col, i);
            $44bb6d473543b89d$var$$.each(settings.aoColumns[i].searchFixed, function(name, term) {
                $44bb6d473543b89d$var$_fnFilter(settings.aiDisplay, settings, term, {}, i);
            });
        }
        // And finally global filtering
        $44bb6d473543b89d$var$_fnFilterCustom(settings);
    }
    // Tell the draw function we have been filtering
    settings.bFiltered = true;
    $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'search', [
        settings
    ]);
}
/**
 * Apply custom filtering functions
 * 
 * This is legacy now that we have named functions, but it is widely used
 * from 1.x, so it is not yet deprecated.
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnFilterCustom(settings) {
    var filters = $44bb6d473543b89d$var$DataTable.ext.search;
    var displayRows = settings.aiDisplay;
    var row, rowIdx;
    for(var i = 0, iLen = filters.length; i < iLen; i++){
        var rows = [];
        // Loop over each row and see if it should be included
        for(var j = 0, jen = displayRows.length; j < jen; j++){
            rowIdx = displayRows[j];
            row = settings.aoData[rowIdx];
            if (filters[i](settings, row._aFilterData, rowIdx, row._aData, j)) rows.push(rowIdx);
        }
        // So the array reference doesn't break set the results into the
        // existing array
        displayRows.length = 0;
        $44bb6d473543b89d$var$_fnArrayApply(displayRows, rows);
    }
}
/**
 * Filter the data table based on user input and draw the table
 */ function $44bb6d473543b89d$var$_fnFilter(searchRows, settings, input, options, column) {
    if (input === '') return;
    var i = 0;
    var matched = [];
    // Search term can be a function, regex or string - if a string we apply our
    // smart filtering regex (assuming the options require that)
    var searchFunc = typeof input === 'function' ? input : null;
    var rpSearch = input instanceof RegExp ? input : searchFunc ? null : $44bb6d473543b89d$var$_fnFilterCreateSearch(input, options);
    // Then for each row, does the test pass. If not, lop the row from the array
    for(i = 0; i < searchRows.length; i++){
        var row = settings.aoData[searchRows[i]];
        var data = column === undefined ? row._sFilterRow : row._aFilterData[column];
        if (searchFunc && searchFunc(data, row._aData, searchRows[i], column) || rpSearch && rpSearch.test(data)) matched.push(searchRows[i]);
    }
    // Mutate the searchRows array
    searchRows.length = matched.length;
    for(i = 0; i < matched.length; i++)searchRows[i] = matched[i];
}
/**
 * Build a regular expression object suitable for searching a table
 *  @param {string} sSearch string to search for
 *  @param {bool} bRegex treat as a regular expression or not
 *  @param {bool} bSmart perform smart filtering or not
 *  @param {bool} bCaseInsensitive Do case-insensitive matching or not
 *  @returns {RegExp} constructed object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnFilterCreateSearch(search, inOpts) {
    var not = [];
    var options = $44bb6d473543b89d$var$$.extend({}, {
        boundary: false,
        caseInsensitive: true,
        exact: false,
        regex: false,
        smart: true
    }, inOpts);
    if (typeof search !== 'string') search = search.toString();
    // Remove diacritics if normalize is set up to do so
    search = $44bb6d473543b89d$var$_normalize(search);
    if (options.exact) return new RegExp('^' + $44bb6d473543b89d$var$_fnEscapeRegex(search) + '$', options.caseInsensitive ? 'i' : '');
    search = options.regex ? search : $44bb6d473543b89d$var$_fnEscapeRegex(search);
    if (options.smart) {
        /* For smart filtering we want to allow the search to work regardless of
		 * word order. We also want double quoted text to be preserved, so word
		 * order is important - a la google. And a negative look around for
		 * finding rows which don't contain a given string.
		 * 
		 * So this is the sort of thing we want to generate:
		 * 
		 * ^(?=.*?\bone\b)(?=.*?\btwo three\b)(?=.*?\bfour\b).*$
		 */ var parts = search.match(/!?["\u201C][^"\u201D]+["\u201D]|[^ ]+/g) || [
            ''
        ];
        var a = parts.map(function(word) {
            var negative = false;
            var m;
            // Determine if it is a "does not include"
            if (word.charAt(0) === '!') {
                negative = true;
                word = word.substring(1);
            }
            // Strip the quotes from around matched phrases
            if (word.charAt(0) === '"') {
                m = word.match(/^"(.*)"$/);
                word = m ? m[1] : word;
            } else if (word.charAt(0) === '\u201C') {
                // Smart quote match (iPhone users)
                m = word.match(/^\u201C(.*)\u201D$/);
                word = m ? m[1] : word;
            }
            // For our "not" case, we need to modify the string that is
            // allowed to match at the end of the expression.
            if (negative) {
                if (word.length > 1) not.push('(?!' + word + ')');
                word = '';
            }
            return word.replace(/"/g, '');
        });
        var match = not.length ? not.join('') : '';
        var boundary = options.boundary ? '\\b' : '';
        search = '^(?=.*?' + boundary + a.join(')(?=.*?' + boundary) + ')(' + match + '.)*$';
    }
    return new RegExp(search, options.caseInsensitive ? 'i' : '');
}
/**
 * Escape a string such that it can be used in a regular expression
 *  @param {string} sVal string to escape
 *  @returns {string} escaped string
 *  @memberof DataTable#oApi
 */ var $44bb6d473543b89d$var$_fnEscapeRegex = $44bb6d473543b89d$var$DataTable.util.escapeRegex;
var $44bb6d473543b89d$var$__filter_div = $44bb6d473543b89d$var$$('<div>')[0];
var $44bb6d473543b89d$var$__filter_div_textContent = $44bb6d473543b89d$var$__filter_div.textContent !== undefined;
// Update the filtering data for each row if needed (by invalidation or first run)
function $44bb6d473543b89d$var$_fnFilterData(settings) {
    var columns = settings.aoColumns;
    var data = settings.aoData;
    var column;
    var j, jen, filterData, cellData, row;
    var wasInvalidated = false;
    for(var rowIdx = 0; rowIdx < data.length; rowIdx++){
        if (!data[rowIdx]) continue;
        row = data[rowIdx];
        if (!row._aFilterData) {
            filterData = [];
            for(j = 0, jen = columns.length; j < jen; j++){
                column = columns[j];
                if (column.bSearchable) {
                    cellData = $44bb6d473543b89d$var$_fnGetCellData(settings, rowIdx, j, 'filter');
                    // Search in DataTables is string based
                    if (cellData === null) cellData = '';
                    if (typeof cellData !== 'string' && cellData.toString) cellData = cellData.toString();
                } else cellData = '';
                // If it looks like there is an HTML entity in the string,
                // attempt to decode it so sorting works as expected. Note that
                // we could use a single line of jQuery to do this, but the DOM
                // method used here is much faster https://jsperf.com/html-decode
                if (cellData.indexOf && cellData.indexOf('&') !== -1) {
                    $44bb6d473543b89d$var$__filter_div.innerHTML = cellData;
                    cellData = $44bb6d473543b89d$var$__filter_div_textContent ? $44bb6d473543b89d$var$__filter_div.textContent : $44bb6d473543b89d$var$__filter_div.innerText;
                }
                if (cellData.replace) cellData = cellData.replace(/[\r\n\u2028]/g, '');
                filterData.push(cellData);
            }
            row._aFilterData = filterData;
            row._sFilterRow = filterData.join('  ');
            wasInvalidated = true;
        }
    }
    return wasInvalidated;
}
/**
 * Draw the table for the first time, adding all required features
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnInitialise(settings) {
    var i;
    var init = settings.oInit;
    var deferLoading = settings.deferLoading;
    var dataSrc = $44bb6d473543b89d$var$_fnDataSource(settings);
    // Ensure that the table data is fully initialised
    if (!settings.bInitialised) {
        setTimeout(function() {
            $44bb6d473543b89d$var$_fnInitialise(settings);
        }, 200);
        return;
    }
    // Build the header / footer for the table
    $44bb6d473543b89d$var$_fnBuildHead(settings, 'header');
    $44bb6d473543b89d$var$_fnBuildHead(settings, 'footer');
    // Load the table's state (if needed) and then render around it and draw
    $44bb6d473543b89d$var$_fnLoadState(settings, init, function() {
        // Then draw the header / footer
        $44bb6d473543b89d$var$_fnDrawHead(settings, settings.aoHeader);
        $44bb6d473543b89d$var$_fnDrawHead(settings, settings.aoFooter);
        // Cache the paging start point, as the first redraw will reset it
        var iAjaxStart = settings.iInitDisplayStart;
        // Local data load
        // Check if there is data passing into the constructor
        if (init.aaData) for(i = 0; i < init.aaData.length; i++)$44bb6d473543b89d$var$_fnAddData(settings, init.aaData[i]);
        else if (deferLoading || dataSrc == 'dom') // Grab the data from the page
        $44bb6d473543b89d$var$_fnAddTr(settings, $44bb6d473543b89d$var$$(settings.nTBody).children('tr'));
        // Filter not yet applied - copy the display master
        settings.aiDisplay = settings.aiDisplayMaster.slice();
        // Enable features
        $44bb6d473543b89d$var$_fnAddOptionsHtml(settings);
        $44bb6d473543b89d$var$_fnSortInit(settings);
        $44bb6d473543b89d$var$_colGroup(settings);
        /* Okay to show that something is going on now */ $44bb6d473543b89d$var$_fnProcessingDisplay(settings, true);
        $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'preInit', [
            settings
        ], true);
        // If there is default sorting required - let's do it. The sort function
        // will do the drawing for us. Otherwise we draw the table regardless of the
        // Ajax source - this allows the table to look initialised for Ajax sourcing
        // data (show 'loading' message possibly)
        $44bb6d473543b89d$var$_fnReDraw(settings);
        // Server-side processing init complete is done by _fnAjaxUpdateDraw
        if (dataSrc != 'ssp' || deferLoading) {
            // if there is an ajax source load the data
            if (dataSrc == 'ajax') $44bb6d473543b89d$var$_fnBuildAjax(settings, {}, function(json) {
                var aData = $44bb6d473543b89d$var$_fnAjaxDataSrc(settings, json);
                // Got the data - add it to the table
                for(i = 0; i < aData.length; i++)$44bb6d473543b89d$var$_fnAddData(settings, aData[i]);
                // Reset the init display for cookie saving. We've already done
                // a filter, and therefore cleared it before. So we need to make
                // it appear 'fresh'
                settings.iInitDisplayStart = iAjaxStart;
                $44bb6d473543b89d$var$_fnReDraw(settings);
                $44bb6d473543b89d$var$_fnProcessingDisplay(settings, false);
                $44bb6d473543b89d$var$_fnInitComplete(settings);
            }, settings);
            else {
                $44bb6d473543b89d$var$_fnInitComplete(settings);
                $44bb6d473543b89d$var$_fnProcessingDisplay(settings, false);
            }
        }
    });
}
/**
 * Draw the table for the first time, adding all required features
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnInitComplete(settings) {
    if (settings._bInitComplete) return;
    var args = [
        settings,
        settings.json
    ];
    // If the footer element is empty after initialisation, then remove it
    let tfoot = $44bb6d473543b89d$var$$(settings.tfoot);
    if (tfoot.children().length === 0) tfoot.remove();
    settings._bInitComplete = true;
    // Table is fully set up and we have data, so calculate the
    // column widths
    $44bb6d473543b89d$var$_fnAdjustColumnSizing(settings);
    $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'plugin-init', args, true);
    $44bb6d473543b89d$var$_fnCallbackFire(settings, 'aoInitComplete', 'init', args, true);
}
function $44bb6d473543b89d$var$_fnLengthChange(settings, val) {
    var len = parseInt(val, 10);
    settings._iDisplayLength = len;
    $44bb6d473543b89d$var$_fnLengthOverflow(settings);
    // Fire length change event
    $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'length', [
        settings,
        len
    ]);
}
/**
 * Alter the display settings to change the page
 *  @param {object} settings DataTables settings object
 *  @param {string|int} action Paging action to take: "first", "previous",
 *    "next" or "last" or page number to jump to (integer)
 *  @param [bool] redraw Automatically draw the update or not
 *  @returns {bool} true page has changed, false - no change
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnPageChange(settings, action, redraw) {
    var start = settings._iDisplayStart, len = settings._iDisplayLength, records = settings.fnRecordsDisplay();
    if (records === 0 || len === -1) start = 0;
    else if (typeof action === "number") {
        start = action * len;
        if (start > records) start = 0;
    } else if (action == "first") start = 0;
    else if (action == "previous") {
        start = len >= 0 ? start - len : 0;
        if (start < 0) start = 0;
    } else if (action == "next") {
        if (start + len < records) start += len;
    } else if (action == "last") start = Math.floor((records - 1) / len) * len;
    else if (action === 'ellipsis') return;
    else $44bb6d473543b89d$var$_fnLog(settings, 0, "Unknown paging action: " + action, 5);
    var changed = settings._iDisplayStart !== start;
    settings._iDisplayStart = start;
    $44bb6d473543b89d$var$_fnCallbackFire(settings, null, changed ? 'page' : 'page-nc', [
        settings
    ]);
    if (changed && redraw) $44bb6d473543b89d$var$_fnDraw(settings);
    return changed;
}
/**
 * Generate the node required for the processing node
 *  @param {object} settings DataTables settings object
 */ function $44bb6d473543b89d$var$_processingHtml(settings) {
    var table = settings.nTable;
    var scrolling = settings.oScroll.sX !== '' || settings.oScroll.sY !== '';
    if (settings.oFeatures.bProcessing) {
        var n = $44bb6d473543b89d$var$$('<div/>', {
            'id': settings.sTableId + '_processing',
            'class': settings.oClasses.processing.container,
            'role': 'status'
        }).html(settings.oLanguage.sProcessing).append('<div><div></div><div></div><div></div><div></div></div>');
        // Different positioning depending on if scrolling is enabled or not
        if (scrolling) n.prependTo($44bb6d473543b89d$var$$('div.dt-scroll', settings.nTableWrapper));
        else n.insertBefore(table);
        $44bb6d473543b89d$var$$(table).on('processing.dt.DT', function(e, s, show) {
            n.css('display', show ? 'block' : 'none');
        });
    }
}
/**
 * Display or hide the processing indicator
 *  @param {object} settings DataTables settings object
 *  @param {bool} show Show the processing indicator (true) or not (false)
 */ function $44bb6d473543b89d$var$_fnProcessingDisplay(settings, show) {
    // Ignore cases when we are still redrawing
    if (settings.bDrawing && show === false) return;
    $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'processing', [
        settings,
        show
    ]);
}
/**
 * Show the processing element if an action takes longer than a given time
 *
 * @param {*} settings DataTables settings object
 * @param {*} enable Do (true) or not (false) async processing (local feature enablement)
 * @param {*} run Function to run
 */ function $44bb6d473543b89d$var$_fnProcessingRun(settings, enable, run) {
    if (!enable) // Immediate execution, synchronous
    run();
    else {
        $44bb6d473543b89d$var$_fnProcessingDisplay(settings, true);
        // Allow the processing display to show if needed
        setTimeout(function() {
            run();
            $44bb6d473543b89d$var$_fnProcessingDisplay(settings, false);
        }, 0);
    }
}
/**
 * Add any control elements for the table - specifically scrolling
 *  @param {object} settings dataTables settings object
 *  @returns {node} Node to add to the DOM
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnFeatureHtmlTable(settings) {
    var table = $44bb6d473543b89d$var$$(settings.nTable);
    // Scrolling from here on in
    var scroll = settings.oScroll;
    if (scroll.sX === '' && scroll.sY === '') return settings.nTable;
    var scrollX = scroll.sX;
    var scrollY = scroll.sY;
    var classes = settings.oClasses.scrolling;
    var caption = settings.captionNode;
    var captionSide = caption ? caption._captionSide : null;
    var headerClone = $44bb6d473543b89d$var$$(table[0].cloneNode(false));
    var footerClone = $44bb6d473543b89d$var$$(table[0].cloneNode(false));
    var footer = table.children('tfoot');
    var _div = '<div/>';
    var size = function(s) {
        return !s ? null : $44bb6d473543b89d$var$_fnStringToCss(s);
    };
    if (!footer.length) footer = null;
    /*
	 * The HTML structure that we want to generate in this function is:
	 *  div - scroller
	 *    div - scroll head
	 *      div - scroll head inner
	 *        table - scroll head table
	 *          thead - thead
	 *    div - scroll body
	 *      table - table (master table)
	 *        thead - thead clone for sizing
	 *        tbody - tbody
	 *    div - scroll foot
	 *      div - scroll foot inner
	 *        table - scroll foot table
	 *          tfoot - tfoot
	 */ var scroller = $44bb6d473543b89d$var$$(_div, {
        'class': classes.container
    }).append($44bb6d473543b89d$var$$(_div, {
        'class': classes.header.self
    }).css({
        overflow: 'hidden',
        position: 'relative',
        border: 0,
        width: scrollX ? size(scrollX) : '100%'
    }).append($44bb6d473543b89d$var$$(_div, {
        'class': classes.header.inner
    }).css({
        'box-sizing': 'content-box',
        width: scroll.sXInner || '100%'
    }).append(headerClone.removeAttr('id').css('margin-left', 0).append(captionSide === 'top' ? caption : null).append(table.children('thead'))))).append($44bb6d473543b89d$var$$(_div, {
        'class': classes.body
    }).css({
        position: 'relative',
        overflow: 'auto',
        width: size(scrollX)
    }).append(table));
    if (footer) scroller.append($44bb6d473543b89d$var$$(_div, {
        'class': classes.footer.self
    }).css({
        overflow: 'hidden',
        border: 0,
        width: scrollX ? size(scrollX) : '100%'
    }).append($44bb6d473543b89d$var$$(_div, {
        'class': classes.footer.inner
    }).append(footerClone.removeAttr('id').css('margin-left', 0).append(captionSide === 'bottom' ? caption : null).append(table.children('tfoot')))));
    var children = scroller.children();
    var scrollHead = children[0];
    var scrollBody = children[1];
    var scrollFoot = footer ? children[2] : null;
    // When the body is scrolled, then we also want to scroll the headers
    $44bb6d473543b89d$var$$(scrollBody).on('scroll.DT', function() {
        var scrollLeft = this.scrollLeft;
        scrollHead.scrollLeft = scrollLeft;
        if (footer) scrollFoot.scrollLeft = scrollLeft;
    });
    // When focus is put on the header cells, we might need to scroll the body
    $44bb6d473543b89d$var$$('th, td', scrollHead).on('focus', function() {
        var scrollLeft = scrollHead.scrollLeft;
        scrollBody.scrollLeft = scrollLeft;
        if (footer) scrollBody.scrollLeft = scrollLeft;
    });
    $44bb6d473543b89d$var$$(scrollBody).css('max-height', scrollY);
    if (!scroll.bCollapse) $44bb6d473543b89d$var$$(scrollBody).css('height', scrollY);
    settings.nScrollHead = scrollHead;
    settings.nScrollBody = scrollBody;
    settings.nScrollFoot = scrollFoot;
    // On redraw - align columns
    settings.aoDrawCallback.push($44bb6d473543b89d$var$_fnScrollDraw);
    return scroller[0];
}
/**
 * Update the header, footer and body tables for resizing - i.e. column
 * alignment.
 *
 * Welcome to the most horrible function DataTables. The process that this
 * function follows is basically:
 *   1. Re-create the table inside the scrolling div
 *   2. Correct colgroup > col values if needed
 *   3. Copy colgroup > col over to header and footer
 *   4. Clean up
 *
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnScrollDraw(settings) {
    // Given that this is such a monster function, a lot of variables are use
    // to try and keep the minimised size as small as possible
    var scroll = settings.oScroll, barWidth = scroll.iBarWidth, divHeader = $44bb6d473543b89d$var$$(settings.nScrollHead), divHeaderInner = divHeader.children('div'), divHeaderTable = divHeaderInner.children('table'), divBodyEl = settings.nScrollBody, divBody = $44bb6d473543b89d$var$$(divBodyEl), divFooter = $44bb6d473543b89d$var$$(settings.nScrollFoot), divFooterInner = divFooter.children('div'), divFooterTable = divFooterInner.children('table'), header = $44bb6d473543b89d$var$$(settings.nTHead), table = $44bb6d473543b89d$var$$(settings.nTable), footer = settings.nTFoot && $44bb6d473543b89d$var$$('th, td', settings.nTFoot).length ? $44bb6d473543b89d$var$$(settings.nTFoot) : null, browser = settings.oBrowser, headerCopy, footerCopy;
    // If the scrollbar visibility has changed from the last draw, we need to
    // adjust the column sizes as the table width will have changed to account
    // for the scrollbar
    var scrollBarVis = divBodyEl.scrollHeight > divBodyEl.clientHeight;
    if (settings.scrollBarVis !== scrollBarVis && settings.scrollBarVis !== undefined) {
        settings.scrollBarVis = scrollBarVis;
        $44bb6d473543b89d$var$_fnAdjustColumnSizing(settings);
        return; // adjust column sizing will call this function again
    } else settings.scrollBarVis = scrollBarVis;
    // 1. Re-create the table inside the scrolling div
    // Remove the old minimised thead and tfoot elements in the inner table
    table.children('thead, tfoot').remove();
    // Clone the current header and footer elements and then place it into the inner table
    headerCopy = header.clone().prependTo(table);
    headerCopy.find('th, td').removeAttr('tabindex');
    headerCopy.find('[id]').removeAttr('id');
    if (footer) {
        footerCopy = footer.clone().prependTo(table);
        footerCopy.find('[id]').removeAttr('id');
    }
    // 2. Correct colgroup > col values if needed
    // It is possible that the cell sizes are smaller than the content, so we need to
    // correct colgroup>col for such cases. This can happen if the auto width detection
    // uses a cell which has a longer string, but isn't the widest! For example 
    // "Chief Executive Officer (CEO)" is the longest string in the demo, but
    // "Systems Administrator" is actually the widest string since it doesn't collapse.
    // Note the use of translating into a column index to get the `col` element. This
    // is because of Responsive which might remove `col` elements, knocking the alignment
    // of the indexes out.
    if (settings.aiDisplay.length) {
        // Get the column sizes from the first row in the table. This should really be a
        // [].find, but it wasn't supported in Chrome until Sept 2015, and DT has 10 year
        // browser support
        var firstTr = null;
        var start = $44bb6d473543b89d$var$_fnDataSource(settings) !== 'ssp' ? settings._iDisplayStart : 0;
        for(i = start; i < start + settings.aiDisplay.length; i++){
            var idx = settings.aiDisplay[i];
            var tr = settings.aoData[idx].nTr;
            if (tr) {
                firstTr = tr;
                break;
            }
        }
        if (firstTr) {
            var colSizes = $44bb6d473543b89d$var$$(firstTr).children('th, td').map(function(vis) {
                return {
                    idx: $44bb6d473543b89d$var$_fnVisibleToColumnIndex(settings, vis),
                    width: $44bb6d473543b89d$var$$(this).outerWidth()
                };
            });
            // Check against what the colgroup > col is set to and correct if needed
            for(var i = 0; i < colSizes.length; i++){
                var colEl = settings.aoColumns[colSizes[i].idx].colEl[0];
                var colWidth = colEl.style.width.replace('px', '');
                if (colWidth !== colSizes[i].width) {
                    colEl.style.width = colSizes[i].width + 'px';
                    if (scroll.sX) colEl.style.minWidth = colSizes[i].width + 'px';
                }
            }
        }
    }
    // 3. Copy the colgroup over to the header and footer
    divHeaderTable.find('colgroup').remove();
    divHeaderTable.append(settings.colgroup.clone());
    if (footer) {
        divFooterTable.find('colgroup').remove();
        divFooterTable.append(settings.colgroup.clone());
    }
    // "Hide" the header and footer that we used for the sizing. We need to keep
    // the content of the cell so that the width applied to the header and body
    // both match, but we want to hide it completely.
    $44bb6d473543b89d$var$$('th, td', headerCopy).each(function() {
        $44bb6d473543b89d$var$$(this.childNodes).wrapAll('<div class="dt-scroll-sizing" />');
    });
    if (footer) $44bb6d473543b89d$var$$('th, td', footerCopy).each(function() {
        $44bb6d473543b89d$var$$(this.childNodes).wrapAll('<div class="dt-scroll-sizing" />');
    });
    // 4. Clean up
    // Figure out if there are scrollbar present - if so then we need the header and footer to
    // provide a bit more space to allow "overflow" scrolling (i.e. past the scrollbar)
    var isScrolling = Math.floor(table.height()) > divBodyEl.clientHeight || divBody.css('overflow-y') == "scroll";
    var paddingSide = 'padding' + (browser.bScrollbarLeft ? 'Left' : 'Right');
    // Set the width's of the header and footer tables
    var outerWidth = table.outerWidth();
    divHeaderTable.css('width', $44bb6d473543b89d$var$_fnStringToCss(outerWidth));
    divHeaderInner.css('width', $44bb6d473543b89d$var$_fnStringToCss(outerWidth)).css(paddingSide, isScrolling ? barWidth + "px" : "0px");
    if (footer) {
        divFooterTable.css('width', $44bb6d473543b89d$var$_fnStringToCss(outerWidth));
        divFooterInner.css('width', $44bb6d473543b89d$var$_fnStringToCss(outerWidth)).css(paddingSide, isScrolling ? barWidth + "px" : "0px");
    }
    // Correct DOM ordering for colgroup - comes before the thead
    table.children('colgroup').prependTo(table);
    // Remove tabindex from the hidden row elements
    table.find('thead, tfoot').find('[tabindex]').removeAttr('tabindex');
    table.find('thead, tfoot').find('role').removeAttr('role');
    // Adjust the position of the header in case we loose the y-scrollbar
    divBody.trigger('scroll');
    // If sorting or filtering has occurred, jump the scrolling back to the top
    // only if we aren't holding the position
    if ((settings.bSorted || settings.bFiltered) && !settings._drawHold) divBodyEl.scrollTop = 0;
}
/**
 * Calculate the width of columns for the table
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnCalculateColumnWidths(settings) {
    // Not interested in doing column width calculation if auto-width is disabled
    if (!settings.oFeatures.bAutoWidth) return;
    var table = settings.nTable, columns = settings.aoColumns, scroll = settings.oScroll, scrollY = scroll.sY, scrollX = scroll.sX, scrollXInner = scroll.sXInner, visibleColumns = $44bb6d473543b89d$var$_fnGetColumns(settings, 'bVisible'), tableWidthAttr = table.getAttribute('width'), tableContainer = table.parentNode, i, j, column, columnIdx;
    var styleWidth = table.style.width;
    var containerWidth = $44bb6d473543b89d$var$_fnWrapperWidth(settings);
    // Don't re-run for the same width as the last time
    if (containerWidth === settings.containerWidth) return false;
    settings.containerWidth = containerWidth;
    // If there is no width applied as a CSS style or as an attribute, we assume that
    // the width is intended to be 100%, which is usually is in CSS, but it is very
    // difficult to correctly parse the rules to get the final result.
    if (!styleWidth && !tableWidthAttr) {
        table.style.width = '100%';
        styleWidth = '100%';
    }
    if (styleWidth && styleWidth.indexOf('%') !== -1) tableWidthAttr = styleWidth;
    // Let plug-ins know that we are doing a recalc, in case they have changed any of the
    // visible columns their own way (e.g. Responsive uses display:none).
    $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'column-calc', {
        visible: visibleColumns
    }, false);
    // Construct a worst case table with the widest, assign any user defined
    // widths, then insert it into  the DOM and allow the browser to do all
    // the hard work of calculating table widths
    var tmpTable = $44bb6d473543b89d$var$$(table.cloneNode()).css('visibility', 'hidden').css('margin', 0).removeAttr('id');
    // Clean up the table body
    tmpTable.append('<tbody/>');
    // Clone the table header and footer - we can't use the header / footer
    // from the cloned table, since if scrolling is active, the table's
    // real header and footer are contained in different table tags
    tmpTable.append($44bb6d473543b89d$var$$(settings.nTHead).clone()).append($44bb6d473543b89d$var$$(settings.nTFoot).clone());
    // Remove any assigned widths from the footer (from scrolling)
    tmpTable.find('tfoot th, tfoot td').css('width', '');
    // Apply custom sizing to the cloned header
    tmpTable.find('thead th, thead td').each(function() {
        // Get the `width` from the header layout
        var width = $44bb6d473543b89d$var$_fnColumnsSumWidth(settings, this, true, false);
        if (width) {
            this.style.width = width;
            // For scrollX we need to force the column width otherwise the
            // browser will collapse it. If this width is smaller than the
            // width the column requires, then it will have no effect
            if (scrollX) {
                this.style.minWidth = width;
                $44bb6d473543b89d$var$$(this).append($44bb6d473543b89d$var$$('<div/>').css({
                    width: width,
                    margin: 0,
                    padding: 0,
                    border: 0,
                    height: 1
                }));
            }
        } else this.style.width = '';
    });
    // Get the widest strings for each of the visible columns and add them to
    // our table to create a "worst case"
    var longestData = [];
    for(i = 0; i < visibleColumns.length; i++)longestData.push($44bb6d473543b89d$var$_fnGetWideStrings(settings, visibleColumns[i]));
    if (longestData.length) for(i = 0; i < longestData[0].length; i++){
        var tr = $44bb6d473543b89d$var$$('<tr/>').appendTo(tmpTable.find('tbody'));
        for(j = 0; j < visibleColumns.length; j++){
            columnIdx = visibleColumns[j];
            column = columns[columnIdx];
            var longest = longestData[j][i] || '';
            var autoClass = $44bb6d473543b89d$var$_ext.type.className[column.sType];
            var padding = column.sContentPadding || (scrollX ? '-' : '');
            var text = longest + padding;
            var insert = longest.indexOf('<') === -1 && longest.indexOf('&') === -1 ? document.createTextNode(text) : text;
            $44bb6d473543b89d$var$$('<td/>').addClass(autoClass).addClass(column.sClass).append(insert).appendTo(tr);
        }
    }
    // Tidy the temporary table - remove name attributes so there aren't
    // duplicated in the dom (radio elements for example)
    $44bb6d473543b89d$var$$('[name]', tmpTable).removeAttr('name');
    // Table has been built, attach to the document so we can work with it.
    // A holding element is used, positioned at the top of the container
    // with minimal height, so it has no effect on if the container scrolls
    // or not. Otherwise it might trigger scrolling when it actually isn't
    // needed
    var holder = $44bb6d473543b89d$var$$('<div/>').css(scrollX || scrollY ? {
        position: 'absolute',
        top: 0,
        left: 0,
        height: 1,
        right: 0,
        overflow: 'hidden'
    } : {}).append(tmpTable).appendTo(tableContainer);
    // When scrolling (X or Y) we want to set the width of the table as 
    // appropriate. However, when not scrolling leave the table width as it
    // is. This results in slightly different, but I think correct behaviour
    if (scrollX && scrollXInner) tmpTable.width(scrollXInner);
    else if (scrollX) {
        tmpTable.css('width', 'auto');
        tmpTable.removeAttr('width');
        // If there is no width attribute or style, then allow the table to
        // collapse
        if (tmpTable.outerWidth() < tableContainer.clientWidth && tableWidthAttr) tmpTable.outerWidth(tableContainer.clientWidth);
    } else if (scrollY) tmpTable.outerWidth(tableContainer.clientWidth);
    else if (tableWidthAttr) tmpTable.outerWidth(tableWidthAttr);
    // Get the width of each column in the constructed table
    var total = 0;
    var bodyCells = tmpTable.find('tbody tr').eq(0).children();
    for(i = 0; i < visibleColumns.length; i++){
        // Use getBounding for sub-pixel accuracy, which we then want to round up!
        var bounding = bodyCells[i].getBoundingClientRect().width;
        // Total is tracked to remove any sub-pixel errors as the outerWidth
        // of the table might not equal the total given here
        total += bounding;
        // Width for each column to use
        columns[visibleColumns[i]].sWidth = $44bb6d473543b89d$var$_fnStringToCss(bounding);
    }
    table.style.width = $44bb6d473543b89d$var$_fnStringToCss(total);
    // Finished with the table - ditch it
    holder.remove();
    // If there is a width attr, we want to attach an event listener which
    // allows the table sizing to automatically adjust when the window is
    // resized. Use the width attr rather than CSS, since we can't know if the
    // CSS is a relative value or absolute - DOM read is always px.
    if (tableWidthAttr) table.style.width = $44bb6d473543b89d$var$_fnStringToCss(tableWidthAttr);
    if ((tableWidthAttr || scrollX) && !settings._reszEvt) {
        var resize = $44bb6d473543b89d$var$DataTable.util.throttle(function() {
            var newWidth = $44bb6d473543b89d$var$_fnWrapperWidth(settings);
            // Don't do it if destroying or the container width is 0
            if (!settings.bDestroying && newWidth !== 0) $44bb6d473543b89d$var$_fnAdjustColumnSizing(settings);
        });
        // For browsers that support it (~2020 onwards for wide support) we can watch for the
        // container changing width.
        if (window.ResizeObserver) {
            // This is a tricky beast - if the element is visible when `.observe()` is called,
            // then the callback is immediately run. Which we don't want. If the element isn't
            // visible, then it isn't run, but we want it to run when it is then made visible.
            // This flag allows the above to be satisfied.
            var first = $44bb6d473543b89d$var$$(settings.nTableWrapper).is(':visible');
            // Use an empty div to attach the observer so it isn't impacted by height changes
            var resizer = $44bb6d473543b89d$var$$('<div>').css({
                width: '100%',
                height: 0
            }).addClass('dt-autosize').appendTo(settings.nTableWrapper);
            settings.resizeObserver = new ResizeObserver(function(e) {
                if (first) first = false;
                else resize();
            });
            settings.resizeObserver.observe(resizer[0]);
        } else // For old browsers, the best we can do is listen for a window resize
        $44bb6d473543b89d$var$$(window).on('resize.DT-' + settings.sInstance, resize);
        settings._reszEvt = true;
    }
}
/**
 * Get the width of the DataTables wrapper element
 *
 * @param {*} settings DataTables settings object
 * @returns Width
 */ function $44bb6d473543b89d$var$_fnWrapperWidth(settings) {
    return $44bb6d473543b89d$var$$(settings.nTableWrapper).is(':visible') ? $44bb6d473543b89d$var$$(settings.nTableWrapper).width() : 0;
}
/**
 * Get the widest strings for each column.
 *
 * It is very difficult to determine what the widest string actually is due to variable character
 * width and kerning. Doing an exact calculation with the DOM or even Canvas would kill performance
 * and this is a critical point, so we use two techniques to determine a collection of the longest
 * strings from the column, which will likely contain the widest strings:
 *
 * 1) Get the top three longest strings from the column
 * 2) Get the top three widest words (i.e. an unbreakable phrase)
 *
 *  @param {object} settings dataTables settings object
 *  @param {int} colIdx column of interest
 *  @returns {string[]} Array of the longest strings
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnGetWideStrings(settings, colIdx) {
    var column = settings.aoColumns[colIdx];
    // Do we need to recalculate (i.e. was invalidated), or just use the cached data?
    if (!column.wideStrings) {
        var allStrings = [];
        var collection = [];
        // Create an array with the string information for the column
        for(var i = 0, iLen = settings.aiDisplayMaster.length; i < iLen; i++){
            var rowIdx = settings.aiDisplayMaster[i];
            var data = $44bb6d473543b89d$var$_fnGetRowDisplay(settings, rowIdx)[colIdx];
            var cellString = data && typeof data === 'object' && data.nodeType ? data.innerHTML : data + '';
            // Remove id / name attributes from elements so they
            // don't interfere with existing elements
            cellString = cellString.replace(/id=".*?"/g, '').replace(/name=".*?"/g, '');
            // Don't want script, dialog or template tags in the width
            // calculations as they are hidden content
            cellString = cellString.replace(/<script[\s\S]*?<\/script>/gi, ' ').replace(/<dialog[\s\S]*?<\/dialog>/gi, ' ').replace(/<template[\s\S]*?<\/template>/gi, ' ');
            var noHtml = $44bb6d473543b89d$var$_stripHtml(cellString, ' ').replace(/&nbsp;/g, ' ');
            // The length is calculated on the text only, but we keep the HTML
            // in the string so it can be used in the calculation table
            collection.push({
                str: cellString,
                len: noHtml.length
            });
            allStrings.push(noHtml);
        }
        // Order and then cut down to the size we need
        collection.sort(function(a, b) {
            return b.len - a.len;
        }).splice(3);
        column.wideStrings = collection.map(function(item) {
            return item.str;
        });
        // Longest unbroken string
        let parts = allStrings.join(' ').split(' ');
        parts.sort(function(a, b) {
            return b.length - a.length;
        });
        if (parts.length) column.wideStrings.push(parts[0]);
        if (parts.length > 1) column.wideStrings.push(parts[1]);
        if (parts.length > 2) column.wideStrings.push(parts[3]);
    }
    return column.wideStrings;
}
/**
 * Append a CSS unit (only if required) to a string
 *  @param {string} value to css-ify
 *  @returns {string} value with css unit
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnStringToCss(s) {
    if (s === null) return '0px';
    if (typeof s == 'number') return s < 0 ? '0px' : s + 'px';
    // Check it has a unit character already
    return s.match(/\d$/) ? s + 'px' : s;
}
/**
 * Re-insert the `col` elements for current visibility
 *
 * @param {*} settings DT settings
 */ function $44bb6d473543b89d$var$_colGroup(settings) {
    var cols = settings.aoColumns;
    settings.colgroup.empty();
    for($44bb6d473543b89d$var$i = 0; $44bb6d473543b89d$var$i < cols.length; $44bb6d473543b89d$var$i++)if (cols[$44bb6d473543b89d$var$i].bVisible) settings.colgroup.append(cols[$44bb6d473543b89d$var$i].colEl);
}
function $44bb6d473543b89d$var$_fnSortInit(settings) {
    var target = settings.nTHead;
    var headerRows = target.querySelectorAll('tr');
    var titleRow = settings.titleRow;
    var notSelector = ':not([data-dt-order="disable"]):not([data-dt-order="icon-only"])';
    // Legacy support for `orderCellsTop`
    if (titleRow === true) target = headerRows[0];
    else if (titleRow === false) target = headerRows[headerRows.length - 1];
    else if (titleRow !== null) target = headerRows[titleRow];
    // else - all rows
    if (settings.orderHandler) $44bb6d473543b89d$var$_fnSortAttachListener(settings, target, target === settings.nTHead ? 'tr' + notSelector + ' th' + notSelector + ', tr' + notSelector + ' td' + notSelector : 'th' + notSelector + ', td' + notSelector);
    // Need to resolve the user input array into our internal structure
    var order = [];
    $44bb6d473543b89d$var$_fnSortResolve(settings, order, settings.aaSorting);
    settings.aaSorting = order;
}
function $44bb6d473543b89d$var$_fnSortAttachListener(settings, node, selector, column, callback) {
    $44bb6d473543b89d$var$_fnBindAction(node, selector, function(e) {
        var run = false;
        var columns = column === undefined ? $44bb6d473543b89d$var$_fnColumnsFromHeader(e.target) : typeof column === 'function' ? column() : Array.isArray(column) ? column : [
            column
        ];
        if (columns.length) {
            for(var i = 0, iLen = columns.length; i < iLen; i++){
                var ret = $44bb6d473543b89d$var$_fnSortAdd(settings, columns[i], i, e.shiftKey);
                if (ret !== false) run = true;
                // If the first entry is no sort, then subsequent
                // sort columns are ignored
                if (settings.aaSorting.length === 1 && settings.aaSorting[0][1] === '') break;
            }
            if (run) $44bb6d473543b89d$var$_fnProcessingRun(settings, true, function() {
                $44bb6d473543b89d$var$_fnSort(settings);
                $44bb6d473543b89d$var$_fnSortDisplay(settings, settings.aiDisplay);
                $44bb6d473543b89d$var$_fnReDraw(settings, false, false);
                if (callback) callback();
            });
        }
    });
}
/**
 * Sort the display array to match the master's order
 * @param {*} settings
 */ function $44bb6d473543b89d$var$_fnSortDisplay(settings, display) {
    if (display.length < 2) return;
    var master = settings.aiDisplayMaster;
    var masterMap = {};
    var map = {};
    var i;
    // Rather than needing an `indexOf` on master array, we can create a map
    for(i = 0; i < master.length; i++)masterMap[master[i]] = i;
    // And then cache what would be the indexOf from the display
    for(i = 0; i < display.length; i++)map[display[i]] = masterMap[display[i]];
    display.sort(function(a, b) {
        // Short version of this function is simply `master.indexOf(a) - master.indexOf(b);`
        return map[a] - map[b];
    });
}
function $44bb6d473543b89d$var$_fnSortResolve(settings, nestedSort, sort) {
    var push = function(a) {
        if ($44bb6d473543b89d$var$$.isPlainObject(a)) {
            if (a.idx !== undefined) // Index based ordering
            nestedSort.push([
                a.idx,
                a.dir
            ]);
            else if (a.name) {
                // Name based ordering
                var cols = $44bb6d473543b89d$var$_pluck(settings.aoColumns, 'sName');
                var idx = cols.indexOf(a.name);
                if (idx !== -1) nestedSort.push([
                    idx,
                    a.dir
                ]);
            }
        } else // Plain column index and direction pair
        nestedSort.push(a);
    };
    if ($44bb6d473543b89d$var$$.isPlainObject(sort)) // Object
    push(sort);
    else if (sort.length && typeof sort[0] === 'number') // 1D array
    push(sort);
    else if (sort.length) // 2D array
    for(var z = 0; z < sort.length; z++)push(sort[z]); // Object or array
}
function $44bb6d473543b89d$var$_fnSortFlatten(settings) {
    var i, k, kLen, aSort = [], extSort = $44bb6d473543b89d$var$DataTable.ext.type.order, aoColumns = settings.aoColumns, aDataSort, iCol, sType, srcCol, fixed = settings.aaSortingFixed, fixedObj = $44bb6d473543b89d$var$$.isPlainObject(fixed), nestedSort = [];
    if (!settings.oFeatures.bSort) return aSort;
    // Build the sort array, with pre-fix and post-fix options if they have been
    // specified
    if (Array.isArray(fixed)) $44bb6d473543b89d$var$_fnSortResolve(settings, nestedSort, fixed);
    if (fixedObj && fixed.pre) $44bb6d473543b89d$var$_fnSortResolve(settings, nestedSort, fixed.pre);
    $44bb6d473543b89d$var$_fnSortResolve(settings, nestedSort, settings.aaSorting);
    if (fixedObj && fixed.post) $44bb6d473543b89d$var$_fnSortResolve(settings, nestedSort, fixed.post);
    for(i = 0; i < nestedSort.length; i++){
        srcCol = nestedSort[i][0];
        if (aoColumns[srcCol]) {
            aDataSort = aoColumns[srcCol].aDataSort;
            for(k = 0, kLen = aDataSort.length; k < kLen; k++){
                iCol = aDataSort[k];
                sType = aoColumns[iCol].sType || 'string';
                if (nestedSort[i]._idx === undefined) nestedSort[i]._idx = aoColumns[iCol].asSorting.indexOf(nestedSort[i][1]);
                if (nestedSort[i][1]) aSort.push({
                    src: srcCol,
                    col: iCol,
                    dir: nestedSort[i][1],
                    index: nestedSort[i]._idx,
                    type: sType,
                    formatter: extSort[sType + "-pre"],
                    sorter: extSort[sType + "-" + nestedSort[i][1]]
                });
            }
        }
    }
    return aSort;
}
/**
 * Change the order of the table
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnSort(oSettings, col, dir) {
    var i, iLen, aiOrig = [], extSort = $44bb6d473543b89d$var$DataTable.ext.type.order, aoData = oSettings.aoData, sortCol, displayMaster = oSettings.aiDisplayMaster, aSort;
    // Make sure the columns all have types defined
    $44bb6d473543b89d$var$_fnColumnTypes(oSettings);
    // Allow a specific column to be sorted, which will _not_ alter the display
    // master
    if (col !== undefined) {
        var srcCol = oSettings.aoColumns[col];
        aSort = [
            {
                src: col,
                col: col,
                dir: dir,
                index: 0,
                type: srcCol.sType,
                formatter: extSort[srcCol.sType + "-pre"],
                sorter: extSort[srcCol.sType + "-" + dir]
            }
        ];
        displayMaster = displayMaster.slice();
    } else aSort = $44bb6d473543b89d$var$_fnSortFlatten(oSettings);
    for(i = 0, iLen = aSort.length; i < iLen; i++){
        sortCol = aSort[i];
        // Load the data needed for the sort, for each cell
        $44bb6d473543b89d$var$_fnSortData(oSettings, sortCol.col);
    }
    /* No sorting required if server-side or no sorting array */ if ($44bb6d473543b89d$var$_fnDataSource(oSettings) != 'ssp' && aSort.length !== 0) {
        // Reset the initial positions on each pass so we get a stable sort
        for(i = 0, iLen = displayMaster.length; i < iLen; i++)aiOrig[i] = i;
        // If the first sort is desc, then reverse the array to preserve original
        // order, just in reverse
        if (aSort.length && aSort[0].dir === 'desc' && oSettings.orderDescReverse) aiOrig.reverse();
        /* Do the sort - here we want multi-column sorting based on a given data source (column)
		 * and sorting function (from oSort) in a certain direction. It's reasonably complex to
		 * follow on its own, but this is what we want (example two column sorting):
		 *  fnLocalSorting = function(a,b){
		 *    var test;
		 *    test = oSort['string-asc']('data11', 'data12');
		 *      if (test !== 0)
		 *        return test;
		 *    test = oSort['numeric-desc']('data21', 'data22');
		 *    if (test !== 0)
		 *      return test;
		 *    return oSort['numeric-asc']( aiOrig[a], aiOrig[b] );
		 *  }
		 * Basically we have a test for each sorting column, if the data in that column is equal,
		 * test the next column. If all columns match, then we use a numeric sort on the row
		 * positions in the original data array to provide a stable sort.
		 */ displayMaster.sort(function(a, b) {
            var x, y, k, test, sort, len = aSort.length, dataA = aoData[a]._aSortData, dataB = aoData[b]._aSortData;
            for(k = 0; k < len; k++){
                sort = aSort[k];
                // Data, which may have already been through a `-pre` function
                x = dataA[sort.col];
                y = dataB[sort.col];
                if (sort.sorter) {
                    // If there is a custom sorter (`-asc` or `-desc`) for this
                    // data type, use it
                    test = sort.sorter(x, y);
                    if (test !== 0) return test;
                } else {
                    // Otherwise, use generic sorting
                    test = x < y ? -1 : x > y ? 1 : 0;
                    if (test !== 0) return sort.dir === 'asc' ? test : -test;
                }
            }
            x = aiOrig[a];
            y = aiOrig[b];
            return x < y ? -1 : x > y ? 1 : 0;
        });
    } else if (aSort.length === 0) // Apply index order
    displayMaster.sort(function(x, y) {
        return x < y ? -1 : x > y ? 1 : 0;
    });
    if (col === undefined) {
        // Tell the draw function that we have sorted the data
        oSettings.bSorted = true;
        oSettings.sortDetails = aSort;
        $44bb6d473543b89d$var$_fnCallbackFire(oSettings, null, 'order', [
            oSettings,
            aSort
        ]);
    }
    return displayMaster;
}
/**
 * Function to run on user sort request
 *  @param {object} settings dataTables settings object
 *  @param {node} attachTo node to attach the handler to
 *  @param {int} colIdx column sorting index
 *  @param {int} addIndex Counter
 *  @param {boolean} [shift=false] Shift click add
 *  @param {function} [callback] callback function
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnSortAdd(settings, colIdx, addIndex, shift) {
    var col = settings.aoColumns[colIdx];
    var sorting = settings.aaSorting;
    var asSorting = col.asSorting;
    var nextSortIdx;
    var next = function(a, overflow) {
        var idx = a._idx;
        if (idx === undefined) idx = asSorting.indexOf(a[1]);
        return idx + 1 < asSorting.length ? idx + 1 : overflow ? null : 0;
    };
    if (!col.bSortable) return false;
    // Convert to 2D array if needed
    if (typeof sorting[0] === 'number') sorting = settings.aaSorting = [
        sorting
    ];
    // If appending the sort then we are multi-column sorting
    if ((shift || addIndex) && settings.oFeatures.bSortMulti) {
        // Are we already doing some kind of sort on this column?
        var sortIdx = $44bb6d473543b89d$var$_pluck(sorting, '0').indexOf(colIdx);
        if (sortIdx !== -1) {
            // Yes, modify the sort
            nextSortIdx = next(sorting[sortIdx], true);
            if (nextSortIdx === null && sorting.length === 1) nextSortIdx = 0; // can't remove sorting completely
            if (nextSortIdx === null || asSorting[nextSortIdx] === '') sorting.splice(sortIdx, 1);
            else {
                sorting[sortIdx][1] = asSorting[nextSortIdx];
                sorting[sortIdx]._idx = nextSortIdx;
            }
        } else if (shift) {
            // No sort on this column yet, being added by shift click
            // add it as itself
            sorting.push([
                colIdx,
                asSorting[0],
                0
            ]);
            sorting[sorting.length - 1]._idx = 0;
        } else {
            // No sort on this column yet, being added from a colspan
            // so add with same direction as first column
            sorting.push([
                colIdx,
                sorting[0][1],
                0
            ]);
            sorting[sorting.length - 1]._idx = 0;
        }
    } else if (sorting.length && sorting[0][0] == colIdx) {
        // Single column - already sorting on this column, modify the sort
        nextSortIdx = next(sorting[0]);
        sorting.length = 1;
        sorting[0][1] = asSorting[nextSortIdx];
        sorting[0]._idx = nextSortIdx;
    } else {
        // Single column - sort only on this column
        sorting.length = 0;
        sorting.push([
            colIdx,
            asSorting[0]
        ]);
        sorting[0]._idx = 0;
    }
}
/**
 * Set the sorting classes on table's body, Note: it is safe to call this function
 * when bSort and bSortClasses are false
 *  @param {object} oSettings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnSortingClasses(settings) {
    var oldSort = settings.aLastSort;
    var sortClass = settings.oClasses.order.position;
    var sort = $44bb6d473543b89d$var$_fnSortFlatten(settings);
    var features = settings.oFeatures;
    var i, iLen, colIdx;
    if (features.bSort && features.bSortClasses) {
        // Remove old sorting classes
        for(i = 0, iLen = oldSort.length; i < iLen; i++){
            colIdx = oldSort[i].src;
            // Remove column sorting
            $44bb6d473543b89d$var$$($44bb6d473543b89d$var$_pluck(settings.aoData, 'anCells', colIdx)).removeClass(sortClass + (i < 2 ? i + 1 : 3));
        }
        // Add new column sorting
        for(i = 0, iLen = sort.length; i < iLen; i++){
            colIdx = sort[i].src;
            $44bb6d473543b89d$var$$($44bb6d473543b89d$var$_pluck(settings.aoData, 'anCells', colIdx)).addClass(sortClass + (i < 2 ? i + 1 : 3));
        }
    }
    settings.aLastSort = sort;
}
// Get the data to sort a column, be it from cache, fresh (populating the
// cache), or from a sort formatter
function $44bb6d473543b89d$var$_fnSortData(settings, colIdx) {
    // Custom sorting function - provided by the sort data type
    var column = settings.aoColumns[colIdx];
    var customSort = $44bb6d473543b89d$var$DataTable.ext.order[column.sSortDataType];
    var customData;
    if (customSort) customData = customSort.call(settings.oInstance, settings, colIdx, $44bb6d473543b89d$var$_fnColumnIndexToVisible(settings, colIdx));
    // Use / populate cache
    var row, cellData;
    var formatter = $44bb6d473543b89d$var$DataTable.ext.type.order[column.sType + "-pre"];
    var data = settings.aoData;
    for(var rowIdx = 0; rowIdx < data.length; rowIdx++){
        // Sparse array
        if (!data[rowIdx]) continue;
        row = data[rowIdx];
        if (!row._aSortData) row._aSortData = [];
        if (!row._aSortData[colIdx] || customSort) {
            cellData = customSort ? customData[rowIdx] : $44bb6d473543b89d$var$_fnGetCellData(settings, rowIdx, colIdx, 'sort');
            row._aSortData[colIdx] = formatter ? formatter(cellData, settings) : cellData;
        }
    }
}
/**
 * State information for a table
 *
 * @param {*} settings
 * @returns State object
 */ function $44bb6d473543b89d$var$_fnSaveState(settings) {
    if (settings._bLoadingState) return;
    // Sort state saving uses [[idx, order]] structure.
    var sorting = [];
    $44bb6d473543b89d$var$_fnSortResolve(settings, sorting, settings.aaSorting);
    /* Store the interesting variables */ var columns = settings.aoColumns;
    var state = {
        time: +new Date(),
        start: settings._iDisplayStart,
        length: settings._iDisplayLength,
        order: sorting.map(function(sort) {
            // If a column name is available, use it
            return columns[sort[0]] && columns[sort[0]].sName ? [
                columns[sort[0]].sName,
                sort[1]
            ] : sort.slice();
        }),
        search: $44bb6d473543b89d$var$$.extend({}, settings.oPreviousSearch),
        columns: settings.aoColumns.map(function(col, i) {
            return {
                name: col.sName,
                visible: col.bVisible,
                search: $44bb6d473543b89d$var$$.extend({}, settings.aoPreSearchCols[i])
            };
        })
    };
    settings.oSavedState = state;
    $44bb6d473543b89d$var$_fnCallbackFire(settings, "aoStateSaveParams", 'stateSaveParams', [
        settings,
        state
    ]);
    if (settings.oFeatures.bStateSave && !settings.bDestroying) settings.fnStateSaveCallback.call(settings.oInstance, settings, state);
}
/**
 * Attempt to load a saved table state
 *  @param {object} oSettings dataTables settings object
 *  @param {object} oInit DataTables init object so we can override settings
 *  @param {function} callback Callback to execute when the state has been loaded
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnLoadState(settings, init, callback) {
    if (!settings.oFeatures.bStateSave) {
        callback();
        return;
    }
    var loaded = function(state) {
        $44bb6d473543b89d$var$_fnImplementState(settings, state, callback);
    };
    var state = settings.fnStateLoadCallback.call(settings.oInstance, settings, loaded);
    if (state !== undefined) $44bb6d473543b89d$var$_fnImplementState(settings, state, callback);
    // otherwise, wait for the loaded callback to be executed
    return true;
}
function $44bb6d473543b89d$var$_fnImplementState(settings, s, callback) {
    var i, iLen;
    var columns = settings.aoColumns;
    var currentNames = $44bb6d473543b89d$var$_pluck(settings.aoColumns, 'sName');
    settings._bLoadingState = true;
    // When StateRestore was introduced the state could now be implemented at any time
    // Not just initialisation. To do this an api instance is required in some places
    var api = settings._bInitComplete ? new $44bb6d473543b89d$var$DataTable.Api(settings) : null;
    if (!s || !s.time) {
        settings._bLoadingState = false;
        callback();
        return;
    }
    // Reject old data
    var duration = settings.iStateDuration;
    if (duration > 0 && s.time < +new Date() - duration * 1000) {
        settings._bLoadingState = false;
        callback();
        return;
    }
    // Allow custom and plug-in manipulation functions to alter the saved data set and
    // cancelling of loading by returning false
    var abStateLoad = $44bb6d473543b89d$var$_fnCallbackFire(settings, 'aoStateLoadParams', 'stateLoadParams', [
        settings,
        s
    ]);
    if (abStateLoad.indexOf(false) !== -1) {
        settings._bLoadingState = false;
        callback();
        return;
    }
    // Store the saved state so it might be accessed at any time
    settings.oLoadedState = $44bb6d473543b89d$var$$.extend(true, {}, s);
    // This is needed for ColReorder, which has to happen first to allow all
    // the stored indexes to be usable. It is not publicly documented.
    $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'stateLoadInit', [
        settings,
        s
    ], true);
    // Page Length
    if (s.length !== undefined) {
        // If already initialised just set the value directly so that the select element is also updated
        if (api) api.page.len(s.length);
        else settings._iDisplayLength = s.length;
    }
    // Restore key features
    if (s.start !== undefined) {
        if (api === null) {
            settings._iDisplayStart = s.start;
            settings.iInitDisplayStart = s.start;
        } else $44bb6d473543b89d$var$_fnPageChange(settings, s.start / settings._iDisplayLength);
    }
    // Order
    if (s.order !== undefined) {
        settings.aaSorting = [];
        $44bb6d473543b89d$var$$.each(s.order, function(i, col) {
            var set = [
                col[0],
                col[1]
            ];
            // A column name was stored and should be used for restore
            if (typeof col[0] === 'string') {
                // Find the name from the current list of column names
                var idx = currentNames.indexOf(col[0]);
                if (idx < 0) // If the column was not found ignore it and continue
                return;
                set[0] = idx;
            } else if (set[0] >= columns.length) // If the column index is out of bounds ignore it and continue
            return;
            settings.aaSorting.push(set);
        });
    }
    // Search
    if (s.search !== undefined) $44bb6d473543b89d$var$$.extend(settings.oPreviousSearch, s.search);
    // Columns
    if (s.columns) {
        var set = s.columns;
        var incoming = $44bb6d473543b89d$var$_pluck(s.columns, 'name');
        // Check if it is a 2.2 style state object with a `name` property for the columns, and if
        // the name was defined. If so, then create a new array that will map the state object
        // given, to the current columns (don't bother if they are already matching tho).
        if (incoming.join('').length && incoming.join('') !== currentNames.join('')) {
            set = [];
            // For each column, try to find the name in the incoming array
            for(i = 0; i < currentNames.length; i++)if (currentNames[i] != '') {
                var idx = incoming.indexOf(currentNames[i]);
                if (idx >= 0) set.push(s.columns[idx]);
                else // No matching column name in the state's columns, so this might be a new
                // column and thus can't have a state already.
                set.push({});
            } else // If no name, but other columns did have a name, then there is no knowing
            // where this one came from originally so it can't be restored.
            set.push({});
        }
        // If the number of columns to restore is different from current, then all bets are off.
        if (set.length === columns.length) {
            for(i = 0, iLen = set.length; i < iLen; i++){
                var col = set[i];
                // Visibility
                if (col.visible !== undefined) {
                    // If the api is defined, the table has been initialised so we need to use it rather than internal settings
                    if (api) // Don't redraw the columns on every iteration of this loop, we will do this at the end instead
                    api.column(i).visible(col.visible, false);
                    else columns[i].bVisible = col.visible;
                }
                // Search
                if (col.search !== undefined) $44bb6d473543b89d$var$$.extend(settings.aoPreSearchCols[i], col.search);
            }
            // If the api is defined then we need to adjust the columns once the visibility has been changed
            if (api) api.one('draw', function() {
                api.columns.adjust();
            });
        }
    }
    settings._bLoadingState = false;
    $44bb6d473543b89d$var$_fnCallbackFire(settings, 'aoStateLoaded', 'stateLoaded', [
        settings,
        s
    ]);
    callback();
}
/**
 * Log an error message
 *  @param {object} settings dataTables settings object
 *  @param {int} level log error messages, or display them to the user
 *  @param {string} msg error message
 *  @param {int} tn Technical note id to get more information about the error.
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnLog(settings, level, msg, tn) {
    msg = 'DataTables warning: ' + (settings ? 'table id=' + settings.sTableId + ' - ' : '') + msg;
    if (tn) msg += ". For more information about this error, please see https://datatables.net/tn/" + tn;
    if (!level) {
        // Backwards compatibility pre 1.10
        var ext = $44bb6d473543b89d$var$DataTable.ext;
        var type = ext.sErrMode || ext.errMode;
        if (settings) $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'dt-error', [
            settings,
            tn,
            msg
        ], true);
        if (type == 'alert') alert(msg);
        else if (type == 'throw') throw new Error(msg);
        else if (typeof type == 'function') type(settings, tn, msg);
    } else if (window.console && console.log) console.log(msg);
}
/**
 * See if a property is defined on one object, if so assign it to the other object
 *  @param {object} ret target object
 *  @param {object} src source object
 *  @param {string} name property
 *  @param {string} [mappedName] name to map too - optional, name used if not given
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnMap(ret, src, name, mappedName) {
    if (Array.isArray(name)) {
        $44bb6d473543b89d$var$$.each(name, function(i, val) {
            if (Array.isArray(val)) $44bb6d473543b89d$var$_fnMap(ret, src, val[0], val[1]);
            else $44bb6d473543b89d$var$_fnMap(ret, src, val);
        });
        return;
    }
    if (mappedName === undefined) mappedName = name;
    if (src[name] !== undefined) ret[mappedName] = src[name];
}
/**
 * Extend objects - very similar to jQuery.extend, but deep copy objects, and
 * shallow copy arrays. The reason we need to do this, is that we don't want to
 * deep copy array init values (such as aaSorting) since the dev wouldn't be
 * able to override them, but we do want to deep copy arrays.
 *  @param {object} out Object to extend
 *  @param {object} extender Object from which the properties will be applied to
 *      out
 *  @param {boolean} breakRefs If true, then arrays will be sliced to take an
 *      independent copy with the exception of the `data` or `aaData` parameters
 *      if they are present. This is so you can pass in a collection to
 *      DataTables and have that used as your data source without breaking the
 *      references
 *  @returns {object} out Reference, just for convenience - out === the return.
 *  @memberof DataTable#oApi
 *  @todo This doesn't take account of arrays inside the deep copied objects.
 */ function $44bb6d473543b89d$var$_fnExtend(out, extender, breakRefs) {
    var val;
    for(var prop in extender)if (Object.prototype.hasOwnProperty.call(extender, prop)) {
        val = extender[prop];
        if ($44bb6d473543b89d$var$$.isPlainObject(val)) {
            if (!$44bb6d473543b89d$var$$.isPlainObject(out[prop])) out[prop] = {};
            $44bb6d473543b89d$var$$.extend(true, out[prop], val);
        } else if (breakRefs && prop !== 'data' && prop !== 'aaData' && Array.isArray(val)) out[prop] = val.slice();
        else out[prop] = val;
    }
    return out;
}
/**
 * Bind an event handler to allow a click or return key to activate the callback.
 * This is good for accessibility since a return on the keyboard will have the
 * same effect as a click, if the element has focus.
 *  @param {element} n Element to bind the action to
 *  @param {object|string} selector Selector (for delegated events) or data object
 *   to pass to the triggered function
 *  @param {function} fn Callback function for when the event is triggered
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnBindAction(n, selector, fn) {
    $44bb6d473543b89d$var$$(n).on('click.DT', selector, function(e) {
        fn(e);
    }).on('keypress.DT', selector, function(e) {
        if (e.which === 13) {
            e.preventDefault();
            fn(e);
        }
    }).on('selectstart.DT', selector, function() {
        // Don't want a double click resulting in text selection
        return false;
    });
}
/**
 * Register a callback function. Easily allows a callback function to be added to
 * an array store of callback functions that can then all be called together.
 *  @param {object} settings dataTables settings object
 *  @param {string} store Name of the array storage for the callbacks in oSettings
 *  @param {function} fn Function to be called back
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnCallbackReg(settings, store, fn) {
    if (fn) settings[store].push(fn);
}
/**
 * Fire callback functions and trigger events. Note that the loop over the
 * callback array store is done backwards! Further note that you do not want to
 * fire off triggers in time sensitive applications (for example cell creation)
 * as its slow.
 *  @param {object} settings dataTables settings object
 *  @param {string} callbackArr Name of the array storage for the callbacks in
 *      oSettings
 *  @param {string} eventName Name of the jQuery custom event to trigger. If
 *      null no trigger is fired
 *  @param {array} args Array of arguments to pass to the callback function /
 *      trigger
 *  @param {boolean} [bubbles] True if the event should bubble
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnCallbackFire(settings, callbackArr, eventName, args, bubbles) {
    var ret = [];
    if (callbackArr) ret = settings[callbackArr].slice().reverse().map(function(val) {
        return val.apply(settings.oInstance, args);
    });
    if (eventName !== null) {
        var e = $44bb6d473543b89d$var$$.Event(eventName + '.dt');
        var table = $44bb6d473543b89d$var$$(settings.nTable);
        // Expose the DataTables API on the event object for easy access
        e.dt = settings.api;
        table[bubbles ? 'trigger' : 'triggerHandler'](e, args);
        // If not yet attached to the document, trigger the event
        // on the body directly to sort of simulate the bubble
        if (bubbles && table.parents('body').length === 0) $44bb6d473543b89d$var$$('body').trigger(e, args);
        ret.push(e.result);
    }
    return ret;
}
function $44bb6d473543b89d$var$_fnLengthOverflow(settings) {
    var start = settings._iDisplayStart, end = settings.fnDisplayEnd(), len = settings._iDisplayLength;
    /* If we have space to show extra rows (backing up from the end point - then do so */ if (start >= end) start = end - len;
    // Keep the start record on the current page
    start -= start % len;
    if (len === -1 || start < 0) start = 0;
    settings._iDisplayStart = start;
}
function $44bb6d473543b89d$var$_fnRenderer(settings, type) {
    var renderer = settings.renderer;
    var host = $44bb6d473543b89d$var$DataTable.ext.renderer[type];
    if ($44bb6d473543b89d$var$$.isPlainObject(renderer) && renderer[type]) // Specific renderer for this type. If available use it, otherwise use
    // the default.
    return host[renderer[type]] || host._;
    else if (typeof renderer === 'string') // Common renderer - if there is one available for this type use it,
    // otherwise use the default
    return host[renderer] || host._;
    // Use the default
    return host._;
}
/**
 * Detect the data source being used for the table. Used to simplify the code
 * a little (ajax) and to make it compress a little smaller.
 *
 *  @param {object} settings dataTables settings object
 *  @returns {string} Data source
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnDataSource(settings) {
    if (settings.oFeatures.bServerSide) return 'ssp';
    else if (settings.ajax) return 'ajax';
    return 'dom';
}
/**
 * Common replacement for language strings
 *
 * @param {*} settings DT settings object
 * @param {*} str String with values to replace
 * @param {*} entries Plural number for _ENTRIES_ - can be undefined
 * @returns String
 */ function $44bb6d473543b89d$var$_fnMacros(settings, str, entries) {
    // When infinite scrolling, we are always starting at 1. _iDisplayStart is
    // used only internally
    var formatter = settings.fnFormatNumber, start = settings._iDisplayStart + 1, len = settings._iDisplayLength, vis = settings.fnRecordsDisplay(), max = settings.fnRecordsTotal(), all = len === -1;
    return str.replace(/_START_/g, formatter.call(settings, start)).replace(/_END_/g, formatter.call(settings, settings.fnDisplayEnd())).replace(/_MAX_/g, formatter.call(settings, max)).replace(/_TOTAL_/g, formatter.call(settings, vis)).replace(/_PAGE_/g, formatter.call(settings, all ? 1 : Math.ceil(start / len))).replace(/_PAGES_/g, formatter.call(settings, all ? 1 : Math.ceil(vis / len))).replace(/_ENTRIES_/g, settings.api.i18n('entries', '', entries)).replace(/_ENTRIES-MAX_/g, settings.api.i18n('entries', '', max)).replace(/_ENTRIES-TOTAL_/g, settings.api.i18n('entries', '', vis));
}
/**
 * Add elements to an array as quickly as possible, but stack safe.
 *
 * @param {*} arr Array to add the data to
 * @param {*} data Data array that is to be added
 * @returns 
 */ function $44bb6d473543b89d$var$_fnArrayApply(arr, data) {
    if (!data) return;
    // Chrome can throw a max stack error if apply is called with
    // too large an array, but apply is faster.
    if (data.length < 10000) arr.push.apply(arr, data);
    else for($44bb6d473543b89d$var$i = 0; $44bb6d473543b89d$var$i < data.length; $44bb6d473543b89d$var$i++)arr.push(data[$44bb6d473543b89d$var$i]);
}
/**
 * Add one or more listeners to the table
 *
 * @param {*} that JQ for the table
 * @param {*} name Event name
 * @param {*} src Listener(s)
 */ function $44bb6d473543b89d$var$_fnListener(that, name, src) {
    if (!Array.isArray(src)) src = [
        src
    ];
    for($44bb6d473543b89d$var$i = 0; $44bb6d473543b89d$var$i < src.length; $44bb6d473543b89d$var$i++)that.on(name + '.dt', src[$44bb6d473543b89d$var$i]);
}
/**
 * Escape HTML entities in strings, in an object
 */ function $44bb6d473543b89d$var$_fnEscapeObject(obj) {
    if ($44bb6d473543b89d$var$DataTable.ext.escape.attributes) $44bb6d473543b89d$var$$.each(obj, function(key, val) {
        obj[key] = $44bb6d473543b89d$var$_escapeHtml(val);
    });
    return obj;
}
/**
 * Computed structure of the DataTables API, defined by the options passed to
 * `DataTable.Api.register()` when building the API.
 *
 * The structure is built in order to speed creation and extension of the Api
 * objects since the extensions are effectively pre-parsed.
 *
 * The array is an array of objects with the following structure, where this
 * base array represents the Api prototype base:
 *
 *     [
 *       {
 *         name:      'data'                -- string   - Property name
 *         val:       function () {},       -- function - Api method (or undefined if just an object
 *         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
 *         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
 *       },
 *       {
 *         name:     'row'
 *         val:       {},
 *         methodExt: [ ... ],
 *         propExt:   [
 *           {
 *             name:      'data'
 *             val:       function () {},
 *             methodExt: [ ... ],
 *             propExt:   [ ... ]
 *           },
 *           ...
 *         ]
 *       }
 *     ]
 *
 * @type {Array}
 * @ignore
 */ var $44bb6d473543b89d$var$__apiStruct = [];
/**
 * `Array.prototype` reference.
 *
 * @type object
 * @ignore
 */ var $44bb6d473543b89d$var$__arrayProto = Array.prototype;
/**
 * Abstraction for `context` parameter of the `Api` constructor to allow it to
 * take several different forms for ease of use.
 *
 * Each of the input parameter types will be converted to a DataTables settings
 * object where possible.
 *
 * @param  {string|node|jQuery|object} mixed DataTable identifier. Can be one
 *   of:
 *
 *   * `string` - jQuery selector. Any DataTables' matching the given selector
 *     with be found and used.
 *   * `node` - `TABLE` node which has already been formed into a DataTable.
 *   * `jQuery` - A jQuery object of `TABLE` nodes.
 *   * `object` - DataTables settings object
 *   * `DataTables.Api` - API instance
 * @return {array|null} Matching DataTables settings objects. `null` or
 *   `undefined` is returned if no matching DataTable is found.
 * @ignore
 */ var $44bb6d473543b89d$var$_toSettings = function(mixed) {
    var idx, jq;
    var settings = $44bb6d473543b89d$var$DataTable.settings;
    var tables = $44bb6d473543b89d$var$_pluck(settings, 'nTable');
    if (!mixed) return [];
    else if (mixed.nTable && mixed.oFeatures) // DataTables settings object
    return [
        mixed
    ];
    else if (mixed.nodeName && mixed.nodeName.toLowerCase() === 'table') {
        // Table node
        idx = tables.indexOf(mixed);
        return idx !== -1 ? [
            settings[idx]
        ] : null;
    } else if (mixed && typeof mixed.settings === 'function') return mixed.settings().toArray();
    else if (typeof mixed === 'string') // jQuery selector
    jq = $44bb6d473543b89d$var$$(mixed).get();
    else if (mixed instanceof $44bb6d473543b89d$var$$) // jQuery object (also DataTables instance)
    jq = mixed.get();
    if (jq) return settings.filter(function(v, idx) {
        return jq.includes(tables[idx]);
    });
};
/**
 * DataTables API class - used to control and interface with  one or more
 * DataTables enhanced tables.
 *
 * The API class is heavily based on jQuery, presenting a chainable interface
 * that you can use to interact with tables. Each instance of the API class has
 * a "context" - i.e. the tables that it will operate on. This could be a single
 * table, all tables on a page or a sub-set thereof.
 *
 * Additionally the API is designed to allow you to easily work with the data in
 * the tables, retrieving and manipulating it as required. This is done by
 * presenting the API class as an array like interface. The contents of the
 * array depend upon the actions requested by each method (for example
 * `rows().nodes()` will return an array of nodes, while `rows().data()` will
 * return an array of objects or arrays depending upon your table's
 * configuration). The API object has a number of array like methods (`push`,
 * `pop`, `reverse` etc) as well as additional helper methods (`each`, `pluck`,
 * `unique` etc) to assist your working with the data held in a table.
 *
 * Most methods (those which return an Api instance) are chainable, which means
 * the return from a method call also has all of the methods available that the
 * top level object had. For example, these two calls are equivalent:
 *
 *     // Not chained
 *     api.row.add( {...} );
 *     api.draw();
 *
 *     // Chained
 *     api.row.add( {...} ).draw();
 *
 * @class DataTable.Api
 * @param {array|object|string|jQuery} context DataTable identifier. This is
 *   used to define which DataTables enhanced tables this API will operate on.
 *   Can be one of:
 *
 *   * `string` - jQuery selector. Any DataTables' matching the given selector
 *     with be found and used.
 *   * `node` - `TABLE` node which has already been formed into a DataTable.
 *   * `jQuery` - A jQuery object of `TABLE` nodes.
 *   * `object` - DataTables settings object
 * @param {array} [data] Data to initialise the Api instance with.
 *
 * @example
 *   // Direct initialisation during DataTables construction
 *   var api = $('#example').DataTable();
 *
 * @example
 *   // Initialisation using a DataTables jQuery object
 *   var api = $('#example').dataTable().api();
 *
 * @example
 *   // Initialisation as a constructor
 *   var api = new DataTable.Api( 'table.dataTable' );
 */ $44bb6d473543b89d$var$_Api = function(context, data) {
    if (!(this instanceof $44bb6d473543b89d$var$_Api)) return new $44bb6d473543b89d$var$_Api(context, data);
    var i;
    var settings = [];
    var ctxSettings = function(o) {
        var a = $44bb6d473543b89d$var$_toSettings(o);
        if (a) settings.push.apply(settings, a);
    };
    if (Array.isArray(context)) for(i = 0; i < context.length; i++)ctxSettings(context[i]);
    else ctxSettings(context);
    // Remove duplicates
    this.context = settings.length > 1 ? $44bb6d473543b89d$var$_unique(settings) : settings;
    // Initial data
    $44bb6d473543b89d$var$_fnArrayApply(this, data);
    // selector
    this.selector = {
        rows: null,
        cols: null,
        opts: null
    };
    $44bb6d473543b89d$var$_Api.extend(this, this, $44bb6d473543b89d$var$__apiStruct);
};
$44bb6d473543b89d$var$DataTable.Api = $44bb6d473543b89d$var$_Api;
// Don't destroy the existing prototype, just extend it. Required for jQuery 2's
// isPlainObject.
$44bb6d473543b89d$var$$.extend($44bb6d473543b89d$var$_Api.prototype, {
    any: function() {
        return this.count() !== 0;
    },
    context: [],
    count: function() {
        return this.flatten().length;
    },
    each: function(fn) {
        for(var i = 0, iLen = this.length; i < iLen; i++)fn.call(this, this[i], i, this);
        return this;
    },
    eq: function(idx) {
        var ctx = this.context;
        return ctx.length > idx ? new $44bb6d473543b89d$var$_Api(ctx[idx], this[idx]) : null;
    },
    filter: function(fn) {
        var a = $44bb6d473543b89d$var$__arrayProto.filter.call(this, fn, this);
        return new $44bb6d473543b89d$var$_Api(this.context, a);
    },
    flatten: function() {
        var a = [];
        return new $44bb6d473543b89d$var$_Api(this.context, a.concat.apply(a, this.toArray()));
    },
    get: function(idx) {
        return this[idx];
    },
    join: $44bb6d473543b89d$var$__arrayProto.join,
    includes: function(find) {
        return this.indexOf(find) === -1 ? false : true;
    },
    indexOf: $44bb6d473543b89d$var$__arrayProto.indexOf,
    iterator: function(flatten, type, fn, alwaysNew) {
        var a = [], ret, i, iLen, j, jen, context = this.context, rows, items, item, selector = this.selector;
        // Argument shifting
        if (typeof flatten === 'string') {
            alwaysNew = fn;
            fn = type;
            type = flatten;
            flatten = false;
        }
        for(i = 0, iLen = context.length; i < iLen; i++){
            var apiInst = new $44bb6d473543b89d$var$_Api(context[i]);
            if (type === 'table') {
                ret = fn.call(apiInst, context[i], i);
                if (ret !== undefined) a.push(ret);
            } else if (type === 'columns' || type === 'rows') {
                // this has same length as context - one entry for each table
                ret = fn.call(apiInst, context[i], this[i], i);
                if (ret !== undefined) a.push(ret);
            } else if (type === 'every' || type === 'column' || type === 'column-rows' || type === 'row' || type === 'cell') {
                // columns and rows share the same structure.
                // 'this' is an array of column indexes for each context
                items = this[i];
                if (type === 'column-rows') rows = $44bb6d473543b89d$var$_selector_row_indexes(context[i], selector.opts);
                for(j = 0, jen = items.length; j < jen; j++){
                    item = items[j];
                    if (type === 'cell') ret = fn.call(apiInst, context[i], item.row, item.column, i, j);
                    else ret = fn.call(apiInst, context[i], item, i, j, rows);
                    if (ret !== undefined) a.push(ret);
                }
            }
        }
        if (a.length || alwaysNew) {
            var api = new $44bb6d473543b89d$var$_Api(context, flatten ? a.concat.apply([], a) : a);
            var apiSelector = api.selector;
            apiSelector.rows = selector.rows;
            apiSelector.cols = selector.cols;
            apiSelector.opts = selector.opts;
            return api;
        }
        return this;
    },
    lastIndexOf: $44bb6d473543b89d$var$__arrayProto.lastIndexOf,
    length: 0,
    map: function(fn) {
        var a = $44bb6d473543b89d$var$__arrayProto.map.call(this, fn, this);
        return new $44bb6d473543b89d$var$_Api(this.context, a);
    },
    pluck: function(prop) {
        var fn = $44bb6d473543b89d$var$DataTable.util.get(prop);
        return this.map(function(el) {
            return fn(el);
        });
    },
    pop: $44bb6d473543b89d$var$__arrayProto.pop,
    push: $44bb6d473543b89d$var$__arrayProto.push,
    reduce: $44bb6d473543b89d$var$__arrayProto.reduce,
    reduceRight: $44bb6d473543b89d$var$__arrayProto.reduceRight,
    reverse: $44bb6d473543b89d$var$__arrayProto.reverse,
    // Object with rows, columns and opts
    selector: null,
    shift: $44bb6d473543b89d$var$__arrayProto.shift,
    slice: function() {
        return new $44bb6d473543b89d$var$_Api(this.context, this);
    },
    sort: $44bb6d473543b89d$var$__arrayProto.sort,
    splice: $44bb6d473543b89d$var$__arrayProto.splice,
    toArray: function() {
        return $44bb6d473543b89d$var$__arrayProto.slice.call(this);
    },
    to$: function() {
        return $44bb6d473543b89d$var$$(this);
    },
    toJQuery: function() {
        return $44bb6d473543b89d$var$$(this);
    },
    unique: function() {
        return new $44bb6d473543b89d$var$_Api(this.context, $44bb6d473543b89d$var$_unique(this.toArray()));
    },
    unshift: $44bb6d473543b89d$var$__arrayProto.unshift
});
function $44bb6d473543b89d$var$_api_scope(scope, fn, struct) {
    return function() {
        var ret = fn.apply(scope || this, arguments);
        // Method extension
        $44bb6d473543b89d$var$_Api.extend(ret, ret, struct.methodExt);
        return ret;
    };
}
function $44bb6d473543b89d$var$_api_find(src, name) {
    for(var i = 0, iLen = src.length; i < iLen; i++){
        if (src[i].name === name) return src[i];
    }
    return null;
}
window.__apiStruct = $44bb6d473543b89d$var$__apiStruct;
$44bb6d473543b89d$var$_Api.extend = function(scope, obj, ext) {
    // Only extend API instances and static properties of the API
    if (!ext.length || !obj || !(obj instanceof $44bb6d473543b89d$var$_Api) && !obj.__dt_wrapper) return;
    var i, iLen, struct;
    for(i = 0, iLen = ext.length; i < iLen; i++){
        struct = ext[i];
        if (struct.name === '__proto__') continue;
        // Value
        obj[struct.name] = struct.type === 'function' ? $44bb6d473543b89d$var$_api_scope(scope, struct.val, struct) : struct.type === 'object' ? {} : struct.val;
        obj[struct.name].__dt_wrapper = true;
        // Property extension
        $44bb6d473543b89d$var$_Api.extend(scope, obj[struct.name], struct.propExt);
    }
};
//     [
//       {
//         name:      'data'                -- string   - Property name
//         val:       function () {},       -- function - Api method (or undefined if just an object
//         methodExt: [ ... ],              -- array    - Array of Api object definitions to extend the method result
//         propExt:   [ ... ]               -- array    - Array of Api object definitions to extend the property
//       },
//       {
//         name:     'row'
//         val:       {},
//         methodExt: [ ... ],
//         propExt:   [
//           {
//             name:      'data'
//             val:       function () {},
//             methodExt: [ ... ],
//             propExt:   [ ... ]
//           },
//           ...
//         ]
//       }
//     ]
$44bb6d473543b89d$var$_Api.register = $44bb6d473543b89d$var$_api_register = function(name, val) {
    if (Array.isArray(name)) {
        for(var j = 0, jen = name.length; j < jen; j++)$44bb6d473543b89d$var$_Api.register(name[j], val);
        return;
    }
    var i, iLen, heir = name.split('.'), struct = $44bb6d473543b89d$var$__apiStruct, key, method;
    for(i = 0, iLen = heir.length; i < iLen; i++){
        method = heir[i].indexOf('()') !== -1;
        key = method ? heir[i].replace('()', '') : heir[i];
        var src = $44bb6d473543b89d$var$_api_find(struct, key);
        if (!src) {
            src = {
                name: key,
                val: {},
                methodExt: [],
                propExt: [],
                type: 'object'
            };
            struct.push(src);
        }
        if (i === iLen - 1) {
            src.val = val;
            src.type = typeof val === 'function' ? 'function' : $44bb6d473543b89d$var$$.isPlainObject(val) ? 'object' : 'other';
        } else struct = method ? src.methodExt : src.propExt;
    }
};
$44bb6d473543b89d$var$_Api.registerPlural = $44bb6d473543b89d$var$_api_registerPlural = function(pluralName, singularName, val) {
    $44bb6d473543b89d$var$_Api.register(pluralName, val);
    $44bb6d473543b89d$var$_Api.register(singularName, function() {
        var ret = val.apply(this, arguments);
        if (ret === this) // Returned item is the API instance that was passed in, return it
        return this;
        else if (ret instanceof $44bb6d473543b89d$var$_Api) // New API instance returned, want the value from the first item
        // in the returned array for the singular result.
        return ret.length ? Array.isArray(ret[0]) ? new $44bb6d473543b89d$var$_Api(ret.context, ret[0]) : ret[0] : undefined;
        // Non-API return - just fire it back
        return ret;
    });
};
/**
 * Selector for HTML tables. Apply the given selector to the give array of
 * DataTables settings objects.
 *
 * @param {string|integer} [selector] jQuery selector string or integer
 * @param  {array} Array of DataTables settings objects to be filtered
 * @return {array}
 * @ignore
 */ var $44bb6d473543b89d$var$__table_selector = function(selector, a) {
    if (Array.isArray(selector)) {
        var result = [];
        selector.forEach(function(sel) {
            var inner = $44bb6d473543b89d$var$__table_selector(sel, a);
            $44bb6d473543b89d$var$_fnArrayApply(result, inner);
        });
        return result.filter(function(item) {
            return item;
        });
    }
    // Integer is used to pick out a table by index
    if (typeof selector === 'number') return [
        a[selector]
    ];
    // Perform a jQuery selector on the table nodes
    var nodes = a.map(function(el) {
        return el.nTable;
    });
    return $44bb6d473543b89d$var$$(nodes).filter(selector).map(function() {
        // Need to translate back from the table node to the settings
        var idx = nodes.indexOf(this);
        return a[idx];
    }).toArray();
};
/**
 * Context selector for the API's context (i.e. the tables the API instance
 * refers to.
 *
 * @name    DataTable.Api#tables
 * @param {string|integer} [selector] Selector to pick which tables the iterator
 *   should operate on. If not given, all tables in the current context are
 *   used. This can be given as a jQuery selector (for example `':gt(0)'`) to
 *   select multiple tables or as an integer to select a single table.
 * @returns {DataTable.Api} Returns a new API instance if a selector is given.
 */ $44bb6d473543b89d$var$_api_register('tables()', function(selector) {
    // A new instance is created if there was a selector specified
    return selector !== undefined && selector !== null ? new $44bb6d473543b89d$var$_Api($44bb6d473543b89d$var$__table_selector(selector, this.context)) : this;
});
$44bb6d473543b89d$var$_api_register('table()', function(selector) {
    var tables = this.tables(selector);
    var ctx = tables.context;
    // Truncate to the first matched table
    return ctx.length ? new $44bb6d473543b89d$var$_Api(ctx[0]) : tables;
});
// Common methods, combined to reduce size
[
    [
        'nodes',
        'node',
        'nTable'
    ],
    [
        'body',
        'body',
        'nTBody'
    ],
    [
        'header',
        'header',
        'nTHead'
    ],
    [
        'footer',
        'footer',
        'nTFoot'
    ]
].forEach(function(item) {
    $44bb6d473543b89d$var$_api_registerPlural('tables().' + item[0] + '()', 'table().' + item[1] + '()', function() {
        return this.iterator('table', function(ctx) {
            return ctx[item[2]];
        }, 1);
    });
});
// Structure methods
[
    [
        'header',
        'aoHeader'
    ],
    [
        'footer',
        'aoFooter'
    ]
].forEach(function(item) {
    $44bb6d473543b89d$var$_api_register('table().' + item[0] + '.structure()', function(selector) {
        var indexes = this.columns(selector).indexes().flatten().toArray();
        var ctx = this.context[0];
        var structure = $44bb6d473543b89d$var$_fnHeaderLayout(ctx, ctx[item[1]], indexes);
        // The structure is in column index order - but from this method we want the return to be
        // in the columns() selector API order. In order to do that we need to map from one form
        // to the other
        var orderedIndexes = indexes.slice().sort(function(a, b) {
            return a - b;
        });
        return structure.map(function(row) {
            return indexes.map(function(colIdx) {
                return row[orderedIndexes.indexOf(colIdx)];
            });
        });
    });
});
$44bb6d473543b89d$var$_api_registerPlural('tables().containers()', 'table().container()', function() {
    return this.iterator('table', function(ctx) {
        return ctx.nTableWrapper;
    }, 1);
});
$44bb6d473543b89d$var$_api_register('tables().every()', function(fn) {
    var that = this;
    return this.iterator('table', function(s, i) {
        fn.call(that.table(i), i);
    });
});
$44bb6d473543b89d$var$_api_register('caption()', function(value, side) {
    var context = this.context;
    // Getter - return existing node's content
    if (value === undefined) {
        var caption = context[0].captionNode;
        return caption && context.length ? caption.innerHTML : null;
    }
    return this.iterator('table', function(ctx) {
        var table = $44bb6d473543b89d$var$$(ctx.nTable);
        var caption = $44bb6d473543b89d$var$$(ctx.captionNode);
        var container = $44bb6d473543b89d$var$$(ctx.nTableWrapper);
        // Create the node if it doesn't exist yet
        if (!caption.length) {
            caption = $44bb6d473543b89d$var$$('<caption/>').html(value);
            ctx.captionNode = caption[0];
            // If side isn't set, we need to insert into the document to let the
            // CSS decide so we can read it back, otherwise there is no way to
            // know if the CSS would put it top or bottom for scrolling
            if (!side) {
                table.prepend(caption);
                side = caption.css('caption-side');
            }
        }
        caption.html(value);
        if (side) {
            caption.css('caption-side', side);
            caption[0]._captionSide = side;
        }
        if (container.find('div.dataTables_scroll').length) {
            var selector = side === 'top' ? 'Head' : 'Foot';
            container.find('div.dataTables_scroll' + selector + ' table').prepend(caption);
        } else table.prepend(caption);
    }, 1);
});
$44bb6d473543b89d$var$_api_register('caption.node()', function() {
    var ctx = this.context;
    return ctx.length ? ctx[0].captionNode : null;
});
/**
 * Redraw the tables in the current context.
 */ $44bb6d473543b89d$var$_api_register('draw()', function(paging) {
    return this.iterator('table', function(settings) {
        if (paging === 'page') $44bb6d473543b89d$var$_fnDraw(settings);
        else {
            if (typeof paging === 'string') paging = paging === 'full-hold' ? false : true;
            $44bb6d473543b89d$var$_fnReDraw(settings, paging === false);
        }
    });
});
/**
 * Get the current page index.
 *
 * @return {integer} Current page index (zero based)
 */ /**
 * Set the current page.
 *
 * Note that if you attempt to show a page which does not exist, DataTables will
 * not throw an error, but rather reset the paging.
 *
 * @param {integer|string} action The paging action to take. This can be one of:
 *  * `integer` - The page index to jump to
 *  * `string` - An action to take:
 *    * `first` - Jump to first page.
 *    * `next` - Jump to the next page
 *    * `previous` - Jump to previous page
 *    * `last` - Jump to the last page.
 * @returns {DataTables.Api} this
 */ $44bb6d473543b89d$var$_api_register('page()', function(action) {
    if (action === undefined) return this.page.info().page; // not an expensive call
    // else, have an action to take on all tables
    return this.iterator('table', function(settings) {
        $44bb6d473543b89d$var$_fnPageChange(settings, action);
    });
});
/**
 * Paging information for the first table in the current context.
 *
 * If you require paging information for another table, use the `table()` method
 * with a suitable selector.
 *
 * @return {object} Object with the following properties set:
 *  * `page` - Current page index (zero based - i.e. the first page is `0`)
 *  * `pages` - Total number of pages
 *  * `start` - Display index for the first record shown on the current page
 *  * `end` - Display index for the last record shown on the current page
 *  * `length` - Display length (number of records). Note that generally `start
 *    + length = end`, but this is not always true, for example if there are
 *    only 2 records to show on the final page, with a length of 10.
 *  * `recordsTotal` - Full data set length
 *  * `recordsDisplay` - Data set length once the current filtering criterion
 *    are applied.
 */ $44bb6d473543b89d$var$_api_register('page.info()', function() {
    if (this.context.length === 0) return undefined;
    var settings = this.context[0], start = settings._iDisplayStart, len = settings.oFeatures.bPaginate ? settings._iDisplayLength : -1, visRecords = settings.fnRecordsDisplay(), all = len === -1;
    return {
        "page": all ? 0 : Math.floor(start / len),
        "pages": all ? 1 : Math.ceil(visRecords / len),
        "start": start,
        "end": settings.fnDisplayEnd(),
        "length": len,
        "recordsTotal": settings.fnRecordsTotal(),
        "recordsDisplay": visRecords,
        "serverSide": $44bb6d473543b89d$var$_fnDataSource(settings) === 'ssp'
    };
});
/**
 * Get the current page length.
 *
 * @return {integer} Current page length. Note `-1` indicates that all records
 *   are to be shown.
 */ /**
 * Set the current page length.
 *
 * @param {integer} Page length to set. Use `-1` to show all records.
 * @returns {DataTables.Api} this
 */ $44bb6d473543b89d$var$_api_register('page.len()', function(len) {
    // Note that we can't call this function 'length()' because `length`
    // is a JavaScript property of functions which defines how many arguments
    // the function expects.
    if (len === undefined) return this.context.length !== 0 ? this.context[0]._iDisplayLength : undefined;
    // else, set the page length
    return this.iterator('table', function(settings) {
        $44bb6d473543b89d$var$_fnLengthChange(settings, len);
    });
});
var $44bb6d473543b89d$var$__reload = function(settings, holdPosition, callback) {
    // Use the draw event to trigger a callback
    if (callback) {
        var api = new $44bb6d473543b89d$var$_Api(settings);
        api.one('draw', function() {
            callback(api.ajax.json());
        });
    }
    if ($44bb6d473543b89d$var$_fnDataSource(settings) == 'ssp') $44bb6d473543b89d$var$_fnReDraw(settings, holdPosition);
    else {
        $44bb6d473543b89d$var$_fnProcessingDisplay(settings, true);
        // Cancel an existing request
        var xhr = settings.jqXHR;
        if (xhr && xhr.readyState !== 4) xhr.abort();
        // Trigger xhr
        $44bb6d473543b89d$var$_fnBuildAjax(settings, {}, function(json) {
            $44bb6d473543b89d$var$_fnClearTable(settings);
            var data = $44bb6d473543b89d$var$_fnAjaxDataSrc(settings, json);
            for(var i = 0, iLen = data.length; i < iLen; i++)$44bb6d473543b89d$var$_fnAddData(settings, data[i]);
            $44bb6d473543b89d$var$_fnReDraw(settings, holdPosition);
            $44bb6d473543b89d$var$_fnInitComplete(settings);
            $44bb6d473543b89d$var$_fnProcessingDisplay(settings, false);
        });
    }
};
/**
 * Get the JSON response from the last Ajax request that DataTables made to the
 * server. Note that this returns the JSON from the first table in the current
 * context.
 *
 * @return {object} JSON received from the server.
 */ $44bb6d473543b89d$var$_api_register('ajax.json()', function() {
    var ctx = this.context;
    if (ctx.length > 0) return ctx[0].json;
// else return undefined;
});
/**
 * Get the data submitted in the last Ajax request
 */ $44bb6d473543b89d$var$_api_register('ajax.params()', function() {
    var ctx = this.context;
    if (ctx.length > 0) return ctx[0].oAjaxData;
// else return undefined;
});
/**
 * Reload tables from the Ajax data source. Note that this function will
 * automatically re-draw the table when the remote data has been loaded.
 *
 * @param {boolean} [reset=true] Reset (default) or hold the current paging
 *   position. A full re-sort and re-filter is performed when this method is
 *   called, which is why the pagination reset is the default action.
 * @returns {DataTables.Api} this
 */ $44bb6d473543b89d$var$_api_register('ajax.reload()', function(callback, resetPaging) {
    return this.iterator('table', function(settings) {
        $44bb6d473543b89d$var$__reload(settings, resetPaging === false, callback);
    });
});
/**
 * Get the current Ajax URL. Note that this returns the URL from the first
 * table in the current context.
 *
 * @return {string} Current Ajax source URL
 */ /**
 * Set the Ajax URL. Note that this will set the URL for all tables in the
 * current context.
 *
 * @param {string} url URL to set.
 * @returns {DataTables.Api} this
 */ $44bb6d473543b89d$var$_api_register('ajax.url()', function(url) {
    var ctx = this.context;
    if (url === undefined) {
        // get
        if (ctx.length === 0) return undefined;
        ctx = ctx[0];
        return $44bb6d473543b89d$var$$.isPlainObject(ctx.ajax) ? ctx.ajax.url : ctx.ajax;
    }
    // set
    return this.iterator('table', function(settings) {
        if ($44bb6d473543b89d$var$$.isPlainObject(settings.ajax)) settings.ajax.url = url;
        else settings.ajax = url;
    });
});
/**
 * Load data from the newly set Ajax URL. Note that this method is only
 * available when `ajax.url()` is used to set a URL. Additionally, this method
 * has the same effect as calling `ajax.reload()` but is provided for
 * convenience when setting a new URL. Like `ajax.reload()` it will
 * automatically redraw the table once the remote data has been loaded.
 *
 * @returns {DataTables.Api} this
 */ $44bb6d473543b89d$var$_api_register('ajax.url().load()', function(callback, resetPaging) {
    // Same as a reload, but makes sense to present it for easy access after a
    // url change
    return this.iterator('table', function(ctx) {
        $44bb6d473543b89d$var$__reload(ctx, resetPaging === false, callback);
    });
});
var $44bb6d473543b89d$var$_selector_run = function(type, selector, selectFn, settings, opts) {
    var out = [], res, i, iLen, selectorType = typeof selector;
    // Can't just check for isArray here, as an API or jQuery instance might be
    // given with their array like look
    if (!selector || selectorType === 'string' || selectorType === 'function' || selector.length === undefined) selector = [
        selector
    ];
    for(i = 0, iLen = selector.length; i < iLen; i++){
        res = selectFn(typeof selector[i] === 'string' ? selector[i].trim() : selector[i]);
        // Remove empty items
        res = res.filter(function(item) {
            return item !== null && item !== undefined;
        });
        if (res && res.length) out = out.concat(res);
    }
    // selector extensions
    var ext = $44bb6d473543b89d$var$_ext.selector[type];
    if (ext.length) for(i = 0, iLen = ext.length; i < iLen; i++)out = ext[i](settings, opts, out);
    return $44bb6d473543b89d$var$_unique(out);
};
var $44bb6d473543b89d$var$_selector_opts = function(opts) {
    if (!opts) opts = {};
    // Backwards compatibility for 1.9- which used the terminology filter rather
    // than search
    if (opts.filter && opts.search === undefined) opts.search = opts.filter;
    return $44bb6d473543b89d$var$$.extend({
        columnOrder: 'implied',
        search: 'none',
        order: 'current',
        page: 'all'
    }, opts);
};
// Reduce the API instance to the first item found
var $44bb6d473543b89d$var$_selector_first = function(old) {
    var inst = new $44bb6d473543b89d$var$_Api(old.context[0]);
    // Use a push rather than passing to the constructor, since it will
    // merge arrays down automatically, which isn't what is wanted here
    if (old.length) inst.push(old[0]);
    inst.selector = old.selector;
    // Limit to a single row / column / cell
    if (inst.length && inst[0].length > 1) inst[0].splice(1);
    return inst;
};
var $44bb6d473543b89d$var$_selector_row_indexes = function(settings, opts) {
    var i, iLen, tmp, a = [], displayFiltered = settings.aiDisplay, displayMaster = settings.aiDisplayMaster;
    var search = opts.search, order = opts.order, page = opts.page; // all, current
    if ($44bb6d473543b89d$var$_fnDataSource(settings) == 'ssp') // In server-side processing mode, most options are irrelevant since
    // rows not shown don't exist and the index order is the applied order
    // Removed is a special case - for consistency just return an empty
    // array
    return search === 'removed' ? [] : $44bb6d473543b89d$var$_range(0, displayMaster.length);
    if (page == 'current') // Current page implies that order=current and filter=applied, since it is
    // fairly senseless otherwise, regardless of what order and search actually
    // are
    for(i = settings._iDisplayStart, iLen = settings.fnDisplayEnd(); i < iLen; i++)a.push(displayFiltered[i]);
    else if (order == 'current' || order == 'applied') {
        if (search == 'none') a = displayMaster.slice();
        else if (search == 'applied') a = displayFiltered.slice();
        else if (search == 'removed') {
            // O(n+m) solution by creating a hash map
            var displayFilteredMap = {};
            for(i = 0, iLen = displayFiltered.length; i < iLen; i++)displayFilteredMap[displayFiltered[i]] = null;
            displayMaster.forEach(function(item) {
                if (!Object.prototype.hasOwnProperty.call(displayFilteredMap, item)) a.push(item);
            });
        }
    } else if (order == 'index' || order == 'original') for(i = 0, iLen = settings.aoData.length; i < iLen; i++){
        if (!settings.aoData[i]) continue;
        if (search == 'none') a.push(i);
        else {
            tmp = displayFiltered.indexOf(i);
            if (tmp === -1 && search == 'removed' || tmp >= 0 && search == 'applied') a.push(i);
        }
    }
    else if (typeof order === 'number') {
        // Order the rows by the given column
        var ordered = $44bb6d473543b89d$var$_fnSort(settings, order, 'asc');
        if (search === 'none') a = ordered;
        else for(i = 0; i < ordered.length; i++){
            tmp = displayFiltered.indexOf(ordered[i]);
            if (tmp === -1 && search == 'removed' || tmp >= 0 && search == 'applied') a.push(ordered[i]);
        }
    }
    return a;
};
/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Rows
 *
 * {}          - no selector - use all available rows
 * {integer}   - row aoData index
 * {node}      - TR node
 * {string}    - jQuery selector to apply to the TR elements
 * {array}     - jQuery array of nodes, or simply an array of TR nodes
 *
 */ var $44bb6d473543b89d$var$__row_selector = function(settings, selector, opts) {
    var rows;
    var run = function(sel) {
        var selInt = $44bb6d473543b89d$var$_intVal(sel);
        var aoData = settings.aoData;
        // Short cut - selector is a number and no options provided (default is
        // all records, so no need to check if the index is in there, since it
        // must be - dev error if the index doesn't exist).
        if (selInt !== null && !opts) return [
            selInt
        ];
        if (!rows) rows = $44bb6d473543b89d$var$_selector_row_indexes(settings, opts);
        if (selInt !== null && rows.indexOf(selInt) !== -1) // Selector - integer
        return [
            selInt
        ];
        else if (sel === null || sel === undefined || sel === '') // Selector - none
        return rows;
        // Selector - function
        if (typeof sel === 'function') return rows.map(function(idx) {
            var row = aoData[idx];
            return sel(idx, row._aData, row.nTr) ? idx : null;
        });
        // Selector - node
        if (sel.nodeName) {
            var rowIdx = sel._DT_RowIndex; // Property added by DT for fast lookup
            var cellIdx = sel._DT_CellIndex;
            if (rowIdx !== undefined) // Make sure that the row is actually still present in the table
            return aoData[rowIdx] && aoData[rowIdx].nTr === sel ? [
                rowIdx
            ] : [];
            else if (cellIdx) return aoData[cellIdx.row] && aoData[cellIdx.row].nTr === sel.parentNode ? [
                cellIdx.row
            ] : [];
            else {
                var host = $44bb6d473543b89d$var$$(sel).closest('*[data-dt-row]');
                return host.length ? [
                    host.data('dt-row')
                ] : [];
            }
        }
        // ID selector. Want to always be able to select rows by id, regardless
        // of if the tr element has been created or not, so can't rely upon
        // jQuery here - hence a custom implementation. This does not match
        // Sizzle's fast selector or HTML4 - in HTML5 the ID can be anything,
        // but to select it using a CSS selector engine (like Sizzle or
        // querySelect) it would need to need to be escaped for some characters.
        // DataTables simplifies this for row selectors since you can select
        // only a row. A # indicates an id any anything that follows is the id -
        // unescaped.
        if (typeof sel === 'string' && sel.charAt(0) === '#') {
            // get row index from id
            var rowObj = settings.aIds[sel.replace(/^#/, '')];
            if (rowObj !== undefined) return [
                rowObj.idx
            ];
        // need to fall through to jQuery in case there is DOM id that
        // matches
        }
        // Get nodes in the order from the `rows` array with null values removed
        var nodes = $44bb6d473543b89d$var$_removeEmpty($44bb6d473543b89d$var$_pluck_order(settings.aoData, rows, 'nTr'));
        // Selector - jQuery selector string, array of nodes or jQuery object/
        // As jQuery's .filter() allows jQuery objects to be passed in filter,
        // it also allows arrays, so this will cope with all three options
        return $44bb6d473543b89d$var$$(nodes).filter(sel).map(function() {
            return this._DT_RowIndex;
        }).toArray();
    };
    var matched = $44bb6d473543b89d$var$_selector_run('row', selector, run, settings, opts);
    if (opts.order === 'current' || opts.order === 'applied') $44bb6d473543b89d$var$_fnSortDisplay(settings, matched);
    return matched;
};
$44bb6d473543b89d$var$_api_register('rows()', function(selector, opts) {
    // argument shifting
    if (selector === undefined) selector = '';
    else if ($44bb6d473543b89d$var$$.isPlainObject(selector)) {
        opts = selector;
        selector = '';
    }
    opts = $44bb6d473543b89d$var$_selector_opts(opts);
    var inst = this.iterator('table', function(settings) {
        return $44bb6d473543b89d$var$__row_selector(settings, selector, opts);
    }, 1);
    // Want argument shifting here and in __row_selector?
    inst.selector.rows = selector;
    inst.selector.opts = opts;
    return inst;
});
$44bb6d473543b89d$var$_api_register('rows().nodes()', function() {
    return this.iterator('row', function(settings, row) {
        return settings.aoData[row].nTr || undefined;
    }, 1);
});
$44bb6d473543b89d$var$_api_register('rows().data()', function() {
    return this.iterator(true, 'rows', function(settings, rows) {
        return $44bb6d473543b89d$var$_pluck_order(settings.aoData, rows, '_aData');
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('rows().cache()', 'row().cache()', function(type) {
    return this.iterator('row', function(settings, row) {
        var r = settings.aoData[row];
        return type === 'search' ? r._aFilterData : r._aSortData;
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('rows().invalidate()', 'row().invalidate()', function(src) {
    return this.iterator('row', function(settings, row) {
        $44bb6d473543b89d$var$_fnInvalidate(settings, row, src);
    });
});
$44bb6d473543b89d$var$_api_registerPlural('rows().indexes()', 'row().index()', function() {
    return this.iterator('row', function(settings, row) {
        return row;
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('rows().ids()', 'row().id()', function(hash) {
    var a = [];
    var context = this.context;
    // `iterator` will drop undefined values, but in this case we want them
    for(var i = 0, iLen = context.length; i < iLen; i++)for(var j = 0, jen = this[i].length; j < jen; j++){
        var id = context[i].rowIdFn(context[i].aoData[this[i][j]]._aData);
        a.push((hash === true ? '#' : '') + id);
    }
    return new $44bb6d473543b89d$var$_Api(context, a);
});
$44bb6d473543b89d$var$_api_registerPlural('rows().remove()', 'row().remove()', function() {
    this.iterator('row', function(settings, row) {
        var data = settings.aoData;
        var rowData = data[row];
        // Delete from the display arrays
        var idx = settings.aiDisplayMaster.indexOf(row);
        if (idx !== -1) settings.aiDisplayMaster.splice(idx, 1);
        // For server-side processing tables - subtract the deleted row from the count
        if (settings._iRecordsDisplay > 0) settings._iRecordsDisplay--;
        // Check for an 'overflow' they case for displaying the table
        $44bb6d473543b89d$var$_fnLengthOverflow(settings);
        // Remove the row's ID reference if there is one
        var id = settings.rowIdFn(rowData._aData);
        if (id !== undefined) delete settings.aIds[id];
        data[row] = null;
    });
    return this;
});
$44bb6d473543b89d$var$_api_register('rows.add()', function(rows) {
    var newRows = this.iterator('table', function(settings) {
        var row, i, iLen;
        var out = [];
        for(i = 0, iLen = rows.length; i < iLen; i++){
            row = rows[i];
            if (row.nodeName && row.nodeName.toUpperCase() === 'TR') out.push($44bb6d473543b89d$var$_fnAddTr(settings, row)[0]);
            else out.push($44bb6d473543b89d$var$_fnAddData(settings, row));
        }
        return out;
    }, 1);
    // Return an Api.rows() extended instance, so rows().nodes() etc can be used
    var modRows = this.rows(-1);
    modRows.pop();
    $44bb6d473543b89d$var$_fnArrayApply(modRows, newRows);
    return modRows;
});
/**
 *
 */ $44bb6d473543b89d$var$_api_register('row()', function(selector, opts) {
    return $44bb6d473543b89d$var$_selector_first(this.rows(selector, opts));
});
$44bb6d473543b89d$var$_api_register('row().data()', function(data) {
    var ctx = this.context;
    if (data === undefined) // Get
    return ctx.length && this.length && this[0].length ? ctx[0].aoData[this[0]]._aData : undefined;
    // Set
    var row = ctx[0].aoData[this[0]];
    row._aData = data;
    // If the DOM has an id, and the data source is an array
    if (Array.isArray(data) && row.nTr && row.nTr.id) $44bb6d473543b89d$var$_fnSetObjectDataFn(ctx[0].rowId)(data, row.nTr.id);
    // Automatically invalidate
    $44bb6d473543b89d$var$_fnInvalidate(ctx[0], this[0], 'data');
    return this;
});
$44bb6d473543b89d$var$_api_register('row().node()', function() {
    var ctx = this.context;
    if (ctx.length && this.length && this[0].length) {
        var row = ctx[0].aoData[this[0]];
        if (row && row.nTr) return row.nTr;
    }
    return null;
});
$44bb6d473543b89d$var$_api_register('row.add()', function(row) {
    // Allow a jQuery object to be passed in - only a single row is added from
    // it though - the first element in the set
    if (row instanceof $44bb6d473543b89d$var$$ && row.length) row = row[0];
    var rows = this.iterator('table', function(settings) {
        if (row.nodeName && row.nodeName.toUpperCase() === 'TR') return $44bb6d473543b89d$var$_fnAddTr(settings, row)[0];
        return $44bb6d473543b89d$var$_fnAddData(settings, row);
    });
    // Return an Api.rows() extended instance, with the newly added row selected
    return this.row(rows[0]);
});
$44bb6d473543b89d$var$$(document).on('plugin-init.dt', function(e, context) {
    var api = new $44bb6d473543b89d$var$_Api(context);
    api.on('stateSaveParams.DT', function(e, settings, d) {
        // This could be more compact with the API, but it is a lot faster as a simple
        // internal loop
        var idFn = settings.rowIdFn;
        var rows = settings.aiDisplayMaster;
        var ids = [];
        for(var i = 0; i < rows.length; i++){
            var rowIdx = rows[i];
            var data = settings.aoData[rowIdx];
            if (data._detailsShow) ids.push('#' + idFn(data._aData));
        }
        d.childRows = ids;
    });
    // For future state loads (e.g. with StateRestore)
    api.on('stateLoaded.DT', function(e, settings, state) {
        $44bb6d473543b89d$var$__details_state_load(api, state);
    });
    // And the initial load state
    $44bb6d473543b89d$var$__details_state_load(api, api.state.loaded());
});
var $44bb6d473543b89d$var$__details_state_load = function(api, state) {
    if (state && state.childRows) api.rows(state.childRows.map(function(id) {
        // Escape any `:` characters from the row id. Accounts for
        // already escaped characters.
        return id.replace(/([^:\\]*(?:\\.[^:\\]*)*):/g, "$1\\:");
    })).every(function() {
        $44bb6d473543b89d$var$_fnCallbackFire(api.settings()[0], null, 'requestChild', [
            this
        ]);
    });
};
var $44bb6d473543b89d$var$__details_add = function(ctx, row, data, klass) {
    // Convert to array of TR elements
    var rows = [];
    var addRow = function(r, k) {
        // Recursion to allow for arrays of jQuery objects
        if (Array.isArray(r) || r instanceof $44bb6d473543b89d$var$$) {
            for(var i = 0, iLen = r.length; i < iLen; i++)addRow(r[i], k);
            return;
        }
        // If we get a TR element, then just add it directly - up to the dev
        // to add the correct number of columns etc
        if (r.nodeName && r.nodeName.toLowerCase() === 'tr') {
            r.setAttribute('data-dt-row', row.idx);
            rows.push(r);
        } else {
            // Otherwise create a row with a wrapper
            var created = $44bb6d473543b89d$var$$('<tr><td></td></tr>').attr('data-dt-row', row.idx).addClass(k);
            $44bb6d473543b89d$var$$('td', created).addClass(k).html(r)[0].colSpan = $44bb6d473543b89d$var$_fnVisibleColumns(ctx);
            rows.push(created[0]);
        }
    };
    addRow(data, klass);
    if (row._details) row._details.detach();
    row._details = $44bb6d473543b89d$var$$(rows);
    // If the children were already shown, that state should be retained
    if (row._detailsShow) row._details.insertAfter(row.nTr);
};
// Make state saving of child row details async to allow them to be batch processed
var $44bb6d473543b89d$var$__details_state = $44bb6d473543b89d$var$DataTable.util.throttle(function(ctx) {
    $44bb6d473543b89d$var$_fnSaveState(ctx[0]);
}, 500);
var $44bb6d473543b89d$var$__details_remove = function(api, idx) {
    var ctx = api.context;
    if (ctx.length) {
        var row = ctx[0].aoData[idx !== undefined ? idx : api[0]];
        if (row && row._details) {
            row._details.detach();
            row._detailsShow = undefined;
            row._details = undefined;
            $44bb6d473543b89d$var$$(row.nTr).removeClass('dt-hasChild');
            $44bb6d473543b89d$var$__details_state(ctx);
        }
    }
};
var $44bb6d473543b89d$var$__details_display = function(api, show) {
    var ctx = api.context;
    if (ctx.length && api.length) {
        var row = ctx[0].aoData[api[0]];
        if (row._details) {
            row._detailsShow = show;
            if (show) {
                row._details.insertAfter(row.nTr);
                $44bb6d473543b89d$var$$(row.nTr).addClass('dt-hasChild');
            } else {
                row._details.detach();
                $44bb6d473543b89d$var$$(row.nTr).removeClass('dt-hasChild');
            }
            $44bb6d473543b89d$var$_fnCallbackFire(ctx[0], null, 'childRow', [
                show,
                api.row(api[0])
            ]);
            $44bb6d473543b89d$var$__details_events(ctx[0]);
            $44bb6d473543b89d$var$__details_state(ctx);
        }
    }
};
var $44bb6d473543b89d$var$__details_events = function(settings) {
    var api = new $44bb6d473543b89d$var$_Api(settings);
    var namespace = '.dt.DT_details';
    var drawEvent = 'draw' + namespace;
    var colvisEvent = 'column-sizing' + namespace;
    var destroyEvent = 'destroy' + namespace;
    var data = settings.aoData;
    api.off(drawEvent + ' ' + colvisEvent + ' ' + destroyEvent);
    if ($44bb6d473543b89d$var$_pluck(data, '_details').length > 0) {
        // On each draw, insert the required elements into the document
        api.on(drawEvent, function(e, ctx) {
            if (settings !== ctx) return;
            api.rows({
                page: 'current'
            }).eq(0).each(function(idx) {
                // Internal data grab
                var row = data[idx];
                if (row._detailsShow) row._details.insertAfter(row.nTr);
            });
        });
        // Column visibility change - update the colspan
        api.on(colvisEvent, function(e, ctx) {
            if (settings !== ctx) return;
            // Update the colspan for the details rows (note, only if it already has
            // a colspan)
            var row, visible = $44bb6d473543b89d$var$_fnVisibleColumns(ctx);
            for(var i = 0, iLen = data.length; i < iLen; i++){
                row = data[i];
                if (row && row._details) row._details.each(function() {
                    var el = $44bb6d473543b89d$var$$(this).children('td');
                    if (el.length == 1) el.attr('colspan', visible);
                });
            }
        });
        // Table destroyed - nuke any child rows
        api.on(destroyEvent, function(e, ctx) {
            if (settings !== ctx) return;
            for(var i = 0, iLen = data.length; i < iLen; i++)if (data[i] && data[i]._details) $44bb6d473543b89d$var$__details_remove(api, i);
        });
    }
};
// Strings for the method names to help minification
var $44bb6d473543b89d$var$_emp = '';
var $44bb6d473543b89d$var$_child_obj = $44bb6d473543b89d$var$_emp + 'row().child';
var $44bb6d473543b89d$var$_child_mth = $44bb6d473543b89d$var$_child_obj + '()';
// data can be:
//  tr
//  string
//  jQuery or array of any of the above
$44bb6d473543b89d$var$_api_register($44bb6d473543b89d$var$_child_mth, function(data, klass) {
    var ctx = this.context;
    if (data === undefined) // get
    return ctx.length && this.length && ctx[0].aoData[this[0]] ? ctx[0].aoData[this[0]]._details : undefined;
    else if (data === true) // show
    this.child.show();
    else if (data === false) // remove
    $44bb6d473543b89d$var$__details_remove(this);
    else if (ctx.length && this.length) // set
    $44bb6d473543b89d$var$__details_add(ctx[0], ctx[0].aoData[this[0]], data, klass);
    return this;
});
$44bb6d473543b89d$var$_api_register([
    $44bb6d473543b89d$var$_child_obj + '.show()',
    $44bb6d473543b89d$var$_child_mth + '.show()' // only when `child()` was called with parameters (without
], function() {
    $44bb6d473543b89d$var$__details_display(this, true);
    return this;
});
$44bb6d473543b89d$var$_api_register([
    $44bb6d473543b89d$var$_child_obj + '.hide()',
    $44bb6d473543b89d$var$_child_mth + '.hide()' // only when `child()` was called with parameters (without
], function() {
    $44bb6d473543b89d$var$__details_display(this, false);
    return this;
});
$44bb6d473543b89d$var$_api_register([
    $44bb6d473543b89d$var$_child_obj + '.remove()',
    $44bb6d473543b89d$var$_child_mth + '.remove()' // only when `child()` was called with parameters (without
], function() {
    $44bb6d473543b89d$var$__details_remove(this);
    return this;
});
$44bb6d473543b89d$var$_api_register($44bb6d473543b89d$var$_child_obj + '.isShown()', function() {
    var ctx = this.context;
    if (ctx.length && this.length && ctx[0].aoData[this[0]]) // _detailsShown as false or undefined will fall through to return false
    return ctx[0].aoData[this[0]]._detailsShow || false;
    return false;
});
/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
 * Columns
 *
 * {integer}           - column index (>=0 count from left, <0 count from right)
 * "{integer}:visIdx"  - visible column index (i.e. translate to column index)  (>=0 count from left, <0 count from right)
 * "{integer}:visible" - alias for {integer}:visIdx  (>=0 count from left, <0 count from right)
 * "{string}:name"     - column name
 * "{string}"          - jQuery selector on column header nodes
 *
 */ // can be an array of these items, comma separated list, or an array of comma
// separated lists
var $44bb6d473543b89d$var$__re_column_selector = /^([^:]+)?:(name|title|visIdx|visible)$/;
// r1 and r2 are redundant - but it means that the parameters match for the
// iterator callback in columns().data()
var $44bb6d473543b89d$var$__columnData = function(settings, column, r1, r2, rows, type) {
    var a = [];
    for(var row = 0, iLen = rows.length; row < iLen; row++)a.push($44bb6d473543b89d$var$_fnGetCellData(settings, rows[row], column, type));
    return a;
};
var $44bb6d473543b89d$var$__column_header = function(settings, column, row) {
    var header = settings.aoHeader;
    var titleRow = settings.titleRow;
    var target = null;
    if (row !== undefined) target = row;
    else if (titleRow === true) target = 0;
    else if (titleRow === false) target = header.length - 1;
    else if (titleRow !== null) target = titleRow;
    else {
        // Automatic - find the _last_ unique cell from the top that is not empty (last for
        // backwards compatibility)
        for(var i = 0; i < header.length; i++)if (header[i][column].unique && $44bb6d473543b89d$var$$('.dt-column-title', header[i][column].cell).text()) target = i;
        if (target === null) target = 0;
    }
    return header[target][column].cell;
};
var $44bb6d473543b89d$var$__column_header_cells = function(header) {
    var out = [];
    for(var i = 0; i < header.length; i++)for(var j = 0; j < header[i].length; j++){
        var cell = header[i][j].cell;
        if (!out.includes(cell)) out.push(cell);
    }
    return out;
};
var $44bb6d473543b89d$var$__column_selector = function(settings, selector, opts) {
    var columns = settings.aoColumns, names, titles, nodes = $44bb6d473543b89d$var$__column_header_cells(settings.aoHeader);
    var run = function(s) {
        var selInt = $44bb6d473543b89d$var$_intVal(s);
        // Selector - all
        if (s === '') return $44bb6d473543b89d$var$_range(columns.length);
        // Selector - index
        if (selInt !== null) return [
            selInt >= 0 ? selInt : columns.length + selInt // Count from right (+ because its a negative value)
        ];
        // Selector = function
        if (typeof s === 'function') {
            var rows = $44bb6d473543b89d$var$_selector_row_indexes(settings, opts);
            return columns.map(function(col, idx) {
                return s(idx, $44bb6d473543b89d$var$__columnData(settings, idx, 0, 0, rows), $44bb6d473543b89d$var$__column_header(settings, idx)) ? idx : null;
            });
        }
        // jQuery or string selector
        var match = typeof s === 'string' ? s.match($44bb6d473543b89d$var$__re_column_selector) : '';
        if (match) switch(match[2]){
            case 'visIdx':
            case 'visible':
                // Selector is a column index
                if (match[1] && match[1].match(/^\d+$/)) {
                    var idx = parseInt(match[1], 10);
                    // Visible index given, convert to column index
                    if (idx < 0) {
                        // Counting from the right
                        var visColumns = columns.map(function(col, i) {
                            return col.bVisible ? i : null;
                        });
                        return [
                            visColumns[visColumns.length + idx]
                        ];
                    }
                    // Counting from the left
                    return [
                        $44bb6d473543b89d$var$_fnVisibleToColumnIndex(settings, idx)
                    ];
                }
                return columns.map(function(col, idx) {
                    // Not visible, can't match
                    if (!col.bVisible) return null;
                    if (col.responsiveVisible === false) return null;
                    // Selector
                    if (match[1]) return $44bb6d473543b89d$var$$(nodes[idx]).filter(match[1]).length > 0 ? idx : null;
                    // `:visible` on its own
                    return idx;
                });
            case 'name':
                // Don't get names, unless needed, and only get once if it is
                if (!names) names = $44bb6d473543b89d$var$_pluck(columns, 'sName');
                // match by name. `names` is column index complete and in order
                return names.map(function(name, i) {
                    return name === match[1] ? i : null;
                });
            case 'title':
                if (!titles) titles = $44bb6d473543b89d$var$_pluck(columns, 'sTitle');
                // match by column title
                return titles.map(function(title, i) {
                    return title === match[1] ? i : null;
                });
            default:
                return [];
        }
        // Cell in the table body
        if (s.nodeName && s._DT_CellIndex) return [
            s._DT_CellIndex.column
        ];
        // jQuery selector on the TH elements for the columns
        var jqResult = $44bb6d473543b89d$var$$(nodes).filter(s).map(function() {
            return $44bb6d473543b89d$var$_fnColumnsFromHeader(this); // `nodes` is column index complete and in order
        }).toArray().sort(function(a, b) {
            return a - b;
        });
        if (jqResult.length || !s.nodeName) return jqResult;
        // Otherwise a node which might have a `dt-column` data attribute, or be
        // a child or such an element
        var host = $44bb6d473543b89d$var$$(s).closest('*[data-dt-column]');
        return host.length ? [
            host.data('dt-column')
        ] : [];
    };
    var selected = $44bb6d473543b89d$var$_selector_run('column', selector, run, settings, opts);
    return opts.columnOrder && opts.columnOrder === 'index' ? selected.sort(function(a, b) {
        return a - b;
    }) : selected; // implied
};
var $44bb6d473543b89d$var$__setColumnVis = function(settings, column, vis) {
    var cols = settings.aoColumns, col = cols[column], data = settings.aoData, cells, i, iLen, tr;
    // Get
    if (vis === undefined) return col.bVisible;
    // Set
    // No change
    if (col.bVisible === vis) return false;
    if (vis) {
        // Insert column
        // Need to decide if we should use appendChild or insertBefore
        var insertBefore = $44bb6d473543b89d$var$_pluck(cols, 'bVisible').indexOf(true, column + 1);
        for(i = 0, iLen = data.length; i < iLen; i++)if (data[i]) {
            tr = data[i].nTr;
            cells = data[i].anCells;
            if (tr) // insertBefore can act like appendChild if 2nd arg is null
            tr.insertBefore(cells[column], cells[insertBefore] || null);
        }
    } else // Remove column
    $44bb6d473543b89d$var$$($44bb6d473543b89d$var$_pluck(settings.aoData, 'anCells', column)).detach();
    // Common actions
    col.bVisible = vis;
    $44bb6d473543b89d$var$_colGroup(settings);
    return true;
};
$44bb6d473543b89d$var$_api_register('columns()', function(selector, opts) {
    // argument shifting
    if (selector === undefined) selector = '';
    else if ($44bb6d473543b89d$var$$.isPlainObject(selector)) {
        opts = selector;
        selector = '';
    }
    opts = $44bb6d473543b89d$var$_selector_opts(opts);
    var inst = this.iterator('table', function(settings) {
        return $44bb6d473543b89d$var$__column_selector(settings, selector, opts);
    }, 1);
    // Want argument shifting here and in _row_selector?
    inst.selector.cols = selector;
    inst.selector.opts = opts;
    return inst;
});
$44bb6d473543b89d$var$_api_registerPlural('columns().header()', 'column().header()', function(row) {
    return this.iterator('column', function(settings, column) {
        return $44bb6d473543b89d$var$__column_header(settings, column, row);
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().footer()', 'column().footer()', function(row) {
    return this.iterator('column', function(settings, column) {
        var footer = settings.aoFooter;
        if (!footer.length) return null;
        return settings.aoFooter[row !== undefined ? row : 0][column].cell;
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().data()', 'column().data()', function() {
    return this.iterator('column-rows', $44bb6d473543b89d$var$__columnData, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().render()', 'column().render()', function(type) {
    return this.iterator('column-rows', function(settings, column, i, j, rows) {
        return $44bb6d473543b89d$var$__columnData(settings, column, i, j, rows, type);
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().dataSrc()', 'column().dataSrc()', function() {
    return this.iterator('column', function(settings, column) {
        return settings.aoColumns[column].mData;
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().cache()', 'column().cache()', function(type) {
    return this.iterator('column-rows', function(settings, column, i, j, rows) {
        return $44bb6d473543b89d$var$_pluck_order(settings.aoData, rows, type === 'search' ? '_aFilterData' : '_aSortData', column);
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().init()', 'column().init()', function() {
    return this.iterator('column', function(settings, column) {
        return settings.aoColumns[column];
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().names()', 'column().name()', function() {
    return this.iterator('column', function(settings, column) {
        return settings.aoColumns[column].sName;
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().nodes()', 'column().nodes()', function() {
    return this.iterator('column-rows', function(settings, column, i, j, rows) {
        return $44bb6d473543b89d$var$_pluck_order(settings.aoData, rows, 'anCells', column);
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().titles()', 'column().title()', function(title, row) {
    return this.iterator('column', function(settings, column) {
        // Argument shifting
        if (typeof title === 'number') {
            row = title;
            title = undefined;
        }
        var span = $44bb6d473543b89d$var$$('.dt-column-title', this.column(column).header(row));
        if (title !== undefined) {
            span.html(title);
            return this;
        }
        return span.html();
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().types()', 'column().type()', function() {
    return this.iterator('column', function(settings, column) {
        var colObj = settings.aoColumns[column];
        var type = colObj.sType;
        // If the type was invalidated, then resolve it. This actually does
        // all columns at the moment. Would only happen once if getting all
        // column's data types.
        if (!type) {
            $44bb6d473543b89d$var$_fnColumnTypes(settings);
            type = colObj.sType;
        }
        return type;
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().visible()', 'column().visible()', function(vis, calc) {
    var that = this;
    var changed = [];
    var ret = this.iterator('column', function(settings, column) {
        if (vis === undefined) return settings.aoColumns[column].bVisible;
         // else
        if ($44bb6d473543b89d$var$__setColumnVis(settings, column, vis)) changed.push(column);
    });
    // Group the column visibility changes
    if (vis !== undefined) this.iterator('table', function(settings) {
        // Redraw the header after changes
        $44bb6d473543b89d$var$_fnDrawHead(settings, settings.aoHeader);
        $44bb6d473543b89d$var$_fnDrawHead(settings, settings.aoFooter);
        // Update colspan for no records display. Child rows and extensions will use their own
        // listeners to do this - only need to update the empty table item here
        if (!settings.aiDisplay.length) $44bb6d473543b89d$var$$(settings.nTBody).find('td[colspan]').attr('colspan', $44bb6d473543b89d$var$_fnVisibleColumns(settings));
        $44bb6d473543b89d$var$_fnSaveState(settings);
        // Second loop once the first is done for events
        that.iterator('column', function(settings, column) {
            if (changed.includes(column)) $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'column-visibility', [
                settings,
                column,
                vis,
                calc
            ]);
        });
        if (changed.length && (calc === undefined || calc)) that.columns.adjust();
    });
    return ret;
});
$44bb6d473543b89d$var$_api_registerPlural('columns().widths()', 'column().width()', function() {
    // Injects a fake row into the table for just a moment so the widths can
    // be read, regardless of colspan in the header and rows being present in
    // the body
    var columns = this.columns(':visible').count();
    var row = $44bb6d473543b89d$var$$('<tr>').html('<td>' + Array(columns).join('</td><td>') + '</td>');
    $44bb6d473543b89d$var$$(this.table().body()).append(row);
    var widths = row.children().map(function() {
        return $44bb6d473543b89d$var$$(this).outerWidth();
    });
    row.remove();
    return this.iterator('column', function(settings, column) {
        var visIdx = $44bb6d473543b89d$var$_fnColumnIndexToVisible(settings, column);
        return visIdx !== null ? widths[visIdx] : 0;
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('columns().indexes()', 'column().index()', function(type) {
    return this.iterator('column', function(settings, column) {
        return type === 'visible' ? $44bb6d473543b89d$var$_fnColumnIndexToVisible(settings, column) : column;
    }, 1);
});
$44bb6d473543b89d$var$_api_register('columns.adjust()', function() {
    return this.iterator('table', function(settings) {
        // Force a column sizing to happen with a manual call - otherwise it can skip
        // if the size hasn't changed
        settings.containerWidth = -1;
        $44bb6d473543b89d$var$_fnAdjustColumnSizing(settings);
    }, 1);
});
$44bb6d473543b89d$var$_api_register('column.index()', function(type, idx) {
    if (this.context.length !== 0) {
        var ctx = this.context[0];
        if (type === 'fromVisible' || type === 'toData') return $44bb6d473543b89d$var$_fnVisibleToColumnIndex(ctx, idx);
        else if (type === 'fromData' || type === 'toVisible') return $44bb6d473543b89d$var$_fnColumnIndexToVisible(ctx, idx);
    }
});
$44bb6d473543b89d$var$_api_register('column()', function(selector, opts) {
    return $44bb6d473543b89d$var$_selector_first(this.columns(selector, opts));
});
var $44bb6d473543b89d$var$__cell_selector = function(settings, selector, opts) {
    var data = settings.aoData;
    var rows = $44bb6d473543b89d$var$_selector_row_indexes(settings, opts);
    var cells = $44bb6d473543b89d$var$_removeEmpty($44bb6d473543b89d$var$_pluck_order(data, rows, 'anCells'));
    var allCells = $44bb6d473543b89d$var$$($44bb6d473543b89d$var$_flatten([], cells));
    var row;
    var columns = settings.aoColumns.length;
    var a, i, iLen, j, o, host;
    var run = function(s) {
        var fnSelector = typeof s === 'function';
        if (s === null || s === undefined || fnSelector) {
            // All cells and function selectors
            a = [];
            for(i = 0, iLen = rows.length; i < iLen; i++){
                row = rows[i];
                for(j = 0; j < columns; j++){
                    o = {
                        row: row,
                        column: j
                    };
                    if (fnSelector) {
                        // Selector - function
                        host = data[row];
                        if (s(o, $44bb6d473543b89d$var$_fnGetCellData(settings, row, j), host.anCells ? host.anCells[j] : null)) a.push(o);
                    } else // Selector - all
                    a.push(o);
                }
            }
            return a;
        }
        // Selector - index
        if ($44bb6d473543b89d$var$$.isPlainObject(s)) // Valid cell index and its in the array of selectable rows
        return s.column !== undefined && s.row !== undefined && rows.indexOf(s.row) !== -1 ? [
            s
        ] : [];
        // Selector - jQuery filtered cells
        var jqResult = allCells.filter(s).map(function(i, el) {
            return {
                row: el._DT_CellIndex.row,
                column: el._DT_CellIndex.column
            };
        }).toArray();
        if (jqResult.length || !s.nodeName) return jqResult;
        // Otherwise the selector is a node, and there is one last option - the
        // element might be a child of an element which has dt-row and dt-column
        // data attributes
        host = $44bb6d473543b89d$var$$(s).closest('*[data-dt-row]');
        return host.length ? [
            {
                row: host.data('dt-row'),
                column: host.data('dt-column')
            }
        ] : [];
    };
    return $44bb6d473543b89d$var$_selector_run('cell', selector, run, settings, opts);
};
$44bb6d473543b89d$var$_api_register('cells()', function(rowSelector, columnSelector, opts) {
    // Argument shifting
    if ($44bb6d473543b89d$var$$.isPlainObject(rowSelector)) {
        // Indexes
        if (rowSelector.row === undefined) {
            // Selector options in first parameter
            opts = rowSelector;
            rowSelector = null;
        } else {
            // Cell index objects in first parameter
            opts = columnSelector;
            columnSelector = null;
        }
    }
    if ($44bb6d473543b89d$var$$.isPlainObject(columnSelector)) {
        opts = columnSelector;
        columnSelector = null;
    }
    // Cell selector
    if (columnSelector === null || columnSelector === undefined) return this.iterator('table', function(settings) {
        return $44bb6d473543b89d$var$__cell_selector(settings, rowSelector, $44bb6d473543b89d$var$_selector_opts(opts));
    });
    // The default built in options need to apply to row and columns
    var internalOpts = opts ? {
        page: opts.page,
        order: opts.order,
        search: opts.search
    } : {};
    // Row + column selector
    var columns = this.columns(columnSelector, internalOpts);
    var rows = this.rows(rowSelector, internalOpts);
    var i, iLen, j, jen;
    var cellsNoOpts = this.iterator('table', function(settings, idx) {
        var a = [];
        for(i = 0, iLen = rows[idx].length; i < iLen; i++)for(j = 0, jen = columns[idx].length; j < jen; j++)a.push({
            row: rows[idx][i],
            column: columns[idx][j]
        });
        return a;
    }, 1);
    // There is currently only one extension which uses a cell selector extension
    // It is a _major_ performance drag to run this if it isn't needed, so this is
    // an extension specific check at the moment
    var cells = opts && opts.selected ? this.cells(cellsNoOpts, opts) : cellsNoOpts;
    $44bb6d473543b89d$var$$.extend(cells.selector, {
        cols: columnSelector,
        rows: rowSelector,
        opts: opts
    });
    return cells;
});
$44bb6d473543b89d$var$_api_registerPlural('cells().nodes()', 'cell().node()', function() {
    return this.iterator('cell', function(settings, row, column) {
        var data = settings.aoData[row];
        return data && data.anCells ? data.anCells[column] : undefined;
    }, 1);
});
$44bb6d473543b89d$var$_api_register('cells().data()', function() {
    return this.iterator('cell', function(settings, row, column) {
        return $44bb6d473543b89d$var$_fnGetCellData(settings, row, column);
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('cells().cache()', 'cell().cache()', function(type) {
    type = type === 'search' ? '_aFilterData' : '_aSortData';
    return this.iterator('cell', function(settings, row, column) {
        return settings.aoData[row][type][column];
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('cells().render()', 'cell().render()', function(type) {
    return this.iterator('cell', function(settings, row, column) {
        return $44bb6d473543b89d$var$_fnGetCellData(settings, row, column, type);
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('cells().indexes()', 'cell().index()', function() {
    return this.iterator('cell', function(settings, row, column) {
        return {
            row: row,
            column: column,
            columnVisible: $44bb6d473543b89d$var$_fnColumnIndexToVisible(settings, column)
        };
    }, 1);
});
$44bb6d473543b89d$var$_api_registerPlural('cells().invalidate()', 'cell().invalidate()', function(src) {
    return this.iterator('cell', function(settings, row, column) {
        $44bb6d473543b89d$var$_fnInvalidate(settings, row, src, column);
    });
});
$44bb6d473543b89d$var$_api_register('cell()', function(rowSelector, columnSelector, opts) {
    return $44bb6d473543b89d$var$_selector_first(this.cells(rowSelector, columnSelector, opts));
});
$44bb6d473543b89d$var$_api_register('cell().data()', function(data) {
    var ctx = this.context;
    var cell = this[0];
    if (data === undefined) // Get
    return ctx.length && cell.length ? $44bb6d473543b89d$var$_fnGetCellData(ctx[0], cell[0].row, cell[0].column) : undefined;
    // Set
    $44bb6d473543b89d$var$_fnSetCellData(ctx[0], cell[0].row, cell[0].column, data);
    $44bb6d473543b89d$var$_fnInvalidate(ctx[0], cell[0].row, 'data', cell[0].column);
    return this;
});
/**
 * Get current ordering (sorting) that has been applied to the table.
 *
 * @returns {array} 2D array containing the sorting information for the first
 *   table in the current context. Each element in the parent array represents
 *   a column being sorted upon (i.e. multi-sorting with two columns would have
 *   2 inner arrays). The inner arrays may have 2 or 3 elements. The first is
 *   the column index that the sorting condition applies to, the second is the
 *   direction of the sort (`desc` or `asc`) and, optionally, the third is the
 *   index of the sorting order from the `column.sorting` initialisation array.
 */ /**
 * Set the ordering for the table.
 *
 * @param {integer} order Column index to sort upon.
 * @param {string} direction Direction of the sort to be applied (`asc` or `desc`)
 * @returns {DataTables.Api} this
 */ /**
 * Set the ordering for the table.
 *
 * @param {array} order 1D array of sorting information to be applied.
 * @param {array} [...] Optional additional sorting conditions
 * @returns {DataTables.Api} this
 */ /**
 * Set the ordering for the table.
 *
 * @param {array} order 2D array of sorting information to be applied.
 * @returns {DataTables.Api} this
 */ $44bb6d473543b89d$var$_api_register('order()', function(order, dir) {
    var ctx = this.context;
    var args = Array.prototype.slice.call(arguments);
    if (order === undefined) // get
    return ctx.length !== 0 ? ctx[0].aaSorting : undefined;
    // set
    if (typeof order === 'number') // Simple column / direction passed in
    order = [
        [
            order,
            dir
        ]
    ];
    else if (args.length > 1) // Arguments passed in (list of 1D arrays)
    order = args;
    // otherwise a 2D array was passed in
    return this.iterator('table', function(settings) {
        var resolved = [];
        $44bb6d473543b89d$var$_fnSortResolve(settings, resolved, order);
        settings.aaSorting = resolved;
    });
});
/**
 * Attach a sort listener to an element for a given column
 *
 * @param {node|jQuery|string} node Identifier for the element(s) to attach the
 *   listener to. This can take the form of a single DOM node, a jQuery
 *   collection of nodes or a jQuery selector which will identify the node(s).
 * @param {integer} column the column that a click on this node will sort on
 * @param {function} [callback] callback function when sort is run
 * @returns {DataTables.Api} this
 */ $44bb6d473543b89d$var$_api_register('order.listener()', function(node, column, callback) {
    return this.iterator('table', function(settings) {
        $44bb6d473543b89d$var$_fnSortAttachListener(settings, node, {}, column, callback);
    });
});
$44bb6d473543b89d$var$_api_register('order.fixed()', function(set) {
    if (!set) {
        var ctx = this.context;
        var fixed = ctx.length ? ctx[0].aaSortingFixed : undefined;
        return Array.isArray(fixed) ? {
            pre: fixed
        } : fixed;
    }
    return this.iterator('table', function(settings) {
        settings.aaSortingFixed = $44bb6d473543b89d$var$$.extend(true, {}, set);
    });
});
// Order by the selected column(s)
$44bb6d473543b89d$var$_api_register([
    'columns().order()',
    'column().order()'
], function(dir) {
    var that = this;
    if (!dir) return this.iterator('column', function(settings, idx) {
        var sort = $44bb6d473543b89d$var$_fnSortFlatten(settings);
        for(var i = 0, iLen = sort.length; i < iLen; i++){
            if (sort[i].col === idx) return sort[i].dir;
        }
        return null;
    }, 1);
    else return this.iterator('table', function(settings, i) {
        settings.aaSorting = that[i].map(function(col) {
            return [
                col,
                dir
            ];
        });
    });
});
$44bb6d473543b89d$var$_api_registerPlural('columns().orderable()', 'column().orderable()', function(directions) {
    return this.iterator('column', function(settings, idx) {
        var col = settings.aoColumns[idx];
        return directions ? col.asSorting : col.bSortable;
    }, 1);
});
$44bb6d473543b89d$var$_api_register('processing()', function(show) {
    return this.iterator('table', function(ctx) {
        $44bb6d473543b89d$var$_fnProcessingDisplay(ctx, show);
    });
});
$44bb6d473543b89d$var$_api_register('search()', function(input, regex, smart, caseInsen) {
    var ctx = this.context;
    if (input === undefined) // get
    return ctx.length !== 0 ? ctx[0].oPreviousSearch.search : undefined;
    // set
    return this.iterator('table', function(settings) {
        if (!settings.oFeatures.bFilter) return;
        if (typeof regex === 'object') // New style options to pass to the search builder
        $44bb6d473543b89d$var$_fnFilterComplete(settings, $44bb6d473543b89d$var$$.extend(settings.oPreviousSearch, regex, {
            search: input
        }));
        else // Compat for the old options
        $44bb6d473543b89d$var$_fnFilterComplete(settings, $44bb6d473543b89d$var$$.extend(settings.oPreviousSearch, {
            search: input,
            regex: regex === null ? false : regex,
            smart: smart === null ? true : smart,
            caseInsensitive: caseInsen === null ? true : caseInsen
        }));
    });
});
$44bb6d473543b89d$var$_api_register('search.fixed()', function(name, search) {
    var ret = this.iterator(true, 'table', function(settings) {
        var fixed = settings.searchFixed;
        if (!name) return Object.keys(fixed);
        else if (search === undefined) return fixed[name];
        else if (search === null) delete fixed[name];
        else fixed[name] = search;
        return this;
    });
    return name !== undefined && search === undefined ? ret[0] : ret;
});
$44bb6d473543b89d$var$_api_registerPlural('columns().search()', 'column().search()', function(input, regex, smart, caseInsen) {
    return this.iterator('column', function(settings, column) {
        var preSearch = settings.aoPreSearchCols;
        if (input === undefined) // get
        return preSearch[column].search;
        // set
        if (!settings.oFeatures.bFilter) return;
        if (typeof regex === 'object') // New style options to pass to the search builder
        $44bb6d473543b89d$var$$.extend(preSearch[column], regex, {
            search: input
        });
        else // Old style (with not all options available)
        $44bb6d473543b89d$var$$.extend(preSearch[column], {
            search: input,
            regex: regex === null ? false : regex,
            smart: smart === null ? true : smart,
            caseInsensitive: caseInsen === null ? true : caseInsen
        });
        $44bb6d473543b89d$var$_fnFilterComplete(settings, settings.oPreviousSearch);
    });
});
$44bb6d473543b89d$var$_api_register([
    'columns().search.fixed()',
    'column().search.fixed()'
], function(name, search) {
    var ret = this.iterator(true, 'column', function(settings, colIdx) {
        var fixed = settings.aoColumns[colIdx].searchFixed;
        if (!name) return Object.keys(fixed);
        else if (search === undefined) return fixed[name] || null;
        else if (search === null) delete fixed[name];
        else fixed[name] = search;
        return this;
    });
    return name !== undefined && search === undefined ? ret[0] : ret;
});
/*
 * State API methods
 */ $44bb6d473543b89d$var$_api_register('state()', function(set, ignoreTime) {
    // getter
    if (!set) return this.context.length ? this.context[0].oSavedState : null;
    var setMutate = $44bb6d473543b89d$var$$.extend(true, {}, set);
    // setter
    return this.iterator('table', function(settings) {
        if (ignoreTime !== false) setMutate.time = +new Date() + 100;
        $44bb6d473543b89d$var$_fnImplementState(settings, setMutate, function() {});
    });
});
$44bb6d473543b89d$var$_api_register('state.clear()', function() {
    return this.iterator('table', function(settings) {
        // Save an empty object
        settings.fnStateSaveCallback.call(settings.oInstance, settings, {});
    });
});
$44bb6d473543b89d$var$_api_register('state.loaded()', function() {
    return this.context.length ? this.context[0].oLoadedState : null;
});
$44bb6d473543b89d$var$_api_register('state.save()', function() {
    return this.iterator('table', function(settings) {
        $44bb6d473543b89d$var$_fnSaveState(settings);
    });
});
// Can be assigned in DateTable.use() - note luxon and moment vars are in helpers.js
var $44bb6d473543b89d$var$__bootstrap;
var $44bb6d473543b89d$var$__foundation;
/**
 * Set the libraries that DataTables uses, or the global objects.
 * Note that the arguments can be either way around (legacy support)
 * and the second is optional. See docs.
 */ $44bb6d473543b89d$var$DataTable.use = function(arg1, arg2) {
    // Reverse arguments for legacy support
    var module = typeof arg1 === 'string' ? arg2 : arg1;
    var type = typeof arg2 === 'string' ? arg2 : arg1;
    // Getter
    if (module === undefined && typeof type === 'string') switch(type){
        case 'lib':
        case 'jq':
            return $44bb6d473543b89d$var$$;
        case 'win':
            return window;
        case 'datetime':
            return $44bb6d473543b89d$var$DataTable.DateTime;
        case 'luxon':
            return $44bb6d473543b89d$var$__luxon;
        case 'moment':
            return $44bb6d473543b89d$var$__moment;
        case 'bootstrap':
            // Use local if set, otherwise try window, which could be undefined
            return $44bb6d473543b89d$var$__bootstrap || window.bootstrap;
        case 'foundation':
            // Ditto
            return $44bb6d473543b89d$var$__foundation || window.Foundation;
        default:
            return null;
    }
    // Setter
    if (type === 'lib' || type === 'jq' || module && module.fn && module.fn.jquery) $44bb6d473543b89d$var$$ = module;
    else if (type === 'win' || module && module.document) {
        window = module;
        document = module.document;
    } else if (type === 'datetime' || module && module.type === 'DateTime') $44bb6d473543b89d$var$DataTable.DateTime = module;
    else if (type === 'luxon' || module && module.FixedOffsetZone) $44bb6d473543b89d$var$__luxon = module;
    else if (type === 'moment' || module && module.isMoment) $44bb6d473543b89d$var$__moment = module;
    else if (type === 'bootstrap' || module && module.Modal && module.Modal.NAME === 'modal') // This is currently for BS5 only. BS3/4 attach to jQuery, so no need to use `.use()`
    $44bb6d473543b89d$var$__bootstrap = module;
    else if (type === 'foundation' || module && module.Reveal) $44bb6d473543b89d$var$__foundation = module;
};
/**
 * CommonJS factory function pass through. This will check if the arguments
 * given are a window object or a jQuery object. If so they are set
 * accordingly.
 * @param {*} root Window
 * @param {*} jq jQUery
 * @returns {boolean} Indicator
 */ $44bb6d473543b89d$var$DataTable.factory = function(root, jq) {
    var is = false;
    // Test if the first parameter is a window object
    if (root && root.document) {
        window = root;
        document = root.document;
    }
    // Test if the second parameter is a jQuery object
    if (jq && jq.fn && jq.fn.jquery) {
        $44bb6d473543b89d$var$$ = jq;
        is = true;
    }
    return is;
};
/**
 * Provide a common method for plug-ins to check the version of DataTables being
 * used, in order to ensure compatibility.
 *
 *  @param {string} version Version string to check for, in the format "X.Y.Z".
 *    Note that the formats "X" and "X.Y" are also acceptable.
 *  @param {string} [version2=current DataTables version] As above, but optional.
 *   If not given the current DataTables version will be used.
 *  @returns {boolean} true if this version of DataTables is greater or equal to
 *    the required version, or false if this version of DataTales is not
 *    suitable
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    alert( $.fn.dataTable.versionCheck( '1.9.0' ) );
 */ $44bb6d473543b89d$var$DataTable.versionCheck = function(version, version2) {
    var aThis = version2 ? version2.split('.') : $44bb6d473543b89d$var$DataTable.version.split('.');
    var aThat = version.split('.');
    var iThis, iThat;
    for(var i = 0, iLen = aThat.length; i < iLen; i++){
        iThis = parseInt(aThis[i], 10) || 0;
        iThat = parseInt(aThat[i], 10) || 0;
        // Parts are the same, keep comparing
        if (iThis === iThat) continue;
        // Parts are different, return immediately
        return iThis > iThat;
    }
    return true;
};
/**
 * Check if a `<table>` node is a DataTable table already or not.
 *
 *  @param {node|jquery|string} table Table node, jQuery object or jQuery
 *      selector for the table to test. Note that if more than more than one
 *      table is passed on, only the first will be checked
 *  @returns {boolean} true the table given is a DataTable, or false otherwise
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    if ( ! $.fn.DataTable.isDataTable( '#example' ) ) {
 *      $('#example').dataTable();
 *    }
 */ $44bb6d473543b89d$var$DataTable.isDataTable = function(table) {
    var t = $44bb6d473543b89d$var$$(table).get(0);
    var is = false;
    if (table instanceof $44bb6d473543b89d$var$DataTable.Api) return true;
    $44bb6d473543b89d$var$$.each($44bb6d473543b89d$var$DataTable.settings, function(i, o) {
        var head = o.nScrollHead ? $44bb6d473543b89d$var$$('table', o.nScrollHead)[0] : null;
        var foot = o.nScrollFoot ? $44bb6d473543b89d$var$$('table', o.nScrollFoot)[0] : null;
        if (o.nTable === t || head === t || foot === t) is = true;
    });
    return is;
};
/**
 * Get all DataTable tables that have been initialised - optionally you can
 * select to get only currently visible tables.
 *
 *  @param {boolean} [visible=false] Flag to indicate if you want all (default)
 *    or visible tables only.
 *  @returns {array} Array of `table` nodes (not DataTable instances) which are
 *    DataTables
 *  @static
 *  @dtopt API-Static
 *
 *  @example
 *    $.each( $.fn.dataTable.tables(true), function () {
 *      $(table).DataTable().columns.adjust();
 *    } );
 */ $44bb6d473543b89d$var$DataTable.tables = function(visible) {
    var api = false;
    if ($44bb6d473543b89d$var$$.isPlainObject(visible)) {
        api = visible.api;
        visible = visible.visible;
    }
    var a = $44bb6d473543b89d$var$DataTable.settings.filter(function(o) {
        return !visible || visible && $44bb6d473543b89d$var$$(o.nTable).is(':visible') ? true : false;
    }).map(function(o) {
        return o.nTable;
    });
    return api ? new $44bb6d473543b89d$var$_Api(a) : a;
};
/**
 * Convert from camel case parameters to Hungarian notation. This is made public
 * for the extensions to provide the same ability as DataTables core to accept
 * either the 1.9 style Hungarian notation, or the 1.10+ style camelCase
 * parameters.
 *
 *  @param {object} src The model object which holds all parameters that can be
 *    mapped.
 *  @param {object} user The object to convert from camel case to Hungarian.
 *  @param {boolean} force When set to `true`, properties which already have a
 *    Hungarian value in the `user` object will be overwritten. Otherwise they
 *    won't be.
 */ $44bb6d473543b89d$var$DataTable.camelToHungarian = $44bb6d473543b89d$var$_fnCamelToHungarian;
/**
 *
 */ $44bb6d473543b89d$var$_api_register('$()', function(selector, opts) {
    var rows = this.rows(opts).nodes(), jqRows = $44bb6d473543b89d$var$$(rows);
    return $44bb6d473543b89d$var$$([].concat(jqRows.filter(selector).toArray(), jqRows.find(selector).toArray()));
});
// jQuery functions to operate on the tables
$44bb6d473543b89d$var$$.each([
    'on',
    'one',
    'off'
], function(i, key) {
    $44bb6d473543b89d$var$_api_register(key + '()', function() {
        var args = Array.prototype.slice.call(arguments);
        // Add the `dt` namespace automatically if it isn't already present
        args[0] = args[0].split(/\s/).map(function(e) {
            return !e.match(/\.dt\b/) ? e + '.dt' : e;
        }).join(' ');
        var inst = $44bb6d473543b89d$var$$(this.tables().nodes());
        inst[key].apply(inst, args);
        return this;
    });
});
$44bb6d473543b89d$var$_api_register('clear()', function() {
    return this.iterator('table', function(settings) {
        $44bb6d473543b89d$var$_fnClearTable(settings);
    });
});
$44bb6d473543b89d$var$_api_register('error()', function(msg) {
    return this.iterator('table', function(settings) {
        $44bb6d473543b89d$var$_fnLog(settings, 0, msg);
    });
});
$44bb6d473543b89d$var$_api_register('settings()', function() {
    return new $44bb6d473543b89d$var$_Api(this.context, this.context);
});
$44bb6d473543b89d$var$_api_register('init()', function() {
    var ctx = this.context;
    return ctx.length ? ctx[0].oInit : null;
});
$44bb6d473543b89d$var$_api_register('data()', function() {
    return this.iterator('table', function(settings) {
        return $44bb6d473543b89d$var$_pluck(settings.aoData, '_aData');
    }).flatten();
});
$44bb6d473543b89d$var$_api_register('trigger()', function(name, args, bubbles) {
    return this.iterator('table', function(settings) {
        return $44bb6d473543b89d$var$_fnCallbackFire(settings, null, name, args, bubbles);
    }).flatten();
});
$44bb6d473543b89d$var$_api_register('ready()', function(fn) {
    var ctx = this.context;
    // Get status of first table
    if (!fn) return ctx.length ? ctx[0]._bInitComplete || false : null;
    // Function to run either once the table becomes ready or
    // immediately if it is already ready.
    return this.tables().every(function() {
        var api = this;
        if (this.context[0]._bInitComplete) fn.call(api);
        else this.on('init.dt.DT', function() {
            fn.call(api);
        });
    });
});
$44bb6d473543b89d$var$_api_register('destroy()', function(remove) {
    remove = remove || false;
    return this.iterator('table', function(settings) {
        var classes = settings.oClasses;
        var table = settings.nTable;
        var tbody = settings.nTBody;
        var thead = settings.nTHead;
        var tfoot = settings.nTFoot;
        var jqTable = $44bb6d473543b89d$var$$(table);
        var jqTbody = $44bb6d473543b89d$var$$(tbody);
        var jqWrapper = $44bb6d473543b89d$var$$(settings.nTableWrapper);
        var rows = settings.aoData.map(function(r) {
            return r ? r.nTr : null;
        });
        var orderClasses = classes.order;
        // Flag to note that the table is currently being destroyed - no action
        // should be taken
        settings.bDestroying = true;
        // Fire off the destroy callbacks for plug-ins etc
        $44bb6d473543b89d$var$_fnCallbackFire(settings, "aoDestroyCallback", "destroy", [
            settings
        ], true);
        // If not being removed from the document, make all columns visible
        if (!remove) new $44bb6d473543b89d$var$_Api(settings).columns().visible(true);
        // Container width change listener
        if (settings.resizeObserver) settings.resizeObserver.disconnect();
        // Blitz all `DT` namespaced events (these are internal events, the
        // lowercase, `dt` events are user subscribed and they are responsible
        // for removing them
        jqWrapper.off('.DT').find(':not(tbody *)').off('.DT');
        $44bb6d473543b89d$var$$(window).off('.DT-' + settings.sInstance);
        // When scrolling we had to break the table up - restore it
        if (table != thead.parentNode) {
            jqTable.children('thead').detach();
            jqTable.append(thead);
        }
        if (tfoot && table != tfoot.parentNode) {
            jqTable.children('tfoot').detach();
            jqTable.append(tfoot);
        }
        // Clean up the header / footer
        $44bb6d473543b89d$var$cleanHeader(thead, 'header');
        $44bb6d473543b89d$var$cleanHeader(tfoot, 'footer');
        settings.colgroup.remove();
        settings.aaSorting = [];
        settings.aaSortingFixed = [];
        $44bb6d473543b89d$var$_fnSortingClasses(settings);
        $44bb6d473543b89d$var$$(jqTable).find('th, td').removeClass($44bb6d473543b89d$var$$.map($44bb6d473543b89d$var$DataTable.ext.type.className, function(v) {
            return v;
        }).join(' '));
        $44bb6d473543b89d$var$$('th, td', thead).removeClass(orderClasses.none + ' ' + orderClasses.canAsc + ' ' + orderClasses.canDesc + ' ' + orderClasses.isAsc + ' ' + orderClasses.isDesc).css('width', '').removeAttr('aria-sort');
        // Add the TR elements back into the table in their original order
        jqTbody.children().detach();
        jqTbody.append(rows);
        var orig = settings.nTableWrapper.parentNode;
        var insertBefore = settings.nTableWrapper.nextSibling;
        // Remove the DataTables generated nodes, events and classes
        var removedMethod = remove ? 'remove' : 'detach';
        jqTable[removedMethod]();
        jqWrapper[removedMethod]();
        // If we need to reattach the table to the document
        if (!remove && orig) {
            // insertBefore acts like appendChild if !arg[1]
            orig.insertBefore(table, insertBefore);
            // Restore the width of the original table - was read from the style property,
            // so we can restore directly to that
            jqTable.css('width', settings.sDestroyWidth).removeClass(classes.table);
        }
        /* Remove the settings object from the settings array */ var idx = $44bb6d473543b89d$var$DataTable.settings.indexOf(settings);
        if (idx !== -1) $44bb6d473543b89d$var$DataTable.settings.splice(idx, 1);
    });
});
// Add the `every()` method for rows, columns and cells in a compact form
$44bb6d473543b89d$var$$.each([
    'column',
    'row',
    'cell'
], function(i, type) {
    $44bb6d473543b89d$var$_api_register(type + 's().every()', function(fn) {
        var opts = this.selector.opts;
        var api = this;
        var inst;
        var counter = 0;
        return this.iterator('every', function(settings, selectedIdx, tableIdx) {
            inst = api[type](selectedIdx, opts);
            if (type === 'cell') fn.call(inst, inst[0][0].row, inst[0][0].column, tableIdx, counter);
            else fn.call(inst, selectedIdx, tableIdx, counter);
            counter++;
        });
    });
});
// i18n method for extensions to be able to use the language object from the
// DataTable
$44bb6d473543b89d$var$_api_register('i18n()', function(token, def, plural) {
    var ctx = this.context[0];
    var resolved = $44bb6d473543b89d$var$_fnGetObjectDataFn(token)(ctx.oLanguage);
    if (resolved === undefined) resolved = def;
    if ($44bb6d473543b89d$var$$.isPlainObject(resolved)) resolved = plural !== undefined && resolved[plural] !== undefined ? resolved[plural] : plural === false ? resolved : resolved._;
    return typeof resolved === 'string' ? resolved.replace('%d', plural) // nb: plural might be undefined,
     : resolved;
});
// Needed for header and footer, so pulled into its own function
function $44bb6d473543b89d$var$cleanHeader(node, className) {
    $44bb6d473543b89d$var$$(node).find('.dt-column-order').remove();
    $44bb6d473543b89d$var$$(node).find('.dt-column-title').each(function() {
        var title = $44bb6d473543b89d$var$$(this).html();
        $44bb6d473543b89d$var$$(this).parent().parent().append(title);
        $44bb6d473543b89d$var$$(this).remove();
    });
    $44bb6d473543b89d$var$$(node).find('div.dt-column-' + className).remove();
    $44bb6d473543b89d$var$$('th, td', node).removeAttr('data-dt-column');
}
/**
 * Version string for plug-ins to check compatibility. Allowed format is
 * `a.b.c-d` where: a:int, b:int, c:int, d:string(dev|beta|alpha). `d` is used
 * only for non-release builds. See https://semver.org/ for more information.
 *  @member
 *  @type string
 *  @default Version number
 */ $44bb6d473543b89d$var$DataTable.version = "2.3.8";
/**
 * Private data store, containing all of the settings objects that are
 * created for the tables on a given page.
 *
 * Note that the `DataTable.settings` object is aliased to
 * `jQuery.fn.dataTableExt` through which it may be accessed and
 * manipulated, or `jQuery.fn.dataTable.settings`.
 *  @member
 *  @type array
 *  @default []
 *  @private
 */ $44bb6d473543b89d$var$DataTable.settings = [];
/**
 * Object models container, for the various models that DataTables has
 * available to it. These models define the objects that are used to hold
 * the active state and configuration of the table.
 *  @namespace
 */ $44bb6d473543b89d$var$DataTable.models = {};
/**
 * Template object for the way in which DataTables holds information about
 * search information for the global filter and individual column filters.
 *  @namespace
 */ $44bb6d473543b89d$var$DataTable.models.oSearch = {
    /**
	 * Flag to whether or not the filtering should be case-insensitive
	 */ "caseInsensitive": true,
    /**
	 * Applied search term
	 */ "search": "",
    /**
	 * Flag to indicate if the search term should be interpreted as a
	 * regular expression (true) or not (false) and therefore and special
	 * regex characters escaped.
	 */ "regex": false,
    /**
	 * Flag to indicate if DataTables is to use its smart filtering or not.
	 */ "smart": true,
    /**
	 * Flag to indicate if DataTables should only trigger a search when
	 * the return key is pressed.
	 */ "return": false
};
/**
 * Template object for the way in which DataTables holds information about
 * each individual row. This is the object format used for the settings
 * aoData array.
 *  @namespace
 */ $44bb6d473543b89d$var$DataTable.models.oRow = {
    /**
	 * TR element for the row
	 */ "nTr": null,
    /**
	 * Array of TD elements for each row. This is null until the row has been
	 * created.
	 */ "anCells": null,
    /**
	 * Data object from the original data source for the row. This is either
	 * an array if using the traditional form of DataTables, or an object if
	 * using mData options. The exact type will depend on the passed in
	 * data from the data source, or will be an array if using DOM a data
	 * source.
	 */ "_aData": [],
    /**
	 * Sorting data cache - this array is ostensibly the same length as the
	 * number of columns (although each index is generated only as it is
	 * needed), and holds the data that is used for sorting each column in the
	 * row. We do this cache generation at the start of the sort in order that
	 * the formatting of the sort data need be done only once for each cell
	 * per sort. This array should not be read from or written to by anything
	 * other than the master sorting methods.
	 */ "_aSortData": null,
    /**
	 * Per cell filtering data cache. As per the sort data cache, used to
	 * increase the performance of the filtering in DataTables
	 */ "_aFilterData": null,
    /**
	 * Filtering data cache. This is the same as the cell filtering cache, but
	 * in this case a string rather than an array. This is easily computed with
	 * a join on `_aFilterData`, but is provided as a cache so the join isn't
	 * needed on every search (memory traded for performance)
	 */ "_sFilterRow": null,
    /**
	 * Denote if the original data source was from the DOM, or the data source
	 * object. This is used for invalidating data, so DataTables can
	 * automatically read data from the original source, unless uninstructed
	 * otherwise.
	 */ "src": null,
    /**
	 * Index in the aoData array. This saves an indexOf lookup when we have the
	 * object, but want to know the index
	 */ "idx": -1,
    /**
	 * Cached display value
	 */ displayData: null
};
/**
 * Template object for the column information object in DataTables. This object
 * is held in the settings aoColumns array and contains all the information that
 * DataTables needs about each individual column.
 *
 * Note that this object is related to {@link DataTable.defaults.column}
 * but this one is the internal data store for DataTables's cache of columns.
 * It should NOT be manipulated outside of DataTables. Any configuration should
 * be done through the initialisation options.
 *  @namespace
 */ $44bb6d473543b89d$var$DataTable.models.oColumn = {
    /**
	 * Column index.
	 */ "idx": null,
    /**
	 * A list of the columns that sorting should occur on when this column
	 * is sorted. That this property is an array allows multi-column sorting
	 * to be defined for a column (for example first name / last name columns
	 * would benefit from this). The values are integers pointing to the
	 * columns to be sorted on (typically it will be a single integer pointing
	 * at itself, but that doesn't need to be the case).
	 */ "aDataSort": null,
    /**
	 * Define the sorting directions that are applied to the column, in sequence
	 * as the column is repeatedly sorted upon - i.e. the first value is used
	 * as the sorting direction when the column if first sorted (clicked on).
	 * Sort it again (click again) and it will move on to the next index.
	 * Repeat until loop.
	 */ "asSorting": null,
    /**
	 * Flag to indicate if the column is searchable, and thus should be included
	 * in the filtering or not.
	 */ "bSearchable": null,
    /**
	 * Flag to indicate if the column is sortable or not.
	 */ "bSortable": null,
    /**
	 * Flag to indicate if the column is currently visible in the table or not
	 */ "bVisible": null,
    /**
	 * Store for manual type assignment using the `column.type` option. This
	 * is held in store so we can manipulate the column's `sType` property.
	 */ "_sManualType": null,
    /**
	 * Flag to indicate if HTML5 data attributes should be used as the data
	 * source for filtering or sorting. True is either are.
	 */ "_bAttrSrc": false,
    /**
	 * Developer definable function that is called whenever a cell is created (Ajax source,
	 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
	 * allowing you to modify the DOM element (add background colour for example) when the
	 * element is available.
	 */ "fnCreatedCell": null,
    /**
	 * Function to get data from a cell in a column. You should <b>never</b>
	 * access data directly through _aData internally in DataTables - always use
	 * the method attached to this property. It allows mData to function as
	 * required. This function is automatically assigned by the column
	 * initialisation method
	 */ "fnGetData": null,
    /**
	 * Function to set data for a cell in the column. You should <b>never</b>
	 * set the data directly to _aData internally in DataTables - always use
	 * this method. It allows mData to function as required. This function
	 * is automatically assigned by the column initialisation method
	 */ "fnSetData": null,
    /**
	 * Property to read the value for the cells in the column from the data
	 * source array / object. If null, then the default content is used, if a
	 * function is given then the return from the function is used.
	 */ "mData": null,
    /**
	 * Partner property to mData which is used (only when defined) to get
	 * the data - i.e. it is basically the same as mData, but without the
	 * 'set' option, and also the data fed to it is the result from mData.
	 * This is the rendering method to match the data method of mData.
	 */ "mRender": null,
    /**
	 * The class to apply to all TD elements in the table's TBODY for the column
	 */ "sClass": null,
    /**
	 * When DataTables calculates the column widths to assign to each column,
	 * it finds the longest string in each column and then constructs a
	 * temporary table and reads the widths from that. The problem with this
	 * is that "mmm" is much wider then "iiii", but the latter is a longer
	 * string - thus the calculation can go wrong (doing it properly and putting
	 * it into an DOM object and measuring that is horribly(!) slow). Thus as
	 * a "work around" we provide this option. It will append its value to the
	 * text that is found to be the longest string for the column - i.e. padding.
	 */ "sContentPadding": null,
    /**
	 * Allows a default value to be given for a column's data, and will be used
	 * whenever a null data source is encountered (this can be because mData
	 * is set to null, or because the data source itself is null).
	 */ "sDefaultContent": null,
    /**
	 * Name for the column, allowing reference to the column by name as well as
	 * by index (needs a lookup to work by name).
	 */ "sName": null,
    /**
	 * Custom sorting data type - defines which of the available plug-ins in
	 * afnSortData the custom sorting will use - if any is defined.
	 */ "sSortDataType": 'std',
    /**
	 * Class to be applied to the header element when sorting on this column
	 */ "sSortingClass": null,
    /**
	 * Title of the column - what is seen in the TH element (nTh).
	 */ "sTitle": null,
    /**
	 * Column sorting and filtering type
	 */ "sType": null,
    /**
	 * Width of the column
	 */ "sWidth": null,
    /**
	 * Width of the column when it was first "encountered"
	 */ "sWidthOrig": null,
    /** Cached longest strings from a column */ wideStrings: null,
    /**
	 * Store for named searches
	 */ searchFixed: null
};
/*
 * Developer note: The properties of the object below are given in Hungarian
 * notation, that was used as the interface for DataTables prior to v1.10, however
 * from v1.10 onwards the primary interface is camel case. In order to avoid
 * breaking backwards compatibility utterly with this change, the Hungarian
 * version is still, internally the primary interface, but is is not documented
 * - hence the @name tags in each doc comment. This allows a JavaScript function
 * to create a map from Hungarian notation to camel case (going the other direction
 * would require each property to be listed, which would add around 3K to the size
 * of DataTables, while this method is about a 0.5K hit).
 *
 * Ultimately this does pave the way for Hungarian notation to be dropped
 * completely, but that is a massive amount of work and will break current
 * installs (therefore is on-hold until v2).
 */ /**
 * Initialisation options that can be given to DataTables at initialisation
 * time.
 *  @namespace
 */ $44bb6d473543b89d$var$DataTable.defaults = {
    /**
	 * An array of data to use for the table, passed in at initialisation which
	 * will be used in preference to any data which is already in the DOM. This is
	 * particularly useful for constructing tables purely in JavaScript, for
	 * example with a custom Ajax call.
	 */ "aaData": null,
    /**
	 * If ordering is enabled, then DataTables will perform a first pass sort on
	 * initialisation. You can define which column(s) the sort is performed
	 * upon, and the sorting direction, with this variable. The `sorting` array
	 * should contain an array for each column to be sorted initially containing
	 * the column's index and a direction string ('asc' or 'desc').
	 */ "aaSorting": [
        [
            0,
            'asc'
        ]
    ],
    /**
	 * This parameter is basically identical to the `sorting` parameter, but
	 * cannot be overridden by user interaction with the table. What this means
	 * is that you could have a column (visible or hidden) which the sorting
	 * will always be forced on first - any sorting after that (from the user)
	 * will then be performed as required. This can be useful for grouping rows
	 * together.
	 */ "aaSortingFixed": [],
    /**
	 * DataTables can be instructed to load data to display in the table from a
	 * Ajax source. This option defines how that Ajax call is made and where to.
	 *
	 * The `ajax` property has three different modes of operation, depending on
	 * how it is defined. These are:
	 *
	 * * `string` - Set the URL from where the data should be loaded from.
	 * * `object` - Define properties for `jQuery.ajax`.
	 * * `function` - Custom data get function
	 *
	 * `string`
	 * --------
	 *
	 * As a string, the `ajax` property simply defines the URL from which
	 * DataTables will load data.
	 *
	 * `object`
	 * --------
	 *
	 * As an object, the parameters in the object are passed to
	 * [jQuery.ajax](https://api.jquery.com/jQuery.ajax/) allowing fine control
	 * of the Ajax request. DataTables has a number of default parameters which
	 * you can override using this option. Please refer to the jQuery
	 * documentation for a full description of the options available, although
	 * the following parameters provide additional options in DataTables or
	 * require special consideration:
	 *
	 * * `data` - As with jQuery, `data` can be provided as an object, but it
	 *   can also be used as a function to manipulate the data DataTables sends
	 *   to the server. The function takes a single parameter, an object of
	 *   parameters with the values that DataTables has readied for sending. An
	 *   object may be returned which will be merged into the DataTables
	 *   defaults, or you can add the items to the object that was passed in and
	 *   not return anything from the function. This supersedes `fnServerParams`
	 *   from DataTables 1.9-.
	 *
	 * * `dataSrc` - By default DataTables will look for the property `data` (or
	 *   `aaData` for compatibility with DataTables 1.9-) when obtaining data
	 *   from an Ajax source or for server-side processing - this parameter
	 *   allows that property to be changed. You can use JavaScript dotted
	 *   object notation to get a data source for multiple levels of nesting, or
	 *   it my be used as a function. As a function it takes a single parameter,
	 *   the JSON returned from the server, which can be manipulated as
	 *   required, with the returned value being that used by DataTables as the
	 *   data source for the table.
	 *
	 * * `success` - Should not be overridden it is used internally in
	 *   DataTables. To manipulate / transform the data returned by the server
	 *   use `ajax.dataSrc`, or use `ajax` as a function (see below).
	 *
	 * `function`
	 * ----------
	 *
	 * As a function, making the Ajax call is left up to yourself allowing
	 * complete control of the Ajax request. Indeed, if desired, a method other
	 * than Ajax could be used to obtain the required data, such as Web storage
	 * or an AIR database.
	 *
	 * The function is given four parameters and no return is required. The
	 * parameters are:
	 *
	 * 1. _object_ - Data to send to the server
	 * 2. _function_ - Callback function that must be executed when the required
	 *    data has been obtained. That data should be passed into the callback
	 *    as the only parameter
	 * 3. _object_ - DataTables settings object for the table
	 */ "ajax": null,
    /**
	 * This parameter allows you to readily specify the entries in the length drop
	 * down menu that DataTables shows when pagination is enabled. It can be
	 * either a 1D array of options which will be used for both the displayed
	 * option and the value, or a 2D array which will use the array in the first
	 * position as the value, and the array in the second position as the
	 * displayed options (useful for language strings such as 'All').
	 *
	 * Note that the `pageLength` property will be automatically set to the
	 * first value given in this array, unless `pageLength` is also provided.
	 */ "aLengthMenu": [
        10,
        25,
        50,
        100
    ],
    /**
	 * The `columns` option in the initialisation parameter allows you to define
	 * details about the way individual columns behave. For a full list of
	 * column options that can be set, please see
	 * {@link DataTable.defaults.column}. Note that if you use `columns` to
	 * define your columns, you must have an entry in the array for every single
	 * column that you have in your table (these can be null if you don't which
	 * to specify any options).
	 */ "aoColumns": null,
    /**
	 * Very similar to `columns`, `columnDefs` allows you to target a specific
	 * column, multiple columns, or all columns, using the `targets` property of
	 * each object in the array. This allows great flexibility when creating
	 * tables, as the `columnDefs` arrays can be of any length, targeting the
	 * columns you specifically want. `columnDefs` may use any of the column
	 * options available: {@link DataTable.defaults.column}, but it _must_
	 * have `targets` defined in each object in the array. Values in the `targets`
	 * array may be:
	 *   <ul>
	 *     <li>a string - class name will be matched on the TH for the column</li>
	 *     <li>0 or a positive integer - column index counting from the left</li>
	 *     <li>a negative integer - column index counting from the right</li>
	 *     <li>the string "_all" - all columns (i.e. assign a default)</li>
	 *   </ul>
	 */ "aoColumnDefs": null,
    /**
	 * Basically the same as `search`, this parameter defines the individual column
	 * filtering state at initialisation time. The array must be of the same size
	 * as the number of columns, and each element be an object with the parameters
	 * `search` and `escapeRegex` (the latter is optional). 'null' is also
	 * accepted and the default will be used.
	 */ "aoSearchCols": [],
    /**
	 * Enable or disable automatic column width calculation. This can be disabled
	 * as an optimisation (it takes some time to calculate the widths) if the
	 * tables widths are passed in using `columns`.
	 */ "bAutoWidth": true,
    /**
	 * Deferred rendering can provide DataTables with a huge speed boost when you
	 * are using an Ajax or JS data source for the table. This option, when set to
	 * true, will cause DataTables to defer the creation of the table elements for
	 * each row until they are needed for a draw - saving a significant amount of
	 * time.
	 */ "bDeferRender": true,
    /**
	 * Replace a DataTable which matches the given selector and replace it with
	 * one which has the properties of the new initialisation object passed. If no
	 * table matches the selector, then the new DataTable will be constructed as
	 * per normal.
	 */ "bDestroy": false,
    /**
	 * Enable or disable filtering of data. Filtering in DataTables is "smart" in
	 * that it allows the end user to input multiple words (space separated) and
	 * will match a row containing those words, even if not in the order that was
	 * specified (this allow matching across multiple columns). Note that if you
	 * wish to use filtering in DataTables this must remain 'true' - to remove the
	 * default filtering input box and retain filtering abilities, please use
	 * {@link DataTable.defaults.dom}.
	 */ "bFilter": true,
    /**
	 * Used only for compatibility with DT1
	 * @deprecated
	 */ "bInfo": true,
    /**
	 * Used only for compatibility with DT1
	 * @deprecated
	 */ "bLengthChange": true,
    /**
	 * Enable or disable pagination.
	 */ "bPaginate": true,
    /**
	 * Enable or disable the display of a 'processing' indicator when the table is
	 * being processed (e.g. a sort). This is particularly useful for tables with
	 * large amounts of data where it can take a noticeable amount of time to sort
	 * the entries.
	 */ "bProcessing": false,
    /**
	 * Retrieve the DataTables object for the given selector. Note that if the
	 * table has already been initialised, this parameter will cause DataTables
	 * to simply return the object that has already been set up - it will not take
	 * account of any changes you might have made to the initialisation object
	 * passed to DataTables (setting this parameter to true is an acknowledgement
	 * that you understand this). `destroy` can be used to reinitialise a table if
	 * you need.
	 */ "bRetrieve": false,
    /**
	 * When vertical (y) scrolling is enabled, DataTables will force the height of
	 * the table's viewport to the given height at all times (useful for layout).
	 * However, this can look odd when filtering data down to a small data set,
	 * and the footer is left "floating" further down. This parameter (when
	 * enabled) will cause DataTables to collapse the table's viewport down when
	 * the result set will fit within the given Y height.
	 */ "bScrollCollapse": false,
    /**
	 * Configure DataTables to use server-side processing. Note that the
	 * `ajax` parameter must also be given in order to give DataTables a
	 * source to obtain the required data for each draw.
	 */ "bServerSide": false,
    /**
	 * Enable or disable sorting of columns. Sorting of individual columns can be
	 * disabled by the `sortable` option for each column.
	 */ "bSort": true,
    /**
	 * Enable or display DataTables' ability to sort multiple columns at the
	 * same time (activated by shift-click by the user).
	 */ "bSortMulti": true,
    /**
	 * Allows control over whether DataTables should use the top (true) unique
	 * cell that is found for a single column, or the bottom (false - default).
	 * This is useful when using complex headers.
	 */ "bSortCellsTop": null,
    /** Specify which row is the title row in the header. Replacement for bSortCellsTop */ titleRow: null,
    /**
	 * Enable or disable the addition of the classes `sorting\_1`, `sorting\_2` and
	 * `sorting\_3` to the columns which are currently being sorted on. This is
	 * presented as a feature switch as it can increase processing time (while
	 * classes are removed and added) so for large data sets you might want to
	 * turn this off.
	 */ "bSortClasses": true,
    /**
	 * Enable or disable state saving. When enabled HTML5 `localStorage` will be
	 * used to save table display information such as pagination information,
	 * display length, filtering and sorting. As such when the end user reloads
	 * the page the display will match what thy had previously set up.
	 */ "bStateSave": false,
    /**
	 * This function is called when a TR element is created (and all TD child
	 * elements have been inserted), or registered if using a DOM source, allowing
	 * manipulation of the TR element (adding classes etc).
	 */ "fnCreatedRow": null,
    /**
	 * This function is called on every 'draw' event, and allows you to
	 * dynamically modify any aspect you want about the created DOM.
	 */ "fnDrawCallback": null,
    /**
	 * Identical to fnHeaderCallback() but for the table footer this function
	 * allows you to modify the table footer on every 'draw' event.
	 */ "fnFooterCallback": null,
    /**
	 * When rendering large numbers in the information element for the table
	 * (i.e. "Showing 1 to 10 of 57 entries") DataTables will render large numbers
	 * to have a comma separator for the 'thousands' units (e.g. 1 million is
	 * rendered as "1,000,000") to help readability for the end user. This
	 * function will override the default method DataTables uses.
	 */ "fnFormatNumber": function(toFormat) {
        return toFormat.toString().replace(/\B(?=(\d{3})+(?!\d))/g, this.oLanguage.sThousands);
    },
    /**
	 * This function is called on every 'draw' event, and allows you to
	 * dynamically modify the header row. This can be used to calculate and
	 * display useful information about the table.
	 */ "fnHeaderCallback": null,
    /**
	 * The information element can be used to convey information about the current
	 * state of the table. Although the internationalisation options presented by
	 * DataTables are quite capable of dealing with most customisations, there may
	 * be times where you wish to customise the string further. This callback
	 * allows you to do exactly that.
	 */ "fnInfoCallback": null,
    /**
	 * Called when the table has been initialised. Normally DataTables will
	 * initialise sequentially and there will be no need for this function,
	 * however, this does not hold true when using external language information
	 * since that is obtained using an async XHR call.
	 */ "fnInitComplete": null,
    /**
	 * Called at the very start of each table draw and can be used to cancel the
	 * draw by returning false, any other return (including undefined) results in
	 * the full draw occurring).
	 */ "fnPreDrawCallback": null,
    /**
	 * This function allows you to 'post process' each row after it have been
	 * generated for each table draw, but before it is rendered on screen. This
	 * function might be used for setting the row class name etc.
	 */ "fnRowCallback": null,
    /**
	 * Load the table state. With this function you can define from where, and how, the
	 * state of a table is loaded. By default DataTables will load from `localStorage`
	 * but you might wish to use a server-side database or cookies.
	 */ "fnStateLoadCallback": function(settings) {
        try {
            return JSON.parse((settings.iStateDuration === -1 ? sessionStorage : localStorage).getItem('DataTables_' + settings.sInstance + '_' + location.pathname));
        } catch (e) {
            return {};
        }
    },
    /**
	 * Callback which allows modification of the saved state prior to loading that state.
	 * This callback is called when the table is loading state from the stored data, but
	 * prior to the settings object being modified by the saved state. Note that for
	 * plug-in authors, you should use the `stateLoadParams` event to load parameters for
	 * a plug-in.
	 */ "fnStateLoadParams": null,
    /**
	 * Callback that is called when the state has been loaded from the state saving method
	 * and the DataTables settings object has been modified as a result of the loaded state.
	 */ "fnStateLoaded": null,
    /**
	 * Save the table state. This function allows you to define where and how the state
	 * information for the table is stored By default DataTables will use `localStorage`
	 * but you might wish to use a server-side database or cookies.
	 */ "fnStateSaveCallback": function(settings, data) {
        try {
            (settings.iStateDuration === -1 ? sessionStorage : localStorage).setItem('DataTables_' + settings.sInstance + '_' + location.pathname, JSON.stringify(data));
        } catch (e) {
        // noop
        }
    },
    /**
	 * Callback which allows modification of the state to be saved. Called when the table
	 * has changed state a new state save is required. This method allows modification of
	 * the state saving object prior to actually doing the save, including addition or
	 * other state properties or modification. Note that for plug-in authors, you should
	 * use the `stateSaveParams` event to save parameters for a plug-in.
	 */ "fnStateSaveParams": null,
    /**
	 * Duration for which the saved state information is considered valid. After this period
	 * has elapsed the state will be returned to the default.
	 * Value is given in seconds.
	 */ "iStateDuration": 7200,
    /**
	 * Number of rows to display on a single page when using pagination. If
	 * feature enabled (`lengthChange`) then the end user will be able to override
	 * this to a custom setting using a pop-up menu.
	 */ "iDisplayLength": 10,
    /**
	 * Define the starting point for data display when using DataTables with
	 * pagination. Note that this parameter is the number of records, rather than
	 * the page number, so if you have 10 records per page and want to start on
	 * the third page, it should be "20".
	 */ "iDisplayStart": 0,
    /**
	 * By default DataTables allows keyboard navigation of the table (sorting, paging,
	 * and filtering) by adding a `tabindex` attribute to the required elements. This
	 * allows you to tab through the controls and press the enter key to activate them.
	 * The tabindex is default 0, meaning that the tab follows the flow of the document.
	 * You can overrule this using this parameter if you wish. Use a value of -1 to
	 * disable built-in keyboard navigation.
	 */ "iTabIndex": 0,
    /**
	 * Classes that DataTables assigns to the various components and features
	 * that it adds to the HTML table. This allows classes to be configured
	 * during initialisation in addition to through the static
	 * {@link DataTable.ext.oStdClasses} object).
	 */ "oClasses": {},
    /**
	 * All strings that DataTables uses in the user interface that it creates
	 * are defined in this object, allowing you to modified them individually or
	 * completely replace them all as required.
	 */ "oLanguage": {
        /**
		 * Strings that are used for WAI-ARIA labels and controls only (these are not
		 * actually visible on the page, but will be read by screenreaders, and thus
		 * must be internationalised as well).
		 */ "oAria": {
            /**
			 * ARIA label that is added to the table headers when the column may be sorted
			 */ "orderable": ": Activate to sort",
            /**
			 * ARIA label that is added to the table headers when the column is currently being sorted
			 */ "orderableReverse": ": Activate to invert sorting",
            /**
			 * ARIA label that is added to the table headers when the column is currently being 
			 * sorted and next step is to remove sorting
			 */ "orderableRemove": ": Activate to remove sorting",
            paginate: {
                first: 'First',
                last: 'Last',
                next: 'Next',
                previous: 'Previous',
                number: ''
            }
        },
        /**
		 * Pagination string used by DataTables for the built-in pagination
		 * control types.
		 */ "oPaginate": {
            /**
			 * Label and character for first page button («)
			 */ "sFirst": "\u00AB",
            /**
			 * Last page button (»)
			 */ "sLast": "\u00BB",
            /**
			 * Next page button (›)
			 */ "sNext": "\u203A",
            /**
			 * Previous page button (‹)
			 */ "sPrevious": "\u2039"
        },
        /**
		 * Plural object for the data type the table is showing
		 */ entries: {
            _: "entries",
            1: "entry"
        },
        /**
		 * Page length options
		 */ lengthLabels: {
            '-1': 'All'
        },
        /**
		 * This string is shown in preference to `zeroRecords` when the table is
		 * empty of data (regardless of filtering). Note that this is an optional
		 * parameter - if it is not given, the value of `zeroRecords` will be used
		 * instead (either the default or given value).
		 */ "sEmptyTable": "No data available in table",
        /**
		 * This string gives information to the end user about the information
		 * that is current on display on the page. The following tokens can be
		 * used in the string and will be dynamically replaced as the table
		 * display updates. This tokens can be placed anywhere in the string, or
		 * removed as needed by the language requires:
		 *
		 * * `\_START\_` - Display index of the first record on the current page
		 * * `\_END\_` - Display index of the last record on the current page
		 * * `\_TOTAL\_` - Number of records in the table after filtering
		 * * `\_MAX\_` - Number of records in the table without filtering
		 * * `\_PAGE\_` - Current page number
		 * * `\_PAGES\_` - Total number of pages of data in the table
		 */ "sInfo": "Showing _START_ to _END_ of _TOTAL_ _ENTRIES-TOTAL_",
        /**
		 * Display information string for when the table is empty. Typically the
		 * format of this string should match `info`.
		 */ "sInfoEmpty": "Showing 0 to 0 of 0 _ENTRIES-TOTAL_",
        /**
		 * When a user filters the information in a table, this string is appended
		 * to the information (`info`) to give an idea of how strong the filtering
		 * is. The variable _MAX_ is dynamically updated.
		 */ "sInfoFiltered": "(filtered from _MAX_ total _ENTRIES-MAX_)",
        /**
		 * If can be useful to append extra information to the info string at times,
		 * and this variable does exactly that. This information will be appended to
		 * the `info` (`infoEmpty` and `infoFiltered` in whatever combination they are
		 * being used) at all times.
		 */ "sInfoPostFix": "",
        /**
		 * This decimal place operator is a little different from the other
		 * language options since DataTables doesn't output floating point
		 * numbers, so it won't ever use this for display of a number. Rather,
		 * what this parameter does is modify the sort methods of the table so
		 * that numbers which are in a format which has a character other than
		 * a period (`.`) as a decimal place will be sorted numerically.
		 *
		 * Note that numbers with different decimal places cannot be shown in
		 * the same table and still be sortable, the table must be consistent.
		 * However, multiple different tables on the page can use different
		 * decimal place characters.
		 */ "sDecimal": "",
        /**
		 * DataTables has a build in number formatter (`formatNumber`) which is
		 * used to format large numbers that are used in the table information.
		 * By default a comma is used, but this can be trivially changed to any
		 * character you wish with this parameter.
		 */ "sThousands": ",",
        /**
		 * Detail the action that will be taken when the drop down menu for the
		 * pagination length option is changed. The '_MENU_' variable is replaced
		 * with a default select list of 10, 25, 50 and 100, and can be replaced
		 * with a custom select box if required.
		 */ "sLengthMenu": "_MENU_ _ENTRIES_ per page",
        /**
		 * When using Ajax sourced data and during the first draw when DataTables is
		 * gathering the data, this message is shown in an empty row in the table to
		 * indicate to the end user the data is being loaded. Note that this
		 * parameter is not used when loading data by server-side processing, just
		 * Ajax sourced data with client-side processing.
		 */ "sLoadingRecords": "Loading...",
        /**
		 * Text which is displayed when the table is processing a user action
		 * (usually a sort command or similar).
		 */ "sProcessing": "",
        /**
		 * Details the actions that will be taken when the user types into the
		 * filtering input text box. The variable "_INPUT_", if used in the string,
		 * is replaced with the HTML text box for the filtering input allowing
		 * control over where it appears in the string. If "_INPUT_" is not given
		 * then the input box is appended to the string automatically.
		 */ "sSearch": "Search:",
        /**
		 * Assign a `placeholder` attribute to the search `input` element
		 *  @type string
		 *  @default 
		 *
		 *  @dtopt Language
		 *  @name DataTable.defaults.language.searchPlaceholder
		 */ "sSearchPlaceholder": "",
        /**
		 * All of the language information can be stored in a file on the
		 * server-side, which DataTables will look up if this parameter is passed.
		 * It must store the URL of the language file, which is in a JSON format,
		 * and the object has the same properties as the oLanguage object in the
		 * initialiser object (i.e. the above parameters). Please refer to one of
		 * the example language files to see how this works in action.
		 */ "sUrl": "",
        /**
		 * Text shown inside the table records when the is no information to be
		 * displayed after filtering. `emptyTable` is shown when there is simply no
		 * information in the table at all (regardless of filtering).
		 */ "sZeroRecords": "No matching records found"
    },
    /** The initial data order is reversed when `desc` ordering */ orderDescReverse: true,
    /**
	 * This parameter allows you to have define the global filtering state at
	 * initialisation time. As an object the `search` parameter must be
	 * defined, but all other parameters are optional. When `regex` is true,
	 * the search string will be treated as a regular expression, when false
	 * (default) it will be treated as a straight string. When `smart`
	 * DataTables will use it's smart filtering methods (to word match at
	 * any point in the data), when false this will not be done.
	 */ "oSearch": $44bb6d473543b89d$var$$.extend({}, $44bb6d473543b89d$var$DataTable.models.oSearch),
    /**
	 * Table and control layout. This replaces the legacy `dom` option.
	 */ layout: {
        topStart: 'pageLength',
        topEnd: 'search',
        bottomStart: 'info',
        bottomEnd: 'paging'
    },
    /**
	 * Legacy DOM layout option
	 */ "sDom": null,
    /**
	 * Search delay option. This will throttle full table searches that use the
	 * DataTables provided search input element (it does not effect calls to
	 * `dt-api search()`, providing a delay before the search is made.
	 */ "searchDelay": null,
    /**
	 * DataTables features six different built-in options for the buttons to
	 * display for pagination control:
	 *
	 * * `numbers` - Page number buttons only
	 * * `simple` - 'Previous' and 'Next' buttons only
	 * * 'simple_numbers` - 'Previous' and 'Next' buttons, plus page numbers
	 * * `full` - 'First', 'Previous', 'Next' and 'Last' buttons
	 * * `full_numbers` - 'First', 'Previous', 'Next' and 'Last' buttons, plus page numbers
	 * * `first_last_numbers` - 'First' and 'Last' buttons, plus page numbers
	 */ "sPaginationType": "",
    /**
	 * Enable horizontal scrolling. When a table is too wide to fit into a
	 * certain layout, or you have a large number of columns in the table, you
	 * can enable x-scrolling to show the table in a viewport, which can be
	 * scrolled. This property can be `true` which will allow the table to
	 * scroll horizontally when needed, or any CSS unit, or a number (in which
	 * case it will be treated as a pixel measurement). Setting as simply `true`
	 * is recommended.
	 */ "sScrollX": "",
    /**
	 * This property can be used to force a DataTable to use more width than it
	 * might otherwise do when x-scrolling is enabled. For example if you have a
	 * table which requires to be well spaced, this parameter is useful for
	 * "over-sizing" the table, and thus forcing scrolling. This property can by
	 * any CSS unit, or a number (in which case it will be treated as a pixel
	 * measurement).
	 */ "sScrollXInner": "",
    /**
	 * Enable vertical scrolling. Vertical scrolling will constrain the DataTable
	 * to the given height, and enable scrolling for any data which overflows the
	 * current viewport. This can be used as an alternative to paging to display
	 * a lot of data in a small area (although paging and scrolling can both be
	 * enabled at the same time). This property can be any CSS unit, or a number
	 * (in which case it will be treated as a pixel measurement).
	 */ "sScrollY": "",
    /**
	 * __Deprecated__ The functionality provided by this parameter has now been
	 * superseded by that provided through `ajax`, which should be used instead.
	 *
	 * Set the HTTP method that is used to make the Ajax call for server-side
	 * processing or Ajax sourced data.
	 */ "sServerMethod": "GET",
    /**
	 * DataTables makes use of renderers when displaying HTML elements for
	 * a table. These renderers can be added or modified by plug-ins to
	 * generate suitable mark-up for a site. For example the Bootstrap
	 * integration plug-in for DataTables uses a paging button renderer to
	 * display pagination buttons in the mark-up required by Bootstrap.
	 *
	 * For further information about the renderers available see
	 * DataTable.ext.renderer
	 */ "renderer": null,
    /**
	 * Set the data property name that DataTables should use to get a row's id
	 * to set as the `id` property in the node.
	 */ "rowId": "DT_RowId",
    /**
	 * Caption value
	 */ "caption": null,
    /**
	 * For server-side processing - use the data from the DOM for the first draw
	 */ iDeferLoading: null,
    /** Event listeners */ on: null,
    /** Title wrapper element type */ columnTitleTag: 'span'
};
$44bb6d473543b89d$var$_fnHungarianMap($44bb6d473543b89d$var$DataTable.defaults);
/*
 * Developer note - See note in model.defaults.js about the use of Hungarian
 * notation and camel case.
 */ /**
 * Column options that can be given to DataTables at initialisation time.
 *  @namespace
 */ $44bb6d473543b89d$var$DataTable.defaults.column = {
    /**
	 * Define which column(s) an order will occur on for this column. This
	 * allows a column's ordering to take multiple columns into account when
	 * doing a sort or use the data from a different column. For example first
	 * name / last name columns make sense to do a multi-column sort over the
	 * two columns.
	 */ "aDataSort": null,
    "iDataSort": -1,
    ariaTitle: '',
    /**
	 * You can control the default ordering direction, and even alter the
	 * behaviour of the sort handler (i.e. only allow ascending ordering etc)
	 * using this parameter.
	 */ "asSorting": [
        'asc',
        'desc',
        ''
    ],
    /**
	 * Enable or disable filtering on the data in this column.
	 */ "bSearchable": true,
    /**
	 * Enable or disable ordering on this column.
	 */ "bSortable": true,
    /**
	 * Enable or disable the display of this column.
	 */ "bVisible": true,
    /**
	 * Developer definable function that is called whenever a cell is created (Ajax source,
	 * etc) or processed for input (DOM source). This can be used as a compliment to mRender
	 * allowing you to modify the DOM element (add background colour for example) when the
	 * element is available.
	 */ "fnCreatedCell": null,
    /**
	 * This property can be used to read data from any data source property,
	 * including deeply nested objects / properties. `data` can be given in a
	 * number of different ways which effect its behaviour:
	 *
	 * * `integer` - treated as an array index for the data source. This is the
	 *   default that DataTables uses (incrementally increased for each column).
	 * * `string` - read an object property from the data source. There are
	 *   three 'special' options that can be used in the string to alter how
	 *   DataTables reads the data from the source object:
	 *    * `.` - Dotted JavaScript notation. Just as you use a `.` in
	 *      JavaScript to read from nested objects, so to can the options
	 *      specified in `data`. For example: `browser.version` or
	 *      `browser.name`. If your object parameter name contains a period, use
	 *      `\\` to escape it - i.e. `first\\.name`.
	 *    * `[]` - Array notation. DataTables can automatically combine data
	 *      from and array source, joining the data with the characters provided
	 *      between the two brackets. For example: `name[, ]` would provide a
	 *      comma-space separated list from the source array. If no characters
	 *      are provided between the brackets, the original array source is
	 *      returned.
	 *    * `()` - Function notation. Adding `()` to the end of a parameter will
	 *      execute a function of the name given. For example: `browser()` for a
	 *      simple function on the data source, `browser.version()` for a
	 *      function in a nested property or even `browser().version` to get an
	 *      object property if the function called returns an object. Note that
	 *      function notation is recommended for use in `render` rather than
	 *      `data` as it is much simpler to use as a renderer.
	 * * `null` - use the original data source for the row rather than plucking
	 *   data directly from it. This action has effects on two other
	 *   initialisation options:
	 *    * `defaultContent` - When null is given as the `data` option and
	 *      `defaultContent` is specified for the column, the value defined by
	 *      `defaultContent` will be used for the cell.
	 *    * `render` - When null is used for the `data` option and the `render`
	 *      option is specified for the column, the whole data source for the
	 *      row is used for the renderer.
	 * * `function` - the function given will be executed whenever DataTables
	 *   needs to set or get the data for a cell in the column. The function
	 *   takes three parameters:
	 *    * Parameters:
	 *      * `{array|object}` The data source for the row
	 *      * `{string}` The type call data requested - this will be 'set' when
	 *        setting data or 'filter', 'display', 'type', 'sort' or undefined
	 *        when gathering data. Note that when `undefined` is given for the
	 *        type DataTables expects to get the raw data for the object back<
	 *      * `{*}` Data to set when the second parameter is 'set'.
	 *    * Return:
	 *      * The return value from the function is not required when 'set' is
	 *        the type of call, but otherwise the return is what will be used
	 *        for the data requested.
	 *
	 * Note that `data` is a getter and setter option. If you just require
	 * formatting of data for output, you will likely want to use `render` which
	 * is simply a getter and thus simpler to use.
	 *
	 * Note that prior to DataTables 1.9.2 `data` was called `mDataProp`. The
	 * name change reflects the flexibility of this property and is consistent
	 * with the naming of mRender. If 'mDataProp' is given, then it will still
	 * be used by DataTables, as it automatically maps the old name to the new
	 * if required.
	 */ "mData": null,
    /**
	 * This property is the rendering partner to `data` and it is suggested that
	 * when you want to manipulate data for display (including filtering,
	 * sorting etc) without altering the underlying data for the table, use this
	 * property. `render` can be considered to be the read only companion to
	 * `data` which is read / write (then as such more complex). Like `data`
	 * this option can be given in a number of different ways to effect its
	 * behaviour:
	 *
	 * * `integer` - treated as an array index for the data source. This is the
	 *   default that DataTables uses (incrementally increased for each column).
	 * * `string` - read an object property from the data source. There are
	 *   three 'special' options that can be used in the string to alter how
	 *   DataTables reads the data from the source object:
	 *    * `.` - Dotted JavaScript notation. Just as you use a `.` in
	 *      JavaScript to read from nested objects, so to can the options
	 *      specified in `data`. For example: `browser.version` or
	 *      `browser.name`. If your object parameter name contains a period, use
	 *      `\\` to escape it - i.e. `first\\.name`.
	 *    * `[]` - Array notation. DataTables can automatically combine data
	 *      from and array source, joining the data with the characters provided
	 *      between the two brackets. For example: `name[, ]` would provide a
	 *      comma-space separated list from the source array. If no characters
	 *      are provided between the brackets, the original array source is
	 *      returned.
	 *    * `()` - Function notation. Adding `()` to the end of a parameter will
	 *      execute a function of the name given. For example: `browser()` for a
	 *      simple function on the data source, `browser.version()` for a
	 *      function in a nested property or even `browser().version` to get an
	 *      object property if the function called returns an object.
	 * * `object` - use different data for the different data types requested by
	 *   DataTables ('filter', 'display', 'type' or 'sort'). The property names
	 *   of the object is the data type the property refers to and the value can
	 *   defined using an integer, string or function using the same rules as
	 *   `render` normally does. Note that an `_` option _must_ be specified.
	 *   This is the default value to use if you haven't specified a value for
	 *   the data type requested by DataTables.
	 * * `function` - the function given will be executed whenever DataTables
	 *   needs to set or get the data for a cell in the column. The function
	 *   takes three parameters:
	 *    * Parameters:
	 *      * {array|object} The data source for the row (based on `data`)
	 *      * {string} The type call data requested - this will be 'filter',
	 *        'display', 'type' or 'sort'.
	 *      * {array|object} The full data source for the row (not based on
	 *        `data`)
	 *    * Return:
	 *      * The return value from the function is what will be used for the
	 *        data requested.
	 */ "mRender": null,
    /**
	 * Change the cell type created for the column - either TD cells or TH cells. This
	 * can be useful as TH cells have semantic meaning in the table body, allowing them
	 * to act as a header for a row (you may wish to add scope='row' to the TH elements).
	 */ "sCellType": "td",
    /**
	 * Class to give to each cell in this column.
	 */ "sClass": "",
    /**
	 * When DataTables calculates the column widths to assign to each column,
	 * it finds the longest string in each column and then constructs a
	 * temporary table and reads the widths from that. The problem with this
	 * is that "mmm" is much wider then "iiii", but the latter is a longer
	 * string - thus the calculation can go wrong (doing it properly and putting
	 * it into an DOM object and measuring that is horribly(!) slow). Thus as
	 * a "work around" we provide this option. It will append its value to the
	 * text that is found to be the longest string for the column - i.e. padding.
	 * Generally you shouldn't need this!
	 */ "sContentPadding": "",
    /**
	 * Allows a default value to be given for a column's data, and will be used
	 * whenever a null data source is encountered (this can be because `data`
	 * is set to null, or because the data source itself is null).
	 */ "sDefaultContent": null,
    /**
	 * This parameter is only used in DataTables' server-side processing. It can
	 * be exceptionally useful to know what columns are being displayed on the
	 * client side, and to map these to database fields. When defined, the names
	 * also allow DataTables to reorder information from the server if it comes
	 * back in an unexpected order (i.e. if you switch your columns around on the
	 * client-side, your server-side code does not also need updating).
	 */ "sName": "",
    /**
	 * Defines a data source type for the ordering which can be used to read
	 * real-time information from the table (updating the internally cached
	 * version) prior to ordering. This allows ordering to occur on user
	 * editable elements such as form inputs.
	 */ "sSortDataType": "std",
    /**
	 * The title of this column.
	 */ "sTitle": null,
    /**
	 * The type allows you to specify how the data for this column will be
	 * ordered. Four types (string, numeric, date and html (which will strip
	 * HTML tags before ordering)) are currently available. Note that only date
	 * formats understood by JavaScript's Date() object will be accepted as type
	 * date. For example: "Mar 26, 2008 5:03 PM". May take the values: 'string',
	 * 'numeric', 'date' or 'html' (by default). Further types can be adding
	 * through plug-ins.
	 */ "sType": null,
    /**
	 * Defining the width of the column, this parameter may take any CSS value
	 * (3em, 20px etc). DataTables applies 'smart' widths to columns which have not
	 * been given a specific width through this interface ensuring that the table
	 * remains readable.
	 */ "sWidth": null
};
$44bb6d473543b89d$var$_fnHungarianMap($44bb6d473543b89d$var$DataTable.defaults.column);
/**
 * DataTables settings object - this holds all the information needed for a
 * given table, including configuration, data and current application of the
 * table options. DataTables does not have a single instance for each DataTable
 * with the settings attached to that instance, but rather instances of the
 * DataTable "class" are created on-the-fly as needed (typically by a
 * $().dataTable() call) and the settings object is then applied to that
 * instance.
 *
 * Note that this object is related to {@link DataTable.defaults} but this
 * one is the internal data store for DataTables's cache of columns. It should
 * NOT be manipulated outside of DataTables. Any configuration should be done
 * through the initialisation options.
 */ $44bb6d473543b89d$var$DataTable.models.oSettings = {
    /**
	 * Primary features of DataTables and their enablement state.
	 */ "oFeatures": {
        /**
		 * Flag to say if DataTables should automatically try to calculate the
		 * optimum table and columns widths (true) or not (false).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bAutoWidth": null,
        /**
		 * Delay the creation of TR and TD elements until they are actually
		 * needed by a driven page draw. This can give a significant speed
		 * increase for Ajax source and JavaScript source data, but makes no
		 * difference at all for DOM and server-side processing tables.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bDeferRender": null,
        /**
		 * Enable filtering on the table or not. Note that if this is disabled
		 * then there is no filtering at all on the table, including fnFilter.
		 * To just remove the filtering input use sDom and remove the 'f' option.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bFilter": null,
        /**
		 * Used only for compatibility with DT1
		 * @deprecated
		 */ "bInfo": true,
        /**
		 * Used only for compatibility with DT1
		 * @deprecated
		 */ "bLengthChange": true,
        /**
		 * Pagination enabled or not. Note that if this is disabled then length
		 * changing must also be disabled.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bPaginate": null,
        /**
		 * Processing indicator enable flag whenever DataTables is enacting a
		 * user request - typically an Ajax request for server-side processing.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bProcessing": null,
        /**
		 * Server-side processing enabled flag - when enabled DataTables will
		 * get all data from the server for every draw - there is no filtering,
		 * sorting or paging done on the client-side.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bServerSide": null,
        /**
		 * Sorting enablement flag.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bSort": null,
        /**
		 * Multi-column sorting
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bSortMulti": null,
        /**
		 * Apply a class to the columns which are being sorted to provide a
		 * visual highlight or not. This can slow things down when enabled since
		 * there is a lot of DOM interaction.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bSortClasses": null,
        /**
		 * State saving enablement flag.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bStateSave": null
    },
    /**
	 * Scrolling settings for a table.
	 */ "oScroll": {
        /**
		 * When the table is shorter in height than sScrollY, collapse the
		 * table container down to the height of the table (when true).
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "bCollapse": null,
        /**
		 * Width of the scrollbar for the web-browser's platform. Calculated
		 * during table initialisation.
		 */ "iBarWidth": 0,
        /**
		 * Viewport width for horizontal scrolling. Horizontal scrolling is
		 * disabled if an empty string.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "sX": null,
        /**
		 * Width to expand the table to when using x-scrolling. Typically you
		 * should not need to use this.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 *  @deprecated
		 */ "sXInner": null,
        /**
		 * Viewport height for vertical scrolling. Vertical scrolling is disabled
		 * if an empty string.
		 * Note that this parameter will be set by the initialisation routine. To
		 * set a default use {@link DataTable.defaults}.
		 */ "sY": null
    },
    /**
	 * Language information for the table.
	 */ "oLanguage": {
        /**
		 * Information callback function. See
		 * {@link DataTable.defaults.fnInfoCallback}
		 */ "fnInfoCallback": null
    },
    /**
	 * Browser support parameters
	 */ "oBrowser": {
        /**
		 * Determine if the vertical scrollbar is on the right or left of the
		 * scrolling container - needed for rtl language layout, although not
		 * all browsers move the scrollbar (Safari).
		 */ "bScrollbarLeft": false,
        /**
		 * Browser scrollbar width
		 */ "barWidth": 0
    },
    "ajax": null,
    /**
	 * Array referencing the nodes which are used for the features. The
	 * parameters of this object match what is allowed by sDom - i.e.
	 *   <ul>
	 *     <li>'l' - Length changing</li>
	 *     <li>'f' - Filtering input</li>
	 *     <li>'t' - The table!</li>
	 *     <li>'i' - Information</li>
	 *     <li>'p' - Pagination</li>
	 *     <li>'r' - pRocessing</li>
	 *   </ul>
	 */ "aanFeatures": [],
    /**
	 * Store data information - see {@link DataTable.models.oRow} for detailed
	 * information.
	 */ "aoData": [],
    /**
	 * Array of indexes which are in the current display (after filtering etc)
	 */ "aiDisplay": [],
    /**
	 * Array of indexes for display - no filtering
	 */ "aiDisplayMaster": [],
    /**
	 * Map of row ids to data indexes
	 */ "aIds": {},
    /**
	 * Store information about each column that is in use
	 */ "aoColumns": [],
    /**
	 * Store information about the table's header
	 */ "aoHeader": [],
    /**
	 * Store information about the table's footer
	 */ "aoFooter": [],
    /**
	 * Store the applied global search information in case we want to force a
	 * research or compare the old search to a new one.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "oPreviousSearch": {},
    /**
	 * Store for named searches
	 */ searchFixed: {},
    /**
	 * Store the applied search for each column - see
	 * {@link DataTable.models.oSearch} for the format that is used for the
	 * filtering information for each column.
	 */ "aoPreSearchCols": [],
    /**
	 * Sorting that is applied to the table. Note that the inner arrays are
	 * used in the following manner:
	 * <ul>
	 *   <li>Index 0 - column number</li>
	 *   <li>Index 1 - current sorting direction</li>
	 * </ul>
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "aaSorting": null,
    /**
	 * Sorting that is always applied to the table (i.e. prefixed in front of
	 * aaSorting).
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "aaSortingFixed": [],
    /**
	 * If restoring a table - we should restore its width
	 */ "sDestroyWidth": 0,
    /**
	 * Callback functions array for every time a row is inserted (i.e. on a draw).
	 */ "aoRowCallback": [],
    /**
	 * Callback functions for the header on each draw.
	 */ "aoHeaderCallback": [],
    /**
	 * Callback function for the footer on each draw.
	 */ "aoFooterCallback": [],
    /**
	 * Array of callback functions for draw callback functions
	 */ "aoDrawCallback": [],
    /**
	 * Array of callback functions for row created function
	 */ "aoRowCreatedCallback": [],
    /**
	 * Callback functions for just before the table is redrawn. A return of
	 * false will be used to cancel the draw.
	 */ "aoPreDrawCallback": [],
    /**
	 * Callback functions for when the table has been initialised.
	 */ "aoInitComplete": [],
    /**
	 * Callbacks for modifying the settings to be stored for state saving, prior to
	 * saving state.
	 */ "aoStateSaveParams": [],
    /**
	 * Callbacks for modifying the settings that have been stored for state saving
	 * prior to using the stored values to restore the state.
	 */ "aoStateLoadParams": [],
    /**
	 * Callbacks for operating on the settings object once the saved state has been
	 * loaded
	 */ "aoStateLoaded": [],
    /**
	 * Cache the table ID for quick access
	 */ "sTableId": "",
    /**
	 * The TABLE node for the main table
	 */ "nTable": null,
    /**
	 * Permanent ref to the thead element
	 */ "nTHead": null,
    /**
	 * Permanent ref to the tfoot element - if it exists
	 */ "nTFoot": null,
    /**
	 * Permanent ref to the tbody element
	 */ "nTBody": null,
    /**
	 * Cache the wrapper node (contains all DataTables controlled elements)
	 */ "nTableWrapper": null,
    /**
	 * Indicate if all required information has been read in
	 */ "bInitialised": false,
    /**
	 * Information about open rows. Each object in the array has the parameters
	 * 'nTr' and 'nParent'
	 */ "aoOpenRows": [],
    /**
	 * Dictate the positioning of DataTables' control elements - see
	 * {@link DataTable.model.oInit.sDom}.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "sDom": null,
    /**
	 * Search delay (in mS)
	 */ "searchDelay": null,
    /**
	 * Which type of pagination should be used.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "sPaginationType": "two_button",
    /**
	 * Number of paging controls on the page. Only used for backwards compatibility
	 */ pagingControls: 0,
    /**
	 * The state duration (for `stateSave`) in seconds.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "iStateDuration": 0,
    /**
	 * Array of callback functions for state saving. Each array element is an
	 * object with the following parameters:
	 *   <ul>
	 *     <li>function:fn - function to call. Takes two parameters, oSettings
	 *       and the JSON string to save that has been thus far created. Returns
	 *       a JSON string to be inserted into a json object
	 *       (i.e. '"param": [ 0, 1, 2]')</li>
	 *     <li>string:sName - name of callback</li>
	 *   </ul>
	 */ "aoStateSave": [],
    /**
	 * Array of callback functions for state loading. Each array element is an
	 * object with the following parameters:
	 *   <ul>
	 *     <li>function:fn - function to call. Takes two parameters, oSettings
	 *       and the object stored. May return false to cancel state loading</li>
	 *     <li>string:sName - name of callback</li>
	 *   </ul>
	 */ "aoStateLoad": [],
    /**
	 * State that was saved. Useful for back reference
	 */ "oSavedState": null,
    /**
	 * State that was loaded. Useful for back reference
	 */ "oLoadedState": null,
    /**
	 * Note if draw should be blocked while getting data
	 */ "bAjaxDataGet": true,
    /**
	 * The last jQuery XHR object that was used for server-side data gathering.
	 * This can be used for working with the XHR information in one of the
	 * callbacks
	 */ "jqXHR": null,
    /**
	 * JSON returned from the server in the last Ajax request
	 */ "json": undefined,
    /**
	 * Data submitted as part of the last Ajax request
	 */ "oAjaxData": undefined,
    /**
	 * Send the XHR HTTP method - GET or POST (could be PUT or DELETE if
	 * required).
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "sServerMethod": null,
    /**
	 * Format numbers for display.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "fnFormatNumber": null,
    /**
	 * List of options that can be used for the user selectable length menu.
	 * Note that this parameter will be set by the initialisation routine. To
	 * set a default use {@link DataTable.defaults}.
	 */ "aLengthMenu": null,
    /**
	 * Counter for the draws that the table does. Also used as a tracker for
	 * server-side processing
	 */ "iDraw": 0,
    /**
	 * Indicate if a redraw is being done - useful for Ajax
	 */ "bDrawing": false,
    /**
	 * Draw index (iDraw) of the last error when parsing the returned data
	 */ "iDrawError": -1,
    /**
	 * Paging display length
	 */ "_iDisplayLength": 10,
    /**
	 * Paging start point - aiDisplay index
	 */ "_iDisplayStart": 0,
    /**
	 * Server-side processing - number of records in the result set
	 * (i.e. before filtering), Use fnRecordsTotal rather than
	 * this property to get the value of the number of records, regardless of
	 * the server-side processing setting.
	 */ "_iRecordsTotal": 0,
    /**
	 * Server-side processing - number of records in the current display set
	 * (i.e. after filtering). Use fnRecordsDisplay rather than
	 * this property to get the value of the number of records, regardless of
	 * the server-side processing setting.
	 */ "_iRecordsDisplay": 0,
    /**
	 * The classes to use for the table
	 */ "oClasses": {},
    /**
	 * Flag attached to the settings object so you can check in the draw
	 * callback if filtering has been done in the draw. Deprecated in favour of
	 * events.
	 *  @deprecated
	 */ "bFiltered": false,
    /**
	 * Flag attached to the settings object so you can check in the draw
	 * callback if sorting has been done in the draw. Deprecated in favour of
	 * events.
	 *  @deprecated
	 */ "bSorted": false,
    /**
	 * Indicate that if multiple rows are in the header and there is more than
	 * one unique cell per column. Replaced by titleRow
	 */ "bSortCellsTop": null,
    /**
	 * Initialisation object that is used for the table
	 */ "oInit": null,
    /**
	 * Destroy callback functions - for plug-ins to attach themselves to the
	 * destroy so they can clean up markup and events.
	 */ "aoDestroyCallback": [],
    /**
	 * Get the number of records in the current record set, before filtering
	 */ "fnRecordsTotal": function() {
        return $44bb6d473543b89d$var$_fnDataSource(this) == 'ssp' ? this._iRecordsTotal * 1 : this.aiDisplayMaster.length;
    },
    /**
	 * Get the number of records in the current record set, after filtering
	 */ "fnRecordsDisplay": function() {
        return $44bb6d473543b89d$var$_fnDataSource(this) == 'ssp' ? this._iRecordsDisplay * 1 : this.aiDisplay.length;
    },
    /**
	 * Get the display end point - aiDisplay index
	 */ "fnDisplayEnd": function() {
        var len = this._iDisplayLength, start = this._iDisplayStart, calc = start + len, records = this.aiDisplay.length, features = this.oFeatures, paginate = features.bPaginate;
        if (features.bServerSide) return paginate === false || len === -1 ? start + records : Math.min(start + len, this._iRecordsDisplay);
        else return !paginate || calc > records || len === -1 ? records : calc;
    },
    /**
	 * The DataTables object for this table
	 */ "oInstance": null,
    /**
	 * Unique identifier for each instance of the DataTables object. If there
	 * is an ID on the table node, then it takes that value, otherwise an
	 * incrementing internal counter is used.
	 */ "sInstance": null,
    /**
	 * tabindex attribute value that is added to DataTables control elements, allowing
	 * keyboard navigation of the table and its controls.
	 */ "iTabIndex": 0,
    /**
	 * DIV container for the footer scrolling table if scrolling
	 */ "nScrollHead": null,
    /**
	 * DIV container for the footer scrolling table if scrolling
	 */ "nScrollFoot": null,
    /**
	 * Last applied sort
	 */ "aLastSort": [],
    /**
	 * Stored plug-in instances
	 */ "oPlugins": {},
    /**
	 * Function used to get a row's id from the row's data
	 */ "rowIdFn": null,
    /**
	 * Data location where to store a row's id
	 */ "rowId": null,
    caption: '',
    captionNode: null,
    colgroup: null,
    /** Delay loading of data */ deferLoading: null,
    /** Allow auto type detection */ typeDetect: true,
    /** ResizeObserver for the container div */ resizeObserver: null,
    /** Keep a record of the last size of the container, so we can skip duplicates */ containerWidth: -1,
    /** Reverse the initial order of the data set on desc ordering */ orderDescReverse: null,
    /** Show / hide ordering indicators in headers */ orderIndicators: true,
    /** Default ordering listener */ orderHandler: true,
    /** Title row indicator */ titleRow: null,
    /** Title wrapper element type */ columnTitleTag: 'span'
};
/**
 * Extension object for DataTables that is used to provide all extension
 * options.
 *
 * Note that the `DataTable.ext` object is available through
 * `jQuery.fn.dataTable.ext` where it may be accessed and manipulated. It is
 * also aliased to `jQuery.fn.dataTableExt` for historic reasons.
 *  @namespace
 *  @extends DataTable.models.ext
 */ var $44bb6d473543b89d$var$extPagination = $44bb6d473543b89d$var$DataTable.ext.pager;
// Paging buttons configuration
$44bb6d473543b89d$var$$.extend($44bb6d473543b89d$var$extPagination, {
    simple: function() {
        return [
            'previous',
            'next'
        ];
    },
    full: function() {
        return [
            'first',
            'previous',
            'next',
            'last'
        ];
    },
    numbers: function() {
        return [
            'numbers'
        ];
    },
    simple_numbers: function() {
        return [
            'previous',
            'numbers',
            'next'
        ];
    },
    full_numbers: function() {
        return [
            'first',
            'previous',
            'numbers',
            'next',
            'last'
        ];
    },
    first_last: function() {
        return [
            'first',
            'last'
        ];
    },
    first_last_numbers: function() {
        return [
            'first',
            'numbers',
            'last'
        ];
    },
    // For testing and plug-ins to use
    _numbers: $44bb6d473543b89d$var$_pagingNumbers,
    // Number of number buttons - legacy, use `numbers` option for paging feature
    numbers_length: 7
});
$44bb6d473543b89d$var$$.extend(true, $44bb6d473543b89d$var$DataTable.ext.renderer, {
    pagingButton: {
        _: function(settings, buttonType, content, active, disabled) {
            var classes = settings.oClasses.paging;
            var btnClasses = [
                classes.button
            ];
            var btn;
            if (active) btnClasses.push(classes.active);
            if (disabled) btnClasses.push(classes.disabled);
            if (buttonType === 'ellipsis') btn = $44bb6d473543b89d$var$$('<span class="ellipsis"></span>').html(content)[0];
            else btn = $44bb6d473543b89d$var$$('<button>', {
                class: btnClasses.join(' '),
                role: 'link',
                type: 'button'
            }).html(content);
            return {
                display: btn,
                clicker: btn
            };
        }
    },
    pagingContainer: {
        _: function(settings, buttons) {
            // No wrapping element - just append directly to the host
            return buttons;
        }
    }
});
// Common function to remove new lines, strip HTML and diacritic control
var $44bb6d473543b89d$var$_filterString = function(stripHtml, normalize) {
    return function(str) {
        if ($44bb6d473543b89d$var$_empty(str) || typeof str !== 'string') return str;
        str = str.replace($44bb6d473543b89d$var$_re_new_lines, " ");
        if (stripHtml) str = $44bb6d473543b89d$var$_stripHtml(str);
        if (normalize) str = $44bb6d473543b89d$var$_normalize(str, false);
        return str;
    };
};
/*
 * Public helper functions. These aren't used internally by DataTables, or
 * called by any of the options passed into DataTables, but they can be used
 * externally by developers working with DataTables. They are helper functions
 * to make working with DataTables a little bit easier.
 */ /**
 * Common logic for moment, luxon or a date action.
 *
 * Happens after __mldObj, so don't need to call `resolveWindowsLibs` again
 */ function $44bb6d473543b89d$var$__mld(dtLib, momentFn, luxonFn, dateFn, arg1) {
    if ($44bb6d473543b89d$var$__moment) return dtLib[momentFn](arg1);
    else if ($44bb6d473543b89d$var$__luxon) return dtLib[luxonFn](arg1);
    return dateFn ? dtLib[dateFn](arg1) : dtLib;
}
var $44bb6d473543b89d$var$__mlWarning = false;
var $44bb6d473543b89d$var$__luxon; // Can be assigned in DateTable.use()
var $44bb6d473543b89d$var$__moment; // Can be assigned in DateTable.use()
var $44bb6d473543b89d$var$__reIsoTimezone = /[T\s]\d{2}.*?(Z|[+-]\d{2}(?::?\d{2})?)$/;
/**
 * 
 */ function $44bb6d473543b89d$var$resolveWindowLibs() {
    if (window.luxon && !$44bb6d473543b89d$var$__luxon) $44bb6d473543b89d$var$__luxon = window.luxon;
    if (window.moment && !$44bb6d473543b89d$var$__moment) $44bb6d473543b89d$var$__moment = window.moment;
}
function $44bb6d473543b89d$var$__mldObj(d, format, locale) {
    var dt;
    $44bb6d473543b89d$var$resolveWindowLibs();
    if ($44bb6d473543b89d$var$__moment) {
        dt = $44bb6d473543b89d$var$__moment(d, format, locale, true);
        if (!dt.isValid()) return null;
    } else if ($44bb6d473543b89d$var$__luxon) {
        dt = format && typeof d === 'string' ? $44bb6d473543b89d$var$__luxon.DateTime.fromFormat(d, format) : $44bb6d473543b89d$var$__luxon.DateTime.fromISO(d);
        if (!dt.isValid) return null;
        dt = dt.setLocale(locale);
    } else if (!format) // No format given, must be ISO
    dt = new Date(d);
    else {
        if (!$44bb6d473543b89d$var$__mlWarning) alert('DataTables warning: Formatted date without Moment.js or Luxon - https://datatables.net/tn/17');
        $44bb6d473543b89d$var$__mlWarning = true;
    }
    return dt;
}
// Wrapper for date, datetime and time which all operate the same way with the exception of
// the output string for auto locale support
function $44bb6d473543b89d$var$__mlHelper(localeString) {
    return function(from, to, locale, def) {
        // Luxon and Moment support
        // Argument shifting
        if (arguments.length === 0) {
            locale = 'en';
            to = null; // means toLocaleString
            from = null; // means iso8601
        } else if (arguments.length === 1) {
            locale = 'en';
            to = from;
            from = null;
        } else if (arguments.length === 2) {
            locale = to;
            to = from;
            from = null;
        }
        var typeName = 'datetime' + (to ? '-' + to : '');
        // Add type detection and sorting specific to this date format - we need to be able to identify
        // date type columns as such, rather than as numbers in extensions. Hence the need for this.
        if (!$44bb6d473543b89d$var$DataTable.ext.type.order[typeName + '-pre']) $44bb6d473543b89d$var$DataTable.type(typeName, {
            detect: function(d) {
                // The renderer will give the value to type detect as the type!
                return d === typeName ? typeName : false;
            },
            order: {
                pre: function(d) {
                    // The renderer gives us Moment, Luxon or Date objects for the sorting, all of which have a
                    // `valueOf` which gives milliseconds epoch
                    return d.valueOf();
                }
            },
            className: 'dt-right'
        });
        return function(d, type) {
            // Allow for a default value
            if (d === null || d === undefined) {
                if (def === '--now') {
                    // We treat everything as UTC further down, so no changes are
                    // made, as such need to get the local date / time as if it were
                    // UTC
                    var local = new Date();
                    d = new Date(Date.UTC(local.getFullYear(), local.getMonth(), local.getDate(), local.getHours(), local.getMinutes(), local.getSeconds()));
                } else d = '';
            }
            if (type === 'type') // Typing uses the type name for fast matching
            return typeName;
            if (d === '') return type !== 'sort' ? '' : $44bb6d473543b89d$var$__mldObj('0000-01-01 00:00:00', null, locale);
            // Shortcut. If `from` and `to` are the same, we are using the renderer to
            // format for ordering, not display - its already in the display format.
            if (to !== null && from === to && type !== 'sort' && type !== 'type' && !(d instanceof Date)) return d;
            // Determine if there is a timezone. If there is, we want to reuse
            // it for the output, so the timezone doesn't change between the
            // input and output.
            let options = {};
            let tzMatch = typeof d === 'string' ? d.match($44bb6d473543b89d$var$__reIsoTimezone) : null;
            if (tzMatch) options.timeZone = tzMatch[1] === 'Z' ? 'UTC' : tzMatch[1];
            var dt = $44bb6d473543b89d$var$__mldObj(d, from, locale);
            if (dt === null) return d;
            if (type === 'sort') return dt;
            var formatted = to === null ? $44bb6d473543b89d$var$__mld(dt, 'toDate', 'toJSDate', '')[localeString](navigator.language, options) : $44bb6d473543b89d$var$__mld(dt, 'format', 'toFormat', 'toISOString', to);
            // XSS protection
            return type === 'display' ? $44bb6d473543b89d$var$_escapeHtml(formatted) : formatted;
        };
    };
}
// Based on locale, determine standard number formatting
// Fallback for legacy browsers is US English
var $44bb6d473543b89d$var$__thousands = ',';
var $44bb6d473543b89d$var$__decimal = '.';
if (window.Intl !== undefined) try {
    var $44bb6d473543b89d$var$num = new Intl.NumberFormat().formatToParts(100000.1);
    for(var $44bb6d473543b89d$var$i = 0; $44bb6d473543b89d$var$i < $44bb6d473543b89d$var$num.length; $44bb6d473543b89d$var$i++){
        if ($44bb6d473543b89d$var$num[$44bb6d473543b89d$var$i].type === 'group') $44bb6d473543b89d$var$__thousands = $44bb6d473543b89d$var$num[$44bb6d473543b89d$var$i].value;
        else if ($44bb6d473543b89d$var$num[$44bb6d473543b89d$var$i].type === 'decimal') $44bb6d473543b89d$var$__decimal = $44bb6d473543b89d$var$num[$44bb6d473543b89d$var$i].value;
    }
} catch (e) {
// noop
}
// Formatted date time detection - use by declaring the formats you are going to use
$44bb6d473543b89d$var$DataTable.datetime = function(format, locale) {
    var typeName = 'datetime-' + format;
    if (!locale) locale = 'en';
    if (!$44bb6d473543b89d$var$DataTable.ext.type.order[typeName]) $44bb6d473543b89d$var$DataTable.type(typeName, {
        detect: function(d) {
            var dt = $44bb6d473543b89d$var$__mldObj(d, format, locale);
            return d === '' || dt ? typeName : false;
        },
        order: {
            pre: function(d) {
                return $44bb6d473543b89d$var$__mldObj(d, format, locale) || 0;
            }
        },
        className: 'dt-right'
    });
};
/**
 * Helpers for `columns.render`.
 *
 * The options defined here can be used with the `columns.render` initialisation
 * option to provide a display renderer. The following functions are defined:
 *
 * * `moment` - Uses the MomentJS library to convert from a given format into another.
 * This renderer has three overloads:
 *   * 1 parameter:
 *     * `string` - Format to convert to (assumes input is ISO8601 and locale is `en`)
 *   * 2 parameters:
 *     * `string` - Format to convert from
 *     * `string` - Format to convert to. Assumes `en` locale
 *   * 3 parameters:
 *     * `string` - Format to convert from
 *     * `string` - Format to convert to
 *     * `string` - Locale
 * * `number` - Will format numeric data (defined by `columns.data`) for
 *   display, retaining the original unformatted data for sorting and filtering.
 *   It takes 5 parameters:
 *   * `string` - Thousands grouping separator
 *   * `string` - Decimal point indicator
 *   * `integer` - Number of decimal points to show
 *   * `string` (optional) - Prefix.
 *   * `string` (optional) - Postfix (/suffix).
 * * `text` - Escape HTML to help prevent XSS attacks. It has no optional
 *   parameters.
 *
 * @example
 *   // Column definition using the number renderer
 *   {
 *     data: "salary",
 *     render: $.fn.dataTable.render.number( '\'', '.', 0, '$' )
 *   }
 *
 * @namespace
 */ $44bb6d473543b89d$var$DataTable.render = {
    date: $44bb6d473543b89d$var$__mlHelper('toLocaleDateString'),
    datetime: $44bb6d473543b89d$var$__mlHelper('toLocaleString'),
    time: $44bb6d473543b89d$var$__mlHelper('toLocaleTimeString'),
    number: function(thousands, decimal, precision, prefix, postfix) {
        // Auto locale detection
        if (thousands === null || thousands === undefined) thousands = $44bb6d473543b89d$var$__thousands;
        if (decimal === null || decimal === undefined) decimal = $44bb6d473543b89d$var$__decimal;
        return {
            display: function(d) {
                if (typeof d !== 'number' && typeof d !== 'string') return d;
                if (d === '' || d === null) return d;
                var negative = d < 0 ? '-' : '';
                var flo = parseFloat(d);
                var abs = Math.abs(flo);
                // Scientific notation for large and small numbers
                if (abs >= 100000000000 || abs < 0.0001 && abs !== 0) {
                    var exp = flo.toExponential(precision).split(/e\+?/);
                    return exp[0] + ' x 10<sup>' + exp[1] + '</sup>';
                }
                // If NaN then there isn't much formatting that we can do - just
                // return immediately, escaping any HTML (this was supposed to
                // be a number after all)
                if (isNaN(flo)) return $44bb6d473543b89d$var$_escapeHtml(d);
                flo = flo.toFixed(precision);
                d = Math.abs(flo);
                var intPart = parseInt(d, 10);
                var floatPart = precision ? decimal + (d - intPart).toFixed(precision).substring(2) : '';
                // If zero, then can't have a negative prefix
                if (intPart === 0 && parseFloat(floatPart) === 0) negative = '';
                return negative + (prefix || '') + intPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + floatPart + (postfix || '');
            }
        };
    },
    text: function() {
        return {
            display: $44bb6d473543b89d$var$_escapeHtml,
            filter: $44bb6d473543b89d$var$_escapeHtml
        };
    }
};
var $44bb6d473543b89d$var$_extTypes = $44bb6d473543b89d$var$DataTable.ext.type;
// Get / set type
$44bb6d473543b89d$var$DataTable.type = function(name, prop, val) {
    if (!prop) return {
        className: $44bb6d473543b89d$var$_extTypes.className[name],
        detect: $44bb6d473543b89d$var$_extTypes.detect.find(function(fn) {
            return fn._name === name;
        }),
        order: {
            pre: $44bb6d473543b89d$var$_extTypes.order[name + '-pre'],
            asc: $44bb6d473543b89d$var$_extTypes.order[name + '-asc'],
            desc: $44bb6d473543b89d$var$_extTypes.order[name + '-desc']
        },
        render: $44bb6d473543b89d$var$_extTypes.render[name],
        search: $44bb6d473543b89d$var$_extTypes.search[name]
    };
    var setProp = function(prop, propVal) {
        $44bb6d473543b89d$var$_extTypes[prop][name] = propVal;
    };
    var setDetect = function(detect) {
        // `detect` can be a function or an object - we set a name
        // property for either - that is used for the detection
        Object.defineProperty(detect, "_name", {
            value: name
        });
        var idx = $44bb6d473543b89d$var$_extTypes.detect.findIndex(function(item) {
            return item._name === name;
        });
        if (idx === -1) $44bb6d473543b89d$var$_extTypes.detect.unshift(detect);
        else $44bb6d473543b89d$var$_extTypes.detect.splice(idx, 1, detect);
    };
    var setOrder = function(obj) {
        $44bb6d473543b89d$var$_extTypes.order[name + '-pre'] = obj.pre; // can be undefined
        $44bb6d473543b89d$var$_extTypes.order[name + '-asc'] = obj.asc; // can be undefined
        $44bb6d473543b89d$var$_extTypes.order[name + '-desc'] = obj.desc; // can be undefined
    };
    // prop is optional
    if (val === undefined) {
        val = prop;
        prop = null;
    }
    if (prop === 'className') setProp('className', val);
    else if (prop === 'detect') setDetect(val);
    else if (prop === 'order') setOrder(val);
    else if (prop === 'render') setProp('render', val);
    else if (prop === 'search') setProp('search', val);
    else if (!prop) {
        if (val.className) setProp('className', val.className);
        if (val.detect !== undefined) setDetect(val.detect);
        if (val.order) setOrder(val.order);
        if (val.render !== undefined) setProp('render', val.render);
        if (val.search !== undefined) setProp('search', val.search);
    }
};
// Get a list of types
$44bb6d473543b89d$var$DataTable.types = function() {
    return $44bb6d473543b89d$var$_extTypes.detect.map(function(fn) {
        return fn._name;
    });
};
var $44bb6d473543b89d$var$__diacriticSort = function(a, b) {
    a = a !== null && a !== undefined ? a.toString().toLowerCase() : '';
    b = b !== null && b !== undefined ? b.toString().toLowerCase() : '';
    // Checked for `navigator.languages` support in `oneOf` so this code can't execute in old
    // Safari and thus can disable this check
    // eslint-disable-next-line compat/compat
    return a.localeCompare(b, navigator.languages[0] || navigator.language, {
        numeric: true,
        ignorePunctuation: true
    });
};
var $44bb6d473543b89d$var$__diacriticHtmlSort = function(a, b) {
    a = $44bb6d473543b89d$var$_stripHtml(a);
    b = $44bb6d473543b89d$var$_stripHtml(b);
    return $44bb6d473543b89d$var$__diacriticSort(a, b);
};
//
// Built in data types
//
$44bb6d473543b89d$var$DataTable.type('string', {
    detect: function() {
        return 'string';
    },
    order: {
        pre: function(a) {
            // This is a little complex, but faster than always calling toString,
            // http://jsperf.com/tostring-v-check
            return $44bb6d473543b89d$var$_empty(a) && typeof a !== 'boolean' ? '' : typeof a === 'string' ? a.toLowerCase() : !a.toString ? '' : a.toString();
        }
    },
    search: $44bb6d473543b89d$var$_filterString(false, true)
});
$44bb6d473543b89d$var$DataTable.type('string-utf8', {
    detect: {
        allOf: function(d) {
            return true;
        },
        oneOf: function(d) {
            // At least one data point must contain a non-ASCII character
            // This line will also check if navigator.languages is supported or not. If not (Safari 10.0-)
            // this data type won't be supported.
            // eslint-disable-next-line compat/compat
            return !$44bb6d473543b89d$var$_empty(d) && navigator.languages && typeof d === 'string' && d.match(/[^\x00-\x7F]/);
        }
    },
    order: {
        asc: $44bb6d473543b89d$var$__diacriticSort,
        desc: function(a, b) {
            return $44bb6d473543b89d$var$__diacriticSort(a, b) * -1;
        }
    },
    search: $44bb6d473543b89d$var$_filterString(false, true)
});
$44bb6d473543b89d$var$DataTable.type('html', {
    detect: {
        allOf: function(d) {
            return $44bb6d473543b89d$var$_empty(d) || typeof d === 'string' && d.indexOf('<') !== -1;
        },
        oneOf: function(d) {
            // At least one data point must contain a `<`
            return !$44bb6d473543b89d$var$_empty(d) && typeof d === 'string' && d.indexOf('<') !== -1;
        }
    },
    order: {
        pre: function(a) {
            return $44bb6d473543b89d$var$_empty(a) ? '' : a.replace ? $44bb6d473543b89d$var$_stripHtml(a).trim().toLowerCase() : a + '';
        }
    },
    search: $44bb6d473543b89d$var$_filterString(true, true)
});
$44bb6d473543b89d$var$DataTable.type('html-utf8', {
    detect: {
        allOf: function(d) {
            return $44bb6d473543b89d$var$_empty(d) || typeof d === 'string' && d.indexOf('<') !== -1;
        },
        oneOf: function(d) {
            // At least one data point must contain a `<` and a non-ASCII character
            // eslint-disable-next-line compat/compat
            return navigator.languages && !$44bb6d473543b89d$var$_empty(d) && typeof d === 'string' && d.indexOf('<') !== -1 && typeof d === 'string' && d.match(/[^\x00-\x7F]/);
        }
    },
    order: {
        asc: $44bb6d473543b89d$var$__diacriticHtmlSort,
        desc: function(a, b) {
            return $44bb6d473543b89d$var$__diacriticHtmlSort(a, b) * -1;
        }
    },
    search: $44bb6d473543b89d$var$_filterString(true, true)
});
$44bb6d473543b89d$var$DataTable.type('date', {
    className: 'dt-type-date',
    detect: {
        allOf: function(d) {
            // V8 tries _very_ hard to make a string passed into `Date.parse()`
            // valid, so we need to use a regex to restrict date formats. Use a
            // plug-in for anything other than ISO8601 style strings
            if (d && !(d instanceof Date) && !$44bb6d473543b89d$var$_re_date.test(d)) return null;
            var parsed = Date.parse(d);
            return parsed !== null && !isNaN(parsed) || $44bb6d473543b89d$var$_empty(d);
        },
        oneOf: function(d) {
            // At least one entry must be a date or a string with a date
            return d instanceof Date || typeof d === 'string' && $44bb6d473543b89d$var$_re_date.test(d);
        }
    },
    order: {
        pre: function(d) {
            var ts = Date.parse(d);
            return isNaN(ts) ? -Infinity : ts;
        }
    }
});
$44bb6d473543b89d$var$DataTable.type('html-num-fmt', {
    className: 'dt-type-numeric',
    detect: {
        allOf: function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$_htmlNumeric(d, decimal, true, false);
        },
        oneOf: function(d, settings) {
            // At least one data point must contain a numeric value
            var decimal = settings.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$_htmlNumeric(d, decimal, true, false);
        }
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$__numericReplace(d, dp, $44bb6d473543b89d$var$_re_html, $44bb6d473543b89d$var$_re_formatted_numeric);
        }
    },
    search: $44bb6d473543b89d$var$_filterString(true, true)
});
$44bb6d473543b89d$var$DataTable.type('html-num', {
    className: 'dt-type-numeric',
    detect: {
        allOf: function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$_htmlNumeric(d, decimal, false, true);
        },
        oneOf: function(d, settings) {
            // At least one data point must contain a numeric value
            var decimal = settings.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$_htmlNumeric(d, decimal, false, false);
        }
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$__numericReplace(d, dp, $44bb6d473543b89d$var$_re_html);
        }
    },
    search: $44bb6d473543b89d$var$_filterString(true, true)
});
$44bb6d473543b89d$var$DataTable.type('num-fmt', {
    className: 'dt-type-numeric',
    detect: {
        allOf: function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$_isNumber(d, decimal, true, true);
        },
        oneOf: function(d, settings) {
            // At least one data point must contain a numeric value
            var decimal = settings.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$_isNumber(d, decimal, true, false);
        }
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$__numericReplace(d, dp, $44bb6d473543b89d$var$_re_formatted_numeric);
        }
    }
});
$44bb6d473543b89d$var$DataTable.type('num', {
    className: 'dt-type-numeric',
    detect: {
        allOf: function(d, settings) {
            var decimal = settings.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$_isNumber(d, decimal, false, true);
        },
        oneOf: function(d, settings) {
            // At least one data point must contain a numeric value
            var decimal = settings.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$_isNumber(d, decimal, false, false);
        }
    },
    order: {
        pre: function(d, s) {
            var dp = s.oLanguage.sDecimal;
            return $44bb6d473543b89d$var$__numericReplace(d, dp);
        }
    }
});
var $44bb6d473543b89d$var$__numericReplace = function(d, decimalPlace, re1, re2) {
    if (d !== 0 && (!d || d === '-')) return -Infinity;
    var type = typeof d;
    if (type === 'number' || type === 'bigint') return d;
    // If a decimal place other than `.` is used, it needs to be given to the
    // function so we can detect it and replace with a `.` which is the only
    // decimal place JavaScript recognises - it is not locale aware.
    if (decimalPlace) d = $44bb6d473543b89d$var$_numToDecimal(d, decimalPlace);
    if (d.replace) {
        if (re1) d = d.replace(re1, '');
        if (re2) d = d.replace(re2, '');
    }
    return d * 1;
};
$44bb6d473543b89d$var$$.extend(true, $44bb6d473543b89d$var$DataTable.ext.renderer, {
    footer: {
        _: function(settings, cell, classes) {
            cell.addClass(classes.tfoot.cell);
        }
    },
    header: {
        _: function(settings, cell, classes) {
            cell.addClass(classes.thead.cell);
            if (!settings.oFeatures.bSort) cell.addClass(classes.order.none);
            var titleRow = settings.titleRow;
            var headerRows = cell.closest('thead').find('tr');
            var rowIdx = cell.parent().index();
            // Conditions to not apply the ordering icons
            if (// Cells and rows which have the attribute to disable the icons
            cell.attr('data-dt-order') === 'disable' || cell.parent().attr('data-dt-order') === 'disable' || // titleRow support, for defining a specific row in the header
            titleRow === true && rowIdx !== 0 || titleRow === false && rowIdx !== headerRows.length - 1 || typeof titleRow === 'number' && rowIdx !== titleRow) return;
            // No additional mark-up required
            // Attach a sort listener to update on sort - note that using the
            // `DT` namespace will allow the event to be removed automatically
            // on destroy, while the `dt` namespaced event is the one we are
            // listening for
            $44bb6d473543b89d$var$$(settings.nTable).on('order.dt.DT column-visibility.dt.DT', function(e, ctx, column) {
                if (settings !== ctx) return; // table, not a nested one
                var sorting = ctx.sortDetails;
                if (!sorting) return;
                var orderedColumns = $44bb6d473543b89d$var$_pluck(sorting, 'col');
                // This handler is only needed on column visibility if the column is part of the
                // ordering. If it isn't, then we can bail out to save performance. It could be a
                // separate event handler, but this is a balance between code reuse / size and performance
                // console.log(e, e.name, column, orderedColumns, orderedColumns.includes(column))
                if (e.type === 'column-visibility' && !orderedColumns.includes(column)) return;
                var i;
                var orderClasses = classes.order;
                var columns = ctx.api.columns(cell);
                var col = settings.aoColumns[columns.flatten()[0]];
                var orderable = columns.orderable().includes(true);
                var ariaType = '';
                var indexes = columns.indexes();
                var sortDirs = columns.orderable(true).flatten();
                var tabIndex = settings.iTabIndex;
                var canOrder = ctx.orderHandler && orderable;
                cell.removeClass(orderClasses.isAsc + ' ' + orderClasses.isDesc).toggleClass(orderClasses.none, !orderable).toggleClass(orderClasses.canAsc, canOrder && sortDirs.includes('asc')).toggleClass(orderClasses.canDesc, canOrder && sortDirs.includes('desc'));
                // Determine if all of the columns that this cell covers are included in the
                // current ordering
                var isOrdering = true;
                for(i = 0; i < indexes.length; i++)if (!orderedColumns.includes(indexes[i])) isOrdering = false;
                if (isOrdering) {
                    // Get the ordering direction for the columns under this cell
                    // Note that it is possible for a cell to be asc and desc sorting
                    // (column spanning cells)
                    var orderDirs = columns.order();
                    cell.addClass(orderDirs.includes('asc') ? orderClasses.isAsc : '' + orderDirs.includes('desc') ? orderClasses.isDesc : '');
                }
                // Find the first visible column that has ordering applied to it - it get's
                // the aria information, as the ARIA spec says that only one column should
                // be marked with aria-sort
                var firstVis = -1; // column index
                for(i = 0; i < orderedColumns.length; i++)if (settings.aoColumns[orderedColumns[i]].bVisible) {
                    firstVis = orderedColumns[i];
                    break;
                }
                if (indexes[0] == firstVis) {
                    var firstSort = sorting[0];
                    var sortOrder = col.asSorting;
                    cell.attr('aria-sort', firstSort.dir === 'asc' ? 'ascending' : 'descending');
                    // Determine if the next click will remove sorting or change the sort
                    ariaType = !sortOrder[firstSort.index + 1] ? 'Remove' : 'Reverse';
                } else cell.removeAttr('aria-sort');
                // Make the headers tab-able for keyboard navigation
                if (orderable) {
                    var orderSpan = cell.find('.dt-column-order');
                    orderSpan.attr('role', 'button').attr('aria-label', orderable ? col.ariaTitle + ctx.api.i18n('oAria.orderable' + ariaType) : col.ariaTitle);
                    if (tabIndex !== -1) orderSpan.attr('tabindex', tabIndex);
                }
            });
        }
    },
    layout: {
        _: function(settings, container, items) {
            var classes = settings.oClasses.layout;
            var row = $44bb6d473543b89d$var$$('<div/>').attr('id', items.id || null).addClass(items.className || classes.row).appendTo(container);
            $44bb6d473543b89d$var$DataTable.ext.renderer.layout._forLayoutRow(items, function(key, val) {
                if (key === 'id' || key === 'className') return;
                var klass = '';
                if (val.table) {
                    row.addClass(classes.tableRow);
                    klass += classes.tableCell + ' ';
                }
                if (key === 'start') klass += classes.start;
                else if (key === 'end') klass += classes.end;
                else klass += classes.full;
                $44bb6d473543b89d$var$$('<div/>').attr({
                    id: val.id || null,
                    "class": val.className ? val.className : classes.cell + ' ' + klass
                }).append(val.contents).appendTo(row);
            });
        },
        // Shared for use by the styling frameworks
        _forLayoutRow: function(items, fn) {
            // As we are inserting dom elements, we need start / end in a
            // specific order, this function is used for sorting the layout
            // keys.
            var layoutEnum = function(x) {
                switch(x){
                    case '':
                        return 0;
                    case 'start':
                        return 1;
                    case 'end':
                        return 2;
                    default:
                        return 3;
                }
            };
            Object.keys(items).sort(function(a, b) {
                return layoutEnum(a) - layoutEnum(b);
            }).forEach(function(key) {
                fn(key, items[key]);
            });
        }
    }
});
$44bb6d473543b89d$var$DataTable.feature = {};
// Third parameter is internal only!
$44bb6d473543b89d$var$DataTable.feature.register = function(name, cb, legacy) {
    $44bb6d473543b89d$var$DataTable.ext.features[name] = cb;
    if (legacy) $44bb6d473543b89d$var$_ext.feature.push({
        cFeature: legacy,
        fnInit: cb
    });
};
function $44bb6d473543b89d$var$_divProp(el, prop, val) {
    if (val) el[prop] = val;
}
$44bb6d473543b89d$var$DataTable.feature.register('div', function(settings, opts) {
    var n = $44bb6d473543b89d$var$$('<div>')[0];
    if (opts) {
        $44bb6d473543b89d$var$_divProp(n, 'className', opts.className);
        $44bb6d473543b89d$var$_divProp(n, 'id', opts.id);
        $44bb6d473543b89d$var$_divProp(n, 'innerHTML', opts.html);
        $44bb6d473543b89d$var$_divProp(n, 'textContent', opts.text);
    }
    return n;
});
$44bb6d473543b89d$var$DataTable.feature.register('info', function(settings, opts) {
    // For compatibility with the legacy `info` top level option
    if (!settings.oFeatures.bInfo) return null;
    var lang = settings.oLanguage, tid = settings.sTableId, n = $44bb6d473543b89d$var$$('<div/>', {
        'class': settings.oClasses.info.container
    });
    opts = $44bb6d473543b89d$var$$.extend({
        callback: lang.fnInfoCallback,
        empty: lang.sInfoEmpty,
        postfix: lang.sInfoPostFix,
        search: lang.sInfoFiltered,
        text: lang.sInfo
    }, opts);
    // Update display on each draw
    settings.aoDrawCallback.push(function(s) {
        $44bb6d473543b89d$var$_fnUpdateInfo(s, opts, n);
    });
    // For the first info display in the table, we add a callback and aria information.
    if (!settings._infoEl) {
        n.attr({
            'aria-live': 'polite',
            id: tid + '_info',
            role: 'status'
        });
        // Table is described by our info div
        $44bb6d473543b89d$var$$(settings.nTable).attr('aria-describedby', tid + '_info');
        settings._infoEl = n;
    }
    return n;
}, 'i');
/**
 * Update the information elements in the display
 *  @param {object} settings dataTables settings object
 *  @memberof DataTable#oApi
 */ function $44bb6d473543b89d$var$_fnUpdateInfo(settings, opts, node) {
    var start = settings._iDisplayStart + 1, end = settings.fnDisplayEnd(), max = settings.fnRecordsTotal(), total = settings.fnRecordsDisplay(), out = total ? opts.text : opts.empty;
    if (total !== max) // Record set after filtering
    out += ' ' + opts.search;
    // Convert the macros
    out += opts.postfix;
    out = $44bb6d473543b89d$var$_fnMacros(settings, out);
    if (opts.callback) out = opts.callback.call(settings.oInstance, settings, start, end, max, total, out);
    node.html(out);
    $44bb6d473543b89d$var$_fnCallbackFire(settings, null, 'info', [
        settings,
        node[0],
        out
    ]);
}
var $44bb6d473543b89d$var$__searchCounter = 0;
// opts
// - text
// - placeholder
$44bb6d473543b89d$var$DataTable.feature.register('search', function(settings, opts) {
    // Don't show the input if filtering isn't available on the table
    if (!settings.oFeatures.bFilter) return null;
    var classes = settings.oClasses.search;
    var tableId = settings.sTableId;
    var language = settings.oLanguage;
    var previousSearch = settings.oPreviousSearch;
    var input = '<input type="search" class="' + classes.input + '"/>';
    opts = $44bb6d473543b89d$var$$.extend({
        placeholder: language.sSearchPlaceholder,
        processing: false,
        text: language.sSearch
    }, opts);
    // The _INPUT_ is optional - is appended if not present
    if (opts.text.indexOf('_INPUT_') === -1) opts.text += '_INPUT_';
    opts.text = $44bb6d473543b89d$var$_fnMacros(settings, opts.text);
    // We can put the <input> outside of the label if it is at the start or end
    // which helps improve accessability (not all screen readers like implicit
    // for elements).
    var end = opts.text.match(/_INPUT_$/);
    var start = opts.text.match(/^_INPUT_/);
    var removed = opts.text.replace(/_INPUT_/, '');
    var str = '<label>' + opts.text + '</label>';
    if (start) str = '_INPUT_<label>' + removed + '</label>';
    else if (end) str = '<label>' + removed + '</label>_INPUT_';
    var filter = $44bb6d473543b89d$var$$('<div>').addClass(classes.container).append(str.replace(/_INPUT_/, input));
    // add for and id to label and input
    filter.find('label').attr('for', 'dt-search-' + $44bb6d473543b89d$var$__searchCounter);
    filter.find('input').attr('id', 'dt-search-' + $44bb6d473543b89d$var$__searchCounter);
    $44bb6d473543b89d$var$__searchCounter++;
    var searchFn = function(event) {
        var val = this.value;
        if (previousSearch.return && event.key !== "Enter") return;
        /* Now do the filter */ if (val != previousSearch.search) $44bb6d473543b89d$var$_fnProcessingRun(settings, opts.processing, function() {
            previousSearch.search = val;
            $44bb6d473543b89d$var$_fnFilterComplete(settings, previousSearch);
            // Need to redraw, without resorting
            settings._iDisplayStart = 0;
            $44bb6d473543b89d$var$_fnDraw(settings);
        });
    };
    var searchDelay = settings.searchDelay !== null ? settings.searchDelay : 0;
    var jqFilter = $44bb6d473543b89d$var$$('input', filter).val(previousSearch.search).attr('placeholder', opts.placeholder).on('keyup.DT search.DT input.DT paste.DT cut.DT', searchDelay ? $44bb6d473543b89d$var$DataTable.util.debounce(searchFn, searchDelay) : searchFn).on('mouseup.DT', function(e) {
        // Edge fix! Edge 17 does not trigger anything other than mouse events when clicking
        // on the clear icon (Edge bug 17584515). This is safe in other browsers as `searchFn`
        // checks the value to see if it has changed. In other browsers it won't have.
        setTimeout(function() {
            searchFn.call(jqFilter[0], e);
        }, 10);
    }).on('keypress.DT', function(e) {
        /* Prevent form submission */ if (e.keyCode == 13) return false;
    }).attr('aria-controls', tableId);
    // Update the input elements whenever the table is filtered
    $44bb6d473543b89d$var$$(settings.nTable).on('search.dt.DT', function(ev, s) {
        if (settings === s && jqFilter[0] !== document.activeElement) jqFilter.val(typeof previousSearch.search !== 'function' ? previousSearch.search : '');
    });
    return filter;
}, 'f');
// opts
// - type - button configuration
// - buttons - number of buttons to show - must be odd
$44bb6d473543b89d$var$DataTable.feature.register('paging', function(settings, opts) {
    // Don't show the paging input if the table doesn't have paging enabled
    if (!settings.oFeatures.bPaginate) return null;
    opts = $44bb6d473543b89d$var$$.extend({
        buttons: $44bb6d473543b89d$var$DataTable.ext.pager.numbers_length,
        type: settings.sPaginationType,
        boundaryNumbers: true,
        firstLast: true,
        previousNext: true,
        numbers: true
    }, opts);
    var host = $44bb6d473543b89d$var$$('<div/>').addClass(settings.oClasses.paging.container + (opts.type ? ' paging_' + opts.type : '')).append($44bb6d473543b89d$var$$('<nav>').attr('aria-label', 'pagination').addClass(settings.oClasses.paging.nav));
    var draw = function() {
        $44bb6d473543b89d$var$_pagingDraw(settings, host.children(), opts);
    };
    settings.aoDrawCallback.push(draw);
    // Responsive redraw of paging control
    $44bb6d473543b89d$var$$(settings.nTable).on('column-sizing.dt.DT', draw);
    return host;
}, 'p');
/**
 * Dynamically create the button type array based on the configuration options.
 * This will only happen if the paging type is not defined.
 */ function $44bb6d473543b89d$var$_pagingDynamic(opts) {
    var out = [];
    if (opts.numbers) out.push('numbers');
    if (opts.previousNext) {
        out.unshift('previous');
        out.push('next');
    }
    if (opts.firstLast) {
        out.unshift('first');
        out.push('last');
    }
    return out;
}
function $44bb6d473543b89d$var$_pagingDraw(settings, host, opts) {
    if (!settings._bInitComplete) return;
    var plugin = opts.type ? $44bb6d473543b89d$var$DataTable.ext.pager[opts.type] : $44bb6d473543b89d$var$_pagingDynamic, aria = settings.oLanguage.oAria.paginate || {}, start = settings._iDisplayStart, len = settings._iDisplayLength, visRecords = settings.fnRecordsDisplay(), all = len === -1, page = all ? 0 : Math.ceil(start / len), pages = all ? 1 : Math.ceil(visRecords / len), buttons = [], buttonEls = [], buttonsNested = plugin(opts).map(function(val) {
        return val === 'numbers' ? $44bb6d473543b89d$var$_pagingNumbers(page, pages, opts.buttons, opts.boundaryNumbers) : val;
    });
    // .flat() would be better, but not supported in old Safari
    buttons = buttons.concat.apply(buttons, buttonsNested);
    for(var i = 0; i < buttons.length; i++){
        var button = buttons[i];
        var btnInfo = $44bb6d473543b89d$var$_pagingButtonInfo(settings, button, page, pages);
        var btn = $44bb6d473543b89d$var$_fnRenderer(settings, 'pagingButton')(settings, button, btnInfo.display, btnInfo.active, btnInfo.disabled);
        var ariaLabel = typeof button === 'string' ? aria[button] : aria.number ? aria.number + (button + 1) : null;
        // Common attributes
        $44bb6d473543b89d$var$$(btn.clicker).attr({
            'aria-controls': settings.sTableId,
            'aria-disabled': btnInfo.disabled ? 'true' : null,
            'aria-current': btnInfo.active ? 'page' : null,
            'aria-label': ariaLabel,
            'data-dt-idx': button,
            'tabIndex': btnInfo.disabled ? -1 : settings.iTabIndex && btn.clicker[0].nodeName.toLowerCase() !== 'span' ? settings.iTabIndex : null
        });
        if (typeof button !== 'number') $44bb6d473543b89d$var$$(btn.clicker).addClass(button);
        $44bb6d473543b89d$var$_fnBindAction(btn.clicker, {
            action: button
        }, function(e) {
            e.preventDefault();
            $44bb6d473543b89d$var$_fnPageChange(settings, e.data.action, true);
        });
        buttonEls.push(btn.display);
    }
    var wrapped = $44bb6d473543b89d$var$_fnRenderer(settings, 'pagingContainer')(settings, buttonEls);
    var activeEl = host.find(document.activeElement).data('dt-idx');
    host.empty().append(wrapped);
    if (activeEl !== undefined) host.find('[data-dt-idx=' + activeEl + ']').trigger('focus');
    // Responsive - check if the buttons are over two lines based on the
    // height of the buttons and the container.
    if (buttonEls.length) {
        var outerHeight = $44bb6d473543b89d$var$$(buttonEls[0]).outerHeight();
        if (opts.buttons > 1 && // prevent infinite
        outerHeight > 0 && // will be 0 if hidden
        $44bb6d473543b89d$var$$(host).height() >= outerHeight * 2 - 10) $44bb6d473543b89d$var$_pagingDraw(settings, host, $44bb6d473543b89d$var$$.extend({}, opts, {
            buttons: opts.buttons - 2
        }));
    }
}
/**
 * Get properties for a button based on the current paging state of the table
 *
 * @param {*} settings DT settings object
 * @param {*} button The button type in question
 * @param {*} page Table's current page
 * @param {*} pages Number of pages
 * @returns Info object
 */ function $44bb6d473543b89d$var$_pagingButtonInfo(settings, button, page, pages) {
    var lang = settings.oLanguage.oPaginate;
    var o = {
        display: '',
        active: false,
        disabled: false
    };
    switch(button){
        case 'ellipsis':
            o.display = '&#x2026;';
            break;
        case 'first':
            o.display = lang.sFirst;
            if (page === 0) o.disabled = true;
            break;
        case 'previous':
            o.display = lang.sPrevious;
            if (page === 0) o.disabled = true;
            break;
        case 'next':
            o.display = lang.sNext;
            if (pages === 0 || page === pages - 1) o.disabled = true;
            break;
        case 'last':
            o.display = lang.sLast;
            if (pages === 0 || page === pages - 1) o.disabled = true;
            break;
        default:
            if (typeof button === 'number') {
                o.display = settings.fnFormatNumber(button + 1);
                if (page === button) o.active = true;
            }
            break;
    }
    return o;
}
/**
 * Compute what number buttons to show in the paging control
 *
 * @param {*} page Current page
 * @param {*} pages Total number of pages
 * @param {*} buttons Target number of number buttons
 * @param {boolean} addFirstLast Indicate if page 1 and end should be included
 * @returns Buttons to show
 */ function $44bb6d473543b89d$var$_pagingNumbers(page, pages, buttons, addFirstLast) {
    var numbers = [], half = Math.floor(buttons / 2), before = addFirstLast ? 2 : 1, after = addFirstLast ? 1 : 0;
    if (pages <= buttons) numbers = $44bb6d473543b89d$var$_range(0, pages);
    else if (buttons === 1) // Single button - current page only
    numbers = [
        page
    ];
    else if (buttons === 3) {
        // Special logic for just three buttons
        if (page <= 1) numbers = [
            0,
            1,
            'ellipsis'
        ];
        else if (page >= pages - 2) {
            numbers = $44bb6d473543b89d$var$_range(pages - 2, pages);
            numbers.unshift('ellipsis');
        } else numbers = [
            'ellipsis',
            page,
            'ellipsis'
        ];
    } else if (page <= half) {
        numbers = $44bb6d473543b89d$var$_range(0, buttons - before);
        numbers.push('ellipsis');
        if (addFirstLast) numbers.push(pages - 1);
    } else if (page >= pages - 1 - half) {
        numbers = $44bb6d473543b89d$var$_range(pages - (buttons - before), pages);
        numbers.unshift('ellipsis');
        if (addFirstLast) numbers.unshift(0);
    } else {
        numbers = $44bb6d473543b89d$var$_range(page - half + before, page + half - after);
        numbers.push('ellipsis');
        numbers.unshift('ellipsis');
        if (addFirstLast) {
            numbers.push(pages - 1);
            numbers.unshift(0);
        }
    }
    return numbers;
}
var $44bb6d473543b89d$var$__lengthCounter = 0;
// opts
// - menu
// - text
$44bb6d473543b89d$var$DataTable.feature.register('pageLength', function(settings, opts) {
    var features = settings.oFeatures;
    // For compatibility with the legacy `pageLength` top level option
    if (!features.bPaginate || !features.bLengthChange) return null;
    opts = $44bb6d473543b89d$var$$.extend({
        menu: settings.aLengthMenu,
        text: settings.oLanguage.sLengthMenu
    }, opts);
    var classes = settings.oClasses.length, tableId = settings.sTableId, menu = opts.menu, lengths = [], language = [], i;
    // Options can be given in a number of ways
    if (Array.isArray(menu[0])) {
        // Old 1.x style - 2D array
        lengths = menu[0];
        language = menu[1];
    } else {
        for(i = 0; i < menu.length; i++)// An object with different label and value
        if ($44bb6d473543b89d$var$$.isPlainObject(menu[i])) {
            lengths.push(menu[i].value);
            language.push(menu[i].label);
        } else {
            // Or just a number to display and use
            lengths.push(menu[i]);
            language.push(menu[i]);
        }
    }
    // We can put the <select> outside of the label if it is at the start or
    // end which helps improve accessability (not all screen readers like
    // implicit for elements).
    var end = opts.text.match(/_MENU_$/);
    var start = opts.text.match(/^_MENU_/);
    var removed = opts.text.replace(/_MENU_/, '');
    var str = '<label>' + opts.text + '</label>';
    if (start) str = '_MENU_<label>' + removed + '</label>';
    else if (end) str = '<label>' + removed + '</label>_MENU_';
    // Wrapper element - use a span as a holder for where the select will go
    var tmpId = 'tmp-' + +new Date();
    var div = $44bb6d473543b89d$var$$('<div/>').addClass(classes.container).append(str.replace('_MENU_', '<span id="' + tmpId + '"></span>'));
    // Save text node content for macro updating
    var textNodes = [];
    Array.prototype.slice.call(div.find('label')[0].childNodes).forEach(function(el) {
        if (el.nodeType === Node.TEXT_NODE) textNodes.push({
            el: el,
            text: el.textContent
        });
    });
    // Update the label text in case it has an entries value
    var updateEntries = function(len) {
        textNodes.forEach(function(node) {
            node.el.textContent = $44bb6d473543b89d$var$_fnMacros(settings, node.text, len);
        });
    };
    // Next, the select itself, along with the options
    var select = $44bb6d473543b89d$var$$('<select/>', {
        'aria-controls': tableId,
        'class': classes.select
    });
    for(i = 0; i < lengths.length; i++){
        // Attempt to look up the length from the i18n options
        var label = settings.api.i18n('lengthLabels.' + lengths[i], null);
        if (label === null) // If not present, fallback to old style
        label = typeof language[i] === 'number' ? settings.fnFormatNumber(language[i]) : language[i];
        select[0][i] = new Option(label, lengths[i]);
    }
    // add for and id to label and input
    div.find('label').attr('for', 'dt-length-' + $44bb6d473543b89d$var$__lengthCounter);
    select.attr('id', 'dt-length-' + $44bb6d473543b89d$var$__lengthCounter);
    $44bb6d473543b89d$var$__lengthCounter++;
    // Swap in the select list
    div.find('#' + tmpId).replaceWith(select);
    // Can't use `select` variable as user might provide their own and the
    // reference is broken by the use of outerHTML
    $44bb6d473543b89d$var$$('select', div).val(settings._iDisplayLength).on('change.DT', function() {
        $44bb6d473543b89d$var$_fnLengthChange(settings, $44bb6d473543b89d$var$$(this).val());
        $44bb6d473543b89d$var$_fnDraw(settings);
    });
    // Update node value whenever anything changes the table's length
    $44bb6d473543b89d$var$$(settings.nTable).on('length.dt.DT', function(e, s, len) {
        if (settings === s) {
            $44bb6d473543b89d$var$$('select', div).val(len);
            // Resolve plurals in the text for the new length
            updateEntries(len);
        }
    });
    updateEntries(settings._iDisplayLength);
    return div;
}, 'l');
// jQuery access
$44bb6d473543b89d$var$$.fn.dataTable = $44bb6d473543b89d$var$DataTable;
// Provide access to the host jQuery object (circular reference)
$44bb6d473543b89d$var$DataTable.$ = $44bb6d473543b89d$var$$;
// Legacy aliases
$44bb6d473543b89d$var$$.fn.dataTableSettings = $44bb6d473543b89d$var$DataTable.settings;
$44bb6d473543b89d$var$$.fn.dataTableExt = $44bb6d473543b89d$var$DataTable.ext;
// With a capital `D` we return a DataTables API instance rather than a
// jQuery object
$44bb6d473543b89d$var$$.fn.DataTable = function(opts) {
    return $44bb6d473543b89d$var$$(this).dataTable(opts).api();
};
// All properties that are available to $.fn.dataTable should also be
// available on $.fn.DataTable
$44bb6d473543b89d$var$$.each($44bb6d473543b89d$var$DataTable, function(prop, val) {
    $44bb6d473543b89d$var$$.fn.DataTable[prop] = val;
});
var $44bb6d473543b89d$export$2e2bcd8739ae039 = $44bb6d473543b89d$var$DataTable;

});


parcelRequire("lJx7k");

var $iUSsr = parcelRequire("iUSsr");

// DataTables();
const $a4d2157ecdea15fe$var$datatableBaseOptions = {
    dom: "rtp",
    responsive: true,
    searching: true,
    paging: true,
    info: false,
    language: {
        emptyTable: "La lista dei profili sar\xe0 disponibile a breve"
    },
    pageLength: 30
};
const $a4d2157ecdea15fe$var$datatableOptions = {
    ajax: {
        url: "/get_bande_minime/",
        dataSrc: ""
    },
    columnDefs: [
        {
            targets: "_all",
            defaultContent: "-"
        }
    ],
    columns: [
        {
            data: "operatore"
        },
        {
            data: "alias"
        },
        {
            data: "tipo_cliente"
        },
        {
            data: "tecnologia"
        },
        {
            data: "profilo_tecnico"
        },
        {
            data: "down_all"
        },
        {
            data: "down"
        },
        {
            data: "min_down"
        },
        {
            data: "max_down"
        },
        {
            data: "norm_down"
        }
    ]
};
const $a4d2157ecdea15fe$var$table = (0, (/*@__PURE__*/$parcel$interopDefault($iUSsr)))("#bande-minime").DataTable({
    ...$a4d2157ecdea15fe$var$datatableBaseOptions,
    ...$a4d2157ecdea15fe$var$datatableOptions
});
$("#bande-minime thead tr").clone(true).addClass("filters").appendTo("#bande-minime thead");
$a4d2157ecdea15fe$var$table.columns().eq(0).each((colIdx)=>{
    const cell = $(".filters th").eq($($a4d2157ecdea15fe$var$table.column(colIdx).header()).index());
    const title = $(cell).text();
    $(cell).html(`<input type="text" placeholder="cerca..." class="small" />`);
    $("input", $(".filters th").eq($($a4d2157ecdea15fe$var$table.column(colIdx).header()).index())).off("keyup change").on("keyup change", function(e) {
        e.stopPropagation();
        $(this).attr("title", $(this).val());
        const regexr = "({search})";
        $a4d2157ecdea15fe$var$table.column(colIdx).search(this.value !== "" ? regexr.replace("{search}", `(((${this.value})))`) : "", this.value !== "", this.value === "").draw();
    });
    $("select", $(".filters th").eq($($a4d2157ecdea15fe$var$table.column(colIdx).header()).index())).off("change").on("change", function() {
        $(this).parents("th").find("input").trigger("change");
    });
});

})();
//# sourceMappingURL=bande_minime.js.map
